<template>
  <div>
    <div id="SeatingBK">
      <b-container fluid class="seatingMain">
        <b-row>
          <b-col lg="7" md="12" class="map">
            <svg
              version="1.1"
              id="pricingMapSvg"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              viewBox="0 0 600 526"
              style="enable-background: new 0 0 600 526"
              xml:space="preserve"
            >
              <g id="grey">
                <path
                  class="st0"
                  d="M313.5,349.1c-1.7,0.7-3.8,1.4-5.6,1.8c2.8,13.4,9.6,44.2,11.2,51.9l0,0c5.2-1,10.2-2.5,15.2-4.4
            C329.4,386.8,319.1,362.4,313.5,349.1"
                />
                <path
                  class="st0"
                  d="M317.6,403.1L317.6,403.1l-10.9-52c-1.7,0.3-3.4,0.5-5.2,0.6c0.2,14.4,0.6,45.3,0.7,52.9v0.1
            C307.4,404.5,312.5,404,317.6,403.1"
                />
                <path
                  class="st0"
                  d="M374.1,369.7l-35.9-34.8c-2.3,0-6,0.1-8.2,0.1c-1.1,1.8-2.3,3.5-3.6,5l39.4,38.2
            C367,376.9,369.9,373.9,374.1,369.7"
                />
                <path
                  class="st0"
                  d="M325.3,341.2c-1.4,1.4-2.8,2.6-4.3,3.7l31.6,47c4.7-3,7.8-8.7,12-12.7L325.3,341.2z"
                />
                <path
                  class="st0"
                  d="M319.7,345.8c-1.5,1-3.1,1.9-4.7,2.6l20.8,49.3l0.8,2.2c4.8-2,9.6-5.3,14.1-8L319.7,345.8z"
                />
                <path
                  class="st0"
                  d="M239.8,315.9l-9-8.8l-33.1,33.8c3.1,3,6.1,6,9.1,8.8L239.8,315.9z"
                />
                <path
                  class="st0"
                  d="M260.4,335.9l-9.3-9l-33,33.8c3.5,3.4,6.6,6.4,9.3,9L260.4,335.9z"
                />
                <path
                  class="st0"
                  d="M215.4,280c-2.6-2.5-5.8-5.6-9.1-8.8l-39.2,40.1c3,2.9,6,5.8,9.1,8.8L215.4,280z"
                />
                <path
                  class="st0"
                  d="M220.7,294.8c0.5-6.5,0.5-6.7,0.6-9c-0.7-0.7-2.5-2.4-4.8-4.7l-39.2,40.1c3,2.9,6.1,5.9,9,8.8L220.7,294.8z"
                />
                <path
                  class="st0"
                  d="M229.6,306l-9.1-8.8l0,0l-33,33.8c3.1,3,6.1,5.9,9.1,8.8L229.6,306z"
                />
                <path
                  class="st0"
                  d="M250,325.8l-9.1-8.8l-33.1,33.8c3.2,3.1,6.2,6,9.1,8.8L250,325.8z"
                />
                <path
                  class="st0"
                  d="M274.8,341c-1.5-1.6-2.8-3.3-4-5.2c-2.2,0-5.8,0.1-8.2,0.1l-34.1,34.9c4.5,4.3,7.6,7.4,8.8,8.5L274.8,341z"
                />
                <path
                  class="st0"
                  d="M282.6,402.9l9.5-52.1c-1.8-0.4-3.5-1-5.2-1.7c-5,12.7-15.1,38.7-19.3,49.5l0,0
            C272.5,400.5,277.5,401.9,282.6,402.9L282.6,402.9z"
                />
                <path
                  class="st0"
                  d="M266.1,398l19.3-49.5c-1.8-0.8-3.5-1.8-5.2-2.9l-28.5,45.1C256.3,393.6,261.1,396,266.1,398L266.1,398z"
                />
                <path
                  class="st0"
                  d="M275.9,342.1l-37.5,38.4c0.6,0.6,1.5,1.4,1.5,1.4c3.3,3,6.8,5.6,10.4,8l28.6-45.2
            C277.9,343.8,276.9,343,275.9,342.1"
                />
                <path
                  class="st0"
                  d="M291.9,404.2c0.5,0,1,0.1,1.6,0.1v0.1c2.4,0.2,4.7,0.3,7.1,0.3l0,0l-0.7-52.9c-2.1,0-4.2-0.2-6.3-0.6l-9.4,52
            v0.1C286.7,403.7,289.3,404,291.9,404.2L291.9,404.2z"
                />
                <path
                  class="st0"
                  d="M383.9,359.6l-34.8-33.7l-7,7.2l-1.7,1.8l34.8,33.7C377.7,365.9,380.6,362.9,383.9,359.6"
                />
                <path
                  class="st0"
                  d="M434.1,308.2l-41.8-40.5c-3.3,3.4-6.4,6.6-9,9.2l41.8,40.5C428.2,314.3,431.2,311.2,434.1,308.2"
                />
                <path
                  class="st0"
                  d="M414,328.8l-34.8-33.7l-8.9,9.1l34.8,33.7C408,334.9,411,331.9,414,328.8"
                />
                <path
                  class="st0"
                  d="M404,339.1l-34.8-33.7l-9,9.2l34.8,33.7C397.9,345.3,400.9,342.2,404,339.1"
                />
                <path
                  class="st0"
                  d="M393.9,349.3l-34.8-33.7l-8.9,9.1l34.8,33.7C387.8,355.6,390.8,352.6,393.9,349.3"
                />
                <path
                  class="st0"
                  d="M416.1,328.7c3-3.1,6.1-6.3,9.2-9.4l-42.8-41.5c-2.9,3-4.8,4.9-4.8,4.9c0.3,2.4,1,7.1,1.3,10.1L416.1,328.7z"
                />
                <polygon
                  class="st0"
                  points="109.6,288.9 129.6,308.3 141.8,295.8 121.8,276.4 	"
                />
                <polygon
                  class="st0"
                  points="472.3,303.8 489.4,286.3 477,274.3 459.9,291.7 	"
                />
                <path
                  class="st0"
                  d="M195,260.2c-5.2-5-9-8.7-9-8.7l0,0l-39.2,40.1c2.9,2.8,5.9,5.8,9.1,8.8L195,260.2z"
                />
                <polygon
                  class="st0"
                  points="130,308.7 139.1,317.4 151.3,304.9 142.2,296.2 	"
                />
                <path
                  class="st0"
                  d="M185.9,250.9c-3.1-4.9-13.5-21-14.1-21.9c-0.2-0.2-0.8-0.8-1.8-1.7l-43.6,44.6c5.3,5.1,12.2,11.8,20,19.4
            L185.9,250.9z"
                />
                <path
                  class="st0"
                  d="M412.4,247.1c-1.9,2-5.2,5.3-9,9.2l41.8,40.5c3.1-3.2,6.1-6.2,9-9.2L412.4,247.1z"
                />
                <path
                  class="st0"
                  d="M424.4,223c-2.2,5-10.1,22.5-10.1,22.5s-0.3,0.3-0.8,0.8l41.8,40.2c6.6-6.7,12.4-12.6,17.1-17.3L424.4,223z"
                />
                <polygon
                  class="st0"
                  points="202.3,354.3 193.2,345.5 181,358.1 190,366.8 	"
                />
                <polygon
                  class="st0"
                  points="222.9,374.3 213.6,365.3 201.3,377.8 210.6,386.8 	"
                />
                <polygon
                  class="st0"
                  points="171.7,324.7 162.6,315.9 150.4,328.4 159.4,337.2 	"
                />
                <polygon
                  class="st0"
                  points="181.8,334.5 172.8,325.8 160.6,338.3 169.6,347 	"
                />
                <polygon
                  class="st0"
                  points="192.1,344.4 183,335.6 170.7,348.1 179.8,357 	"
                />
                <polygon
                  class="st0"
                  points="212.4,364.2 203.4,355.4 191.2,367.9 200.2,376.7 	"
                />
                <polygon
                  class="st0"
                  points="232.8,383.9 224,375.4 211.8,387.9 220.6,396.5 	"
                />
                <path
                  class="st0"
                  d="M205.2,270.1c-3.1-3-6.2-6-9.1-8.8l-39.2,40.1c3,2.9,6,5.8,9.1,8.8L205.2,270.1z"
                />
                <polygon
                  class="st0"
                  points="161.5,314.8 152.4,306 140.2,318.5 149.3,327.3 	"
                />
                <path
                  class="st0"
                  d="M230.2,405.7c2.2,1.9,4.4,3.7,6.6,5.5l10.1-15.9c-3.9-2.6-7.7-5.5-11.3-8.7c0,0-1-0.9-1.7-1.5l-12.3,12.5
            l8.4,8.1H230.2z"
                />
                <path
                  class="st0"
                  d="M402.3,257.4c-2.8,2.9-5.9,6.1-8.9,9.1l41.8,40.5c3-3.1,6-6.1,8.9-9.1L402.3,257.4z"
                />
                <path
                  class="st0"
                  d="M170.7,366.3c-7-6.8-14.2-13.8-21.4-20.7l-11.9,12.1c7.2,6.9,14.4,13.9,21.4,20.7L170.7,366.3z"
                />
                <path
                  class="st0"
                  d="M71.4,270.1l-11.9,12.2c0.1,0.1,3.2,3.1,8.5,8.2l11.9-12.1C74.8,273.3,71.7,270.3,71.4,270.1"
                />
                <path
                  class="st0"
                  d="M227.5,444.9l10.5-13.3c-0.3-0.3-0.6-0.5-0.7-0.7c-0.1-0.1-7.9-7.7-20.1-19.4l-11.9,12.1
            c11.8,11.4,19.5,18.9,20.3,19.7C225.9,443.5,227.2,444.6,227.5,444.9z"
                />
                <path
                  class="st0"
                  d="M175.2,394.3c2.1,2.1,4.2,4.1,6.3,6.1l11.9-12.1c-6.8-6.6-14-13.6-21.4-20.7l-11.9,12.1
            c4.7,4.6,9.4,9.1,13.9,13.4"
                />
                <path
                  class="st0"
                  d="M148,344.3c-7.3-7.1-14.5-14.1-21.5-20.8l-11.9,12.1c6.9,6.7,14.2,13.7,21.5,20.8L148,344.3z"
                />
                <path
                  class="st0"
                  d="M90.7,312.4l11.9-12.1c-8.6-8.4-16-15.5-21.4-20.7l-11.9,12.1C74.7,296.9,82.1,304.1,90.7,312.4"
                />
                <path
                  class="st0"
                  d="M190.3,408.9c5,4.9,9.7,9.4,13.9,13.4l11.9-12.1c-6.2-6-13.5-13.1-21.4-20.7l-11.9,12.1
            c2.1,2.1,4.2,4.1,6.3,6.1"
                />
                <path
                  class="st0"
                  d="M125.3,322.3c-7.6-7.4-14.8-14.4-21.4-20.7L92,313.7c6.6,6.4,13.8,13.4,21.4,20.7L125.3,322.3z"
                />
                <path
                  class="st0"
                  d="M255.6,444.3l-7.5,15.2c2.6,1.4,5.1,2.7,7.8,3.9l6.1-15.8C259.8,446.6,257.7,445.5,255.6,444.3z"
                />
                <path
                  class="st0"
                  d="M238.5,453.5L238.5,453.5c2.6,1.9,5.3,3.5,8.1,5.1l7.5-15.2c-5.1-3-10-6.6-14.6-10.6L229,446.1
            c2.9,2.5,5.8,4.8,8.9,7L238.5,453.5z"
                />
                <polygon
                  class="st1"
                  points="51.1,250.4 71.5,270.2 59.6,282.5 39.1,262.5 	"
                />
                <path
                  class="st0"
                  d="M418,403.5c2-2,4-4.1,6.1-6.2l-12.2-11.8c-7.7,7.9-14.8,15.1-20.8,21.3l12.2,11.8c1.9-2,4-4.1,6.1-6.2l0,0
            l1.2-1.3l0,0c2-2,4-4.1,6.2-6.3"
                />
                <path
                  class="st0"
                  d="M460.9,359.6L460.9,359.6l1.2-1.3l0,0c2-2.1,4.1-4.2,6.1-6.2L456,340.3c-7,7.1-14,14.3-20.8,21.3l12.2,11.8
            C451.9,368.8,456.4,364.2,460.9,359.6z"
                />
                <path
                  class="st0"
                  d="M432.7,388.5c2-2.1,4.1-4.2,6.2-6.3l0,0l1.2-1.3l0,0c2-2.1,4-4.1,6.1-6.2L434,362.8
            c-7.2,7.4-14.2,14.6-20.8,21.3l12.2,11.8c2-2,4-4.1,6.1-6.2"
                />
                <path
                  class="st0"
                  d="M505.1,314.4L505.1,314.4l1.2-1.3l0,0c2.1-2.2,4.2-4.3,6.2-6.3L500.3,295c-6.4,6.5-13.4,13.7-20.8,21.3
            l12.2,11.8C496.3,323.4,500.8,318.8,505.1,314.4z"
                />
                <path
                  class="st0"
                  d="M475.7,344.5L475.7,344.5l1.2-1.3l0,0c2.1-2.1,4.1-4.2,6.1-6.2l0,0l1.2-1.3l0,0c2.1-2.1,4.1-4.2,6.2-6.3
            l-12.2-11.8c-6.8,6.9-13.8,14.1-20.9,21.4l12.2,11.8C471.6,348.7,473.6,346.6,475.7,344.5z"
                />
                <path
                  class="st0"
                  d="M519.8,299.4L519.8,299.4l1.2-1.3l0,0c4.9-5,9.2-9.4,12.8-13.1c0.2-0.3,0.5-0.5,0.7-0.8l-12.2-11.8
            c-5.3,5.4-12.5,12.8-20.8,21.3l12.2,11.8C515.8,303.5,517.8,301.4,519.8,299.4"
                />
                <path
                  class="st0"
                  d="M532.3,262.3c-0.4,0.4-3.5,3.6-8.7,8.9l12.2,11.8c5.4-5.5,8.5-8.7,8.7-8.9L532.3,262.3z"
                />
                <path
                  class="st0"
                  d="M352.6,442.2c-3,1.9-6.1,3.6-9.3,5.1l6.7,15.6c3.6-1.7,7.2-3.6,10.6-5.7L352.6,442.2z"
                />
                <path
                  class="st0"
                  d="M371.4,449.7c2.7-2.1,5.3-4.4,7.9-6.8l-10.9-13.1c-4.4,4.3-9.2,8.1-14.2,11.3l8,15c2.7-1.7,5.3-3.5,7.9-5.5"
                />
                <path
                  class="st0"
                  d="M381.7,440.6c0,0,0.1-0.1,0.3-0.3c0.1-0.1,0.3-0.3,0.5-0.5s0.4-0.4,0.7-0.7c0.2-0.2,0.4-0.4,0.6-0.6
            c0.1-0.2,0.3-0.3,0.5-0.5c0.6-0.6,1.3-1.3,2-2.1c0.3-0.3,0.6-0.7,1-1l0,0l1.2-1.3l0,0c0.7-0.7,1.3-1.4,2.1-2.1
            c0.3-0.3,0.6-0.6,0.9-0.9c1-1,2-2.1,3.1-3.2l0,0l1.2-1.3l0,0c1.6-1.7,3.4-3.5,5.3-5.4c0.3-0.3,0.6-0.6,0.9-0.9L389.9,408
            c-12.3,12.5-20.1,20.6-20.2,20.7l0,0l10.9,13.1C380.9,441.3,381.3,441,381.7,440.6z"
                />
                <polygon
                  class="st1"
                  points="563.7,253.3 544.5,274.2 532.1,262.6 551.2,241.6 	"
                />
                <polygon
                  class="st2"
                  points="77.6,352.9 67,363.8 64.4,361.3 63.9,361.9 87.6,385.4 87.8,385.2 88.4,384.7 86,382.4 96.6,371.5
            99,373.8 106.9,365.6 83,342.2 75,350.4 	"
                />
                <polygon
                  class="st2"
                  points="52.1,328.1 40.8,339.5 62.4,360.5 63,359.9 60.6,357.7 71.3,346.7 73.6,349 81.6,340.8 57.6,317.5
            49.7,325.7 	"
                />
                <polygon
                  class="st2"
                  points="108.4,367 100.4,375.2 103,377.7 92.4,388.6 89.8,386.1 89.2,386.6 89,386.8 112.8,410.4 113.4,409.8
            113.8,409.4 111.4,407.1 122,396.2 124.4,398.5 132.3,390.3 	"
                />
                <path
                  class="st2"
                  d="M46.3,322.3l2.4,2.5l8.2-8l-23.3-24l-13.7,13.3c0,0-5.8,5.9-5.8,6l20.8,21L46.3,322.3z"
                />
                <g class="st3">
                  <polygon
                    class="st4"
                    points="527.8,340.7 538.4,351 556.8,331.9 546.3,321.6 548.7,319.1 540.5,311.2 517.2,335.1 525.4,343.1
            "
                  />
                  <path
                    class="st4"
                    d="M552.5,315.3l10.6,10.1l20.5-21.4c-1.7-1.7-4.7-4.8-4.7-4.8l-13.7-13.3l-23.3,24l8.2,8L552.5,315.3z"
                  />
                  <polygon
                    class="st4"
                    points="507.6,383 496.9,372.5 499.3,369.9 491.1,362 467.8,386 476,393.9 478.3,391.5 489.2,402.1 		"
                  />
                  <polygon
                    class="st4"
                    points="503,366.1 513.8,376.6 532.2,357.4 521.6,347 524,344.5 515.8,336.6 492.5,360.5 500.7,368.5 		"
                  />
                </g>
                <path
                  class="st2"
                  d="M313.7,532.7l-1.9-15.1l3.6-0.5l-1.1-11.3c-7.6,0.9-15.3,1.2-22.9,0.6l-0.8,11.3l3.5,0.3l-1.3,15.2l-3.3-0.3
            l-0.2,2.2c1.2,0,2.5,0.1,3.7,0.1c8.4,0,16.4-0.7,24.1-1.8l-0.1-1.1L313.7,532.7z"
                />
                <path
                  class="st2"
                  d="M340.8,526.5L336,512l3.4-1.1l-3.1-10.8c-6.9,2.3-14,3.9-21.1,4.9l1.1,11.3l3.2-0.4l1.9,15.1l-3.6,0.5l0.1,1
            c9.2-1.5,17.7-3.8,25.6-6.5l-0.1-0.4L340.8,526.5z"
                />
                <path
                  class="st2"
                  d="M428.5,442.2l10.9,10.6l-2.3,2.4l1.2,1.1c6.8-7.1,14.7-15.3,23.2-24.1l-1-1l-2.2,2.3l-10.9-10.6l2.2-2.3
            l-8.2-8l-23.3,24l8.2,8L428.5,442.2z"
                />
                <path
                  class="st2"
                  d="M385.5,485.7l9.6,11.8l-3,2.5l0.4,0.6c10.6-8.1,17.3-15.1,19.7-17.4L411,482l-2.3,2.3l-10.9-10.6l2.3-2.3
            l-8.2-8l-8.2,8.4l0,0c-2.3,2.3-4.7,4.5-7.1,6.6l6.6,9.2L385.5,485.7z"
                />
                <path
                  class="st2"
                  d="M369.5,515.4l-2.4,1.3l-7.4-13.3l3.2-1.8l-4.9-10.2c-6,3.4-12.3,6.2-18.6,8.5l3.1,10.9l3.1-1l4.7,14.5
            l-3.7,1.2l0.1,0.3C354.9,522.8,362.6,519.2,369.5,515.4L369.5,515.4z"
                />
                <path
                  class="st2"
                  d="M404,467.3l10.9,10.6l-2.5,2.6l1.2,1.2c3.7-3.7,12-12.4,23.2-24l-1.2-1.1l-2.5,2.6l-10.9-10.6l2.5-2.6l-8.2-8
            l-23.3,24l8.2,8L404,467.3z"
                />
                <path
                  class="st2"
                  d="M367.4,499.1l7.5,13.3l-3.6,2l0.1,0.1c7.5-4.2,14.1-8.6,19.7-12.8l-0.4-0.6l-2.3,1.9l-9.6-11.8l3-2.5l-6.6-9.2
            c-4.9,4.1-10.1,7.6-15.4,10.8l4.9,10.2L367.4,499.1z"
                />
                <path
                  class="st2"
                  d="M283.9,532.5l1.3-15.2l3.4,0.3l0.8-11.3c-7.6-0.7-15.2-2.1-22.6-4.2l-2.8,11l3.6,1l-4.2,14.6l-3.2-0.9
            l-0.4,1.6c8.7,2.8,17.9,4.9,27.4,5.5l0.2-2.2L283.9,532.5z"
                />
                <polygon
                  class="st2"
                  points="164.1,458.6 161.4,456.1 172,445.2 174.7,447.7 182.6,439.6 158.7,416.2 150.7,424.4 153.2,426.9
            142.6,437.8 140.1,435.3 139.9,435.6 164,458.8 	"
                />
                <path
                  class="st2"
                  d="M232.6,516.9l-3.3-1.7l6.9-13.6l2.7,1.4l4.7-10.4c-6.2-3.4-12.3-7.3-18-11.9l-6.4,9.4l2.9,2.2l-9.1,12.2
            l-2.4-1.8l-0.1,0.2c4.8,3.7,12.4,9.1,21.9,14.4L232.6,516.9z"
                />
                <path
                  class="st2"
                  d="M245.3,493.5l-4.7,10.4l3.4,1.7l-6.9,13.6l-2.8-1.4l-0.2,0.5c7.1,3.8,15.1,7.6,23.8,10.6l0.4-1.6l-3.4-1
            l4.2-14.6l3,0.9l2.8-11C258.2,499.5,251.6,496.8,245.3,493.5"
                />
                <polygon
                  class="st2"
                  points="197.4,469.9 200,472.5 208,464.3 184.1,440.9 176.1,449.1 178.4,451.3 167.8,462.2 165.5,460
            165.4,460.1 186.8,480.8 	"
                />
                <path
                  class="st2"
                  d="M205.9,499.1L215,487l2.6,1.9l6.5-9.5c-1.1-0.9-2.3-1.9-3.4-2.9h-0.2l-11.1-10.8l-8,8.2l2.3,2.2l-10.5,10.8
            L205.9,499.1z"
                />
                <path
                  class="st2"
                  d="M453.4,416.5l10.9,10.6l-2.6,2.7l1,1c7.4-7.7,15.2-15.8,23.1-24.1l-0.9-0.8l-2.4,2.5l-10.9-10.6l2.4-2.5
            l-8.2-8l-23.3,24l8.2,8L453.4,416.5z"
                />
                <polygon
                  class="st2"
                  points="139.1,434.1 136.7,431.8 147.3,420.9 149.7,423.2 157.7,415 133.8,391.7 125.8,399.9 128.4,402.4
            117.8,413.3 115.2,410.8 114.8,411.2 114,412 138.7,434.5 138.9,434.4 	"
                />
                <g class="st3">
                  <path
                    class="st4"
                    d="M289.9,534.9l-1.8,29.7h32l-2.9-32c-7.6,1.2-15.2,2.4-23.6,2.4C292.4,535,291.2,534.9,289.9,534.9z"
                  />
                  <path
                    class="st4"
                    d="M341.9,526.2c-7.3,2.5-14.8,4.6-23.2,6l3.7,32c10-0.8,21-2,30.7-3.8l-9-34.5l-0.1-0.5
            C343.3,525.7,342.6,526,341.9,526.2z"
                  />
                  <path
                    class="st4"
                    d="M413.4,480.9l27.8,31.3l25.3-22.3l-29.6-32.6l-0.4-0.5l0,0l0,0C425.4,468.5,417.1,477.2,413.4,480.9
            L413.4,480.9z"
                  />
                  <path
                    class="st4"
                    d="M252.7,560.8c10.1,1.6,22.2,3.1,32.6,3.5l2.6-29.6c-9.5-0.6-18.7-2.6-27.4-5.5L252.7,560.8z"
                  />
                  <polygon
                    class="st4"
                    points="140.2,435.1 138.8,433.7 135.7,430.9 115,411.8 88.3,436.6 111.6,461.9 140.5,435.5 140.6,435.4
            "
                  />
                  <polygon
                    class="st4"
                    points="166.1,459.9 164.3,458.2 142.1,436.8 142,436.9 112.6,464.1 136.1,487.7 166,460 		"
                  />
                  <path
                    class="st4"
                    d="M216.6,506.7c-1.7-1.2-3.2-2.3-4.5-3.3v0.1l-21.4,34.8c9.1,4.9,19.5,10.1,29.1,14.5l13.5-35.6
            c-0.1-0.1-0.3-0.2-0.4-0.2c-4.5-2.5-8.4-4.9-11.7-7.1C219.4,508.6,217.9,507.6,216.6,506.7z"
                  />
                  <path
                    class="st4"
                    d="M235.1,517.5L235.1,517.5l-0.2,0.5l-13.5,35.2l28.8,7.2l8.4-31.8c-1.5-0.5-3-1.1-4.4-1.7
            c-6.8-2.7-13.1-6.1-18.9-9.3C235.3,517.7,235.2,517.6,235.1,517.5z"
                  />
                  <polygon
                    class="st4"
                    points="191.5,484.6 191.5,484.5 187.5,480.6 187.5,480.6 187.1,480.3 168,461.8 167.3,461.1 167.3,461.1
            167.2,461.2 136.9,489.8 160.4,514.6 191.4,484.7 		"
                  />
                  <path
                    class="st4"
                    d="M206.6,498.9l-0.3-0.3l-11-10.5l-1.4-1.3l-1.2-1.1l0,0l0,0l-0.1,0.1l-1,1.4l-29.9,30l27.1,19.9l21.8-34.5
            c-0.6-0.5-1.3-1.1-1.8-1.6c-0.4-0.4-0.8-0.7-1.1-1c-0.2-0.2-0.4-0.4-0.6-0.5l0,0L206.6,498.9z"
                  />
                  <path
                    class="st4"
                    d="M386.5,504.8C386.5,504.8,386.4,504.8,386.5,504.8c-3.1,2.1-6.9,4.3-11.3,6.9c-1.7,1-3.5,2.1-5.5,3.4l0.1,0.3
            l15.5,36.2c8.9-4.2,19.2-11.2,28.7-16.4L390.3,502l-0.1-0.1C389.1,502.9,387.9,503.8,386.5,504.8z"
                  />
                  <polygon
                    class="st4"
                    points="463,430.3 493.6,460.3 517.3,434.5 485.7,405.8 485.7,405.8 474.6,418.2 		"
                  />
                  <path
                    class="st4"
                    d="M367.6,515.7c-0.1,0.1-0.3,0.1-0.4,0.2c-0.1,0-0.2,0.1-0.2,0.1c-5.5,3-10.7,4.7-16.9,7
            c-1.5,0.5-3,1.1-4.6,1.6l0.2,0.8l9.6,34.5l28.5-8L368,516.4L367.6,515.7z"
                  />
                  <path
                    class="st4"
                    d="M407.7,486.4l-11.8,11.3c-0.5,0.4-1.9,1.5-3.1,2.5c-0.4,0.3-0.8,0.6-1.1,0.9l23.7,33.4l24.5-20.7l-27.4-31
            l-0.4-0.5l0,0l0,0l-1.7,1.7L407.7,486.4z"
                  />
                  <polygon
                    class="st4"
                    points="468.2,488.2 492.8,462.5 461.6,431.7 438.5,455.8 		"
                  />
                </g>
                <path
                  class="st0"
                  d="M183.2,64.5l-20,17.9l25.7,25.2c6.4-6.6,12.8-13.1,18.5-19L183.2,64.5z"
                />
                <path
                  class="st0"
                  d="M162,83.3l-10.6,8.4l-8.1,10.9l26,25.1c5.9-6,12.2-12.5,18.5-19L162,83.3z"
                />
                <path
                  class="st0"
                  d="M106.3,145.4l37.5,22.5l-2.4-11.6c0,0,2.7-2.8,7.2-7.4L123.5,125c-4.6,4.7-9,9.2-9.2,9.4
            c-0.1,0.2-3.3,4.7-7.2,10.2"
                />
                <path
                  class="st0"
                  d="M149.7,147.8c4.8-4.9,11.3-11.6,18.5-19l-27-26l-15.9,21.5"
                />
                <polyline
                  class="st0"
                  points="390,37.4 363.4,64.6 382.7,83.2 410.8,54.4 	"
                />
                <polyline
                  class="st0"
                  points="433.4,74.2 404.2,104.1 423.4,122.8 451.8,93.2 	"
                />
                <polyline
                  class="st0"
                  points="453.9,94.9 424.6,123.9 443.8,142.5 473.5,112.8 	"
                />
                <polygon
                  class="st0"
                  points="412.6,55 383.8,84.3 403.1,103 432.2,73.1 	"
                />
                <path
                  class="st0"
                  d="M234.9,54.3L215,35l-10.1,9.5l23.4,22.8c1.6-1.6,2.5-2.6,2.7-2.7C231.2,63.7,233,59.2,234.9,54.3"
                />
                <path
                  class="st0"
                  d="M203.3,45.2l-6.8,7.7l-12.1,10.6l24.2,24c7.9-8.1,14.6-15,18.5-19L203.3,45.2z"
                />
                <polygon
                  class="st0"
                  points="378.9,28.2 353,54.4 362.3,63.5 388.2,36.6 	"
                />
                <path
                  class="st0"
                  d="M470.7,117.2l-25.8,26.5l11.5,5.2l5.9,6.2l25.6-16.9c-4.3-5.3-8.3-10.4-8.5-10.5c-0.1-0.1-3.8-5.5-8.6-10.2"
                />
                <polygon
                  class="st0"
                  points="135.3,165 121.6,154.2 229.2,47.3 235.3,54.5 231.4,66.5 	"
                />
                <polygon
                  class="st0"
                  points="367.5,40.2 354.6,52.7 462.5,157.4 477.6,147.1 	"
                />
                <polygon
                  class="st0"
                  points="478.1,273.2 490.5,285.2 499.6,275.8 510.6,256.9 510.2,257.5 496.8,249.1 488.5,262.5 	"
                />
                <polygon
                  class="st0"
                  points="101.2,254 87.8,263 100.9,280.5 109.2,288.3 121.4,275.9 110.7,265.7 	"
                />
                <polygon
                  class="st0"
                  points="88.2,231 69.7,236.7 70,239.1 86.9,261.7 100.2,252.8 91.3,241.9 	"
                />
                <polygon
                  class="st0"
                  points="508.3,224.7 525.4,231.3 525.1,231.8 526.6,229.4 526.7,228.2 521.3,192.9 521.3,192.9 511.9,192.9
            510.6,210.5 	"
                />
                <polygon
                  class="st0"
                  points="504.2,237.2 497.7,247.8 511,256.2 525.5,231.2 508.4,224.6 	"
                />
                <polyline
                  class="st0"
                  points="69.7,236.8 88.3,231.2 84.3,213.5 84.7,197.4 74.3,197.8 	"
                />
                <path
                  class="st0"
                  d="M124.8,270.1l43.6-44.6c-2.8-2.7-7.6-7.1-10.9-10.3l-51.7,34.5c4.5,5.5,8.8,10.8,8.9,10.9
            c0.5,0.4,3.9,3.8,9.4,9.1"
                />
                <path
                  class="st0"
                  d="M491.4,244.9l-55.5-34.8c-3,3-9.5,9.7-10.7,11l48.4,46.9c6.1-6.2,9.9-10.1,9.9-10.2
            C483.6,257.5,487.6,251,491.4,244.9"
                />
                <path
                  class="st0"
                  d="M89.8,212.9c0.1,0.4,2.2,7,4.2,13.3l56.9-24.4l-0.9-4.4l-60.4,0.8c0.1,7.2,0.4,14.3,0.4,14.8"
                />
                <path
                  class="st0"
                  d="M104.8,248.4l51.6-34.3c-2.2-2.1-3.7-3.6-3.7-3.6l-1.5-7.1l-57.2,24c1.6,5.2,2.5,10.1,2.6,10.5
            C97,238.3,100.7,243.3,104.8,248.4"
                />
                <path
                  class="st0"
                  d="M90.2,197.4l59.5-1.6l-0.9-4.5L94,170.1c-1.9,6.4-3.8,12.5-3.9,12.9c0,0.4-0.3,6.3-0.2,13.4"
                />
                <path
                  class="st0"
                  d="M94.5,169l53.8,20.4l-4-19.3l-38.4-24.3c-3.7,5.1-7.2,9.9-7.4,10.3c-0.1,0.5-2,6.2-3.9,12.5"
                />
                <path
                  class="st0"
                  d="M506.4,192.2l-54.3,0.7l-8.8,0.1c0,1.8,0.2,3.8-0.1,5.6l59.2,23c2-6.2,4.1-12.6,4.3-13.1
            C506.7,207.9,506.6,199.8,506.4,192.2"
                />
                <path
                  class="st0"
                  d="M463.4,173l36.5-15.2c-1.3-4.1-2.2-7.3-2.3-7.6c-0.4-0.4-4.4-5.5-8.6-10.7"
                />
                <path
                  class="st0"
                  d="M500.4,159.3l-45.5,19v-0.1l-13.1,5.4c0.5,2.2,0.9,4.9,1,7.7l63.6-0.9c-0.1-6.3-0.2-11.9-0.2-12.3
            C506.1,177.8,502.9,167.3,500.4,159.3"
                />
                <path
                  class="st0"
                  d="M492.3,243.5c3.1-5,5.9-9.6,6.1-9.8c0.1-0.3,1.7-5.2,3.5-10.6l-48.6-18.8v-0.1l-11.2-4.3
            c-0.8,3.1-2.3,6.1-4.7,8.6c0,0-0.1,0.1-0.3,0.3l6.9,4.3l0,0L492.3,243.5z"
                />
                <polyline
                  class="st0"
                  points="489,139.4 460.2,158.5 463.4,173 	"
                />
                <polygon
                  class="st0"
                  points="134.5,164 127,159.2 124.9,162.3 119.9,173.3 116.9,182.5 115.1,191.8 115.9,201.5 118.3,211.3
            119.9,215 138.3,207.2 137.3,203.8 137.2,192.2 131.2,167.4 	"
                />
                <polygon
                  class="st0"
                  points="73.9,84.2 88.2,93.1 98.6,78.6 85.6,68 	"
                />
                <polygon
                  class="st0"
                  points="118.9,33.9 130.4,46.1 144.9,34.1 134.9,20.5 	"
                />
                <polygon
                  class="st0"
                  points="90.2,69.5 99.9,77.3 129.1,47.4 120.6,38.4 	"
                />
                <polygon
                  class="st0"
                  points="39.1,192.7 51.1,195.6 61,150.9 49.3,147 	"
                />
                <polygon
                  class="st0"
                  points="57.1,125.8 68.3,131.1 87.3,94.6 76.8,88 	"
                />
                <polygon
                  class="st0"
                  points="44.7,143.7 60.7,148.9 67.5,132.7 52.3,125.6 	"
                />
                <polygon
                  class="st0"
                  points="139,23.1 146.3,33 170,18.6 163.3,8.2 	"
                />
                <polygon
                  class="st0"
                  points="176.8,0 164.9,7.2 171.5,17.6 183.3,10.4 	"
                />
                <path
                  class="st0"
                  d="M254.1,344.7l-3.3,3.4c3.4,3.3,6.4,6.2,8.8,8.5l3.3-3.4C260.5,350.9,257.5,348,254.1,344.7"
                />
                <path
                  class="st0"
                  d="M243.6,334.6l-3.6,3.6c3.3,3.2,6.5,6.3,9.3,9l3.6-3.6C250.1,340.9,247,337.8,243.6,334.6"
                />
                <path
                  class="st0"
                  d="M270.7,360.5C270.7,360.5,270.6,360.5,270.7,360.5l-3,4.2c2.9,2.5,6.1,4.5,9.5,6.1l2.2-4.6
            C276.2,364.7,273.3,362.8,270.7,360.5"
                />
                <path
                  class="st0"
                  d="M264,354.4l-3.5,3.6c3.3,3.2,5.5,5.3,6.1,5.9c0,0,0.1,0.1,0.2,0.1l2.9-4.1C268.8,359,266.9,357.1,264,354.4"
                />
                <path
                  class="st0"
                  d="M242.5,333.5c-2.9-2.8-5.9-5.7-9.1-8.8l-3.6,3.7c3.1,3,6.2,6,9.1,8.8L242.5,333.5z"
                />
                <path
                  class="st0"
                  d="M213,304.9l-3.6,3.6c3.1,3,6.1,5.9,9.1,8.8l3.6-3.6C219.1,310.8,216.1,307.9,213,304.9"
                />
                <path
                  class="st0"
                  d="M232.3,323.6c-2.9-2.9-6-5.8-9.1-8.8l-3.5,3.6c3.1,3,6.1,5.9,9.1,8.8L232.3,323.6z"
                />
                <path
                  class="st0"
                  d="M311.4,370.3c0.4,1.7,0.8,3.4,1.1,5.2c4.6-1.1,9-2.7,13.3-4.8c-0.7-1.6-1.4-3.3-2.1-4.9
            C319.8,367.8,315.6,369.3,311.4,370.3"
                />
                <path
                  class="st0"
                  d="M333.1,359L333.1,359c-0.6,0.5-1.1,1-1.7,1.5l2.9,3.9c0.8-0.7,1.5-1.3,2.2-2l-0.4,0.4c0,0,2-2.1,5.6-5.7
            l-3.5-3.4C335,357,333.2,358.9,333.1,359"
                />
                <path
                  class="st0"
                  d="M339.3,352.6l3.6,3.5c2.3-2.4,5.1-5.2,8.3-8.5l-3.6-3.5C344.4,347.4,341.6,350.3,339.3,352.6"
                />
                <path
                  class="st0"
                  d="M357.5,334c-3.1,3.2-6.1,6.2-8.7,9l3.6,3.5c2.7-2.7,5.6-5.7,8.8-8.9L357.5,334z"
                />
                <path
                  class="st0"
                  d="M288.8,370.6l-1.2,4.5c4.1,0.6,8.3,0.7,12.6,0.3l0.4-4.4C296.5,371.3,292.6,371.2,288.8,370.6"
                />
                <path
                  class="st0"
                  d="M202.8,295.1l-3.6,3.7c3,2.9,6,5.9,9,8.8l3.6-3.7C208.9,300.9,205.9,298,202.8,295.1"
                />
                <path
                  class="st0"
                  d="M279.3,366.8c-0.6,1.4-1.2,2.9-1.8,4.4c3.6,1.8,7.4,3.2,11.2,4.1l0.9-4.6C286.1,369.8,282.6,368.5,279.3,366.8
            "
                />
                <path
                  class="st0"
                  d="M301.3,371.8c0.1,1.4,0.2,2.8,0.3,4.2c3.6,0.2,7.3,0,10.8-0.6l-1.1-4.1C308.1,371.8,304.7,371.9,301.3,371.8"
                />
                <path
                  class="st0"
                  d="M321.5,366.7l2.4,4.8c3.7-1.7,7.1-3.9,10.3-6.4l-3.2-4.5C328.1,363,324.9,365.1,321.5,366.7"
                />
                <path
                  class="st0"
                  d="M388.7,302.1l3.6,3.5c3-3.1,6-6.1,9-9.2l-3.7-3.5C394.7,296,391.7,299,388.7,302.1"
                />
                <path
                  class="st0"
                  d="M381.2,317l-3.7-3.5c-3.1,3.1-6.1,6.2-9,9.2l3.7,3.5C375.2,323.2,378.2,320.2,381.2,317"
                />
                <path
                  class="st0"
                  d="M371.1,327.3l-3.6-3.5c-3.1,3.2-6.1,6.2-8.9,9.1l3.6,3.5C365,333.5,368,330.4,371.1,327.3"
                />
                <path
                  class="st0"
                  d="M391.3,306.8l-3.7-3.5c-3,3.1-6,6.1-8.9,9.1l3.7,3.5C385.3,312.9,388.3,309.9,391.3,306.8"
                />
                <path
                  class="st0"
                  d="M367.4,323.7l-9.5-9.2c-3.1,3.2-6.1,6.2-8.9,9.1l9.5,9.2C361.4,329.9,364.4,326.9,367.4,323.7"
                />
                <path
                  class="st0"
                  d="M321.1,334.9l18.2,17.6c2.3-2.3,5.1-5.2,8.3-8.5l-18.2-17.6C326.2,329.7,323.4,332.6,321.1,334.9"
                />
                <path
                  class="st0"
                  d="M271.3,327.1l-17.1,17.5c3.4,3.3,6.4,6.2,8.8,8.5l17.1-17.5C277.6,333.3,274.7,330.4,271.3,327.1"
                />
                <path
                  class="st0"
                  d="M251.8,323.9c-2.9-2.8-5.9-5.7-9.1-8.8l-9.3,9.5c3.1,3,6.2,6,9.1,8.8L251.8,323.9z"
                />
                <path
                  class="st0"
                  d="M252.9,325l-9.3,9.5c3.3,3.2,6.5,6.3,9.3,9l9.3-9.5C259.4,331.3,256.3,328.2,252.9,325"
                />
                <path
                  class="st0"
                  d="M222.4,295.4l-9.3,9.5c3.1,3,6.1,5.9,9.1,8.8l9.3-9.5C228.5,301.3,225.4,298.3,222.4,295.4"
                />
                <path
                  class="st0"
                  d="M220.7,276.8L202.9,295c3,2.9,6,5.8,9,8.8l17.8-18.2C226.7,282.6,223.7,279.7,220.7,276.8"
                />
                <path
                  class="st0"
                  d="M232.6,305.3l-9.3,9.5c3.1,3,6.1,5.9,9,8.8l9.3-9.5C238.7,311.2,235.7,308.3,232.6,305.3"
                />
                <path
                  class="st0"
                  d="M377.5,313.4l-9.5-9.2c-3,3.1-6,6.2-8.9,9.2l9.5,9.2C371.5,319.6,374.4,316.5,377.5,313.4"
                />
                <path
                  class="st0"
                  d="M347.9,324.7c-3.1,3.2-6.1,6.2-8.7,8.9l9.5,9.2c2.7-2.7,5.6-5.7,8.7-8.9L347.9,324.7z"
                />
                <path
                  class="st0"
                  d="M323.9,349.3l7.5,11.2c0.6-0.5,1.1-1,1.6-1.6l0,0c0.1-0.1,2-2,5.1-5.2l-9.5-9.2
            C326.2,346.9,324.6,348.6,323.9,349.3"
                />
                <path
                  class="st0"
                  d="M379.1,272.6l9.5,9.2c3-3.1,6-6.2,9-9.2l-9.5-9.2C385.1,266.5,382.1,269.5,379.1,272.6"
                />
                <path
                  class="st0"
                  d="M370.5,284.4l18.2,17.6c3-3.1,6-6.1,9-9.2l-18.2-17.6C376.5,278.3,373.5,281.3,370.5,284.4"
                />
                <path
                  class="st0"
                  d="M389.2,262.5l8.3,8.2c3-3.1,6-6.2,8.9-9.1l-8.3-8.2C395.3,256.3,392.3,259.4,389.2,262.5"
                />
                <path
                  class="st0"
                  d="M399.3,252.3l8.3,8.2c3.1-3.2,6.1-6.3,9-9.2l-8.3-8.2C405.4,246,402.4,249.1,399.3,252.3"
                />
                <path
                  class="st0"
                  d="M369.1,303l9.5,9.2c2.9-3,5.9-6,8.9-9.1l-9.5-9.2C375,297,372,300,369.1,303"
                />
                <path
                  class="st0"
                  d="M301.6,358.9c0.1,4,0.1,8.6,0.2,13.2c3.1-0.1,6.1-0.4,9.1-1.1l-2.7-13C306,358.6,303.8,358.9,301.6,358.9"
                />
                <path
                  class="st0"
                  d="M273.3,344.8l-9.3,9.5c2.8,2.7,4.7,4.6,5.5,5.3l7.2-11.4C275.9,347.2,274.7,346.1,273.3,344.8"
                />
                <path
                  class="st0"
                  d="M309.7,357.7c0.8,3.9,1.8,8.4,2.7,13c3-0.8,6-1.9,8.8-3.3c-1.8-4.3-3.6-8.5-5.2-12.2
            C314,356.3,311.9,357.1,309.7,357.7"
                />
                <path
                  class="st0"
                  d="M284.7,354.6c-1.5,3.7-3.1,8-4.9,12.5c2.8,1.5,5.7,2.6,8.6,3.4l2.4-13.1C288.8,356.6,286.7,355.7,284.7,354.6"
                />
                <path
                  class="st0"
                  d="M210.7,266.8l-9.3,9.5c3,2.9,6,5.8,9.1,8.8l9.3-9.5C216.7,272.6,213.6,269.7,210.7,266.8"
                />
                <path
                  class="st0"
                  d="M200.5,256.9l-8.2,8.7c2.9,2.8,6,5.8,9,8.8l8.2-8.7C206.4,262.7,203.4,259.7,200.5,256.9"
                />
                <path
                  class="st0"
                  d="M190.3,247l-8.2,8.5c2.9,2.8,5.9,5.7,9.1,8.8l8.2-8.5C196.2,252.7,193.2,249.8,190.3,247"
                />
                <path
                  class="st0"
                  d="M317.5,354.4l5.2,12.3c2.6-1.4,5.2-3.2,7.5-5.2l-7.5-11.1C321.1,351.9,319.3,353.2,317.5,354.4"
                />
                <path
                  class="st0"
                  d="M279.6,350.8c0,0-0.4-0.4-0.7-0.6c0,0-0.4-0.4-1.1-1l-7.2,11.4h0.1c2.4,2.2,5,4,7.7,5.6l4.9-12.5
            C282.1,352.9,280.8,351.9,279.6,350.8"
                />
                <path
                  class="st0"
                  d="M292.4,357.8l-2.4,13.1c3.3,0.8,6.7,1.3,10.2,1.3L300,359C297.5,358.9,294.9,358.5,292.4,357.8"
                />
                <path
                  class="st0"
                  d="M376.1,401.5L376.1,401.5l5.6-5.7l-12.4-12.1c-4.5,4.3-9.4,8.1-14.5,11.4l10.6,15.8
            C369,408.1,372.7,404.9,376.1,401.5"
                />
                <polygon
                  class="st0"
                  points="353.3,396 343,401.8 354.3,418.4 364,411.9 	"
                />
                <polygon
                  class="st0"
                  points="462.3,313.3 471.2,304.2 458.8,292.1 449.9,301.3 	"
                />
                <polygon
                  class="st0"
                  points="461.1,314.5 448.6,302.4 370.1,382.7 382.7,394.8 	"
                />
                <polygon
                  class="st5"
                  id="hotSauce"
                  points="355.5,190.2 119.8,118.9 103.9,103 200,10 	"
                />
                <path
                  class="st6"
                  d="M50.9,248.2L37,262.7l74.9,72.3l109.3,105.8c0,0,18.8,18,35.3,24.3l6.9-17.7c0,0-9.2-3.8-25.2-16.9L50.9,248.2
            z"
                />
                <path
                  class="st6"
                  d="M550.6,240.1l14.6,13.8L380,443.9c0,0-12.3,11.6-29.9,20.4l-1.2,0.5l-7.7-18.1c0,0,11.9-4.6,26.5-18.7
            C382.4,413.9,550.6,240.1,550.6,240.1"
                />
              </g>
              <g id="party-deck">
                <polygon
                  class="st7"
                  points="73.9,84.2 88.1,93.1 98.5,78.6 85.5,68 	"
                />
                <polygon
                  class="st7"
                  points="118.8,33.9 130.3,46.1 144.7,34.1 134.8,20.5 	"
                />
                <polygon
                  class="st7"
                  points="90.1,69.5 99.8,77.3 129,47.4 120.5,38.4 	"
                />
                <polygon
                  class="st7"
                  points="39.1,192.7 51,195.6 61,150.9 49.2,147 	"
                />
                <polygon
                  class="st7"
                  points="57.1,125.8 68.3,131.1 87.2,94.6 76.7,88 	"
                />
                <polygon
                  class="st7"
                  points="44.7,143.7 60.7,148.9 67.5,132.7 52.3,125.6 	"
                />
                <polygon
                  class="st7"
                  points="138.9,23.1 146.2,33 169.8,18.6 163.2,8.2 	"
                />
                <polygon
                  class="st7"
                  points="176.6,0 164.7,7.2 171.3,17.6 183.2,10.4 	"
                />
              </g>
              <g id="press-level">
                <path
                  class="st8"
                  d="M170.5,366.3c-7-6.8-14.2-13.8-21.4-20.7l-11.9,12.1c7.1,6.9,14.3,13.9,21.4,20.7L170.5,366.3z"
                />
                <path
                  class="st8"
                  d="M71.4,270.1l-11.8,12.2c0.1,0.1,3.2,3.1,8.5,8.2L80,278.4C74.7,273.3,71.6,270.3,71.4,270.1"
                />
                <path
                  class="st8"
                  d="M227.3,444.9l10.5-13.3c-0.3-0.3-0.6-0.5-0.7-0.7c-0.1-0.1-7.9-7.7-20-19.4l-11.9,12.1
            c11.7,11.4,19.5,18.9,20.3,19.7C225.7,443.5,227,444.6,227.3,444.9"
                />
                <path
                  class="st8"
                  d="M175,394.3c2.1,2.1,4.2,4.1,6.3,6.1l11.8-12.1c-6.8-6.6-14-13.6-21.4-20.7l-11.9,12.1
            c4.7,4.6,9.4,9.1,13.9,13.4"
                />
                <path
                  class="st8"
                  d="M147.9,344.3c-7.3-7.1-14.5-14.1-21.4-20.8l-11.8,12.1c6.9,6.7,14.1,13.7,21.4,20.8L147.9,344.3z"
                />
                <path
                  class="st8"
                  d="M90.7,312.4l11.8-12.1c-8.6-8.4-16-15.5-21.4-20.7l-11.9,12.1C74.7,296.9,82.1,304.1,90.7,312.4"
                />
                <path
                  class="st8"
                  d="M190.1,408.9c5,4.9,9.7,9.4,13.9,13.4l11.9-12.1c-6.2-6-13.5-13.1-21.4-20.7l-11.9,12.1
            c2.1,2.1,4.2,4.1,6.3,6.1"
                />
                <path
                  class="st8"
                  d="M125.2,322.3c-7.6-7.4-14.8-14.4-21.4-20.7l-11.9,12.1c6.5,6.4,13.8,13.4,21.4,20.7L125.2,322.3z"
                />
                <polygon
                  class="st9"
                  points="51.1,250.4 71.5,270.2 59.6,282.5 39.1,262.5 	"
                />
                <path
                  class="st8"
                  d="M417.6,403.5c2-2,4-4.1,6.1-6.2l-12.2-11.8c-7.7,7.9-14.7,15.1-20.8,21.3l12.2,11.8c1.9-2,4-4.1,6.1-6.2l0,0
            l1.2-1.3l0,0c2-2,4-4.1,6.2-6.3"
                />
                <path
                  class="st8"
                  d="M460.4,359.6L460.4,359.6l1.2-1.3l0,0c2-2.1,4.1-4.2,6.1-6.2l-12.2-11.8c-7,7.1-14,14.3-20.8,21.3l12.2,11.8
            C451.4,368.8,455.9,364.2,460.4,359.6"
                />
                <path
                  class="st8"
                  d="M432.2,388.5c2-2.1,4.1-4.2,6.2-6.3l0,0l1.2-1.3l0,0c2-2.1,4-4.1,6.1-6.2l-12.2-11.8
            c-7.2,7.4-14.2,14.6-20.8,21.3l12.2,11.8c2-2,4-4.1,6.1-6.2"
                />
                <path
                  class="st8"
                  d="M504.5,314.4L504.5,314.4l1.2-1.3l0,0c2.1-2.2,4.2-4.3,6.2-6.3L499.7,295c-6.4,6.5-13.4,13.7-20.8,21.3
            l12.2,11.8C495.7,323.4,500.2,318.8,504.5,314.4"
                />
                <path
                  class="st8"
                  d="M475.1,344.5L475.1,344.5l1.2-1.3l0,0c2-2.1,4.1-4.2,6.1-6.2l0,0l1.2-1.3l0,0c2.1-2.1,4.1-4.2,6.2-6.3
            l-12.2-11.8c-6.7,6.9-13.8,14.1-20.9,21.4l12.2,11.8C471,348.7,473.1,346.6,475.1,344.5"
                />
                <path
                  class="st8"
                  d="M519.2,299.4L519.2,299.4l1.2-1.3l0,0c4.9-5,9.2-9.4,12.8-13.1c0.2-0.3,0.5-0.5,0.7-0.8l-12.2-11.8
            c-5.3,5.4-12.5,12.8-20.8,21.3l12.2,11.8C515.2,303.5,517.3,301.4,519.2,299.4"
                />
                <path
                  class="st8"
                  d="M531.7,262.3c-0.4,0.4-3.5,3.6-8.7,8.9l12.2,11.8c5.3-5.5,8.5-8.7,8.7-8.9L531.7,262.3z"
                />
                <path
                  class="st8"
                  d="M381.3,440.6c0,0,0.1-0.1,0.3-0.3c0.1-0.1,0.3-0.3,0.5-0.5s0.4-0.4,0.7-0.7c0.2-0.2,0.4-0.4,0.6-0.6
            c0.1-0.2,0.3-0.3,0.5-0.5c0.6-0.6,1.3-1.3,2-2.1c0.3-0.3,0.6-0.7,1-1l0,0l1.2-1.3l0,0c0.7-0.7,1.3-1.4,2.1-2.1
            c0.3-0.3,0.6-0.6,0.9-0.9c1-1,2-2.1,3.1-3.2l0,0l1.2-1.3l0,0c1.6-1.7,3.4-3.5,5.2-5.4c0.3-0.3,0.6-0.6,0.9-0.9L389.4,408
            c-12.2,12.5-20.1,20.6-20.2,20.7l0,0l10.9,13.1C380.5,441.3,380.9,441,381.3,440.6"
                />
                <polygon
                  class="st9"
                  points="563.1,253.3 543.8,274.2 531.5,262.6 550.6,241.6 	"
                />
              </g>
              <g id="preferred-level">
                <path
                  class="st8"
                  d="M255.3,444.3l-7.5,15.2c2.6,1.4,5.1,2.7,7.8,3.9l6.1-15.8C259.6,446.6,257.4,445.5,255.3,444.3"
                />
                <path
                  class="st8"
                  d="M238.2,453.5L238.2,453.5c2.6,1.9,5.3,3.5,8.1,5.1l7.5-15.2c-5.1-3-10-6.6-14.6-10.6l-10.5,13.3
            c2.9,2.5,5.8,4.8,8.8,7L238.2,453.5z"
                />
                <path
                  class="st8"
                  d="M352.2,442.2c-3,1.9-6.1,3.6-9.3,5.1l6.6,15.6c3.6-1.7,7.2-3.6,10.6-5.7L352.2,442.2z"
                />
                <path
                  class="st8"
                  d="M371,449.7c2.7-2.1,5.3-4.4,7.9-6.8L368,429.8c-4.4,4.3-9.2,8.1-14.2,11.3l7.9,15c2.7-1.7,5.3-3.5,7.9-5.5"
                />
              </g>
              <g id="lower-reserved">
                <polygon
                  class="st10"
                  points="477.6,273.2 489.9,285.2 499.1,275.8 510,256.9 509.7,257.5 496.3,249.1 488,262.5 	"
                />
                <polygon
                  class="st10"
                  points="101.1,254 87.8,263 100.8,280.5 109.1,288.3 121.3,275.9 110.6,265.7 	"
                />
                <polygon
                  class="st10"
                  points="88.1,231 69.7,236.7 69.9,239.1 86.8,261.7 100.1,252.8 91.3,241.9 	"
                />
                <polygon
                  class="st10"
                  points="507.7,224.7 524.8,231.3 524.5,231.8 526,229.4 526.1,228.2 520.7,192.9 511.3,192.9 510,210.5 	"
                />
                <polygon
                  class="st10"
                  points="503.6,237.3 497.1,247.8 510.5,256.2 524.9,231.2 507.8,224.6 	"
                />
                <polyline
                  class="st10"
                  points="69.7,236.8 88.2,231.2 84.3,213.5 84.6,197.4 74.2,197.8 	"
                />
                <path
                  class="st10"
                  d="M124.7,270.1l43.6-44.6c-2.8-2.7-7.6-7.1-10.9-10.3l-51.7,34.5c4.4,5.5,8.8,10.8,8.9,10.9
            c0.5,0.4,3.9,3.8,9.4,9.1"
                />
                <path
                  class="st10"
                  d="M490.9,244.9l-55.5-34.8c-3,3-9.5,9.7-10.7,11L473,268c6.1-6.2,9.8-10.1,9.9-10.2
            C483.1,257.5,487.1,251,490.9,244.9"
                />
                <path
                  class="st10"
                  d="M89.7,212.9c0.1,0.4,2.2,7,4.2,13.3l56.8-24.4l-0.9-4.4l-60.3,0.8c0.1,7.2,0.4,14.3,0.4,14.8"
                />
                <path
                  class="st10"
                  d="M183,64.5l-19.9,17.9l25.7,25.2c6.4-6.6,12.8-13.1,18.5-19L183,64.5z"
                />
                <path
                  class="st10"
                  d="M104.8,248.4l51.5-34.3c-2.2-2.1-3.7-3.6-3.7-3.6l-1.5-7.1l-57.1,24c1.6,5.2,2.5,10.1,2.6,10.5
            C96.9,238.3,100.6,243.3,104.8,248.4"
                />
                <path
                  class="st10"
                  d="M161.8,83.3l-10.5,8.4l-8.1,10.9l26,25.1c5.9-6,12.2-12.5,18.5-19L161.8,83.3z"
                />
                <path
                  class="st10"
                  d="M90.1,197.4l59.4-1.6l-0.9-4.5l-54.7-21.2c-1.9,6.4-3.8,12.5-3.9,12.9c0,0.4-0.3,6.3-0.2,13.4"
                />
                <path
                  class="st10"
                  d="M94.5,169l53.7,20.4l-4-19.3l-38.4-24.3c-3.7,5.1-7.2,9.9-7.4,10.3c-0.1,0.5-2,6.2-3.9,12.5"
                />
                <path
                  class="st10"
                  d="M106.2,145.4l37.5,22.5l-2.4-11.6c0,0,2.7-2.8,7.2-7.4L123.4,125c-4.6,4.7-9,9.2-9.2,9.4
            c-0.1,0.2-3.3,4.7-7.2,10.2"
                />
                <path
                  class="st10"
                  d="M122.7,121.8l26.8,26.1c4.8-4.9,11.3-11.6,18.5-19l-26.9-26l-15.9,21.5l-7.1-7.1"
                />
                <polyline
                  class="st10"
                  points="389.6,37.4 363.1,64.6 382.3,83.2 410.4,54.4 	"
                />
                <polyline
                  class="st10"
                  points="433,74.2 403.7,104.1 423,122.8 451.3,93.2 	"
                />
                <polyline
                  class="st10"
                  points="453.3,94.9 424.1,123.9 443.3,142.5 473,112.8 	"
                />
                <polygon
                  class="st10"
                  points="412.1,55 383.4,84.3 402.6,103 431.7,73.1 	"
                />
                <path
                  class="st10"
                  d="M234.7,54.3l-20-19.3l-10.1,9.5L228,67.3c1.6-1.6,2.5-2.6,2.7-2.7C231,63.7,232.7,59.2,234.7,54.3"
                />
                <path
                  class="st10"
                  d="M203.1,45.2l-6.8,7.7l-12.1,10.6l24.1,24c7.9-8.1,14.6-15,18.5-19L203.1,45.2z"
                />
                <polygon
                  class="st10"
                  points="378.4,28.2 352.6,54.4 361.9,63.5 387.8,36.6 	"
                />
                <path
                  class="st10"
                  d="M505.9,192.2l-54.2,0.7l-8.8,0.1c0,1.8,0.2,3.8-0.1,5.6l59.1,23c2-6.2,4.1-12.6,4.3-13.1
            C506.1,207.9,506,199.8,505.9,192.2"
                />
                <path
                  class="st10"
                  d="M470.2,117.2l-25.7,26.5l11.5,5.2l5.9,6.2l25.6-16.9c-4.2-5.3-8.3-10.4-8.4-10.5s-3.8-5.5-8.6-10.2"
                />
                <path
                  class="st10"
                  d="M462.9,173l36.5-15.2c-1.3-4.1-2.2-7.3-2.3-7.6c-0.4-0.4-4.4-5.5-8.6-10.7"
                />
                <path
                  class="st10"
                  d="M499.9,159.3l-45.4,19v-0.1l-13.1,5.4c0.5,2.2,0.9,4.9,1,7.7l63.5-0.9c-0.1-6.3-0.2-11.9-0.2-12.3
            C505.5,177.8,502.3,167.3,499.9,159.3"
                />
                <path
                  class="st10"
                  d="M491.7,243.5c3.1-5,5.9-9.6,6.1-9.8c0.1-0.3,1.7-5.2,3.5-10.6l-48.6-18.8v-0.1l-11.2-4.3
            c-0.8,3.1-2.3,6.1-4.7,8.6c0,0-0.1,0.1-0.3,0.3l6.9,4.3l0,0L491.7,243.5z"
                />
                <polyline
                  class="st10"
                  points="488.5,139.4 459.7,158.5 462.9,173 	"
                />
                <polygon
                  class="st10"
                  points="135.2,165 121.5,154.2 229,47.3 235.1,54.5 231.1,66.5 	"
                />
                <polygon
                  class="st10"
                  points="367.1,40.2 354.3,52.7 462,157.4 477,147.1 	"
                />
                <polygon
                  class="st10"
                  points="134.4,164 126.8,159.2 124.7,162.3 119.8,173.3 116.8,182.5 115,191.8 115.8,201.5 118.2,211.3
            119.8,215 138.2,207.2 137.1,203.8 137,192.2 131.1,167.4 	"
                />
              </g>
              <g id="lower-box">
                <polygon
                  class="st5"
                  points="109.5,288.9 129.5,308.3 141.7,295.8 121.7,276.4 	"
                />
                <polygon
                  class="st5"
                  points="471.8,303.8 488.8,286.3 476.5,274.3 459.4,291.7 	"
                />
                <path
                  class="st5"
                  d="M194.8,260.2c-5.2-5-9-8.7-9-8.7l0,0l-39.2,40.1c2.9,2.8,5.9,5.8,9,8.8L194.8,260.2z"
                />
                <polygon
                  class="st5"
                  points="129.9,308.7 138.9,317.4 151.2,304.9 142.1,296.2 	"
                />
                <path
                  class="st5"
                  d="M185.8,250.9c-3.1-4.9-13.5-21-14.1-21.9c-0.2-0.2-0.8-0.8-1.8-1.7l-43.6,44.6c5.3,5.1,12.2,11.8,20,19.4
            L185.8,250.9z"
                />
                <path
                  class="st5"
                  d="M411.9,247.1c-1.9,2-5.2,5.3-8.9,9.2l41.8,40.5c3.1-3.2,6.1-6.2,8.9-9.2L411.9,247.1z"
                />
                <path
                  class="st5"
                  d="M423.9,223c-2.2,5-10.1,22.5-10.1,22.5s-0.3,0.3-0.8,0.8l41.8,40.2c6.6-6.7,12.4-12.6,17.1-17.3L423.9,223z"
                />
                <polygon
                  class="st5"
                  points="202.1,354.3 193,345.5 180.8,358.1 189.8,366.8 	"
                />
                <polygon
                  class="st5"
                  points="222.6,374.3 213.4,365.3 201.1,377.8 210.4,386.8 	"
                />
                <polygon
                  class="st5"
                  points="171.5,324.7 162.5,315.9 150.2,328.4 159.3,337.2 	"
                />
                <path
                  class="st5"
                  d="M215.1,280c-2.6-2.5-5.8-5.6-9-8.8l-39.2,40.1c3,2.9,6,5.8,9,8.8L215.1,280z"
                />
                <polygon
                  class="st5"
                  points="181.7,334.5 172.6,325.8 160.4,338.3 169.4,347 	"
                />
                <polygon
                  class="st5"
                  points="191.9,344.4 182.8,335.6 170.6,348.1 179.7,357 	"
                />
                <polygon
                  class="st5"
                  points="212.2,364.2 203.2,355.4 191,367.9 200,376.7 	"
                />
                <polygon
                  class="st5"
                  points="232.6,383.9 223.8,375.4 211.6,387.9 220.3,396.5 	"
                />
                <path
                  class="st5"
                  d="M205,270.1c-3.1-3-6.2-6-9-8.8l-39.2,40.1c3,2.9,6,5.8,9,8.8L205,270.1z"
                />
                <polygon
                  class="st5"
                  points="161.3,314.8 152.3,306 140.1,318.5 149.1,327.3 	"
                />
                <path
                  class="st5"
                  d="M230,405.7c2.2,1.9,4.4,3.7,6.6,5.5l10.1-15.9c-3.9-2.6-7.7-5.5-11.3-8.7c0,0-1-0.9-1.7-1.5l-12.2,12.5
            L230,405.7L230,405.7z"
                />
                <path
                  class="st5"
                  d="M401.9,257.4c-2.8,2.9-5.9,6.1-8.9,9.1l41.8,40.5c3-3.1,6-6.1,8.9-9.1L401.9,257.4z"
                />
                <path
                  class="st5"
                  d="M433.6,308.2l-41.8-40.5c-3.3,3.4-6.4,6.6-8.9,9.2l41.8,40.5C427.7,314.3,430.7,311.2,433.6,308.2"
                />
                <g>
                  <path
                    class="st5"
                    d="M253.8,344.7c3.4,3.3,6.3,6.2,8.8,8.5l12-12.3c-1.5-1.6-2.8-3.3-4-5.2c-2.2,0-5.8,0.1-8.2,0.1L253.8,344.7
            L253.8,344.7z"
                  />
                  <path
                    class="st5"
                    d="M250.4,348.1l-22.2,22.7c4.5,4.3,7.6,7.4,8.8,8.5l22.2-22.7C256.8,354.3,253.7,351.3,250.4,348.1z"
                  />
                </g>
                <g>
                  <path
                    class="st5"
                    d="M243.4,334.6c3.3,3.2,6.4,6.2,9.3,9l7.5-7.7l-9.3-9L243.4,334.6L243.4,334.6z"
                  />
                  <path
                    class="st5"
                    d="M239.8,338.2l-22,22.5c3.5,3.4,6.6,6.4,9.3,9l21.9-22.5C246.3,344.5,243.1,341.4,239.8,338.2z"
                  />
                </g>
                <g>
                  <path
                    class="st5"
                    d="M263.7,354.4c2.7,2.6,4.6,4.4,5.4,5.3l9.5-15c-1-0.8-2.1-1.6-3-2.6L263.7,354.4L263.7,354.4z"
                  />
                  <path
                    class="st5"
                    d="M266.5,363.9c-0.1-0.1-0.1-0.1-0.2-0.1c-0.6-0.5-2.9-2.8-6.1-5.9l-22,22.5c0.6,0.6,1.5,1.4,1.5,1.4
            c3.3,3,6.8,5.6,10.4,8L266.5,363.9L266.5,363.9z"
                  />
                </g>
                <g>
                  <path
                    class="st5"
                    d="M242.2,333.5l7.5-7.7l-9-8.8l-7.5,7.7C236.3,327.7,239.4,330.7,242.2,333.5z"
                  />
                  <path
                    class="st5"
                    d="M229.6,328.4l-21.9,22.4c3.2,3.1,6.2,6,9,8.8l21.9-22.4C235.8,334.4,232.6,331.4,229.6,328.4z"
                  />
                </g>
                <g>
                  <path
                    class="st5"
                    d="M212.8,304.9L212.8,304.9c3.1,3,6.1,5.9,9.1,8.8l7.5-7.7l-9.1-8.8l0,0L212.8,304.9z"
                  />
                  <path
                    class="st5"
                    d="M209.2,308.5l-22,22.5c3.1,3,6.1,5.9,9.1,8.8l22-22.5C215.4,314.5,212.2,311.5,209.2,308.5z"
                  />
                </g>
                <g>
                  <path
                    class="st5"
                    d="M232,323.6l7.5-7.7l-9-8.8l-7.5,7.7C226,317.8,229.2,320.8,232,323.6z"
                  />
                  <path
                    class="st5"
                    d="M219.5,318.4l-22,22.6c3.1,3,6.1,6,9,8.8l22-22.6C225.7,324.4,222.5,321.3,219.5,318.4z"
                  />
                </g>
                <g>
                  <path
                    class="st5"
                    d="M332.7,359L332.7,359c0.1-0.1,2.1-2.1,5.2-5.3L325,341.1c-1.4,1.4-2.8,2.6-4.3,3.7l10.5,15.6
            C331.6,360.1,332.2,359.5,332.7,359z"
                  />
                  <path
                    class="st5"
                    d="M341.4,357.1c-3.4,3.5-5.6,5.7-5.6,5.7l0.4-0.4c-0.7,0.7-1.6,1.5-2.4,2.2l18.4,27.4c4.7-3,7.8-8.7,12-12.7
            L341.4,357.1z"
                  />
                </g>
                <g>
                  <path
                    class="st5"
                    d="M347.3,344.1l-9.5-9.2c-2.3,0-6,0.1-8.2,0.1c-1.1,1.8-2.3,3.5-3.6,5l13,12.6
            C341.2,350.3,344.1,347.3,347.3,344.1z"
                  />
                  <path
                    class="st5"
                    d="M350.9,347.6c-3.1,3.2-6.1,6.2-8.3,8.5l22.8,22.1c1.2-1.3,4.2-4.3,8.3-8.5L350.9,347.6z"
                  />
                </g>
                <g>
                  <path
                    class="st5"
                    d="M357.1,334l-8.4-8.1l-7,7.2l-1.7,1.8l8.4,8.1C351,340.3,354.1,337.1,357.1,334z"
                  />
                  <path
                    class="st5"
                    d="M360.7,337.5c-3.1,3.1-6.1,6.3-8.7,8.9l22.8,22.1c2.5-2.6,5.5-5.6,8.7-9L360.7,337.5z"
                  />
                </g>
                <g>
                  <path
                    class="st5"
                    d="M199,298.8l-21.9,22.4c3,2.9,6,5.9,9,8.8l21.9-22.4C205.1,304.7,202,301.6,199,298.8z"
                  />
                  <path
                    class="st5"
                    d="M216.3,281.1l-13.6,14l0,0c3,2.9,6,5.8,9,8.8l8.8-9c0.5-6.5,0.5-6.7,0.6-9
            C220.4,285.1,218.6,283.4,216.3,281.1z"
                  />
                </g>
                <g>
                  <path
                    class="st5"
                    d="M397.5,292.7l-15.4-15c-2.9,3-4.8,4.9-4.8,4.9c0.3,2.4,1,7.1,1.3,10.1l9.7,9.4
            C391.2,299.1,394.5,295.7,397.5,292.7z"
                  />
                  <path
                    class="st5"
                    d="M401.1,296.2c-3,3-6.2,6.4-9.2,9.4l23.7,23c3-3.1,6.1-6.3,9.2-9.4L401.1,296.2z"
                  />
                </g>
                <g>
                  <path
                    class="st5"
                    d="M380.8,317L380.8,317c-3.1,3.1-6,6.2-8.9,9.2l22.7,22c2.9-2.9,5.9-6,8.9-9.2L380.8,317z"
                  />
                  <path
                    class="st5"
                    d="M377.2,313.5l-8.4-8.1l-8.9,9.2l8.4,8.1C371.1,319.7,374.2,316.5,377.2,313.5z"
                  />
                </g>
                <g>
                  <path
                    class="st5"
                    d="M367.1,323.8l-8.4-8.1l-8.9,9.1l8.4,8.1C361,330,364.1,326.9,367.1,323.8z"
                  />
                  <path
                    class="st5"
                    d="M370.7,327.2L370.7,327.2c-3.1,3.2-6.1,6.2-8.9,9.1l22.8,22.1c2.8-2.8,5.8-5.9,8.9-9.1L370.7,327.2z"
                  />
                </g>
                <g>
                  <path
                    class="st5"
                    d="M387.2,303.2l-8.4-8.1l-8.9,9.1l8.4,8.1C381.1,309.4,384.2,306.2,387.2,303.2z"
                  />
                  <path
                    class="st5"
                    d="M390.8,306.8L390.8,306.8c-3,3.1-6,6.1-8.9,9.1l22.7,22c2.9-3,5.9-6,8.9-9.1L390.8,306.8z"
                  />
                </g>
              </g>
              <g id="lower-box-preferred">
                <g>
                  <path
                    class="st5"
                    d="M278.4,365.9l6.8-17.4c-1.8-0.8-3.5-1.8-5.2-2.9l-9.5,15C272.9,362.7,275.5,364.4,278.4,365.9z"
                  />
                  <path
                    class="st5"
                    d="M267.7,365l-16.2,25.7c4.6,2.9,9.4,5.4,14.4,7.4l0,0l10.7-27.4C273.4,369.1,270.4,367.2,267.7,365z"
                  />
                </g>
                <g>
                  <path
                    class="st5"
                    d="M320.7,367c-2.8-6.7-5.5-13.1-7.5-17.9c-1.7,0.7-3.8,1.4-5.6,1.8c1,4.8,2.5,11.9,4.1,19.3
            C314.8,369.3,317.8,368.3,320.7,367z"
                  />
                  <path
                    class="st5"
                    d="M322.8,371.9c-3.2,1.4-6.6,2.5-10,3.4c2.5,11.6,5,23.1,5.9,27.4l0,0c5.1-1,10.2-2.5,15.2-4.4
            C331.3,392,327,381.9,322.8,371.9z"
                  />
                </g>
                <g>
                  <path
                    class="st5"
                    d="M299.9,371l-0.3-19.3c-2.1,0-4.2-0.2-6.3-0.6l-3.6,19.7C293,371.2,296.4,371.2,299.9,371z"
                  />
                  <path
                    class="st5"
                    d="M299.9,375.4c-3.6,0.3-7.4,0.2-11-0.2l-5.1,27.9v0.1c2.6,0.5,5.2,0.8,7.8,1v-0.1c0.5,0,1,0.1,1.6,0.1v0.1
            c2.4,0.2,4.7,0.3,7.1,0.3l0,0L299.9,375.4z"
                  />
                </g>
                <g>
                  <path
                    class="st5"
                    d="M288.2,370.4l3.6-19.6c-1.8-0.4-3.5-1-5.2-1.7c-1.8,4.7-4.3,11.1-7,18C282.4,368.5,285.2,369.6,288.2,370.4z"
                  />
                  <path
                    class="st5"
                    d="M277.9,371.5c-4.1,10.5-8.2,21.1-10.6,27.1l0,0c4.9,1.9,9.9,3.3,15,4.3v-0.1l5-27.8
            C284.1,374.1,280.9,373,277.9,371.5z"
                  />
                </g>
                <g>
                  <path
                    class="st5"
                    d="M317.2,403.1L317.2,403.1l-5.8-27.6c-3.3,0.5-6.6,0.6-9.9,0.5c0.2,12.2,0.3,24.3,0.4,28.6v0.1
            C307,404.5,312.1,404,317.2,403.1z"
                  />
                  <path
                    class="st5"
                    d="M310.6,371.3l-4.2-20.2c-1.7,0.3-3.4,0.5-5.2,0.6c0.1,5.2,0.2,12.5,0.3,20.1
            C304.5,371.9,307.6,371.7,310.6,371.3z"
                  />
                </g>
                <g>
                  <path
                    class="st5"
                    d="M329.7,361.4l-10.4-15.5c-1.5,1-3.1,1.9-4.7,2.6l7.5,17.8C324.8,364.8,327.3,363.2,329.7,361.4z"
                  />
                  <path
                    class="st5"
                    d="M332.8,365.9c-2.7,2.1-5.6,3.8-8.6,5.3l11.2,26.6l0.8,2.2c4.8-2,9.6-5.3,14.1-8L332.8,365.9z"
                  />
                </g>
              </g>
              <g id="lower-infield-box">
                <path
                  class="st11"
                  d="M253.8,344.7l-3.3,3.4c3.4,3.3,6.4,6.2,8.8,8.5l3.3-3.4C260.2,350.9,257.2,348,253.8,344.7"
                />
                <path
                  class="st11"
                  d="M243.4,334.6l-3.6,3.6c3.3,3.2,6.4,6.3,9.3,9l3.6-3.6C249.8,340.9,246.7,337.8,243.4,334.6"
                />
                <path
                  class="st11"
                  d="M270.4,360.5L270.4,360.5l-3,4.2c2.9,2.5,6.1,4.5,9.5,6.1l2.2-4.6C275.9,364.7,273,362.8,270.4,360.5"
                />
                <path
                  class="st11"
                  d="M263.7,354.4l-3.5,3.6c3.3,3.2,5.5,5.3,6,5.9c0,0,0.1,0.1,0.2,0.1l2.9-4.1C268.6,359,266.6,357.1,263.7,354.4
            "
                />
                <path
                  class="st11"
                  d="M242.3,333.5c-2.9-2.8-5.9-5.7-9.1-8.8l-3.6,3.7c3.1,3,6.2,6,9.1,8.8L242.3,333.5z"
                />
                <path
                  class="st11"
                  d="M212.8,304.9l-3.6,3.6c3.1,3,6.1,5.9,9.1,8.8l3.5-3.6C218.9,310.8,215.9,307.9,212.8,304.9"
                />
                <path
                  class="st11"
                  d="M232.1,323.6c-2.9-2.9-6-5.8-9-8.8l-3.5,3.6c3.1,3,6.1,5.9,9,8.8L232.1,323.6z"
                />
                <path
                  class="st11"
                  d="M311.1,370.3c0.4,1.7,0.8,3.4,1.1,5.2c4.6-1.1,9-2.7,13.2-4.8c-0.7-1.6-1.4-3.3-2.1-4.9
            C319.4,367.8,315.3,369.3,311.1,370.3"
                />
                <path
                  class="st11"
                  d="M332.7,359L332.7,359c-0.6,0.5-1.1,1-1.7,1.5l2.9,3.9c0.8-0.7,1.5-1.3,2.2-2l-0.4,0.4c0,0,2-2.1,5.5-5.7
            l-3.5-3.4C334.7,357,332.8,358.9,332.7,359"
                />
                <path
                  class="st11"
                  d="M338.9,352.6l3.6,3.5c2.3-2.4,5.1-5.2,8.3-8.5l-3.6-3.5C344,347.4,341.2,350.3,338.9,352.6"
                />
                <path
                  class="st11"
                  d="M357.1,334c-3.1,3.2-6.1,6.2-8.7,9l3.6,3.5c2.7-2.7,5.6-5.7,8.7-8.9L357.1,334z"
                />
                <path
                  class="st11"
                  d="M288.5,370.6l-1.2,4.5c4.1,0.6,8.3,0.7,12.6,0.3l0.4-4.4C296.2,371.3,292.3,371.2,288.5,370.6"
                />
                <path
                  class="st11"
                  d="M202.6,295.1l-3.6,3.7c3,2.9,6,5.9,9,8.8l3.6-3.7C208.7,300.9,205.6,298,202.6,295.1"
                />
                <path
                  class="st11"
                  d="M279,366.8c-0.6,1.4-1.2,2.9-1.8,4.4c3.6,1.8,7.4,3.2,11.2,4.1l0.9-4.6C285.8,369.8,282.3,368.5,279,366.8"
                />
                <path
                  class="st11"
                  d="M301,371.8c0.1,1.4,0.2,2.8,0.3,4.2c3.6,0.2,7.2,0,10.8-0.6l-1.1-4.1C307.7,371.8,304.4,371.9,301,371.8"
                />
                <path
                  class="st11"
                  d="M321.2,366.7l2.4,4.8c3.7-1.7,7.1-3.9,10.3-6.4l-3.2-4.5C327.7,363,324.5,365.1,321.2,366.7"
                />
                <path
                  class="st11"
                  d="M388.3,302.1l3.6,3.5c3-3.1,6-6.1,9-9.2l-3.6-3.5C394.3,296,391.3,299,388.3,302.1"
                />
                <path
                  class="st11"
                  d="M380.8,317l-3.7-3.5c-3.1,3.1-6,6.2-9,9.2l3.7,3.5C374.8,323.2,377.8,320.2,380.8,317"
                />
                <path
                  class="st11"
                  d="M370.7,327.3l-3.6-3.5c-3.1,3.2-6.1,6.2-8.9,9.1l3.6,3.5C364.6,333.5,367.6,330.4,370.7,327.3"
                />
                <path
                  class="st11"
                  d="M390.8,306.8l-3.7-3.5c-3,3.1-6,6.1-8.9,9.1l3.7,3.5C384.8,312.9,387.8,309.9,390.8,306.8"
                />
              </g>
              <g id="chalk-box">
                <path
                  class="st12"
                  d="M378.6,272.6l9.5,9.2c3-3.1,6-6.2,8.9-9.2l-9.5-9.2C384.6,266.5,381.7,269.5,378.6,272.6"
                />
                <path
                  class="st12"
                  d="M389.8,263.5l8.3,8.2c3-3.1,6-6.2,8.9-9.1l-8.3-8.2C395.8,257.3,392.9,260.4,389.8,263.5"
                />
                <path
                  class="st12"
                  d="M399.7,253.2l8.3,8.2c3.1-3.2,6.1-6.3,8.9-9.2l-8.3-8.2C405.8,246.9,402.8,249.9,399.7,253.2"
                />
              </g>
              <g id="fieldside-box">
                <path
                  class="st13"
                  d="M367,323.7l-9.5-9.2c-3.1,3.2-6.1,6.2-8.9,9.1l9.5,9.2C361,329.9,364,326.9,367,323.7"
                />
                <path
                  class="st13"
                  d="M320.7,334.9l18.1,17.6c2.3-2.3,5.1-5.2,8.3-8.5L329,326.4C325.8,329.7,323,332.6,320.7,334.9"
                />
                <path
                  class="st13"
                  d="M271,327.1l-17.1,17.5c3.4,3.3,6.4,6.2,8.8,8.5l17.1-17.5C277.3,333.3,274.4,330.4,271,327.1"
                />
                <path
                  class="st13"
                  d="M251.6,323.9c-2.9-2.8-5.9-5.7-9-8.8l-9.2,9.5c3.1,3,6.2,6,9,8.8L251.6,323.9z"
                />
                <path
                  class="st13"
                  d="M252.7,325l-9.3,9.5c3.3,3.2,6.4,6.3,9.3,9l9.3-9.5C259.1,331.3,256,328.2,252.7,325"
                />
                <path
                  class="st13"
                  d="M222.1,295.4l-9.3,9.5c3.1,3,6.1,5.9,9.1,8.8l9.3-9.5C228.2,301.3,225.2,298.3,222.1,295.4"
                />
                <path
                  class="st13"
                  d="M220.5,276.8L202.7,295c3,2.9,6,5.8,9,8.8l17.7-18.2C226.5,282.6,223.5,279.7,220.5,276.8"
                />
                <path
                  class="st13"
                  d="M232.3,305.3l-9.3,9.5c3.1,3,6.1,5.9,9,8.8l9.3-9.5C238.4,311.2,235.4,308.3,232.3,305.3"
                />
                <path
                  class="st13"
                  d="M377.1,313.4l-9.5-9.2c-3,3.1-6,6.2-8.9,9.2l9.5,9.2C371,319.6,374,316.5,377.1,313.4"
                />
                <path
                  class="st13"
                  d="M347.5,324.7c-3.1,3.2-6.1,6.2-8.7,8.9l9.5,9.2c2.7-2.7,5.6-5.7,8.7-8.9L347.5,324.7z"
                />
                <path
                  class="st13"
                  d="M370.1,284.4l18.1,17.6c3-3.1,6-6.1,9-9.2L379,275.2C376,278.3,373.1,281.3,370.1,284.4"
                />
                <path
                  class="st13"
                  d="M380.2,274.2l18.1,17.6c3-3.1,6-6.1,29.3-29.5l-18.2-17.6C386.1,268.1,383.2,271.1,380.2,274.2"
                />
                <path
                  class="st13"
                  d="M368.7,303l9.5,9.2c2.9-3,5.9-6,8.9-9.1l-9.5-9.2C374.6,297,371.6,300,368.7,303"
                />
                <path
                  class="st13"
                  d="M281.3,362.7c-0.6,1.4-1.1,2.9-1.7,4.4c2.8,1.5,5.6,2.6,8.6,3.4l0.9-4.7C286.5,365,283.9,364,281.3,362.7z"
                />
                <path
                  class="st13"
                  d="M210.4,266.8l-9.2,9.5c3,2.9,6,5.8,9,8.8l9.2-9.5C216.4,272.6,213.4,269.7,210.4,266.8"
                />
                <path
                  class="st13"
                  d="M200.3,256.9l-8.2,8.7c2.9,2.8,6,5.8,9,8.8l8.2-8.7C206.2,262.7,203.2,259.7,200.3,256.9"
                />
                <path
                  class="st13"
                  d="M190.1,247l-8.2,8.5c2.9,2.8,5.9,5.7,9,8.8l8.2-8.5C196,252.7,193,249.8,190.1,247"
                />
                <path
                  class="st13"
                  d="M335.1,351.1c-0.8,0.8-3.2,3-6.7,5.5l2.6,3.9c0.6-0.5,1.1-1,1.6-1.6l0,0c0.1-0.1,2-2,5.1-5.2L335.1,351.1z"
                />
                <path
                  class="st13"
                  d="M320.2,361.6l2.1,5.1c2.6-1.4,5.2-3.2,7.5-5.2l-2.7-4C325.1,358.8,322.8,360.3,320.2,361.6z"
                />
                <path
                  class="st13"
                  d="M310.9,365.3c0.4,1.8,0.8,3.6,1.1,5.4c3-0.8,6-1.9,8.8-3.3c-0.7-1.7-1.4-3.4-2.2-5.1
            C316.3,363.4,313.7,364.5,310.9,365.3z"
                />
                <path
                  class="st13"
                  d="M301.4,367c0,1.7,0,3.4,0.1,5.2c3-0.1,6.1-0.4,9.1-1.1l-1.1-5.4C306.8,366.4,304.2,366.8,301.4,367z"
                />
                <path
                  class="st13"
                  d="M290.6,366.1l-0.9,4.8c3.3,0.8,6.7,1.3,10.2,1.3l-0.1-5.1C296.8,367.1,293.7,366.8,290.6,366.1z"
                />
                <path
                  class="st13"
                  d="M272.8,356.9l-2.3,3.7h0.1c2.4,2.2,5,4,7.7,5.6l1.7-4.3C277.5,360.6,275.1,358.9,272.8,356.9z"
                />
                <path
                  class="st13"
                  d="M266.8,351.2l-3,3.1c2.8,2.7,4.7,4.6,5.5,5.3l2.3-3.7C270,354.5,268.4,352.9,266.8,351.2z"
                />
                <text
                  transform="matrix(0.6893 -0.7248 0.7225 0.6913 395.4254 281.4455)"
                  class="st14 st15 st16"
                >
                  CHALK BOX
                </text>
              </g>
              <g id="fieldside-box-grey">
                <path
                  class="st0"
                  d="M367,323.7l-9.5-9.2c-3.1,3.2-6.1,6.2-8.9,9.1l9.5,9.2C361,329.9,364,326.9,367,323.7"
                />
                <path
                  class="st0"
                  d="M320.7,334.9l18.1,17.6c2.3-2.3,5.1-5.2,8.3-8.5L329,326.4C325.8,329.7,323,332.6,320.7,334.9"
                />
                <path
                  class="st0"
                  d="M271,327.1l-17.1,17.5c3.4,3.3,6.4,6.2,8.8,8.5l17.1-17.5C277.3,333.3,274.4,330.4,271,327.1"
                />
                <path
                  class="st0"
                  d="M251.6,323.9c-2.9-2.8-5.9-5.7-9-8.8l-9.2,9.5c3.1,3,6.2,6,9,8.8L251.6,323.9z"
                />
                <path
                  class="st0"
                  d="M252.7,325l-9.3,9.5c3.3,3.2,6.4,6.3,9.3,9l9.3-9.5C259.1,331.3,256,328.2,252.7,325"
                />
                <path
                  class="st0"
                  d="M222.1,295.4l-9.3,9.5c3.1,3,6.1,5.9,9.1,8.8l9.3-9.5C228.2,301.3,225.2,298.3,222.1,295.4"
                />
                <path
                  class="st0"
                  d="M220.5,276.8L202.7,295c3,2.9,6,5.8,9,8.8l17.7-18.2C226.5,282.6,223.5,279.7,220.5,276.8"
                />
                <path
                  class="st0"
                  d="M232.3,305.3l-9.3,9.5c3.1,3,6.1,5.9,9,8.8l9.3-9.5C238.4,311.2,235.4,308.3,232.3,305.3"
                />
                <path
                  class="st0"
                  d="M377.1,313.4l-9.5-9.2c-3,3.1-6,6.2-8.9,9.2l9.5,9.2C371,319.6,374,316.5,377.1,313.4"
                />
                <path
                  class="st0"
                  d="M347.5,324.7c-3.1,3.2-6.1,6.2-8.7,8.9l9.5,9.2c2.7-2.7,5.6-5.7,8.7-8.9L347.5,324.7z"
                />
                <path
                  class="st0"
                  d="M370.1,284.4l18.1,17.6c3-3.1,6-6.1,9-9.2L379,275.2C376,278.3,373.1,281.3,370.1,284.4"
                />
                <path
                  class="st0"
                  d="M380.2,274.2l18.1,17.6c3-3.1,6-6.1,29.3-29.5l-18.2-17.6C386.1,268.1,383.2,271.1,380.2,274.2"
                />
                <path
                  class="st0"
                  d="M368.7,303l9.5,9.2c2.9-3,5.9-6,8.9-9.1l-9.5-9.2C374.6,297,371.6,300,368.7,303"
                />
                <path
                  class="st0"
                  d="M281.3,362.7c-0.6,1.4-1.1,2.9-1.7,4.4c2.8,1.5,5.6,2.6,8.6,3.4l0.9-4.7C286.5,365,283.9,364,281.3,362.7z"
                />
                <path
                  class="st0"
                  d="M210.4,266.8l-9.2,9.5c3,2.9,6,5.8,9,8.8l9.2-9.5C216.4,272.6,213.4,269.7,210.4,266.8"
                />
                <path
                  class="st0"
                  d="M200.3,256.9l-8.2,8.7c2.9,2.8,6,5.8,9,8.8l8.2-8.7C206.2,262.7,203.2,259.7,200.3,256.9"
                />
                <path
                  class="st0"
                  d="M190.1,247l-8.2,8.5c2.9,2.8,5.9,5.7,9,8.8l8.2-8.5C196,252.7,193,249.8,190.1,247"
                />
                <path
                  class="st0"
                  d="M335.1,351.1c-0.8,0.8-3.2,3-6.7,5.5l2.6,3.9c0.6-0.5,1.1-1,1.6-1.6l0,0c0.1-0.1,2-2,5.1-5.2L335.1,351.1z"
                />
                <path
                  class="st0"
                  d="M320.2,361.6l2.1,5.1c2.6-1.4,5.2-3.2,7.5-5.2l-2.7-4C325.1,358.8,322.8,360.3,320.2,361.6z"
                />
                <path
                  class="st0"
                  d="M310.9,365.3c0.4,1.8,0.8,3.6,1.1,5.4c3-0.8,6-1.9,8.8-3.3c-0.7-1.7-1.4-3.4-2.2-5.1
            C316.3,363.4,313.7,364.5,310.9,365.3z"
                />
                <path
                  class="st0"
                  d="M301.4,367c0,1.7,0,3.4,0.1,5.2c3-0.1,6.1-0.4,9.1-1.1l-1.1-5.4C306.8,366.4,304.2,366.8,301.4,367z"
                />
                <path
                  class="st0"
                  d="M290.6,366.1l-0.9,4.8c3.3,0.8,6.7,1.3,10.2,1.3l-0.1-5.1C296.8,367.1,293.7,366.8,290.6,366.1z"
                />
                <path
                  class="st0"
                  d="M272.8,356.9l-2.3,3.7h0.1c2.4,2.2,5,4,7.7,5.6l1.7-4.3C277.5,360.6,275.1,358.9,272.8,356.9z"
                />
                <path
                  class="st0"
                  d="M266.8,351.2l-3,3.1c2.8,2.7,4.7,4.6,5.5,5.3l2.3-3.7C270,354.5,268.4,352.9,266.8,351.2z"
                />
                <text
                  transform="matrix(0.6893 -0.7248 0.7225 0.6913 395.4254 281.4455)"
                  class="st14 st15 st16"
                >
                  CHALK BOX
                </text>
              </g>
              <g id="rays-club">
                <path
                  class="st13"
                  d="M375.7,401.5L375.7,401.5l5.6-5.7l-12.4-12.1c-4.5,4.3-9.4,8.1-14.5,11.4l10.6,15.8
            C368.6,408.1,372.2,404.9,375.7,401.5"
                />
                <polygon
                  class="st13"
                  points="353,396 342.6,401.8 353.9,418.4 363.6,411.9 	"
                />
                <polygon
                  class="st13"
                  points="461.8,313.3 470.7,304.2 458.3,292.1 449.4,301.3 	"
                />
                <polygon
                  class="st13"
                  points="460.6,314.5 448.1,302.4 369.7,382.7 382.3,394.8 	"
                />
              </g>
              <g id="dex-home-plate">
                <path
                  class="st17"
                  d="M335.5,350.7c0,0-36.2,37-69.4-0.4l8.9-9c0,0,26.5,17,49.6-0.9L335.5,350.7z"
                />
              </g>
              <g id="dex-home-plate-grey">
                <path
                  class="st0"
                  d="M335.5,350.7c0,0-36.2,37-69.4-0.4l8.9-9c0,0,26.5,17,49.6-0.9L335.5,350.7z"
                />
              </g>
              <g id="BG">
                <polygon
                  class="st18"
                  points="107.8,107.2 96.1,122.1 76.4,165.2 73.5,197.1 86,196.6 91.9,167.4 101,143.3 122.5,120.4 	"
                />
                <path
                  class="st18"
                  d="M122.8,121.8l-4.6-4.5l-1.1,1.1l4.6,4.5C122.1,122.5,122.5,122.1,122.8,121.8"
                />
                <g>
                  <path
                    class="st19"
                    d="M496.2,33.2c0,13.4-10.9,24.2-24.3,24.2s-24.3-10.8-24.3-24.2S458.5,9,471.9,9
            C485.4,9.1,496.2,19.9,496.2,33.2"
                  />
                  <path
                    class="st20"
                    d="M467.1,20.1c-0.4,0.1-1.2,0.3-2.1,0.3c-1.1,0-1.9-0.3-2.5-0.8s-0.9-1.3-0.9-2.2c0-2,1.5-3.2,3.5-3.2
            c0.8,0,1.4,0.2,1.7,0.3l-0.3,1.1c-0.3-0.2-0.8-0.3-1.4-0.3c-1.2,0-2.1,0.6-2.1,2c0,1.3,0.8,2,1.9,2c0.3,0,0.6,0,0.7-0.1v-1.3h-1
            v-1.1h2.3L467.1,20.1z"
                  />
                  <path
                    class="st20"
                    d="M469.6,18.8l-0.4,1.6h-1.5l1.9-6.1h1.8l1.9,6.2h-1.5l-0.5-1.6L469.6,18.8z M471.2,17.7l-0.4-1.3
            c-0.1-0.4-0.2-0.8-0.3-1.2l0,0c-0.1,0.4-0.2,0.8-0.3,1.2l-0.4,1.3H471.2z"
                  />
                  <polygon
                    class="st20"
                    points="474.6,15.4 472.9,15.4 472.9,14.2 477.6,14.2 477.6,15.4 475.9,15.4 475.9,20.4 474.5,20.4 		"
                  />
                  <polygon
                    class="st20"
                    points="482,17.8 479.8,17.8 479.8,19.2 482.3,19.3 482.3,20.4 478.4,20.4 478.4,14.2 482.2,14.2
            482.2,15.4 479.8,15.4 479.8,16.7 482,16.7 		"
                  />
                  <polygon
                    class="st20"
                    points="470.9,26.5 470.9,26.5 467.8,27.9 467.2,25.2 471.5,23.2 474.5,23.2 474.5,39.1 470.9,39 		"
                  />
                  <path
                    class="st20"
                    d="M456.6,43.8c0.3-0.1,0.7-0.1,1.2-0.1c0.6,0,1,0.1,1.3,0.3s0.4,0.5,0.4,0.9c0,0.5-0.4,0.9-0.7,1l0,0
            c0.3,0.1,0.4,0.4,0.5,0.8c0.1,0.5,0.2,1,0.3,1.2h-1c-0.1-0.1-0.2-0.5-0.3-1c-0.1-0.5-0.3-0.7-0.7-0.7h-0.3v1.6h-0.9L456.6,43.8z
            M457.5,45.5h0.4c0.5,0,0.7-0.2,0.7-0.6c0-0.4-0.3-0.6-0.7-0.6c-0.2,0-0.4,0-0.4,0V45.5z"
                  />
                  <path
                    class="st20"
                    d="M462.5,47.9c-1.2,0-1.9-0.9-1.9-2.1c0-1.2,0.8-2.1,2-2.1c1.3,0,1.9,0.9,1.9,2.1
            C464.5,47.1,463.7,47.9,462.5,47.9L462.5,47.9z M462.5,47.2c0.6,0,1-0.6,1-1.4c0-0.7-0.3-1.4-1-1.4c-0.6,0-1,0.6-1,1.4
            C461.5,46.6,461.9,47.2,462.5,47.2L462.5,47.2z"
                  />
                  <polygon
                    class="st20"
                    points="466.4,44.5 465.2,44.5 465.3,43.7 468.4,43.8 468.4,44.5 467.3,44.5 467.3,47.9 466.3,47.9 		"
                  />
                  <path
                    class="st20"
                    d="M470.4,43.8v2.4c0,0.7,0.3,1.1,0.7,1.1c0.5,0,0.8-0.3,0.8-1.1v-2.4h0.9v2.3c0,1.3-0.6,1.9-1.7,1.9
            c-1,0-1.6-0.6-1.6-1.9v-2.3H470.4z"
                  />
                  <path
                    class="st20"
                    d="M474.3,47.9v-4.1h1.1l0.9,1.5c0.2,0.4,0.5,0.9,0.7,1.4l0,0c-0.1-0.5-0.1-1.1-0.1-1.7v-1.2h0.9v4.1h-1
            l-0.9-1.6c-0.2-0.4-0.5-1-0.7-1.4l0,0c0,0.5,0,1.1,0,1.8v1.2H474.3z"
                  />
                  <path
                    class="st20"
                    d="M479.1,43.9c0.3-0.1,0.8-0.1,1.3-0.1c0.8,0,1.3,0.1,1.7,0.4c0.4,0.3,0.7,0.8,0.7,1.6s-0.3,1.3-0.7,1.7
            c-0.4,0.4-1.1,0.5-1.9,0.5c-0.5,0-0.8,0-1.1-0.1V43.9z M480,47.2c0.1,0,0.2,0,0.3,0c0.8,0,1.4-0.5,1.4-1.4s-0.5-1.3-1.3-1.3
            c-0.2,0-0.3,0-0.4,0V47.2z"
                  />
                  <path
                    class="st20"
                    d="M484.9,46.9l-0.3,1.1h-1l1.3-4.1h1.2l1.3,4.1h-1l-0.3-1.1H484.9z M486,46.2l-0.3-0.9
            c-0.1-0.2-0.1-0.6-0.2-0.8l0,0c-0.1,0.2-0.1,0.6-0.2,0.8l-0.3,0.9H486z"
                  />
                </g>
                <g>
                  <path
                    class="st19"
                    d="M48.6,315.6c0,13.4-10.9,24.2-24.3,24.2C10.9,339.8,0,329,0,315.6s10.9-24.2,24.3-24.2
            C37.7,291.5,48.6,302.3,48.6,315.6"
                  />
                  <path
                    class="st20"
                    d="M17.5,308.4c-0.5,0.2-1.5,0.4-2.5,0.4c-1.4,0-2.4-0.4-3.1-1c-0.7-0.7-1.1-1.7-1.1-2.8c0-2.5,1.9-4,4.4-4
            c1,0,1.7,0.2,2.1,0.4l-0.4,1.4c-0.4-0.2-0.9-0.3-1.8-0.3c-1.4,0-2.5,0.8-2.5,2.5c0,1.6,1,2.5,2.4,2.5c0.4,0,0.7,0,0.8-0.1v-1.6
            h-1.2v-1.3h2.8L17.5,308.4z"
                  />
                  <path
                    class="st20"
                    d="M20.6,306.9l-0.5,1.9h-1.8l2.3-7.6h2.3l2.4,7.6h-1.9l-0.6-2L20.6,306.9z M22.5,305.6L22,304
            c-0.1-0.5-0.3-1-0.4-1.5l0,0c-0.1,0.5-0.2,1-0.3,1.5l-0.5,1.6H22.5z"
                  />
                  <polygon
                    class="st20"
                    points="26.7,302.7 24.7,302.7 24.7,301.2 30.5,301.2 30.5,302.7 28.4,302.7 28.4,308.8 26.7,308.8 		"
                  />
                  <polygon
                    class="st20"
                    points="36,305.6 33.2,305.6 33.2,307.4 36.3,307.4 36.3,308.8 31.4,308.8 31.5,301.2 36.2,301.2
            36.2,302.6 33.2,302.6 33.2,304.2 36,304.2 		"
                  />
                  <path
                    class="st20"
                    d="M28.9,315.6c-0.5,0-1.1,0-1.8,0.1c-4.1,0.3-5.9,2.4-6.4,4.6h0.1c1-1,2.4-1.5,4.2-1.5c3.3,0,6.1,2.3,6.1,6.4
            c0,3.9-3,7.1-7.2,7c-5.2,0-7.8-3.9-7.8-8.5c0-3.7,1.4-6.7,3.5-8.7c1.9-1.8,4.5-2.7,7.6-2.8c0.8-0.1,1.4-0.1,1.8,0L28.9,315.6z
            M23.8,328.8c1.6,0,2.6-1.5,2.6-3.4c0-1.8-1-3.4-2.9-3.4c-1.2,0-2.3,0.7-2.7,1.7c-0.2,0.3-0.2,0.6-0.2,1.2
            C20.7,327,21.7,328.8,23.8,328.8L23.8,328.8z"
                  />
                </g>
                <g>
                  <path
                    class="st19"
                    d="M180.1,486.5c0,13.4-10.9,24.2-24.3,24.2c-13.4,0-24.3-10.8-24.3-24.2c0-13.4,10.9-24.2,24.3-24.2
            C169.2,462.3,180.1,473.2,180.1,486.5"
                  />
                  <path
                    class="st20"
                    d="M148.8,479.3c-0.5,0.2-1.5,0.4-2.5,0.4c-1.4,0-2.4-0.4-3.1-1c-0.7-0.7-1.1-1.7-1.1-2.8c0-2.5,1.9-4,4.4-4
            c1,0,1.7,0.2,2.1,0.4l-0.4,1.4c-0.4-0.2-0.9-0.3-1.8-0.3c-1.4,0-2.5,0.8-2.5,2.5c0,1.6,1,2.5,2.4,2.5c0.4,0,0.7,0,0.8-0.1v-1.6
            h-1.2v-1.3h2.8L148.8,479.3z"
                  />
                  <path
                    class="st20"
                    d="M151.9,477.7l-0.5,1.9h-1.8l2.3-7.6h2.3l2.4,7.6h-1.9l-0.6-2L151.9,477.7z M153.8,476.5l-0.5-1.6
            c-0.1-0.5-0.3-1-0.4-1.5l0,0c-0.1,0.5-0.2,1-0.3,1.5l-0.5,1.6H153.8z"
                  />
                  <polygon
                    class="st20"
                    points="158,473.6 156,473.5 156,472.1 161.8,472.1 161.8,473.6 159.8,473.6 159.7,479.7 158,479.7 		"
                  />
                  <polygon
                    class="st20"
                    points="167.3,476.5 164.5,476.5 164.5,478.3 167.6,478.3 167.6,479.7 162.8,479.7 162.8,472.1 167.5,472.1
            167.5,473.5 164.5,473.5 164.5,475.1 167.3,475.1 		"
                  />
                  <path
                    class="st20"
                    d="M160.8,487h-7.6l-0.4,3c0.4,0,0.8-0.1,1.3-0.1c1.9,0,3.8,0.4,5.2,1.4c1.5,1,2.4,2.6,2.4,4.9
            c0,3.6-3.2,6.8-8.4,6.8c-2.4,0-4.4-0.6-5.5-1.1l0.8-3.4c0.8,0.4,2.6,1,4.4,1c1.9,0,3.9-0.9,3.9-3c0-2-1.6-3.3-5.5-3.3
            c-1.1,0-1.8,0.1-2.6,0.2l1.3-10.2h10.8L160.8,487z"
                  />
                </g>
                <g>
                  <rect
                    x="265.8"
                    y="503.2"
                    class="st19"
                    width="70.6"
                    height="22.8"
                  />
                  <path
                    class="st20"
                    d="M283.9,520.4c-0.9,0.3-2.5,0.7-4.2,0.7c-2.3,0-3.9-0.6-5.1-1.7c-1.1-1.1-1.8-2.7-1.8-4.5
            c0-4.1,3-6.5,7.1-6.5c1.6,0,2.9,0.3,3.5,0.6l-0.6,2.3c-0.7-0.3-1.5-0.5-2.9-0.5c-2.4,0-4.2,1.3-4.2,4c0,2.6,1.6,4.1,3.9,4.1
            c0.6,0,1.1-0.1,1.4-0.2v-2.6h-1.9v-2.2h4.7v6.5H283.9z"
                  />
                  <path
                    class="st20"
                    d="M289,517.8l-0.9,3.2h-2.9l3.8-12.4h3.7l3.9,12.4h-3l-1-3.2H289z M292.1,515.7l-0.8-2.6
            c-0.2-0.7-0.4-1.7-0.6-2.4h-0.1c-0.2,0.7-0.4,1.7-0.6,2.4l-0.8,2.6H292.1z"
                  />
                  <polygon
                    class="st20"
                    points="299,510.9 295.6,510.9 295.6,508.6 305.2,508.6 305.2,510.9 301.8,510.9 301.8,521 299,521 		"
                  />
                  <polygon
                    class="st20"
                    points="314.1,515.8 309.6,515.8 309.6,518.7 314.7,518.7 314.7,521 306.7,521 306.7,508.6 314.4,508.6
            314.4,510.9 309.6,510.9 309.6,513.5 314.1,513.5 		"
                  />
                  <path
                    class="st20"
                    d="M324.9,521v-2.9h-5.3v-1.8l4.5-7.3h3.5v7h1.4v2.1h-1.4v2.9H324.9z M324.9,516.1v-2.7c0-0.7,0-1.5,0.1-2.2
            h-0.1c-0.4,0.8-0.7,1.5-1.1,2.2l-1.6,2.6l0,0h2.7V516.1z"
                  />
                </g>
                <g>
                  <path
                    class="st19"
                    d="M481.9,476.3c0,13.4-10.9,24.2-24.3,24.2s-24.3-10.8-24.3-24.2c0-13.4,10.9-24.2,24.3-24.2
            C471,452.1,481.9,462.9,481.9,476.3"
                  />
                  <path
                    class="st20"
                    d="M451.7,469.9c-0.5,0.2-1.5,0.4-2.5,0.4c-1.4,0-2.4-0.4-3.1-1c-0.7-0.7-1.1-1.7-1.1-2.8c0-2.5,1.9-4,4.4-4
            c1,0,1.7,0.2,2.1,0.4l-0.4,1.4c-0.4-0.2-0.9-0.3-1.8-0.3c-1.4,0-2.5,0.8-2.5,2.4s1,2.5,2.4,2.5c0.4,0,0.7,0,0.8-0.1v-1.6h-1.2
            v-1.3h2.8L451.7,469.9z"
                  />
                  <path
                    class="st20"
                    d="M454.8,468.3l-0.5,1.9h-1.8l2.3-7.6h2.3l2.4,7.6h-1.9l-0.6-2L454.8,468.3z M456.8,467l-0.5-1.6
            c-0.1-0.4-0.3-1-0.4-1.5l0,0c-0.1,0.4-0.2,1-0.3,1.5l-0.5,1.6H456.8z"
                  />
                  <polygon
                    class="st20"
                    points="461,464.1 458.9,464.1 458.9,462.7 464.8,462.7 464.8,464.1 462.7,464.1 462.7,470.3 460.9,470.3
            "
                  />
                  <polygon
                    class="st20"
                    points="470.2,467.1 467.4,467.1 467.4,468.9 470.5,468.9 470.5,470.3 465.7,470.3 465.7,462.7 470.4,462.7
            470.4,464.1 467.4,464.1 467.4,465.7 470.2,465.7 		"
                  />
                  <path
                    class="st20"
                    d="M451.5,488.9c0.8,0.5,2.7,1.2,4.6,1.2c2.4,0,3.6-1.1,3.6-2.6c0-2-1.9-2.8-3.9-2.8h-1.9v-3.3h1.8
            c1.5,0,3.5-0.6,3.5-2.2c0-1.2-0.9-2-2.9-2c-1.6,0-3.3,0.7-4.1,1.2l-0.9-3.3c1.2-0.8,3.5-1.5,6.1-1.5c4.2,0,6.5,2.2,6.5,4.9
            c0,2.1-1.2,3.7-3.6,4.5v0.1c2.4,0.4,4.2,2.2,4.2,4.8c0,3.4-3.1,5.9-8,5.9c-2.5,0-4.7-0.7-5.8-1.4L451.5,488.9z"
                  />
                </g>
                <g>
                  <path
                    class="st19"
                    d="M600,315.6c0,13.4-10.9,24.2-24.3,24.2c-13.4,0-24.3-10.8-24.3-24.2c0-13.4,10.9-24.2,24.3-24.2
            C589.1,291.5,600,302.3,600,315.6"
                  />
                  <path
                    class="st20"
                    d="M570,308.1c-0.5,0.2-1.5,0.4-2.5,0.4c-1.4,0-2.4-0.4-3.1-1c-0.7-0.7-1.1-1.7-1.1-2.8c0-2.5,1.9-4,4.4-4
            c1,0,1.7,0.2,2.1,0.4l-0.4,1.4c-0.4-0.2-0.9-0.3-1.8-0.3c-1.4,0-2.5,0.8-2.5,2.5c0,1.6,1,2.5,2.4,2.5c0.4,0,0.7,0,0.8-0.1v-1.6
            h-1.2v-1.3h2.8L570,308.1z"
                  />
                  <path
                    class="st20"
                    d="M573.1,306.5l-0.5,2h-1.8l2.3-7.6h2.3l2.4,7.6h-1.9l-0.6-2H573.1z M575,305.3l-0.5-1.6
            c-0.1-0.5-0.3-1-0.4-1.5l0,0c-0.1,0.5-0.2,1-0.3,1.5l-0.5,1.6H575z"
                  />
                  <polygon
                    class="st20"
                    points="579.2,302.3 577.2,302.3 577.2,300.9 583,300.9 583,302.4 580.9,302.4 580.9,308.5 579.2,308.5
            "
                  />
                  <polygon
                    class="st20"
                    points="588.5,305.3 585.7,305.3 585.7,307.1 588.8,307.1 588.8,308.5 583.9,308.5 584,300.9 588.7,300.9
            588.7,302.3 585.7,302.3 585.7,303.9 588.5,303.9 		"
                  />
                  <path
                    class="st20"
                    d="M568.9,331.6v-2.8l2.5-2.2c4.3-3.8,6.4-6,6.4-8.3c0-1.6-0.9-2.9-3.2-2.9c-1.7,0-3.2,0.8-4.2,1.6l-1.3-3.2
            c1.4-1.1,3.8-2,6.4-2c4.5,0,6.9,2.6,6.9,6.1c0,3.3-2.4,5.9-5.2,8.4l-1.8,1.5v0.1h7.4v3.8L568.9,331.6z"
                  />
                </g>
                <polygon
                  class="st6"
                  points="459.6,158.7 492.7,136.5 489.3,131 453.9,152.7 	"
                />
                <polygon
                  class="st6"
                  points="119.5,274.3 122,276.6 177,220.2 175,217.6 	"
                />
                <polygon
                  class="st6"
                  points="471.9,303.7 470.7,304.9 458.2,292.9 459.5,291.7 	"
                />
                <polygon
                  class="st21"
                  points="487.7,282.8 486.5,284 476.4,274.3 477.7,273.1 	"
                />
                <polygon
                  class="st6"
                  points="87.7,263 86.8,261.6 100.1,252.8 101.1,254.1 	"
                />
                <polygon
                  class="st6"
                  points="110.1,289.4 109,288.3 121.2,276 122.4,277.1 	"
                />
                <polygon
                  class="st22"
                  points="133,306.9 131.9,305.7 141.7,295.7 142.8,296.8 	"
                />
                <path
                  class="st23"
                  d="M185.8,250.9c-3.1-4.9-13.5-21-14.1-21.9c-0.2-0.2-0.8-0.8-1.8-1.7l-43.6,44.6c5.3,5.1,12.2,11.8,20,19.4
            L185.8,250.9z"
                />
                <path
                  class="st24"
                  d="M185.8,250.9c-3.1-4.9-13.5-21-14.1-21.9c-0.2-0.2-0.8-0.8-1.8-1.7l-43.6,44.6c5.3,5.1,12.2,11.8,20,19.4
            L185.8,250.9z"
                />
                <path
                  class="st25"
                  d="M454.8,287l-0.2-0.2l-42-40.4l0.2-0.2c0.4-0.4,0.7-0.7,0.8-0.8c0.5-1,7.9-17.6,10-22.5l0.2-0.4l48.5,46.7
            l-0.2,0.2c-4.6,4.7-10.5,10.7-17.1,17.3L454.8,287z M413.5,246.3l41.3,39.8c6.4-6.5,12.1-12.3,16.6-16.9L424,223.5
            c-2.5,5.5-9.9,22.1-9.9,22.1l-0.1,0.1C414.1,245.7,413.9,245.9,413.5,246.3"
                />
                <path
                  class="st24"
                  d="M423.9,222.5c-2.2,5.1-10.1,22.7-10.1,22.7s-0.3,0.3-0.8,0.8l41.8,40.5c6.6-6.7,12.4-12.7,17.1-17.5
            L423.9,222.5z"
                />
                <polygon
                  class="st6"
                  points="246.4,417.9 247.8,418.8 258.2,401.4 256.4,400.5 	"
                />
                <polygon
                  class="st26"
                  points="294.1,17.5 237.2,17.9 224.8,24.8 241.3,41.7 337.7,40.7 347,17.9 	"
                />
                <polygon
                  class="st27"
                  points="44.4,144.5 48.6,145.9 48.4,146.8 60.1,150.6 60.3,149.8 60.7,148.9 44.7,143.7 	"
                />
                <polygon
                  class="st27"
                  points="56.5,127 52.5,125.1 52.3,125.6 67.5,132.7 67.6,132.4 68.3,131.1 57.1,125.8 	"
                />
                <polygon
                  class="st27"
                  points="73.4,84.9 77.1,87.2 76.7,88 87.2,94.6 87.7,93.7 88.1,93.1 73.9,84.2 	"
                />
                <polygon
                  class="st27"
                  points="118.1,34.5 121.1,37.7 120.5,38.4 129,47.4 129.6,46.8 130.3,46.1 118.8,33.9 	"
                />
                <polygon
                  class="st27"
                  points="135.4,20 138,23.6 139.2,22.9 146.2,33 145.3,33.7 144.5,34.3 134.7,20.6 	"
                />
                <polygon
                  class="st27"
                  points="86,67.3 89.6,70.2 90.4,69.2 99.7,77.1 99,78 98.4,78.7 85.4,68.1 	"
                />
                <polygon
                  class="st27"
                  points="163.2,8.2 169.8,18.6 171.3,17.6 164.7,7.2 	"
                />
                <path
                  class="st27"
                  d="M430.3,392.4L430.3,392.4c0.4-0.4,0.8-0.8,1.2-1.3C431.1,391.6,430.7,392,430.3,392.4"
                />
                <path
                  class="st27"
                  d="M437.7,384.8L437.7,384.8c0.4-0.4,0.8-0.8,1.2-1.3C438.5,384,438.1,384.4,437.7,384.8"
                />
                <path
                  class="st27"
                  d="M438.9,383.6L438.9,383.6l-1.2,1.3l0,0C438.1,384.4,438.5,384,438.9,383.6"
                />
                <path
                  class="st27"
                  d="M468.4,353.4c-0.4,0.4-0.8,0.8-1.2,1.3C467.6,354.3,468,353.8,468.4,353.4L468.4,353.4z"
                />
                <path
                  class="st27"
                  d="M481.9,339.6L481.9,339.6c0.4-0.4,0.8-0.8,1.2-1.3C482.7,338.7,482.3,339.2,481.9,339.6"
                />
                <path
                  class="st27"
                  d="M483.1,338.3L483.1,338.3l-1.2,1.3l0,0C482.3,339.2,482.7,338.7,483.1,338.3"
                />
                <path
                  class="st27"
                  d="M489.3,332L489.3,332c0.4-0.4,0.8-0.8,1.2-1.3C490.1,331.1,489.7,331.6,489.3,332"
                />
                <path
                  class="st27"
                  d="M511.4,309.4L511.4,309.4c0.4-0.4,0.8-0.8,1.2-1.3C512.2,308.5,511.8,308.9,511.4,309.4"
                />
                <polygon
                  class="st6"
                  points="483.1,338.3 481.9,339.6 481.9,339.6 	"
                />
                <polygon
                  class="st28"
                  points="256.7,401 247.8,395.9 237.1,411.4 246.4,417.9 	"
                />
                <path
                  class="st27"
                  d="M236.6,411.1L236.6,411.1c0.1,0.1,0.2,0.1,0.3,0.2C236.8,411.3,236.7,411.2,236.6,411.1"
                />
                <path
                  class="st6"
                  d="M177.1,321.2c-0.4-0.4-0.8-0.7-1.1-1.1l-4.5,4.6l1.1,1.1L177.1,321.2z"
                />
                <path
                  class="st6"
                  d="M155.6,300.4l-4.5,4.6l1.1,1.1l4.5-4.6C156.4,301.1,156,300.7,155.6,300.4"
                />
                <path
                  class="st6"
                  d="M165.8,310.2l-4.5,4.6l1.1,1.1l4.5-4.6C166.6,310.9,166.2,310.6,165.8,310.2"
                />
                <path
                  class="st6"
                  d="M122.7,121.8l-4.6-4.5l-1.1,1.1l4.6,4.5C122,122.5,122.4,122.1,122.7,121.8"
                />
                <path
                  class="st6"
                  d="M145.5,290.5l-4.5,4.6l1.1,1.1l4.5-4.6C146.2,291.2,145.8,290.8,145.5,290.5"
                />
                <path
                  class="st6"
                  d="M88.1,196.6l-6.4,0.1v1.6l6.4-0.1C88.1,197.6,88.1,197.1,88.1,196.6"
                />
                <path
                  class="st6"
                  d="M124.1,269.7l-4.5,4.6l1.4,1.3l4.5-4.6C125,270.6,124.5,270.2,124.1,269.7"
                />
                <path
                  class="st6"
                  d="M104.8,248.4l-5.4,3.6l1,1.2l5.4-3.6C105.4,249.2,105.1,248.8,104.8,248.4"
                />
                <path
                  class="st6"
                  d="M379.4,373l-4.6-4.5c-0.4,0.4-0.7,0.8-1.1,1.1l4.6,4.5L379.4,373z"
                />
                <path
                  class="st6"
                  d="M369.2,383.4l0.8-0.8l-4.6-4.5c-0.4,0.4-0.7,0.7-0.7,0.7c-0.1,0.1-0.3,0.3-0.5,0.4l4.6,4.5
            C368.9,383.7,369.1,383.5,369.2,383.4"
                />
                <path
                  class="st6"
                  d="M267.3,398.6c-0.5-0.2-1-0.4-1.5-0.6l-2.2,5.8c0,0,0.2,0.2,0.4,0.4c1.2,0.5,2.3,0.9,3.5,1.3
            c-0.9-0.9-1.8-1.8-2.1-2.1C265.5,403.2,266.2,401.5,267.3,398.6"
                />
                <path
                  class="st6"
                  d="M499.9,159.3l6-2.5l-0.5-1.5l-6,2.5C499.5,158.3,499.7,158.8,499.9,159.3"
                />
                <path
                  class="st6"
                  d="M251.4,390.6c-0.4-0.3-0.9-0.5-1.3-0.8l-3.4,5.4c0.4,0.3,0.9,0.6,1.3,0.8L251.4,390.6z"
                />
                <path
                  class="st6"
                  d="M492.8,134.6l-5.4,3.6c0.3,0.4,0.7,0.8,1,1.2l5.4-3.6L492.8,134.6z"
                />
                <path
                  class="st6"
                  d="M233.7,385l4.5-4.6c-0.3-0.3-0.6-0.5-0.6-0.5s-0.2-0.2-0.6-0.6l-4.5,4.6l0.6,0.6
            C233.2,384.6,233.4,384.8,233.7,385"
                />
                <path
                  class="st6"
                  d="M389.2,362.9l-4.6-4.5c-0.4,0.4-0.7,0.8-1.1,1.1l4.6,4.5L389.2,362.9z"
                />
                <path
                  class="st6"
                  d="M443.6,298l4.6,4.5l1.1-1.1l-4.6-4.5C444.4,297.2,444,297.6,443.6,298"
                />
                <path
                  class="st6"
                  d="M301.9,404.6c-0.5,0-1.1,0-1.6,0v2c0,0,1.3,2.8,2,4.4c0.6,0,1.1,0,1.7-0.1c-0.7-1.5-2-4.5-2.1-4.7
            C301.9,406.2,301.9,405.6,301.9,404.6"
                />
                <path
                  class="st6"
                  d="M505.9,192.2l5-0.1v-1.6l-5,0.1C505.9,191.1,505.9,191.6,505.9,192.2"
                />
                <path
                  class="st6"
                  d="M333.9,398.4L333.9,398.4c1.2,2.9,2.1,5,2.5,5.9c0.5-0.2,1-0.4,1.5-0.6l-2.5-5.9
            C334.9,398,334.4,398.2,333.9,398.4"
                />
                <path
                  class="st6"
                  d="M469.3,118.2l4.5-4.6l-1.1-1.1l-4.5,4.6C468.5,117.5,468.9,117.8,469.3,118.2"
                />
                <path
                  class="st6"
                  d="M349.4,390.7l3.6,5.3c0.4-0.3,0.9-0.5,1.3-0.8l-3.6-5.3C350.3,390.1,349.8,390.4,349.4,390.7"
                />
                <path
                  class="st6"
                  d="M282.3,402.9l-1.1,6.3c0.5,0.1,1,0.2,1.6,0.3l1.1-6.3C283.3,403.1,282.8,403,282.3,402.9"
                />
                <path
                  class="st6"
                  d="M291.6,404.2l-0.3,6.4c0.5,0,1,0.1,1.6,0.1l0.3-6.4C292.7,404.3,292.1,404.3,291.6,404.2"
                />
                <path
                  class="st6"
                  d="M187.3,331c-0.4-0.4-0.8-0.7-1.1-1.1l-4.5,4.6l1.1,1.1L187.3,331z"
                />
                <path
                  class="st6"
                  d="M197.5,340.9c-0.4-0.4-0.8-0.7-1.1-1.1l-4.5,4.6l1.1,1.1L197.5,340.9z"
                />
                <path
                  class="st6"
                  d="M207.7,350.8c-0.4-0.4-0.8-0.7-1.1-1.1l-4.5,4.6l1.1,1.1L207.7,350.8z"
                />
                <path
                  class="st6"
                  d="M471.9,269.1l4.6,4.5l1.1-1.1L473,268C472.6,268.3,472.2,268.7,471.9,269.1"
                />
                <path
                  class="st6"
                  d="M429.3,321.8l-4.6-4.5c-0.4,0.4-0.7,0.8-1.1,1.1l4.6,4.5L429.3,321.8z"
                />
                <path
                  class="st6"
                  d="M453.7,287.7l4.6,4.5l1.1-1.1l-4.6-4.5C454.4,286.9,454.1,287.3,453.7,287.7"
                />
                <path
                  class="st6"
                  d="M318.8,402.8c-0.5,0.1-1,0.2-1.6,0.3l0.4,2.1c0,0,1.5,2.2,2.5,3.9c0.6-0.1,1.1-0.2,1.6-0.4
            c-1.1-1.6-2.6-3.9-2.7-4.1C319.1,404.5,319,403.9,318.8,402.8"
                />
                <path
                  class="st6"
                  d="M433.6,308.2l4.6,4.5l1.1-1.1l-4.6-4.5C434.4,307.4,434,307.8,433.6,308.2"
                />
                <path
                  class="st6"
                  d="M490.9,244.9l5.4,3.4l0.8-1.3l-5.4-3.4C491.4,244,491.2,244.4,490.9,244.9"
                />
                <path
                  class="st6"
                  d="M501.3,223.1l6,2.3l0.5-1.5l-6-2.3C501.6,222.1,501.5,222.6,501.3,223.1"
                />
                <path
                  class="st6"
                  d="M217.8,360.7c-0.4-0.4-0.7-0.7-1.1-1.1l-4.5,4.6l1.1,1.1L217.8,360.7z"
                />
                <path
                  class="st6"
                  d="M228.3,370.8c-0.4-0.4-0.7-0.7-1.1-1.1l-4.5,4.6l1.1,1.1L228.3,370.8z"
                />
                <path
                  class="st6"
                  d="M409.2,342.4l-4.6-4.5c-0.4,0.4-0.7,0.7-1.1,1.1l4.6,4.5L409.2,342.4z"
                />
                <path
                  class="st6"
                  d="M399.2,352.7l-4.6-4.5c-0.4,0.4-0.7,0.8-1.1,1.1l4.6,4.5L399.2,352.7z"
                />
                <path
                  class="st6"
                  d="M419.2,332.1l-4.6-4.5c-0.4,0.4-0.7,0.8-1.1,1.1l4.6,4.5L419.2,332.1z"
                />
                <path
                  class="st6"
                  d="M333.9,398.4c-4.9,1.9-10,3.4-15.2,4.4c0.2,1.1,0.4,1.7,0.4,1.8c0.1,0.2,1.7,2.5,2.7,4.1
            c4.9-1.1,9.8-2.6,14.6-4.4C336,403.3,335.1,401.2,333.9,398.4L333.9,398.4"
                />
                <path
                  class="st6"
                  d="M317.2,403.1c-5.1,0.9-10.2,1.5-15.3,1.6c0,1,0,1.6,0,1.6c0.1,0.2,1.5,3.2,2.1,4.7c5.4-0.2,10.8-0.8,16.2-1.9
            c-1.1-1.7-2.5-3.9-2.5-3.9L317.2,403.1z"
                />
                <path
                  class="st6"
                  d="M267.3,398.6c-1.1,2.9-1.8,4.7-1.9,4.8c0.3,0.3,1.2,1.2,2.1,2.1c4.5,1.6,9,2.8,13.7,3.7l1.1-6.3
            C277.2,401.9,272.2,400.5,267.3,398.6"
                />
                <path
                  class="st6"
                  d="M300.3,404.6c-2.4,0-4.8-0.1-7.1-0.3l-0.3,6.4c3.1,0.2,6.3,0.3,9.5,0.3c-0.7-1.6-2-4.4-2-4.4L300.3,404.6z"
                />
                <path
                  class="st6"
                  d="M283.9,403.2l-1.1,6.3c2.8,0.5,5.7,0.9,8.6,1.1l0.3-6.4C289,404,286.4,403.7,283.9,403.2"
                />
                <path
                  class="st6"
                  d="M499.9,159.3l6-2.5l0,0L499.9,159.3L499.9,159.3"
                />
                <path
                  class="st6"
                  d="M501.3,223.1l6,2.3l0,0L501.3,223.1L501.3,223.1"
                />
                <path
                  class="st6"
                  d="M493.8,135.8L493.8,135.8l-5.4,3.6l0,0L493.8,135.8z"
                />
                <path
                  class="st6"
                  d="M491.7,243.5L491.7,243.5l5.4,3.4l0,0L491.7,243.5z"
                />
                <path
                  class="st24"
                  d="M367,323.7l-9.5-9.2c-3.1,3.2-6.1,6.2-8.9,9.1l9.5,9.2C361,329.9,364,326.9,367,323.7z"
                />
                <path
                  class="st24"
                  d="M320.7,334.9l18.1,17.6c2.3-2.3,5.1-5.2,8.3-8.5L329,326.4C325.8,329.7,323,332.6,320.7,334.9"
                />
                <path
                  class="st24"
                  d="M271,327.1l-17.1,17.5c3.4,3.3,6.4,6.2,8.8,8.5l17.1-17.5C277.3,333.3,274.4,330.4,271,327.1"
                />
                <path
                  class="st24"
                  d="M251.6,323.9c-2.9-2.8-5.9-5.7-9-8.8l-9.2,9.5c3.1,3,6.2,6,9,8.8L251.6,323.9z"
                />
                <path
                  class="st24"
                  d="M252.7,325l-9.3,9.5c3.3,3.2,6.4,6.3,9.3,9l9.3-9.5C259.1,331.3,256,328.2,252.7,325z"
                />
                <path
                  class="st24"
                  d="M222.1,295.4l-9.3,9.5c3.1,3,6.1,5.9,9.1,8.8l9.3-9.5C228.2,301.3,225.2,298.3,222.1,295.4"
                />
                <path
                  class="st24"
                  d="M220.5,276.8L202.7,295c3,2.9,6,5.8,9,8.8l17.7-18.2C226.5,282.6,223.5,279.7,220.5,276.8"
                />
                <path
                  class="st24"
                  d="M232.3,305.3l-9.3,9.5c3.1,3,6.1,5.9,9,8.8l9.3-9.5C238.4,311.2,235.4,308.3,232.3,305.3"
                />
                <path
                  class="st24"
                  d="M377.1,313.4l-9.5-9.2c-3,3.1-6,6.2-8.9,9.2l9.5,9.2C371,319.6,374,316.5,377.1,313.4z"
                />
                <path
                  class="st24"
                  d="M347.5,324.7c-3.1,3.2-6.1,6.2-8.7,8.9l9.5,9.2c2.7-2.7,5.6-5.7,8.7-8.9L347.5,324.7z"
                />
                <path
                  class="st24"
                  d="M323.5,349.3l7.5,11.2c0.6-0.5,1.1-1,1.6-1.6l0,0c0.1-0.1,2-2,5.1-5.2l-9.5-9.2
            C325.9,346.9,324.2,348.6,323.5,349.3"
                />
                <path
                  class="st24"
                  d="M370.1,284.4l18.1,17.6c3-3.1,6-6.1,9-9.2L379,275.2C376,278.3,373.1,281.3,370.1,284.4"
                />
                <path
                  class="st29"
                  d="M388.8,262.5l7,6.8c3-3.1,6-6.2,8.9-9.1l-7-6.8C394.8,256.3,391.9,259.4,388.8,262.5"
                />
                <path
                  class="st29"
                  d="M398.8,252.3l7,6.8c3.1-3.2,6.1-6.3,8.9-9.2l-7-6.8C404.9,246,401.9,249.1,398.8,252.3"
                />
                <path
                  class="st24"
                  d="M368.7,303l9.5,9.2c2.9-3,5.9-6,8.9-9.1l-9.5-9.2C374.6,297,371.6,300,368.7,303"
                />
                <path
                  class="st24"
                  d="M301.3,358.9c0.1,4,0.1,8.6,0.2,13.2c3-0.1,6.1-0.4,9.1-1.1l-2.7-13C305.7,358.6,303.5,358.9,301.3,358.9"
                />
                <path
                  class="st24"
                  d="M273,344.8l-9.3,9.5c2.8,2.7,4.7,4.6,5.5,5.3l7.2-11.4C275.6,347.2,274.4,346.1,273,344.8"
                />
                <path
                  class="st24"
                  d="M309.4,357.7c0.8,3.9,1.8,8.4,2.7,13c3-0.8,6-1.9,8.8-3.3c-1.8-4.3-3.6-8.5-5.1-12.2
            C313.7,356.3,311.6,357.1,309.4,357.7"
                />
                <path
                  class="st24"
                  d="M284.4,354.6c-1.5,3.7-3.1,8-4.8,12.5c2.8,1.5,5.6,2.6,8.6,3.4l2.4-13.1C288.5,356.6,286.4,355.7,284.4,354.6
            "
                />
                <path
                  class="st24"
                  d="M210.4,266.8l-9.2,9.5c3,2.9,6,5.8,9,8.8l9.2-9.5C216.4,272.6,213.4,269.7,210.4,266.8"
                />
                <path
                  class="st29"
                  d="M200.3,256.9l-7,7.1c2.9,2.8,6,5.8,9,8.8l7-7.1C206.2,262.7,203.2,259.7,200.3,256.9"
                />
                <path
                  class="st30"
                  d="M201.2,275.2l-10-9.7l9-9.6l10,9.7L201.2,275.2z M193,265.5l8.1,7.9l7.3-7.7l-8.1-7.9L193,265.5z"
                />
                <path
                  class="st24"
                  d="M190.1,247l-8.2,8.7c2.9,2.8,5.9,5.7,9,8.8l8.2-8.7C196,252.7,193,249.8,190.1,247"
                />
                <path
                  class="st24"
                  d="M317.1,354.4l5.2,12.3c2.6-1.4,5.2-3.2,7.5-5.2l-7.4-11.1C320.7,351.9,319,353.2,317.1,354.4"
                />
                <path
                  class="st24"
                  d="M279.3,350.8c0,0-0.4-0.4-0.7-0.6c0,0-0.4-0.4-1.1-1l-7.2,11.4h0.1c2.4,2.2,5,4,7.7,5.6l4.9-12.5
            C281.8,352.9,280.5,351.9,279.3,350.8"
                />
                <path
                  class="st24"
                  d="M292.1,357.8l-2.4,13.1c3.3,0.8,6.7,1.3,10.2,1.3l-0.2-13.2C297.1,358.9,294.6,358.5,292.1,357.8"
                />
                <path
                  class="st24"
                  d="M335.5,350.7c0,0-36.2,37-69.4-0.4l8.9-9c0,0,26.5,17,49.6-0.9L335.5,350.7z"
                />
                <path
                  class="st31"
                  d="M488,261.7l15.7-25.3L509,209l0.1-32l-6.2-30l-19.1-23.8L381.3,30.5l-4-1.3c0,0,102.9,95.2,103.2,95.5
            c0.2,0.3,15.9,24.5,16.6,25.5c0.3,1.1,8.4,27.3,8.6,28.2c0,0.9,0.4,29.2,0.4,30.2c-0.3,1-8.1,24.5-8.3,25.2
            c-0.4,0.6-14.6,23.5-14.9,24.1C482.4,258.4,364.7,379,364.7,379c-35.9,40.2-89.6,34.5-124.9,2.9l-2.1-1.9
            c0,0-120.1-116.5-123-119.3c-0.2-0.3-17-21.9-17.7-22.8c-0.3-1.1-6.8-24-7.1-24.9c0-0.9,0.4-28.8,0.4-29.8c0.3-0.9,7.7-25.7,8-26.7
            c0.6-0.8,15.7-21.1,15.9-21.5c0.3-0.3,9.9-11.1,9.9-11.1l-4.9-4.6l-8.7,11.5l-13.9,24.3l-8.8,27.8l-3,30.7l5.7,27.4l19.4,23.9
            l123.3,119.6c0.1,0.1,2.2,2,2.2,2c37.8,33.8,96.6,32.4,133.8-3.1L488,261.7z"
                />
                <polygon
                  class="st6"
                  points="357.4,67.9 358.6,69 389.8,37.4 388.4,36 	"
                />
                <polygon
                  class="st6"
                  points="419.8,128.3 452.7,95.5 450.8,93.6 418.6,127.2 	"
                />
                <polygon
                  class="st6"
                  points="399.4,108.6 433,74.3 431.8,73 398.3,107.5 	"
                />
                <polygon
                  class="st6"
                  points="379,88.8 412.2,55.1 411,53.6 377.9,87.7 	"
                />
                <polygon
                  class="st6"
                  points="440.1,148.1 473.6,113.8 472.7,112.6 439,147 	"
                />
                <polygon
                  class="st6"
                  points="441.3,200 507.1,225.3 507.7,223.6 441.9,198.6 	"
                />
                <polygon
                  class="st6"
                  points="451.6,192.9 510.9,192 510.7,190.4 451.6,191.3 	"
                />
                <polygon
                  class="st6"
                  points="454.4,178.3 504.5,157.4 503.9,156 453.8,176.9 	"
                />
                <polygon
                  class="st6"
                  points="435.1,209.8 496,248.2 496.8,246.8 435.9,208.5 	"
                />
                <polygon
                  class="st6"
                  points="382.3,394.7 318.1,332.4 317,333.5 381.2,395.8 	"
                />
                <polygon
                  class="st6"
                  points="406.5,241.9 470.7,304.2 471.8,303.1 407.6,240.7 	"
                />
                <polygon
                  class="st6"
                  points="422.4,221.1 476.1,273 477.2,271.9 423.5,219.9 	"
                />
                <path
                  class="st6"
                  d="M364.9,410.9L315.4,337l-1.3,0.9l49.6,73.9C364.1,411.6,364.5,411.3,364.9,410.9"
                />
                <path
                  class="st6"
                  d="M283.7,339.6l-1.3-0.8l-45.7,72.4c0.4,0.3,0.8,0.6,1.3,1L283.7,339.6z"
                />
                <polygon
                  class="st6"
                  points="196.3,238.4 128.8,307.6 129.9,308.7 197.5,239.5 	"
                />
                <polygon
                  class="st6"
                  points="169.5,195.5 73.4,196.8 73.3,198.4 169.5,197.1 	"
                />
                <polygon
                  class="st6"
                  points="160.3,194.1 90.4,167.1 89.9,168.6 159.7,195.6 	"
                />
                <polygon
                  class="st6"
                  points="156.5,176 103.1,142.5 102.6,143.9 155.7,177.4 	"
                />
                <polygon
                  class="st6"
                  points="159.4,198.2 87.6,228.1 87.8,229.7 160,199.6 	"
                />
                <polygon
                  class="st6"
                  points="156.8,213.7 99.6,251.8 100.6,253.1 157.7,215 	"
                />
                <polygon
                  class="st6"
                  points="279.1,318.7 278,317.6 210.4,386.8 211.6,387.9 	"
                />
                <rect
                  x="186"
                  y="341.9"
                  transform="matrix(0.6989 -0.7152 0.7152 0.6989 -174.5365 270.8103)"
                  class="st6"
                  width="96.7"
                  height="1.6"
                />
                <polygon
                  class="st6"
                  points="258.5,298.7 257.4,297.6 189.8,366.8 191,367.9 	"
                />
                <polygon
                  class="st6"
                  points="248.3,288.9 247.2,287.8 179.7,357 180.8,358.1 	"
                />
                <polygon
                  class="st6"
                  points="238.1,279 237,277.9 169.4,347.1 170.6,348.1 	"
                />
                <polygon
                  class="st6"
                  points="228,269.1 226.8,268 159.3,337.2 160.4,338.3 	"
                />
                <polygon
                  class="st6"
                  points="217.8,259.2 216.7,258.1 149.1,327.3 150.2,328.4 	"
                />
                <polygon
                  class="st6"
                  points="206.5,248.3 138.9,317.4 140.1,318.5 207.6,249.4 	"
                />
                <polygon
                  class="st6"
                  points="289,328.4 287.9,327.3 220.3,396.5 221.5,397.6 	"
                />
                <polygon
                  class="st6"
                  points="215.6,94.4 184.3,63.5 183,64.5 214.5,95.5 	"
                />
                <polygon
                  class="st6"
                  points="195.9,114.5 163.1,82.3 161.8,83.3 194.8,115.6 	"
                />
                <polygon
                  class="st6"
                  points="176.3,134.6 143.2,102.6 142.3,103.9 175.2,135.7 	"
                />
                <polygon
                  class="st6"
                  points="235.2,74.3 204.6,44.5 203.1,45.2 234.1,75.4 	"
                />
                <path
                  class="st6"
                  d="M302.3,407.3c0,0-0.4-0.2-0.4-1.3c-0.1-9.9-0.8-60.3-0.8-60.3h-1.6l0.8,60.3v0.5"
                />
                <path
                  class="st6"
                  d="M319.1,404.6c0,0-0.1-0.7-0.4-1.8c-2.1-10-12.2-56.8-12.2-56.8l-1.5,0.3l12.2,56.8l0.4,2.1"
                />
                <path
                  class="st6"
                  d="M334,405.2c0.8-0.4,3.9-1.6,3.9-1.6l-2.3-5.5l-24.2-57.3l-2,0.7c0,0,18,41.3,24.9,57.7
            c1.6,3.8,1.2,4.4,1.3,4.6c-0.8,0.4-0.7,0.4-0.7,0.4"
                />
                <polyline
                  class="st6"
                  points="283.7,404.6 294.3,347.4 292.5,347.1 282.1,404.4 	"
                />
                <path
                  class="st6"
                  d="M265.6,403.4c0.1-0.2,0.2-0.9,1.3-3.8c5.6-14.5,22.5-56.2,22.5-56.2l-2-0.7l-22,56.5l-1.8,4.5"
                />
                <polygon
                  class="st32"
                  points="124.2,161.7 111.2,153.7 116,146.2 128.9,154.2 	"
                />
                <polygon
                  class="st6"
                  points="116.2,181.8 101.6,177.2 104.3,168.8 118.8,173.3 	"
                />
                <polygon
                  class="st32"
                  points="116.2,181.8 101.6,177.2 104.3,168.8 118.8,173.3 	"
                />
                <rect
                  x="99.4"
                  y="192.4"
                  transform="matrix(0.9977 -6.844932e-02 6.844932e-02 0.9977 -13.2239 7.7861)"
                  class="st6"
                  width="15.2"
                  height="8.9"
                />
                <rect
                  x="99.4"
                  y="192.4"
                  transform="matrix(0.9977 -6.844932e-02 6.844932e-02 0.9977 -13.2239 7.7861)"
                  class="st33"
                  width="15.2"
                  height="8.9"
                />
                <polygon
                  class="st6"
                  points="120.8,219.9 106.7,225.4 103.4,217.2 117.6,211.6 	"
                />
                <polygon
                  class="st32"
                  points="120.8,219.9 106.7,225.4 103.4,217.2 117.6,211.6 	"
                />
                <polygon
                  class="st6"
                  points="475.4,163.8 489.4,157.7 492.9,165.8 479,171.9 	"
                />
                <polygon
                  class="st32"
                  points="475.4,163.8 489.4,157.7 492.9,165.8 479,171.9 	"
                />
                <rect
                  x="481.5"
                  y="187"
                  transform="matrix(0.9997 -2.442137e-02 2.442137e-02 0.9997 -4.5296 12.0016)"
                  class="st6"
                  width="15.2"
                  height="8.9"
                />
                <rect
                  x="481.5"
                  y="187"
                  transform="matrix(0.9997 -2.442137e-02 2.442137e-02 0.9997 -4.5296 12.0016)"
                  class="st34"
                  width="15.2"
                  height="8.9"
                />
                <polygon
                  class="st6"
                  points="478.9,208.9 493.4,213.9 490.5,222.3 476.1,217.3 	"
                />
                <polygon
                  class="st32"
                  points="478.9,208.9 493.4,213.9 490.5,222.3 476.1,217.3 	"
                />
                <path
                  class="st6"
                  d="M291.8,350.8l-1.1,6.4h1.6l-0.1,0.7c1.4,0.4,2.8,0.7,4.2,0.9l-0.2,13.3v3.8c1.3,0.1,2.5,0.2,3.8,0.2h1.6
            c1.2,0,2.4,0.2,3.6,0l-0.1-4.1l-0.5-13.2c1.1-0.1,2.2-0.3,3.3-0.6l-0.2-1.2h1.6l-1.3-6.2C302.6,352,297.1,352,291.8,350.8"
                />
                <path
                  class="st35"
                  d="M299.6,347.7h1.6c0-2.2,0-3.5,0-3.5h-1.6V347.7z"
                />
                <path
                  class="st29"
                  d="M377.2,282.7l36.7-37.5c0,0,9.8-22.1,10.6-23.9l12.4-12.7c10.2-10.4,3.3-29.7,2.9-30.6l0,0l13-26.3L336.7,39
            l-96.4,0.8c0,0-8.9,22.8-9.7,24.8c-1.7,1.7-89.4,91.8-89.4,91.8l11.3,54.1c0,0,17.3,16.8,18.2,17.7c0.7,1.1,15,23.3,15,23.3
            s31.7,30.8,35.3,34.3c-0.2,2.5-0.2,2.5-0.8,11.5L260,336l10.2,9.4c0,0,2.6-2.7,4.2-4.1c13.9,13.5,38.5,12.6,52-1.2
            c1.3,1.1,4.2,3.7,4.2,3.7l9.4-8.8l1.8-1.8l37-37.9C378.8,295.1,377.6,286.2,377.2,282.7"
                />
                <path
                  class="st29"
                  d="M299.8,354.3c-9.9,0-19.2-3.8-26.2-10.6c-1.5-1.5-3-3.2-4.4-5.3l-10.1,0.1l-41.4-40.2l0.8-11.4
            c-6.2-6-34.5-33.5-34.5-33.5l-0.2-0.2l-0.2-0.2c0,0-13.1-20.4-14.8-23.1c-2.2-2.1-18-17.5-18-17.5l-0.6-0.5l-11.8-56.2l0.9-1
            c0,0,82.7-84.9,89-91.4c1.5-3.9,9.5-24.3,9.5-24.3l0.6-1.6l99.1-0.8l118.1,114.8l-13.3,27c1.5,4.6,6.1,22-3.9,32.2L426.3,223
            L416,246.6l-31.3,32c-2.4,2.4-3.9,4-4.9,4.9l1.7,12.4l-40.4,41.4l-10,0.1c-1.4,2.1-2.8,3.9-4.3,5.4c-7,7.2-16.4,11.2-26.5,11.3
            C300.2,354.3,300,354.3,299.8,354.3 M271.9,333.2l0.8,1.2c1.5,2.3,2.9,4.1,4.5,5.6c6.2,6,14.4,9.2,23.1,9.2
            c8.7-0.1,16.8-3.6,22.9-9.8c1.5-1.6,2.9-3.4,4.3-5.7l0.7-1.2l10.7-0.2l1-1l36.2-37l-1.9-14h1.8c4.9-5,32.3-33.1,35.6-36.4
            l10.6-23.9l12.7-13c9.1-9.3,2.4-27.7,2.4-27.9l-0.4-1l0.5-1l12.2-24.6l-114-110.7L242,42.5c-2,5.2-8.4,21.5-9.1,23.2l-0.2,0.5
            l-0.4,0.4c-1.6,1.6-79,81.1-88.4,90.8l10.9,52c3,2.9,16.8,16.3,17.7,17.1l0.2,0.2l0.2,0.2c0.7,1,13.3,20.7,14.8,23.1
            c2.8,2.7,31.7,30.7,35.1,34.1l0.9,0.8l-0.8,11.4l38.2,37.1L271.9,333.2z"
                />
                <path
                  class="st36"
                  d="M360.6,257.1c0,0-11.8-45.9-62.7-45.2c-50.8,0.7-60.5,47.8-60.5,47.8l53.9,52.3c-2,3.7-1.5,8.4,1.7,11.5
            c3.8,3.7,9.9,3.6,13.7-0.2c3.3-3.3,3.6-8.5,1-12.2L360.6,257.1z M304.6,308.3c-3.2-1.8-7.3-1.7-10.3,0.5l-30.9-30l0,0
            c2.5-2.5,2.4-6.6-0.1-9.1l30.5-31.2c2.6,2.5,6.6,2.4,9.1-0.1l0,0l31.3,30.4l0,0c-2.5,2.5-2.4,6.6,0.1,9.1L304.6,308.3z"
                />
                <polygon
                  class="st20"
                  points="378.8,295.1 340,334.8 345.6,340.3 384.4,300.5 	"
                />
                <polygon
                  class="st20"
                  points="220.3,297.2 214.8,302.8 254.7,341.5 260.1,335.9 	"
                />
                <path
                  class="st36"
                  d="M303.9,281.6c-2.5,2.5-6.6,2.6-9.1,0.1s-2.6-6.5-0.1-9.1c2.5-2.5,6.6-2.6,9.1-0.1S306.4,279.1,303.9,281.6"
                />
                <polygon
                  class="st31"
                  points="259.8,273.3 257.4,275.7 255,273.3 257.4,270.9 	"
                />
                <polygon
                  class="st31"
                  points="300.6,231.5 298.2,233.9 295.8,231.6 298.1,229.2 	"
                />
                <polygon
                  class="st31"
                  points="343,272.7 340.6,275.1 338.2,272.7 340.5,270.3 	"
                />
                <polygon
                  class="st31"
                  points="301.8,276.4 296.8,276.4 296.8,275.3 301.8,275.3 	"
                />
                <polygon
                  class="st31"
                  points="301.5,315.1 299.8,316.8 298.1,315.1 298.1,313.1 301.5,313.1 	"
                />
                <path
                  class="st36"
                  d="M170.5,198.4c1.5,1.5,1.5,3.9,0.1,5.3l-7.6,7.8c-1.5,1.5-3.9,1.5-5.4,0.1l-1.1-1.1c-1.5-1.4-1.5-3.9-0.1-5.3
            l7.6-7.8c1.5-1.5,3.9-1.5,5.4-0.1L170.5,198.4z"
                />
                <polygon
                  class="st31"
                  points="162.3,204.6 158.8,208.2 158,207.4 161.5,203.8 	"
                />
                <polygon
                  class="st31"
                  points="189.5,232.1 189.5,234.5 187.1,234.6 185.7,233.2 188.1,230.8 	"
                />
                <rect
                  x="162.3"
                  y="200.6"
                  transform="matrix(0.6983 -0.7158 0.7158 0.6983 -94.2798 178.6453)"
                  class="st31"
                  width="5"
                  height="1.1"
                />
                <polygon
                  class="st31"
                  points="194.2,227.3 194.3,229.7 191.9,229.7 190.4,228.3 192.8,225.9 	"
                />
                <path
                  class="st36"
                  d="M432.4,210.6c-1.5,1.5-3.9,1.5-5.4,0.1l-7.8-7.6c-1.5-1.5-1.5-3.9-0.1-5.3l1.1-1.1c1.5-1.5,3.9-1.5,5.4-0.1
            l7.8,7.6c1.5,1.4,1.5,3.9,0.1,5.3L432.4,210.6z"
                />
                <rect
                  x="424.3"
                  y="197.8"
                  transform="matrix(0.6967 -0.7174 0.7174 0.6967 -14.811 365.5461)"
                  class="st31"
                  width="1.1"
                  height="5"
                />
                <polygon
                  class="st31"
                  points="398.6,229.6 396.2,229.6 396.1,227.2 397.5,225.8 400,228.2 	"
                />
                <rect
                  x="429.1"
                  y="202.5"
                  transform="matrix(0.6968 -0.7173 0.7173 0.6968 -16.7568 370.3444)"
                  class="st31"
                  width="1.1"
                  height="5"
                />
                <polygon
                  class="st31"
                  points="403.4,234.3 401,234.3 401,231.9 402.4,230.5 404.8,232.9 	"
                />
                <polygon
                  class="st31"
                  points="299.8,317.1 299.6,317 138.5,160.9 138.9,160.6 299.8,316.4 445.3,166.9 445.6,167.3 	"
                />
                <path
                  class="st31"
                  d="M153.9,170.8c0.2-0.1,0.5-0.2,0.7-0.4c0.4-0.4,0.4-0.9,0-1.3c-0.5-0.5-1-0.4-1.4,0.1l-0.1,0.1l-0.5-0.5
            l0.1-0.1c0.3-0.3,0.5-0.8,0.1-1.3c-0.3-0.3-0.7-0.3-1,0c-0.2,0.2-0.3,0.4-0.3,0.6l-0.6-0.4c0-0.3,0.2-0.7,0.5-1
            c0.6-0.6,1.4-0.6,1.9-0.1c0.4,0.4,0.5,0.9,0.3,1.4l0,0c0.5-0.3,1.1-0.2,1.7,0.3c0.6,0.6,0.7,1.6,0,2.4c-0.3,0.3-0.6,0.5-0.9,0.6
            L153.9,170.8z"
                />
                <polygon
                  class="st31"
                  points="154.5,164.9 154.5,165 154.2,166 153.6,165.6 153.9,164.3 154.5,163.7 158.4,167.5 157.8,168.1 	"
                />
                <path
                  class="st31"
                  d="M157.8,161.4l-1,1l0.7,1l0.1-0.1c0.2-0.2,0.6-0.4,1-0.5c0.4,0,0.8,0.2,1.2,0.5c0.8,0.8,0.9,1.8,0.1,2.6
            c-0.3,0.3-0.6,0.5-0.9,0.5l-0.4-0.6c0.2-0.1,0.5-0.2,0.7-0.4c0.4-0.4,0.4-0.9-0.1-1.4c-0.6-0.6-1.2-0.4-1.6,0.1
            c-0.1,0.1-0.2,0.2-0.3,0.3l-1.7-2.1l1.5-1.5L157.8,161.4z"
                />
                <path
                  class="st31"
                  d="M158.4,159.3c0.4,0.7,0.7,1.5,0.9,2l-0.3,0.4c-0.3-0.6-0.7-1.3-1.1-1.8L158.4,159.3z"
                />
                <path
                  class="st31"
                  d="M187.9,127.2c0.2-0.1,0.5-0.2,0.7-0.4c0.4-0.4,0.4-0.9,0-1.3c-0.5-0.5-1-0.4-1.4,0.1l-0.1,0.1l-0.5-0.5
            l0.1-0.1c0.3-0.3,0.5-0.8,0.1-1.3c-0.3-0.3-0.7-0.3-1,0c-0.2,0.2-0.3,0.4-0.3,0.6l-0.6-0.4c0-0.3,0.2-0.7,0.5-1
            c0.6-0.6,1.4-0.6,1.9-0.1c0.4,0.4,0.5,0.9,0.3,1.4l0,0c0.5-0.3,1.1-0.2,1.7,0.3c0.6,0.6,0.7,1.6,0,2.4c-0.3,0.3-0.6,0.5-0.9,0.6
            L187.9,127.2z"
                />
                <polygon
                  class="st31"
                  points="188.9,119.5 189.3,119.9 191.6,124.6 191,125.2 188.9,120.7 188.9,120.7 187.5,122.1 187,121.5 	"
                />
                <path
                  class="st31"
                  d="M194.3,122c-0.7,0.7-1.9,0.2-3-0.9c-1.2-1.2-1.7-2.3-0.9-3.1c0.8-0.8,1.9-0.2,3,0.9
            C194.8,120.3,194.9,121.4,194.3,122L194.3,122z M193.8,121.4c0.3-0.3-0.1-0.9-1.1-1.8c-0.9-0.9-1.6-1.3-1.9-1c-0.3,0.3,0.1,1,1,1.9
            C192.8,121.3,193.5,121.7,193.8,121.4L193.8,121.4z"
                />
                <path
                  class="st31"
                  d="M192.3,115.6c0.4,0.7,0.7,1.5,0.9,2l-0.3,0.4c-0.3-0.6-0.7-1.3-1.1-1.8L192.3,115.6z"
                />
                <path
                  class="st31"
                  d="M393.3,112.2c0.1,0.2,0.2,0.5,0.4,0.7c0.4,0.4,0.9,0.4,1.3,0c0.5-0.5,0.4-1-0.1-1.4l-0.1-0.1l0.5-0.5l0.1,0.1
            c0.3,0.3,0.8,0.5,1.3,0.1c0.3-0.3,0.3-0.7,0-1c-0.2-0.2-0.4-0.3-0.7-0.3l0.4-0.6c0.3,0,0.7,0.2,1,0.5c0.6,0.6,0.6,1.4,0.1,1.9
            c-0.4,0.4-0.9,0.5-1.5,0.3l0,0c0.3,0.5,0.2,1.1-0.3,1.7c-0.6,0.6-1.6,0.7-2.4,0c-0.3-0.3-0.5-0.6-0.6-0.9L393.3,112.2z"
                />
                <polygon
                  class="st31"
                  points="400.9,113.3 400.5,113.7 395.9,116 395.2,115.3 399.7,113.2 399.7,113.2 398.4,111.9 398.9,111.3
            "
                />
                <path
                  class="st31"
                  d="M398.5,118.6c-0.7-0.7-0.2-1.9,0.9-3c1.2-1.2,2.3-1.7,3.1-0.9c0.8,0.8,0.2,1.9-0.9,3
            C400.2,119.1,399.1,119.2,398.5,118.6L398.5,118.6z M399.1,118.1c0.3,0.3,0.9-0.1,1.8-1.1c0.9-0.9,1.3-1.6,1-1.9s-1,0.1-1.9,1
            C399.1,117.1,398.7,117.8,399.1,118.1L399.1,118.1z"
                />
                <path
                  class="st31"
                  d="M404.8,116.6c-0.7,0.4-1.5,0.7-2,0.9l-0.4-0.3c0.6-0.3,1.3-0.7,1.8-1.1L404.8,116.6z"
                />
                <path
                  class="st31"
                  d="M423.7,159.2c0.1,0.2,0.2,0.5,0.4,0.7c0.4,0.4,0.9,0.4,1.3,0c0.5-0.5,0.4-1-0.1-1.4l-0.1-0.1l0.5-0.5l0.1,0.1
            c0.3,0.3,0.8,0.5,1.3,0.1c0.3-0.3,0.3-0.7,0-1c-0.2-0.2-0.4-0.3-0.7-0.3l0.4-0.6c0.3,0,0.7,0.2,1,0.5c0.6,0.6,0.6,1.4,0.1,1.9
            c-0.4,0.4-0.9,0.5-1.4,0.3l0,0c0.3,0.5,0.2,1.1-0.3,1.7c-0.6,0.6-1.6,0.7-2.4,0c-0.3-0.3-0.5-0.6-0.5-0.9L423.7,159.2z"
                />
                <path
                  class="st31"
                  d="M425.5,162.2l0.4-0.4l0.8-0.1c1.1-0.2,2.2-0.3,2.8-1c0.4-0.4,0.4-0.8,0.1-1.1s-0.6-0.3-0.8-0.4l0.4-0.6
            c0.3,0,0.7,0.2,1.1,0.5c0.8,0.7,0.5,1.5,0,2.1c-0.7,0.7-1.8,0.9-2.8,1.1l-0.6,0.1l0,0l1.2,1.2l-0.6,0.6L425.5,162.2z"
                />
                <path
                  class="st31"
                  d="M428,164.6l0.4-0.4l0.8-0.1c1.1-0.2,2.2-0.3,2.8-1c0.4-0.4,0.4-0.8,0.1-1.1s-0.6-0.3-0.8-0.4l0.4-0.6
            c0.3,0,0.7,0.2,1.1,0.5c0.8,0.7,0.5,1.5,0,2.1c-0.7,0.7-1.8,0.9-2.8,1.1l-0.6,0.1l0,0l1.2,1.2l-0.5,0.6L428,164.6z"
                />
                <path
                  class="st31"
                  d="M435.3,163.7c-0.7,0.4-1.5,0.7-2,0.9l-0.4-0.3c0.6-0.3,1.3-0.7,1.8-1.1L435.3,163.7z"
                />
                <path
                  class="st31"
                  d="M289.7,52.5v-1.4h-1.9v-0.6l1.7-3.5h0.9v3.3h0.6V51h-0.6v1.4L289.7,52.5z M289.6,50.4v-1.3c0-0.3,0-0.7,0-1
            l0,0c-0.1,0.4-0.3,0.6-0.4,0.9l-0.6,1.3l0,0L289.6,50.4z"
                />
                <path
                  class="st31"
                  d="M292.8,52.6c-1,0-1.5-1.2-1.5-2.8c0-1.7,0.5-2.8,1.5-2.8c1.1,0,1.5,1.3,1.5,2.8
            C294.3,51.7,293.7,52.6,292.8,52.6L292.8,52.6z M292.9,51.8c0.4,0,0.6-0.8,0.6-2s-0.2-2-0.6-2s-0.6,0.7-0.6,2
            C292.2,51.1,292.4,51.8,292.9,51.8L292.9,51.8z"
                />
                <path
                  class="st31"
                  d="M296.5,52.5v-1.4h-1.9v-0.6l1.7-3.5h0.9v3.3h0.6V51h-0.6v1.4L296.5,52.5z M296.5,50.3V49c0-0.3,0-0.7,0-1l0,0
            c-0.1,0.4-0.3,0.6-0.4,0.9l-0.6,1.3l0,0L296.5,50.3z"
                />
                <path
                  class="st31"
                  d="M299.4,46.7c-0.2,0.7-0.5,1.5-0.8,2l-0.5,0.1c0.2-0.6,0.4-1.4,0.5-2L299.4,46.7z"
                />
                <path
                  class="st37"
                  d="M248.4,159.3C248.4,159.3,248.4,159.4,248.4,159.3C248.4,159.4,248.4,159.3,248.4,159.3"
                />
                <polygon
                  class="st31"
                  points="382.3,331.2 386.6,326.8 385.7,325.9 384.2,325.4 383.5,326.4 384.6,326.8 384.7,326.8 381.3,330.2
            "
                />
                <polygon
                  class="st31"
                  points="385.7,334.5 390,330.1 389.1,329.2 387.5,328.7 386.9,329.7 388,330 388,330 384.7,333.5 	"
                />
                <path
                  class="st31"
                  d="M391.2,336.9c0.8-0.8,0.9-1.8,0.3-2.4c-0.3-0.3-0.6-0.4-1-0.3l0,0c0.6-0.4,1.3-0.5,1.9-0.1
            c0.2,0.1,0.3,0.2,0.4,0.3l0.8-0.8c-0.1-0.1-0.3-0.2-0.5-0.4c-0.4-0.3-1-0.5-1.6-0.5c-0.8,0-1.8,0.3-2.8,1.3
            c-1.1,1.1-1.2,2.4-0.4,3.2C389.3,338,390.5,337.6,391.2,336.9 M389.5,335.2c0.2-0.2,0.4-0.4,0.5-0.4c0.2-0.1,0.4-0.1,0.5,0
            c0.3,0.2,0,0.7-0.3,0.9c-0.4,0.4-0.9,0.8-1.1,0.6l0,0C388.8,336.2,389.1,335.7,389.5,335.2"
                />
                <polygon
                  class="st31"
                  points="372.2,342 376.5,337.5 375.5,336.6 374,336.2 373.4,337.1 374.5,337.5 374.5,337.5 371.1,340.9 	"
                />
                <polygon
                  class="st31"
                  points="375.5,345.2 379.8,340.8 378.9,339.9 377.3,339.4 376.7,340.4 377.8,340.8 377.8,340.8 374.5,344.2
            "
                />
                <path
                  class="st31"
                  d="M378.2,347.8l0.9,0.9l1-1l0.4,0.4l0.8-0.8l-0.4-0.4l2.5-2.6l-1-1l-4.1,1.3l-0.7,0.7l1.5,1.5L378.2,347.8z
            M379.4,345.4l1.2-0.4c0.3-0.1,0.6-0.2,0.9-0.3l0,0c-0.2,0.2-0.5,0.4-0.7,0.6L380,346L379.4,345.4L379.4,345.4z"
                />
                <polygon
                  class="st31"
                  points="363,352.2 367.3,347.8 366.4,346.9 364.8,346.4 364.2,347.4 365.3,347.7 365.3,347.7 362,351.2 	"
                />
                <polygon
                  class="st31"
                  points="366.4,355.4 370.7,351 369.7,350.1 368.2,349.6 367.6,350.6 368.7,351 368.7,351 365.3,354.4 	"
                />
                <path
                  class="st31"
                  d="M371.1,358.2l-1.3-1.3l0,0h0.5c1,0,2.1-0.1,2.9-1c0.6-0.6,1-1.6-0.1-2.6c-0.4-0.4-0.9-0.7-1.3-0.7l-0.6,1
            c0.3,0.1,0.6,0.2,0.9,0.4c0.3,0.3,0.3,0.7,0,1c-0.5,0.5-1.4,0.7-2.7,0.8l-1,0.1l-0.7,0.7l2.5,2.5L371.1,358.2z"
                />
                <polygon
                  class="st31"
                  points="238.8,366.8 238.9,366.8 242.3,370.2 243.3,369.1 238.9,364.8 238,365.8 237.5,367.3 238.5,367.9
            "
                />
                <path
                  class="st31"
                  d="M245.9,366.5L245.9,366.5c0.7-0.7,0.6-2-1-3.6c-0.9-0.9-2.4-2-3.5-0.8c-1,1-0.2,2.5,0.9,3.6
            C243.4,366.7,244.9,367.6,245.9,366.5 M242.3,363c0.2-0.2,0.7,0.2,1.6,1.1c1,1,1.3,1.4,1.1,1.6l0,0c-0.2,0.2-0.7,0-1.7-1
            C242.4,363.7,242.1,363.2,242.3,363"
                />
                <path
                  class="st31"
                  d="M247.3,361.9c0.3-0.3,0.3-0.5,0.3-0.8l0,0c0.2,0.4,0.4,0.8,0.4,1.1c0,0.3-0.1,0.5-0.2,0.7
            c-0.1,0.2-0.2,0.3-0.4,0.5l0.9,0.8c0.1-0.2,0.3-0.3,0.4-0.4c0.4-0.5,0.6-1.1,0.6-1.6c0-0.8-0.3-1.9-1.4-2.9
            c-1.1-1.1-2.3-1.3-3.1-0.5c-0.9,0.9-0.5,2.2,0.2,2.9C245.7,362.5,246.7,362.5,247.3,361.9 M245.4,359.5L245.4,359.5
            c0.2-0.2,0.6,0,1,0.4c0.4,0.3,0.5,0.5,0.5,0.6s0,0.3-0.1,0.4c-0.2,0.2-0.7,0-1-0.3C245.4,360.2,245.2,359.8,245.4,359.5"
                />
                <polygon
                  class="st31"
                  points="217.1,388.9 217.1,388.9 220.5,392.3 221.5,391.2 217.1,387 216.2,387.9 215.7,389.4 216.7,390.1
            "
                />
                <path
                  class="st31"
                  d="M224.2,388.7L224.2,388.7c0.7-0.7,0.6-2-1-3.6c-0.9-0.9-2.4-2-3.5-0.8c-1,1-0.2,2.5,0.9,3.6
            C221.6,388.8,223.1,389.7,224.2,388.7 M220.6,385.1c0.2-0.2,0.7,0.2,1.6,1c1,1,1.3,1.4,1.1,1.6l0,0c-0.2,0.2-0.7,0-1.7-1
            C220.6,385.8,220.3,385.3,220.6,385.1"
                />
                <path
                  class="st31"
                  d="M225.5,384c0.3-0.3,0.3-0.5,0.3-0.8l0,0c0.2,0.4,0.4,0.8,0.4,1.1c0,0.3-0.1,0.5-0.2,0.7
            c-0.1,0.2-0.2,0.3-0.4,0.5l0.9,0.8c0.1-0.1,0.3-0.3,0.4-0.5c0.4-0.5,0.6-1.1,0.6-1.6c0-0.8-0.3-1.9-1.4-2.9
            c-1.1-1.1-2.3-1.3-3.1-0.5c-0.9,0.9-0.5,2.2,0.2,2.9C224,384.6,224.9,384.6,225.5,384 M223.6,381.7L223.6,381.7
            c0.2-0.2,0.6,0,1,0.4c0.4,0.3,0.5,0.5,0.5,0.6s0,0.3-0.1,0.4c-0.2,0.2-0.7,0-1-0.4C223.6,382.3,223.4,381.9,223.6,381.7"
                />
                <polygon
                  class="st31"
                  points="229.6,400.8 229.6,400.8 233,404.2 234,403.1 229.6,398.8 228.7,399.8 228.2,401.3 229.2,401.9 	"
                />
                <path
                  class="st31"
                  d="M236.6,400.5L236.6,400.5c0.7-0.7,0.6-2-1-3.6c-0.9-0.9-2.4-2-3.5-0.8c-1,1-0.2,2.5,0.9,3.6
            C234.1,400.7,235.6,401.6,236.6,400.5 M233,397c0.2-0.2,0.7,0.2,1.6,1c1,1,1.3,1.4,1.1,1.6l0,0c-0.2,0.2-0.7,0-1.7-1
            C233.1,397.7,232.8,397.2,233,397"
                />
                <polygon
                  class="st31"
                  points="236.6,393.5 236.6,393.5 238.8,398.2 239.8,397.2 237.4,392.3 236.7,391.6 234.2,394.1 235.2,395
            "
                />
                <polygon
                  class="st31"
                  points="229.2,356.3 229.2,356.3 232.6,359.6 233.6,358.6 229.2,354.3 228.3,355.2 227.8,356.8 228.8,357.4
            "
                />
                <polygon
                  class="st31"
                  points="232.4,353 232.4,352.9 235.9,356.3 236.9,355.3 232.5,351 231.6,351.9 231.1,353.4 232,354.1 	"
                />
                <polygon
                  class="st31"
                  points="235.7,349.6 235.7,349.6 239.1,352.9 240.1,351.9 235.7,347.6 234.8,348.5 234.3,350.1 235.3,350.7
            "
                />
                <polygon
                  class="st31"
                  points="206.5,379.1 206.5,379.1 209.9,382.4 210.9,381.4 206.5,377.1 205.6,378 205.1,379.5 206.1,380.2
            "
                />
                <polygon
                  class="st31"
                  points="209.7,375.7 209.7,375.7 213.2,379.1 214.2,378 209.8,373.7 208.9,374.7 208.4,376.2 209.4,376.8
            "
                />
                <polygon
                  class="st31"
                  points="213,372.4 213,372.4 216.4,375.7 217.5,374.7 213,370.4 212.1,371.3 211.6,372.9 212.6,373.5 	"
                />
                <polygon
                  class="st31"
                  points="218.8,345.5 218.9,345.4 222.3,348.8 223.3,347.8 218.9,343.5 218,344.4 217.5,345.9 218.5,346.6
            "
                />
                <polygon
                  class="st31"
                  points="222.1,342.1 222.1,342.1 225.6,345.4 226.6,344.4 222.2,340.1 221.3,341.1 220.8,342.6 221.7,343.2
            "
                />
                <path
                  class="st31"
                  d="M225,338.8c0.3-0.3,0.6-0.3,0.9-0.1c0.4,0.4,0.1,0.8-0.2,1.2l-0.1,0.1l0.8,0.7l0.1-0.1
            c0.4-0.4,0.9-0.6,1.4-0.2c0.3,0.3,0.3,0.7-0.1,1.2c-0.2,0.2-0.5,0.4-0.8,0.5l0.7,0.9c0.3-0.1,0.7-0.3,1.1-0.7c1-1,0.8-2.2,0.2-2.9
            c-0.6-0.5-1.2-0.6-1.8-0.3l0,0c0.2-0.5,0.1-1.1-0.4-1.6c-0.6-0.5-1.5-0.6-2.3,0.2c-0.4,0.4-0.6,0.9-0.7,1.2l0.9,0.6
            C224.7,339.2,224.8,339,225,338.8"
                />
                <polygon
                  class="st31"
                  points="196.2,369 196.2,368.9 199.7,372.3 200.7,371.3 196.3,367 195.4,367.9 194.9,369.4 195.8,370.1 	"
                />
                <polygon
                  class="st31"
                  points="199.5,365.6 199.5,365.6 202.9,368.9 203.9,367.9 199.5,363.6 198.6,364.6 198.1,366.1 199.1,366.7
            "
                />
                <path
                  class="st31"
                  d="M202.4,362.3c0.3-0.3,0.6-0.3,0.9-0.1c0.4,0.4,0.1,0.8-0.2,1.2l-0.1,0.1l0.8,0.7l0.1-0.1
            c0.4-0.4,0.9-0.6,1.4-0.2c0.3,0.3,0.3,0.7-0.1,1.2c-0.2,0.2-0.5,0.4-0.8,0.5l0.7,0.9c0.3-0.1,0.7-0.3,1.1-0.7c1-1,0.8-2.2,0.2-2.9
            c-0.6-0.5-1.2-0.6-1.8-0.3l0,0c0.2-0.5,0.1-1.1-0.4-1.6c-0.6-0.5-1.5-0.6-2.3,0.2c-0.4,0.4-0.6,0.9-0.7,1.2l0.9,0.6
            C202.1,362.7,202.2,362.5,202.4,362.3"
                />
                <polygon
                  class="st31"
                  points="208.4,336.2 208.4,336.2 211.9,339.6 212.9,338.5 208.5,334.3 207.6,335.2 207.1,336.7 208,337.4
            "
                />
                <polygon
                  class="st31"
                  points="211.7,332.9 211.7,332.9 215.1,336.2 216.1,335.2 211.7,330.9 210.8,331.8 210.3,333.4 211.3,334
            "
                />
                <path
                  class="st31"
                  d="M215.8,331.3c0.5-0.5,1.1-0.8,1.6-0.2c0.4,0.4,0.4,0.8,0,1.3c-0.2,0.2-0.5,0.4-0.8,0.5l0.7,0.9
            c0.3-0.1,0.7-0.4,1-0.7c1-1,0.8-2.3,0-3.2c-0.4-0.4-0.9-0.6-1.4-0.6s-1,0.3-1.1,0.5l-0.1,0.1l-0.6-0.7l1.1-1.2l-0.9-0.9l-1.9,1.9
            l2.1,2.4C215.6,331.5,215.7,331.4,215.8,331.3"
                />
                <polygon
                  class="st31"
                  points="186.2,358.8 186.2,358.8 189.6,362.1 190.6,361.1 186.2,356.8 185.3,357.7 184.8,359.3 185.8,359.9
            "
                />
                <polygon
                  class="st31"
                  points="189.4,355.5 189.4,355.5 192.9,358.8 193.9,357.8 189.5,353.5 188.6,354.4 188.1,355.9 189.1,356.6
            "
                />
                <path
                  class="st31"
                  d="M193.6,353.8c0.5-0.5,1.1-0.8,1.6-0.2c0.4,0.4,0.4,0.9,0,1.3c-0.2,0.2-0.5,0.4-0.8,0.5l0.7,1
            c0.3-0.1,0.7-0.4,1-0.7c1-1,0.8-2.3,0-3.2c-0.4-0.4-0.9-0.6-1.4-0.6s-1,0.3-1.1,0.5l-0.1,0.1l-0.6-0.7l1.1-1.2l-0.9-0.9l-1.9,1.9
            l2.1,2.5C193.3,354.1,193.4,354,193.6,353.8"
                />
                <polygon
                  class="st31"
                  points="199.2,325.2 199.2,325.2 202.6,328.5 203.6,327.5 199.2,323.2 198.3,324.1 197.8,325.7 198.8,326.3
            "
                />
                <polygon
                  class="st31"
                  points="202.4,321.8 202.4,321.8 205.9,325.2 206.9,324.1 202.5,319.9 201.6,320.8 201.1,322.3 202.1,323
            "
                />
                <polygon
                  class="st31"
                  points="206.3,315.9 207,316.6 209.4,321.6 208.4,322.6 206.2,317.9 206.2,317.9 204.8,319.4 203.8,318.5
            "
                />
                <polygon
                  class="st31"
                  points="176.3,349.4 176.3,349.4 179.8,352.7 180.8,351.7 176.4,347.4 175.5,348.3 175,349.9 176,350.5 	"
                />
                <polygon
                  class="st31"
                  points="179.6,346.1 179.6,346 183,349.4 184.1,348.4 179.6,344.1 178.7,345 178.2,346.5 179.2,347.2 	"
                />
                <polygon
                  class="st31"
                  points="183.3,342.1 183.4,342.1 185.5,346.8 186.5,345.8 184.2,340.8 183.5,340.2 181,342.7 181.9,343.6
            "
                />
                <polygon
                  class="st31"
                  points="188.9,315.5 188.9,315.5 188.5,316.6 187.6,316 188.1,314.4 189,313.5 193.4,317.8 192.4,318.8 	"
                />
                <polygon
                  class="st31"
                  points="192.2,312.1 192.2,312.1 191.8,313.3 190.8,312.6 191.3,311.1 192.2,310.2 196.6,314.4 195.6,315.5
            "
                />
                <path
                  class="st31"
                  d="M197.4,312c0.2-0.2,0.3-0.3,0.4-0.5c0.1-0.2,0.2-0.4,0.2-0.7c0-0.3-0.1-0.7-0.4-1.1l0,0
            c0,0.3-0.1,0.5-0.3,0.8c-0.6,0.6-1.6,0.6-2.4-0.2c-0.7-0.7-1.1-2-0.2-2.9c0.8-0.8,2-0.6,3.1,0.5c1.1,1,1.4,2.1,1.4,2.9
            c0,0.5-0.2,1.1-0.6,1.6c-0.1,0.2-0.3,0.3-0.4,0.4L197.4,312z M195.5,308.2c-0.2,0.2,0,0.6,0.4,1c0.3,0.3,0.8,0.6,1,0.3
            c0.1-0.1,0.1-0.3,0.1-0.4c-0.1-0.1-0.2-0.2-0.5-0.6C196.1,308.2,195.6,308,195.5,308.2L195.5,308.2z"
                />
                <polygon
                  class="st31"
                  points="165.9,339.6 165.9,339.6 169.4,343 170.4,341.9 166,337.6 165.1,338.6 164.6,340.1 165.6,340.7 	"
                />
                <polygon
                  class="st31"
                  points="169.2,336.3 169.2,336.3 172.6,339.6 173.6,338.6 169.2,334.3 168.3,335.2 167.8,336.8 168.8,337.4
            "
                />
                <path
                  class="st31"
                  d="M174.4,334.7c0.3-0.3,0.3-0.5,0.3-0.8l0,0c0.2,0.4,0.4,0.8,0.4,1.1c0,0.3-0.1,0.5-0.2,0.7
            c-0.1,0.2-0.2,0.3-0.4,0.5l0.9,0.8c0.1-0.2,0.3-0.3,0.4-0.4c0.4-0.5,0.6-1.1,0.6-1.6c0-0.8-0.3-1.9-1.4-2.9
            c-1.1-1.1-2.3-1.3-3.1-0.5c-0.9,0.9-0.5,2.2,0.2,2.9C172.8,335.3,173.8,335.3,174.4,334.7 M172.5,332.4L172.5,332.4
            c0.2-0.2,0.6,0,1,0.4c0.4,0.3,0.5,0.5,0.5,0.6s0,0.3-0.1,0.4c-0.2,0.2-0.7,0-1-0.3C172.5,333,172.3,332.6,172.5,332.4"
                />
                <polygon
                  class="st31"
                  points="179.4,304.7 179.3,304.7 179,305.8 178,305.2 178.5,303.7 179.4,302.7 183.8,307 182.8,308 	"
                />
                <path
                  class="st31"
                  d="M185,305.7l-0.7-0.7l-0.1-1c-0.2-1.3-0.3-2.2-0.8-2.7c-0.3-0.3-0.7-0.3-1,0s-0.4,0.6-0.4,0.9l-1-0.6
            c0.1-0.4,0.3-0.9,0.7-1.3c1-1.1,2-0.7,2.7-0.1c0.8,0.8,0.9,1.9,1,2.9v0.5l0,0l1.3-1.3l0.9,0.9L185,305.7z"
                />
                <polygon
                  class="st31"
                  points="185.9,298 185.9,298 185.5,299.1 184.5,298.5 185,297 185.9,296 190.3,300.3 189.3,301.4 	"
                />
                <polygon
                  class="st31"
                  points="156,330 156,330 159.5,333.3 160.5,332.3 156.1,328 155.2,328.9 154.7,330.5 155.6,331.1 	"
                />
                <path
                  class="st31"
                  d="M159,326.6c0.3-0.3,0.7-0.3,1,0c0.5,0.5,0.7,1.4,0.8,2.7l0.1,1l0.7,0.7l2.5-2.5l-0.9-0.9l-1.3,1.3l0,0v-0.5
            c0-1-0.1-2.1-1-2.9c-0.6-0.6-1.6-1-2.7,0.1c-0.4,0.4-0.7,0.9-0.7,1.3l1,0.6C158.6,327.2,158.8,326.9,159,326.6"
                />
                <polygon
                  class="st31"
                  points="162.5,323.3 162.6,323.3 166,326.6 167,325.6 162.6,321.3 161.7,322.2 161.2,323.8 162.2,324.4 	"
                />
                <polygon
                  class="st31"
                  points="169.5,295.1 169.5,295.1 169.1,296.2 168.2,295.6 168.7,294.1 169.6,293.1 174,297.4 173,298.4 	"
                />
                <path
                  class="st31"
                  d="M175.2,296.1l-0.7-0.7l-0.1-1c-0.2-1.3-0.3-2.2-0.8-2.7c-0.3-0.3-0.7-0.3-1,0s-0.4,0.6-0.4,0.9l-1-0.6
            c0.1-0.4,0.3-0.9,0.7-1.3c1-1.1,2-0.7,2.7-0.1c0.8,0.8,0.9,1.9,1,2.9v0.5l0,0l1.3-1.3l0.9,0.9L175.2,296.1z"
                />
                <path
                  class="st31"
                  d="M177.7,291.7c0.3-0.1,0.6-0.3,0.8-0.5c0.4-0.4,0.4-0.9,0.1-1.2c-0.5-0.4-1-0.2-1.4,0.2l-0.1,0.1l-0.8-0.7
            l0.1-0.1c0.3-0.3,0.6-0.8,0.2-1.2c-0.3-0.3-0.6-0.2-0.9,0.1c-0.2,0.2-0.3,0.4-0.4,0.7l-0.9-0.6c0.1-0.3,0.3-0.8,0.7-1.2
            c0.8-0.8,1.7-0.7,2.3-0.2c0.4,0.4,0.6,1,0.4,1.6l0,0c0.6-0.3,1.3-0.2,1.8,0.3c0.7,0.6,0.8,1.8-0.2,2.9c-0.4,0.4-0.8,0.6-1.1,0.7
            L177.7,291.7z"
                />
                <polygon
                  class="st31"
                  points="145.7,319.8 145.7,319.8 145.3,320.9 144.3,320.3 144.8,318.8 145.7,317.8 150.1,322.1 149.1,323.1
            "
                />
                <path
                  class="st31"
                  d="M151.4,320.8l-0.7-0.7l-0.1-1c-0.2-1.3-0.3-2.2-0.8-2.7c-0.3-0.3-0.7-0.3-1,0s-0.4,0.6-0.4,0.9l-1-0.6
            c0.1-0.4,0.4-0.9,0.7-1.3c1-1.1,2-0.7,2.7-0.1c0.8,0.8,0.9,1.9,1,2.9v0.5l0,0l1.3-1.3l0.9,0.9L151.4,320.8z"
                />
                <path
                  class="st31"
                  d="M153.8,316.4c0.3-0.1,0.6-0.3,0.8-0.5c0.4-0.4,0.4-0.9,0.1-1.2c-0.5-0.4-1-0.2-1.4,0.2l-0.1,0.1l-0.8-0.7
            l0.1-0.1c0.3-0.3,0.6-0.8,0.2-1.2c-0.3-0.3-0.6-0.2-0.9,0.1c-0.2,0.2-0.3,0.4-0.4,0.7l-0.9-0.6c0.1-0.3,0.3-0.8,0.7-1.2
            c0.8-0.8,1.7-0.7,2.3-0.2c0.4,0.4,0.6,1,0.4,1.6l0,0c0.6-0.3,1.3-0.2,1.8,0.3c0.7,0.6,0.8,1.8-0.2,2.9c-0.4,0.4-0.8,0.6-1.1,0.7
            L153.8,316.4z"
                />
                <polygon
                  class="st31"
                  points="159.9,284.3 159.9,284.3 159.5,285.4 158.5,284.8 159.1,283.3 160,282.3 164.4,286.6 163.4,287.6
            "
                />
                <path
                  class="st31"
                  d="M165.6,285.3l-0.7-0.7l-0.1-1c-0.2-1.3-0.3-2.2-0.8-2.7c-0.3-0.3-0.7-0.3-1,0s-0.4,0.6-0.4,0.9l-1-0.6
            c0.1-0.4,0.4-0.9,0.7-1.3c1-1.1,2-0.7,2.7-0.1c0.8,0.8,0.9,1.9,1,2.9v0.5l0,0l1.3-1.3l0.9,0.9L165.6,285.3z"
                />
                <path
                  class="st31"
                  d="M167.7,276.2l-1.1,1.2l0.6,0.7l0.1-0.1c0.2-0.2,0.6-0.5,1.1-0.5s1,0.2,1.4,0.6c0.9,0.8,1,2.1,0,3.2
            c-0.3,0.3-0.7,0.6-1,0.7l-0.7-0.9c0.3-0.1,0.5-0.3,0.8-0.5c0.4-0.4,0.4-0.9,0-1.3c-0.5-0.5-1.1-0.2-1.6,0.2
            c-0.1,0.1-0.2,0.2-0.3,0.3l-2.1-2.5l1.9-1.9L167.7,276.2z"
                />
                <polygon
                  class="st31"
                  points="135.5,309.9 135.4,309.9 135.1,311 134.1,310.4 134.6,308.8 135.5,307.9 139.9,312.2 138.9,313.2
            "
                />
                <path
                  class="st31"
                  d="M141.1,310.9l-0.7-0.7l-0.1-1c-0.2-1.3-0.3-2.2-0.8-2.7c-0.3-0.3-0.7-0.3-1,0s-0.4,0.6-0.4,0.9l-1-0.6
            c0.1-0.4,0.4-0.9,0.7-1.3c1-1.1,2-0.7,2.7-0.1c0.8,0.8,0.9,1.9,1,2.9v0.5l0,0l1.3-1.3l0.9,0.9L141.1,310.9z"
                />
                <path
                  class="st31"
                  d="M143.3,301.7l-1.1,1.2l0.6,0.7l0.1-0.1c0.2-0.2,0.6-0.5,1.1-0.5s1,0.2,1.4,0.6c0.8,0.8,1,2.1,0,3.2
            c-0.3,0.3-0.8,0.6-1,0.7l-0.7-0.9c0.3-0.1,0.5-0.3,0.8-0.5c0.4-0.4,0.4-0.9,0-1.3c-0.6-0.5-1.1-0.2-1.6,0.3
            c-0.1,0.1-0.2,0.2-0.3,0.3l-2.1-2.4l1.9-1.9L143.3,301.7z"
                />
                <polygon
                  class="st31"
                  points="145.7,269.6 145.7,269.6 145.4,270.7 144.4,270.1 144.9,268.5 145.8,267.6 150.2,271.9 149.2,272.9
            "
                />
                <path
                  class="st31"
                  d="M151.4,270.6l-0.7-0.7l-0.1-1c-0.2-1.3-0.3-2.2-0.8-2.7c-0.3-0.3-0.7-0.3-1,0s-0.4,0.6-0.4,0.9l-1-0.6
            c0.1-0.4,0.4-0.9,0.7-1.3c1-1.1,2-0.7,2.7-0.1c0.8,0.8,0.9,1.9,1,2.9v0.5l0,0l1.3-1.3l0.9,0.9L151.4,270.6z"
                />
                <polygon
                  class="st31"
                  points="152.9,260.3 153.6,261 155.9,266 155,267 152.8,262.3 152.8,262.3 151.3,263.8 150.4,262.9 	"
                />
                <polygon
                  class="st31"
                  points="119.6,295.7 119.6,295.7 119.2,296.8 118.2,296.2 118.7,294.7 119.6,293.7 124,298 123,299.1 	"
                />
                <path
                  class="st31"
                  d="M125.3,296.8l-0.7-0.7l-0.1-1c-0.2-1.3-0.3-2.2-0.8-2.7c-0.3-0.3-0.7-0.3-1,0s-0.4,0.6-0.4,0.9l-1-0.6
            c0.1-0.4,0.4-0.9,0.7-1.3c1-1.1,2-0.7,2.7-0.1c0.8,0.8,0.9,1.9,1,2.9v0.5l0,0l1.3-1.3l0.9,0.9L125.3,296.8z"
                />
                <polygon
                  class="st31"
                  points="126.7,286.5 127.4,287.2 129.8,292.1 128.8,293.2 126.6,288.5 126.6,288.4 125.2,289.9 124.2,289
            "
                />
                <polygon
                  class="st31"
                  points="125.2,249.3 125.2,249.3 124.8,250.4 123.8,249.8 124.3,248.3 125.2,247.3 129.6,251.6 128.6,252.7
            "
                />
                <path
                  class="st31"
                  d="M130.9,250.4l-0.7-0.7l-0.1-1c-0.2-1.3-0.3-2.2-0.8-2.7c-0.3-0.3-0.7-0.3-1,0s-0.4,0.6-0.4,0.9l-1-0.6
            c0.1-0.4,0.4-0.9,0.7-1.3c1-1.1,2-0.7,2.7-0.1c0.8,0.8,0.9,1.9,1,2.9v0.5l0,0l1.3-1.3l0.9,0.9L130.9,250.4z"
                />
                <path
                  class="st31"
                  d="M133.7,245.8c0.2-0.2,0.3-0.3,0.4-0.5c0.1-0.2,0.2-0.4,0.2-0.7s-0.1-0.7-0.4-1.1l0,0c0,0.3-0.1,0.5-0.3,0.8
            c-0.6,0.6-1.6,0.6-2.4-0.2c-0.7-0.7-1.1-2-0.2-2.9c0.8-0.8,2-0.6,3.1,0.5c1.1,1,1.4,2.1,1.4,2.9c0,0.5-0.2,1.1-0.6,1.6
            c-0.1,0.2-0.3,0.3-0.4,0.4L133.7,245.8z M131.7,242.1c-0.2,0.2,0,0.6,0.4,1c0.3,0.3,0.8,0.6,1,0.3c0.1-0.1,0.1-0.3,0.1-0.4
            c-0.1-0.1-0.2-0.2-0.5-0.6C132.3,242,131.9,241.9,131.7,242.1L131.7,242.1z"
                />
                <polygon
                  class="st31"
                  points="98.6,274.3 98.5,274.3 98.2,275.4 97.2,274.8 97.7,273.3 98.6,272.3 103,276.6 102,277.6 	"
                />
                <path
                  class="st31"
                  d="M104.2,275.3l-0.7-0.7l-0.1-1c-0.2-1.3-0.3-2.2-0.8-2.7c-0.3-0.3-0.7-0.3-1,0s-0.4,0.6-0.4,0.9l-1-0.6
            c0.1-0.4,0.4-0.9,0.7-1.3c1-1.1,2-0.7,2.7-0.1c0.8,0.8,0.9,1.9,1,2.9v0.5l0,0l1.3-1.3l0.9,0.9L104.2,275.3z"
                />
                <path
                  class="st31"
                  d="M107.1,270.8c0.2-0.2,0.3-0.3,0.4-0.5s0.2-0.4,0.2-0.7c0-0.3-0.1-0.7-0.4-1.1l0,0c0,0.3-0.1,0.5-0.3,0.8
            c-0.6,0.6-1.6,0.6-2.4-0.2c-0.7-0.7-1.1-2-0.2-2.9c0.8-0.8,2-0.6,3.1,0.5c1.1,1,1.4,2.1,1.4,2.9c0,0.5-0.2,1.1-0.6,1.6
            c-0.1,0.2-0.3,0.3-0.4,0.4L107.1,270.8z M105.1,267c-0.2,0.2,0,0.6,0.4,1c0.3,0.3,0.8,0.6,1,0.3c0.1-0.1,0.1-0.3,0.1-0.4
            c-0.1-0.1-0.2-0.2-0.5-0.6C105.7,267,105.3,266.8,105.1,267L105.1,267z"
                />
                <polygon
                  class="st31"
                  points="357.8,357.4 356.2,356.9 355.6,357.9 356.7,358.2 356.7,358.3 353.4,361.7 354.4,362.7 358.7,358.3
            "
                />
                <polygon
                  class="st31"
                  points="357.8,366 362.1,361.6 361.1,360.7 359.6,360.1 359,361.1 360.1,361.5 360.1,361.5 356.7,364.9 	"
                />
                <path
                  class="st31"
                  d="M360.4,368.6c0.7,0.7,2,0.6,3.6-1c0.9-0.9,2-2.4,0.8-3.5c-1-1-2.5-0.2-3.6,0.9
            C360.2,366,359.3,367.5,360.4,368.6L360.4,368.6z M362.2,366c1-1,1.4-1.3,1.7-1c0.2,0.2-0.2,0.7-1.1,1.6c-1,1-1.4,1.3-1.6,1.1l0,0
            C361,367.5,361.2,367,362.2,366"
                />
                <polygon
                  class="st31"
                  points="346.7,367.9 346.6,367.9 345.6,367.4 346.3,366.5 347.8,367.2 348.6,368.2 343.8,372 342.9,370.9
            "
                />
                <path
                  class="st31"
                  d="M346,374.9c-0.9-1.2,0.2-2.5,1.3-3.4c1.3-1,2.8-1.6,3.7-0.5c1,1.3-0.3,2.6-1.3,3.4
            C348,375.8,346.7,375.8,346,374.9L346,374.9z M347,374.2c0.2,0.2,0.6,0,1.7-0.9c1-0.8,1.4-1.2,1.2-1.5c-0.2-0.2-0.7-0.1-1.8,0.8
            C347.1,373.5,346.8,373.9,347,374.2L347,374.2z"
                />
                <path
                  class="st31"
                  d="M353.9,374.7c0.5,0.7,0.6,1.7-0.2,2.3c-0.3,0.2-0.8,0.5-1.5,0.2l0,0c0.1,0.6-0.1,1.3-0.6,1.7
            c-1,0.8-2,0.4-2.7-0.4s-0.7-1.9,0.2-2.6c0.6-0.4,1.2-0.5,1.8-0.3l0,0c-0.1-0.6,0.2-1.1,0.6-1.4
            C352.3,373.7,353.3,373.9,353.9,374.7L353.9,374.7z M349.7,378c0.2,0.3,0.6,0.1,1-0.1c0.4-0.3,0.5-0.8,0.4-1.1
            c-0.3-0.1-0.6,0-1,0.3C349.7,377.3,349.5,377.7,349.7,378L349.7,378z M353.2,375.3c-0.2-0.3-0.6-0.1-0.8,0.1
            c-0.3,0.2-0.4,0.5-0.3,0.9c0.2,0.1,0.6,0,0.8-0.2C353.1,375.9,353.4,375.6,353.2,375.3L353.2,375.3z"
                />
                <polygon
                  class="st31"
                  points="364.4,394.3 369.2,390.5 368.4,389.5 366.9,388.8 366.2,389.7 367.2,390.2 367.2,390.2 363.5,393.2
            "
                />
                <path
                  class="st31"
                  d="M366.6,397.2c0.6,0.8,1.9,0.8,3.7-0.5c1-0.8,2.3-2.1,1.3-3.4c-0.9-1.1-2.4-0.5-3.7,0.5
            C366.8,394.7,365.7,396,366.6,397.2L366.6,397.2z M368.8,394.9c1.1-0.9,1.6-1.1,1.8-0.8c0.2,0.2-0.3,0.7-1.2,1.5
            c-1.1,0.9-1.5,1.1-1.7,0.9l0,0C367.4,396.2,367.7,395.8,368.8,394.9"
                />
                <path
                  class="st31"
                  d="M372.2,401.2c0.6-0.4,0.8-1.1,0.6-1.7l0,0c0.7,0.3,1.3,0,1.5-0.2c0.8-0.6,0.7-1.6,0.2-2.3l0,0
            c-0.6-0.8-1.7-1.1-2.5-0.4c-0.4,0.3-0.7,0.8-0.6,1.4l0,0c-0.6-0.2-1.2-0.2-1.8,0.3c-0.9,0.7-0.8,1.7-0.2,2.6
            C370.2,401.7,371.2,402,372.2,401.2 M372.9,397.6c0.2-0.2,0.6-0.3,0.8-0.1l0,0c0.2,0.3,0,0.6-0.3,0.8c-0.2,0.2-0.6,0.3-0.8,0.2
            C372.5,398.2,372.7,397.9,372.9,397.6 M370.7,399.3c0.3-0.3,0.7-0.3,1-0.3c0.1,0.3,0,0.8-0.4,1.1c-0.3,0.3-0.7,0.4-1,0.1l0,0
            C370.1,400,370.3,399.6,370.7,399.3"
                />
                <polygon
                  class="st31"
                  points="392.2,320.7 396.5,316.3 395.6,315.4 394,314.9 393.4,315.9 394.5,316.2 394.5,316.3 391.2,319.7
            "
                />
                <polygon
                  class="st31"
                  points="395.6,324 399.9,319.6 398.9,318.7 397.4,318.2 396.8,319.1 397.9,319.5 397.9,319.5 394.5,322.9
            "
                />
                <path
                  class="st31"
                  d="M400.8,326.6c0.5-0.5,0.6-1.2,0.4-1.8l0,0c0.8,0.2,1.2-0.1,1.5-0.4c0.7-0.7,0.5-1.7-0.1-2.3l0,0
            c-0.7-0.7-1.8-0.9-2.5-0.1c-0.3,0.3-0.5,0.8-0.4,1.5l0,0c-0.6-0.1-1.2,0-1.7,0.5c-0.8,0.8-0.6,1.8,0.2,2.6
            C398.9,327.3,400,327.5,400.8,326.6 M401.1,322.9c0.2-0.2,0.6-0.4,0.8-0.2l0,0c0.2,0.2,0,0.6-0.2,0.8c-0.2,0.2-0.6,0.4-0.8,0.3
            C400.8,323.5,400.9,323.2,401.1,322.9 M399.1,324.9c0.3-0.3,0.7-0.4,0.9-0.4c0.1,0.3,0.1,0.8-0.2,1.2c-0.3,0.3-0.7,0.5-0.9,0.2l0,0
            C398.6,325.6,398.8,325.2,399.1,324.9"
                />
                <polygon
                  class="st31"
                  points="404.2,305.3 404.2,305.3 403.1,305 403.7,304 405.3,304.5 406.2,305.4 401.9,309.8 400.9,308.8 	"
                />
                <path
                  class="st31"
                  d="M403.2,311l0.7-0.7l1-0.1c1.3-0.1,2.2-0.3,2.7-0.8c0.3-0.3,0.3-0.7,0-1c-0.3-0.2-0.6-0.4-0.9-0.4l0.6-1
            c0.4,0.1,0.9,0.3,1.3,0.7c1.1,1,0.7,2,0.1,2.6c-0.8,0.8-1.9,0.9-2.9,1h-0.5l0,0l1.3,1.3l-0.9,0.9L403.2,311z"
                />
                <path
                  class="st31"
                  d="M407.8,315.7c0.7,0.7,2,0.6,3.6-1c0.9-0.9,2-2.4,0.8-3.5c-1-1-2.5-0.2-3.6,0.9
            C407.7,313.1,406.8,314.6,407.8,315.7L407.8,315.7z M409.7,313.1c1-1,1.4-1.2,1.7-1c0.2,0.2-0.2,0.7-1,1.6c-1,1-1.4,1.3-1.6,1.1
            l0,0C408.5,314.5,408.7,314.1,409.7,313.1"
                />
                <polygon
                  class="st31"
                  points="413.8,294.2 413.8,294.2 412.6,293.8 413.3,292.8 414.8,293.3 415.8,294.2 411.5,298.6 410.4,297.6
            "
                />
                <path
                  class="st31"
                  d="M412.7,299.8l0.7-0.7l1-0.1c1.3-0.2,2.2-0.3,2.7-0.8c0.3-0.3,0.3-0.7,0-1s-0.6-0.4-0.9-0.4l0.6-1
            c0.4,0.1,0.9,0.3,1.3,0.7c1.1,1,0.7,2,0.1,2.6c-0.8,0.8-1.9,0.9-2.9,1h-0.5l0,0l1.3,1.3l-0.9,0.9L412.7,299.8z"
                />
                <path
                  class="st31"
                  d="M416.1,303.1l0.7-0.7l1-0.1c1.3-0.2,2.2-0.3,2.7-0.8c0.3-0.3,0.3-0.7,0-1s-0.6-0.4-0.9-0.4l0.6-1
            c0.4,0.1,0.9,0.3,1.3,0.7c1.1,1,0.7,2,0.1,2.6c-0.8,0.8-1.9,0.9-2.9,1h-0.5l0,0l1.3,1.3l-0.9,0.9L416.1,303.1z"
                />
                <polygon
                  class="st31"
                  points="422.3,283.5 422.3,283.4 421.2,283.1 421.8,282.1 423.4,282.6 424.3,283.5 420,287.9 419,286.9 	"
                />
                <path
                  class="st31"
                  d="M421.3,289.1l0.7-0.7l1-0.1c1.3-0.2,2.2-0.3,2.7-0.8c0.3-0.3,0.3-0.7,0-1c-0.3-0.2-0.6-0.4-0.9-0.4l0.6-1
            c0.4,0.1,0.9,0.4,1.3,0.7c1.1,1,0.7,2,0.1,2.6c-0.8,0.8-1.9,0.9-2.9,1h-0.5l0,0l1.3,1.3l-0.9,0.9L421.3,289.1z"
                />
                <path
                  class="st31"
                  d="M426.1,293.8l1-1l-1.5-1.5l0.7-0.7l4.1-1.3l1,1l-2.5,2.6l0.4,0.4l-0.8,0.8l-0.4-0.4l-1,1L426.1,293.8z
            M427.9,292l0.7-0.7c0.2-0.2,0.5-0.4,0.7-0.6l0,0c-0.3,0.1-0.6,0.2-0.9,0.3l-1.2,0.4l0,0L427.9,292z"
                />
                <polygon
                  class="st31"
                  points="431.6,272.4 431.6,272.4 430.5,272 431.1,271 432.7,271.5 433.6,272.4 429.3,276.8 428.3,275.8 	"
                />
                <path
                  class="st31"
                  d="M430.6,278l0.7-0.7l1-0.1c1.3-0.2,2.2-0.3,2.7-0.8c0.3-0.3,0.3-0.7,0-1c-0.3-0.2-0.6-0.4-0.9-0.4l0.6-1
            c0.4,0.1,0.9,0.3,1.3,0.7c1.1,1,0.7,2,0.1,2.6c-0.8,0.8-1.9,0.9-2.9,1h-0.5l0,0l1.3,1.3l-0.9,0.9L430.6,278z"
                />
                <path
                  class="st31"
                  d="M439.8,280c-0.1-0.1-0.3-0.2-0.4-0.3c-0.6-0.4-1.3-0.3-1.9,0.1l0,0c0.3,0,0.7,0,1,0.3
            c0.6,0.6,0.5,1.5-0.3,2.4c-0.7,0.7-2,1.2-2.9,0.3c-0.9-0.8-0.7-2.1,0.4-3.2c1-1,2-1.3,2.8-1.3c0.6,0,1.2,0.2,1.6,0.5
            c0.3,0.2,0.4,0.3,0.5,0.4L439.8,280z M436,282c0.3,0.3,0.7-0.1,1.1-0.6c0.2-0.3,0.5-0.7,0.3-0.9c-0.1-0.1-0.3-0.1-0.5,0
            c-0.1,0-0.2,0.2-0.5,0.4C436,281.3,435.8,281.7,436,282L436,282z"
                />
                <polygon
                  class="st31"
                  points="444,256 443.9,256 442.8,255.6 443.5,254.7 445,255.2 445.9,256.1 441.6,260.5 440.6,259.5 	"
                />
                <path
                  class="st31"
                  d="M442.9,261.7l0.7-0.7l1-0.1c1.3-0.2,2.2-0.3,2.7-0.8c0.3-0.3,0.3-0.7,0-1s-0.6-0.4-0.9-0.4l0.6-1
            c0.4,0.1,0.9,0.3,1.3,0.7c1.1,1,0.7,2,0.1,2.6c-0.8,0.8-1.9,0.9-2.9,1H445l0,0l1.3,1.3l-0.9,0.9L442.9,261.7z"
                />
                <path
                  class="st31"
                  d="M452.1,261.9c0.6,0.6,0.8,1.6,0.1,2.3c-0.2,0.2-0.7,0.6-1.5,0.4l0,0c0.2,0.6,0.1,1.3-0.4,1.8
            c-0.9,0.9-1.9,0.7-2.7,0c-0.8-0.7-0.9-1.8-0.2-2.6c0.5-0.5,1.2-0.6,1.7-0.5l0,0c-0.1-0.6,0.1-1.1,0.4-1.5
            C450.3,261,451.3,261.2,452.1,261.9L452.1,261.9z M448.3,265.6c0.3,0.3,0.6,0.1,0.9-0.2c0.4-0.4,0.4-0.9,0.3-1.2
            c-0.3,0-0.6,0.1-1,0.4C448.2,265,448,265.4,448.3,265.6L448.3,265.6z M451.3,262.5c-0.2-0.2-0.6-0.1-0.8,0.2
            c-0.2,0.3-0.3,0.6-0.2,1c0.2,0.1,0.6-0.1,0.8-0.3C451.4,263.1,451.6,262.8,451.3,262.5L451.3,262.5z"
                />
                <polygon
                  class="st31"
                  points="471.7,283.5 471.6,283.5 470.5,283.1 471.2,282.1 472.7,282.6 473.6,283.5 469.3,287.9 468.3,286.9
            "
                />
                <path
                  class="st31"
                  d="M470.6,289.2l0.7-0.7l1-0.1c1.3-0.2,2.2-0.3,2.7-0.8c0.3-0.3,0.3-0.7,0-1s-0.6-0.4-0.9-0.4l0.6-1
            c0.4,0.1,0.9,0.3,1.3,0.7c1.1,1,0.7,2,0.1,2.6c-0.8,0.8-1.9,0.9-2.9,1h-0.5l0,0l1.3,1.3l-0.9,0.9L470.6,289.2z"
                />
                <path
                  class="st31"
                  d="M479.7,289.4c0.6,0.6,0.8,1.6,0.1,2.3c-0.2,0.2-0.7,0.6-1.5,0.4l0,0c0.2,0.6,0.1,1.3-0.4,1.8
            c-0.9,0.9-1.9,0.7-2.7,0c-0.8-0.7-0.9-1.8-0.2-2.6c0.5-0.5,1.2-0.6,1.7-0.5l0,0c-0.1-0.6,0.1-1.1,0.4-1.5
            C478,288.5,479,288.6,479.7,289.4L479.7,289.4z M476,293.1c0.3,0.3,0.6,0.1,0.9-0.2c0.4-0.4,0.4-0.9,0.3-1.2c-0.3,0-0.6,0.1-1,0.4
            C475.9,292.4,475.7,292.9,476,293.1L476,293.1z M479,290c-0.2-0.2-0.6-0.1-0.8,0.2c-0.2,0.3-0.3,0.6-0.2,1c0.2,0.1,0.6-0.1,0.8-0.3
            C479.1,290.6,479.3,290.2,479,290L479,290z"
                />
                <polygon
                  class="st31"
                  points="460.1,237.1 460.1,237.1 459,236.7 459.6,235.7 461.2,236.2 462.1,237.1 457.8,241.6 456.8,240.5
            "
                />
                <path
                  class="st31"
                  d="M460.2,242c0.1,0.3,0.3,0.6,0.5,0.8c0.4,0.4,0.9,0.4,1.2,0.1c0.4-0.5,0.2-1-0.2-1.4l-0.1-0.1l0.7-0.8l0.1,0.1
            c0.3,0.3,0.8,0.6,1.2,0.2c0.3-0.3,0.2-0.6-0.1-0.9c-0.2-0.2-0.4-0.3-0.7-0.4l0.6-0.9c0.3,0.1,0.8,0.3,1.2,0.7
            c0.8,0.8,0.7,1.7,0.2,2.3c-0.4,0.4-1,0.5-1.6,0.4l0,0c0.3,0.6,0.2,1.3-0.3,1.8c-0.6,0.7-1.8,0.8-2.9-0.2c-0.4-0.4-0.6-0.8-0.7-1.1
            L460.2,242z"
                />
                <path
                  class="st31"
                  d="M463.7,247.4c-1.1-1-0.2-2.5,0.8-3.6c1.1-1.2,2.6-1.9,3.6-0.9c1.2,1.1,0,2.6-0.8,3.5
            C465.8,248,464.5,248.1,463.7,247.4L463.7,247.4z M464.6,246.5c0.2,0.2,0.6-0.1,1.6-1.1c0.9-0.9,1.3-1.4,1-1.6
            c-0.2-0.2-0.7,0-1.7,1C464.6,245.9,464.4,246.3,464.6,246.5L464.6,246.5z"
                />
                <polygon
                  class="st31"
                  points="492.6,262.3 492.6,262.3 491.5,262 492.1,261 493.6,261.5 494.6,262.4 490.3,266.8 489.2,265.8 	"
                />
                <path
                  class="st31"
                  d="M492.6,267.2c0.1,0.3,0.3,0.6,0.5,0.8c0.4,0.4,0.9,0.4,1.2,0.1c0.4-0.5,0.2-1-0.2-1.4l-0.1-0.1l0.7-0.8
            l0.1,0.1c0.3,0.3,0.8,0.6,1.2,0.2c0.3-0.3,0.2-0.6-0.1-0.9c-0.2-0.2-0.4-0.3-0.7-0.4l0.6-0.9c0.3,0.1,0.8,0.3,1.2,0.7
            c0.8,0.8,0.7,1.7,0.2,2.3c-0.4,0.4-1,0.5-1.6,0.4l0,0c0.3,0.6,0.2,1.3-0.3,1.8c-0.6,0.7-1.8,0.8-2.9-0.2c-0.4-0.4-0.6-0.8-0.7-1.1
            L492.6,267.2z"
                />
                <path
                  class="st31"
                  d="M496.2,272.6c-1.1-1-0.2-2.5,0.8-3.6c1.1-1.2,2.6-1.9,3.6-0.9c1.2,1.1,0,2.6-0.8,3.5
            C498.3,273.2,497,273.4,496.2,272.6L496.2,272.6z M497.1,271.8c0.2,0.2,0.6-0.1,1.6-1.1c0.9-0.9,1.3-1.4,1-1.6
            c-0.2-0.2-0.7,0-1.7,1C497.1,271.1,496.9,271.5,497.1,271.8L497.1,271.8z"
                />
                <polygon
                  class="st31"
                  points="458.2,297.4 458.2,297.4 457.1,297 457.8,296 459.3,296.5 460.2,297.4 455.9,301.8 454.9,300.8 	"
                />
                <path
                  class="st31"
                  d="M457.2,303.1l0.7-0.7l1-0.1c1.3-0.1,2.2-0.3,2.7-0.8c0.3-0.3,0.3-0.7,0-1s-0.6-0.4-0.9-0.4l0.6-1
            c0.4,0.1,0.9,0.4,1.3,0.7c1.1,1,0.7,2,0.1,2.6c-0.8,0.8-1.9,0.9-2.9,1h-0.5l0,0l1.3,1.3l-0.9,0.9L457.2,303.1z"
                />
                <path
                  class="st31"
                  d="M466.5,305c-0.1-0.1-0.3-0.2-0.4-0.3c-0.6-0.4-1.3-0.3-1.9,0.1l0,0c0.3,0,0.7,0,1,0.3
            c0.6,0.6,0.5,1.5-0.3,2.4c-0.7,0.7-1.9,1.2-2.9,0.3c-0.9-0.8-0.7-2.1,0.4-3.2c1-1,2-1.3,2.8-1.3c0.6,0,1.2,0.2,1.6,0.5
            c0.3,0.2,0.4,0.3,0.5,0.4L466.5,305z M462.6,307c0.3,0.3,0.7-0.1,1.1-0.6c0.2-0.3,0.5-0.7,0.3-0.9c-0.1-0.1-0.3-0.1-0.5,0
            c-0.1,0-0.2,0.2-0.5,0.4C462.7,306.3,462.4,306.8,462.6,307L462.6,307z"
                />
                <polygon
                  class="st31"
                  points="471.8,220.9 471.8,220.9 470.7,220.8 471,219.7 472.7,219.8 473.8,220.4 470.6,225.7 469.4,225 	"
                />
                <path
                  class="st31"
                  d="M473,225.6c0.2,0.3,0.4,0.5,0.7,0.7c0.5,0.3,0.9,0.2,1.1-0.2c0.3-0.5,0-1-0.5-1.3l-0.1-0.1l0.5-0.9l0.1,0.1
            c0.4,0.2,0.9,0.4,1.2-0.1c0.2-0.3,0.1-0.7-0.3-0.9c-0.2-0.1-0.5-0.2-0.8-0.2l0.4-1c0.3,0,0.9,0.1,1.3,0.4c1,0.6,1.1,1.5,0.7,2.2
            c-0.3,0.5-0.9,0.8-1.4,0.7l0,0c0.4,0.5,0.5,1.2,0.1,1.9c-0.5,0.8-1.6,1.2-2.8,0.5c-0.5-0.3-0.8-0.6-1-0.9L473,225.6z"
                />
                <path
                  class="st31"
                  d="M476.2,229l0.5-0.9l1-0.4c1.2-0.5,2.1-0.8,2.5-1.4c0.2-0.4,0.1-0.8-0.3-1c-0.3-0.2-0.7-0.2-1-0.2l0.4-1.1
            c0.4,0,0.9,0.1,1.4,0.4c1.3,0.8,1.2,1.8,0.7,2.5c-0.6,1-1.6,1.3-2.6,1.6l-0.5,0.1l0,0l1.6,0.9l-0.7,1.1L476.2,229z"
                />
                <polygon
                  class="st31"
                  points="511.5,225.7 511.5,225.7 510.4,225.6 510.7,224.5 512.4,224.6 513.5,225.3 510.3,230.6 509.1,229.8
            "
                />
                <path
                  class="st31"
                  d="M512.7,230.4c0.2,0.3,0.4,0.5,0.7,0.7c0.5,0.3,0.9,0.2,1.1-0.2c0.3-0.5,0-1-0.5-1.3l-0.1-0.1l0.5-0.9l0.1,0.1
            c0.4,0.2,0.9,0.4,1.2-0.1c0.2-0.3,0.1-0.7-0.3-0.9c-0.2-0.1-0.5-0.2-0.8-0.2l0.4-1c0.3,0,0.9,0.1,1.3,0.4c1,0.6,1.1,1.5,0.7,2.2
            c-0.3,0.5-0.9,0.8-1.4,0.7l0,0c0.4,0.5,0.5,1.2,0.1,1.9c-0.5,0.8-1.6,1.2-2.8,0.5c-0.5-0.3-0.8-0.6-1-0.9L512.7,230.4z"
                />
                <path
                  class="st31"
                  d="M515.9,233.8l0.5-0.9l1-0.4c1.2-0.5,2.1-0.8,2.5-1.4c0.2-0.4,0.1-0.8-0.3-1c-0.3-0.2-0.7-0.2-1-0.2l0.4-1.1
            c0.4,0,0.9,0.1,1.4,0.4c1.3,0.8,1.2,1.8,0.7,2.5c-0.6,1-1.6,1.3-2.6,1.6l-0.5,0.1l0,0l1.6,0.9l-0.7,1.1L515.9,233.8z"
                />
                <polygon
                  class="st31"
                  points="483.7,200.5 483.7,200.4 482.5,200.6 482.7,199.4 484.3,199.2 485.5,199.7 483.5,205.5 482.1,205
            "
                />
                <path
                  class="st31"
                  d="M485.8,204.8c0.2,0.2,0.5,0.4,0.8,0.5c0.6,0.2,0.9,0,1.1-0.4c0.2-0.6-0.2-1-0.8-1.2l-0.2-0.1l0.4-1h0.1
            c0.4,0.1,1,0.2,1.2-0.3c0.1-0.3,0-0.7-0.4-0.8c-0.2-0.1-0.5-0.1-0.8-0.1l0.2-1.1c0.3-0.1,0.9,0,1.4,0.1c1.1,0.4,1.4,1.3,1.1,2
            c-0.2,0.6-0.7,0.9-1.3,1l0,0c0.5,0.4,0.7,1.1,0.5,1.8c-0.3,0.9-1.3,1.5-2.7,1c-0.5-0.2-0.9-0.4-1.1-0.7L485.8,204.8z"
                />
                <path
                  class="st31"
                  d="M491.5,208.2l0.5-1.3l-2-0.7l0.3-0.9l3.2-2.9l1.3,0.5l-1.2,3.4l0.6,0.2l-0.4,1.1l-0.6-0.2l-0.5,1.3
            L491.5,208.2z M492.3,205.8l0.3-1c0.1-0.3,0.2-0.6,0.4-0.9l0,0c-0.2,0.2-0.4,0.4-0.7,0.7l-0.9,0.8l0,0L492.3,205.8z"
                />
                <polygon
                  class="st31"
                  points="482.5,177.9 482.4,177.9 481.5,178.6 481.1,177.5 482.4,176.6 483.7,176.4 484.5,182.5 483.1,182.7
            "
                />
                <path
                  class="st31"
                  d="M486.3,180.9c0.3,0.1,0.7,0.2,1,0.1c0.6-0.1,0.8-0.5,0.8-0.9c-0.1-0.6-0.6-0.8-1.2-0.7h-0.2l-0.1-1.1h0.1
            c0.5-0.1,1-0.3,0.9-0.8c0-0.4-0.3-0.6-0.7-0.5c-0.3,0-0.5,0.1-0.7,0.3l-0.3-1.1c0.2-0.2,0.8-0.4,1.3-0.5c1.2-0.2,1.8,0.5,1.9,1.3
            c0.1,0.6-0.2,1.1-0.7,1.5l0,0c0.6,0.1,1.1,0.6,1.2,1.4c0.1,0.9-0.5,2-1.9,2.1c-0.5,0.1-1,0-1.3-0.1L486.3,180.9z"
                />
                <path
                  class="st31"
                  d="M493.5,176.2c-0.2,0-0.3,0.1-0.5,0.1c-0.7,0.2-1,0.8-1.1,1.5l0,0c0.2-0.3,0.5-0.5,0.8-0.6
            c0.8-0.1,1.5,0.6,1.7,1.7c0.1,1-0.3,2.3-1.6,2.4c-1.2,0.2-2.1-0.7-2.3-2.3c-0.2-1.4,0.2-2.4,0.7-3c0.4-0.5,0.9-0.8,1.4-1
            c0.3-0.1,0.5-0.1,0.7-0.2L493.5,176.2z M492.7,180.4c0.4-0.1,0.3-0.7,0.3-1.2c-0.1-0.3-0.2-0.8-0.6-0.8c-0.1,0-0.3,0.1-0.3,0.3
            c0,0.1,0,0.3,0,0.6C492.2,180,492.4,180.5,492.7,180.4L492.7,180.4z"
                />
                <polygon
                  class="st31"
                  points="334.5,375.7 334.5,375.7 333.5,375 334.4,374.3 335.7,375.2 336.3,376.4 330.9,379.2 330.2,377.9
            "
                />
                <path
                  class="st31"
                  d="M332.5,382.5c-0.7-1.3,0.6-2.5,1.9-3.1c1.5-0.8,3.1-1,3.7,0.2c0.8,1.4-0.8,2.5-1.9,3.1
            C334.3,383.7,333,383.4,332.5,382.5L332.5,382.5z M333.7,382c0.1,0.3,0.6,0.1,1.9-0.5c1.1-0.6,1.6-0.9,1.5-1.2
            c-0.1-0.3-0.7-0.2-1.9,0.5C333.9,381.3,333.5,381.7,333.7,382L333.7,382z"
                />
                <path
                  class="st31"
                  d="M339.9,385.5c-0.1-0.1-0.2-0.3-0.3-0.4c-0.5-0.6-1.1-0.7-1.8-0.5l0,0c0.3,0.1,0.6,0.3,0.8,0.6
            c0.4,0.7,0,1.6-1,2.1c-0.9,0.5-2.2,0.5-2.8-0.6c-0.6-1.1-0.1-2.2,1.3-2.9c1.3-0.7,2.3-0.6,3.1-0.4c0.6,0.2,1.1,0.6,1.4,1
            c0.2,0.3,0.3,0.5,0.4,0.6L339.9,385.5z M335.7,386.2c0.2,0.4,0.7,0.1,1.3-0.2c0.3-0.2,0.7-0.5,0.5-0.8c-0.1-0.1-0.2-0.2-0.4-0.2
            c-0.1,0-0.3,0.1-0.6,0.2C335.9,385.5,335.5,385.9,335.7,386.2L335.7,386.2z"
                />
                <polygon
                  class="st31"
                  points="321.8,380.9 321.8,380.9 321,380.1 322.1,379.5 323.2,380.7 323.5,382 317.6,383.6 317.2,382.3 	"
                />
                <path
                  class="st31"
                  d="M318.5,387.2c-0.4-1.4,1.1-2.3,2.5-2.7c1.6-0.4,3.2-0.4,3.6,1c0.4,1.6-1.3,2.3-2.5,2.6
            C320,388.7,318.8,388.2,318.5,387.2L318.5,387.2z M319.8,386.9c0.1,0.3,0.6,0.2,1.9-0.1c1.2-0.3,1.8-0.6,1.7-0.9
            c-0.1-0.3-0.6-0.3-2,0.1C320.1,386.3,319.7,386.6,319.8,386.9L319.8,386.9z"
                />
                <path
                  class="st31"
                  d="M319.9,391.8l1.3-0.4l-0.6-2.1l1-0.3l4.2,0.9l0.4,1.4l-3.5,1l0.2,0.6l-1.1,0.3l-0.2-0.6l-1.3,0.4L319.9,391.8
            z M322.4,391.1l1-0.3c0.3-0.1,0.6-0.1,0.9-0.2l0,0c-0.3,0-0.6-0.1-0.9-0.1l-1.2-0.2l0,0L322.4,391.1z"
                />
                <polygon
                  class="st31"
                  points="308.8,383.9 308.8,383.8 308.2,382.9 309.3,382.5 310.2,383.8 310.3,385.1 304.2,385.9 304,384.5
            "
                />
                <path
                  class="st31"
                  d="M304.6,389.6c-0.2-1.5,1.5-2.1,2.8-2.3c1.6-0.2,3.2,0.1,3.4,1.5c0.2,1.6-1.6,2.1-2.8,2.2
            C305.9,391.3,304.8,390.6,304.6,389.6L304.6,389.6z M305.9,389.4c0,0.3,0.6,0.3,1.9,0.1c1.3-0.2,1.9-0.3,1.8-0.6
            c0-0.3-0.6-0.4-1.9-0.2C306.3,388.9,305.8,389.1,305.9,389.4L305.9,389.4z"
                />
                <path
                  class="st31"
                  d="M305.1,392.3l1-0.1l0.9,0.5c1.1,0.7,1.9,1.1,2.6,1.1c0.4-0.1,0.7-0.4,0.6-0.8c0-0.4-0.2-0.6-0.4-0.9l1.1-0.4
            c0.2,0.3,0.5,0.8,0.6,1.4c0.2,1.5-0.7,2-1.6,2.1c-1.1,0.1-2.1-0.4-2.9-1l-0.4-0.3l0,0l0.2,1.8l-1.3,0.2L305.1,392.3z"
                />
                <polygon
                  class="st31"
                  points="291.2,394.8 291.2,394.8 291.6,395.9 290.4,396 289.8,394.5 290,393.2 296.1,393.9 295.9,395.3 	"
                />
                <path
                  class="st31"
                  d="M296.6,390.3c-0.2,1.5-1.9,1.7-3.3,1.5c-1.6-0.2-3.1-0.9-3-2.3c0.2-1.6,2.1-1.6,3.3-1.5
            C295.8,388.3,296.7,389.2,296.6,390.3L296.6,390.3z M295.4,390.1c0-0.3-0.5-0.4-1.8-0.6c-1.3-0.1-1.9-0.1-1.9,0.2
            c0,0.3,0.4,0.5,1.8,0.7C294.8,390.5,295.3,390.4,295.4,390.1L295.4,390.1z"
                />
                <polygon
                  class="st31"
                  points="292.2,385.5 292.2,385.5 292.6,386.6 291.4,386.8 290.9,385.2 291,383.9 297.2,384.6 297,386.1 	"
                />
                <polygon
                  class="st31"
                  points="275.7,391.9 275.7,391.9 275.9,393 274.7,392.9 274.5,391.3 274.8,390.1 280.7,391.9 280.3,393.3
            "
                />
                <path
                  class="st31"
                  d="M281.9,388.4c-0.4,1.4-2.2,1.3-3.5,0.9c-1.6-0.5-2.9-1.4-2.5-2.8c0.5-1.5,2.3-1.2,3.5-0.9
            C281.5,386.3,282.2,387.4,281.9,388.4L281.9,388.4z M280.7,388c0.1-0.3-0.4-0.5-1.7-0.9c-1.2-0.4-1.8-0.5-1.9-0.2s0.3,0.6,1.7,1
            C280.1,388.3,280.6,388.3,280.7,388L280.7,388z"
                />
                <path
                  class="st31"
                  d="M281.4,385.1c0.2-0.2,0.4-0.5,0.5-0.8c0.2-0.6-0.1-0.9-0.5-1.1c-0.6-0.2-1,0.3-1.1,0.8v0.2l-1-0.3v-0.1
            c0.1-0.4,0.2-1-0.3-1.2c-0.4-0.1-0.7,0.1-0.8,0.5c-0.1,0.3-0.1,0.5,0,0.8l-1.1-0.2c-0.1-0.3-0.1-0.9,0.1-1.4c0.3-1.1,1.2-1.4,2-1.2
            c0.6,0.2,1,0.7,1,1.2l0,0c0.4-0.5,1-0.8,1.8-0.5c0.9,0.3,1.6,1.3,1.2,2.6c-0.2,0.5-0.4,0.9-0.6,1.1L281.4,385.1z"
                />
                <polygon
                  class="st31"
                  points="262.1,384.3 262.1,384.4 262.1,385.5 260.9,385.2 261,383.6 261.5,382.4 267,385.2 266.4,386.5 	"
                />
                <path
                  class="st31"
                  d="M268.8,382c-0.7,1.3-2.4,0.9-3.6,0.3c-1.5-0.7-2.6-1.9-2-3.2c0.7-1.4,2.5-0.8,3.6-0.2
            C268.7,379.8,269.2,381,268.8,382L268.8,382z M267.7,381.4c0.1-0.3-0.3-0.6-1.5-1.2c-1.1-0.6-1.7-0.8-1.9-0.5
            c-0.1,0.3,0.2,0.6,1.5,1.3C267,381.6,267.5,381.7,267.7,381.4L267.7,381.4z"
                />
                <path
                  class="st31"
                  d="M267.1,374.3l-0.7,1.4l0.7,0.5l0.1-0.1c0.1-0.2,0.5-0.6,0.9-0.8c0.5-0.2,1-0.1,1.5,0.2c1.1,0.5,1.6,1.7,0.9,3
            c-0.2,0.4-0.5,0.8-0.8,1l-0.9-0.7c0.2-0.2,0.4-0.4,0.6-0.7c0.3-0.5,0.1-1-0.4-1.2c-0.7-0.3-1.2,0.1-1.5,0.7
            c-0.1,0.1-0.1,0.3-0.2,0.4l-2.7-1.7l1.2-2.4L267.1,374.3z"
                />
                <polygon
                  class="st31"
                  points="248.9,373.7 248,374.7 247.6,376.2 248.7,376.8 249,375.7 249,375.7 252.7,378.7 253.6,377.6 	"
                />
                <path
                  class="st31"
                  d="M256,374.9c-1,1.2-2.5,0.4-3.6-0.5c-1.3-1-2.1-2.5-1.2-3.5c1-1.2,2.6-0.2,3.6,0.6
            C256.5,372.8,256.7,374.1,256,374.9L256,374.9z M255.1,374c0.2-0.2-0.2-0.6-1.2-1.5c-1-0.8-1.5-1.2-1.7-0.9
            c-0.2,0.2,0.1,0.7,1.2,1.6C254.4,374.1,254.9,374.3,255.1,374L255.1,374z"
                />
                <polygon
                  class="st31"
                  points="255.4,365.9 256.1,366.5 258.9,371.3 258,372.4 255.4,367.9 255.4,367.9 254.1,369.4 253.1,368.6
            "
                />
                <polygon
                  class="st31"
                  points="108.4,160.3 108.4,160.3 107.2,160.6 107.3,159.4 108.8,159.1 110.1,159.4 108.6,165.3 107.2,165
            "
                />
                <path
                  class="st31"
                  d="M110.9,164.5c0.2,0.2,0.6,0.4,0.8,0.4c0.6,0.1,0.9-0.1,1-0.5c0.1-0.6-0.3-0.9-0.9-1.1h-0.2l0.3-1h0.1
            c0.5,0.1,1,0.1,1.1-0.4c0.1-0.4-0.1-0.6-0.5-0.7c-0.3-0.1-0.5-0.1-0.8,0l0.1-1.1c0.3-0.1,0.9-0.1,1.4,0c1.1,0.3,1.5,1.1,1.3,1.9
            c-0.1,0.6-0.6,1-1.2,1.1l0,0c0.5,0.4,0.8,1,0.6,1.7c-0.2,0.9-1.2,1.6-2.6,1.3c-0.5-0.1-0.9-0.4-1.2-0.6L110.9,164.5z"
                />
                <polygon
                  class="st31"
                  points="120,161.8 119.7,162.7 116.6,167.3 115.3,167 118.2,162.7 118.2,162.7 116.2,162.2 116.5,160.9 	"
                />
                <polygon
                  class="st31"
                  points="103.2,182.6 103.2,182.6 102,182.8 102.1,181.7 103.7,181.3 104.9,181.6 103.5,187.6 102.1,187.2
            "
                />
                <path
                  class="st31"
                  d="M105.7,186.7c0.2,0.2,0.6,0.4,0.8,0.5c0.6,0.1,0.9-0.1,1-0.5c0.2-0.6-0.3-0.9-0.9-1.1h-0.2l0.3-1h0.1
            c0.5,0.1,1,0.1,1.1-0.4c0.1-0.4-0.1-0.6-0.5-0.7c-0.3-0.1-0.5-0.1-0.8,0l0.1-1.1c0.3-0.1,0.9-0.1,1.4,0c1.1,0.3,1.5,1.1,1.3,1.9
            c-0.1,0.6-0.6,1-1.2,1.1l0,0c0.5,0.4,0.8,1,0.6,1.7c-0.2,0.9-1.2,1.6-2.6,1.3c-0.5-0.1-0.9-0.4-1.2-0.6L105.7,186.7z"
                />
                <path
                  class="st31"
                  d="M114.2,185.2l-1.6-0.4l-0.3,0.8c0.1,0,0.1,0,0.2,0c0.2,0.1,0.7,0.3,1,0.7s0.3,0.9,0.2,1.5
            c-0.3,1.1-1.3,1.9-2.7,1.6c-0.5-0.1-0.9-0.3-1.1-0.5l0.5-1.1c0.2,0.2,0.5,0.3,0.8,0.4c0.6,0.1,1-0.1,1.1-0.6c0.2-0.7-0.4-1.1-1-1.3
            c-0.1,0-0.3-0.1-0.4-0.1l1.1-3l2.6,0.6L114.2,185.2z"
                />
                <polygon
                  class="st31"
                  points="102.4,205.9 102.4,205.9 101.4,206.5 101.1,205.4 102.5,204.5 103.8,204.5 104.2,210.6 102.8,210.7
            "
                />
                <path
                  class="st31"
                  d="M106.1,209.1c0.3,0.1,0.6,0.2,0.9,0.2c0.6,0,0.9-0.4,0.8-0.8c0-0.6-0.6-0.8-1.2-0.8h-0.2l-0.1-1.1h0.1
            c0.5,0,1-0.2,1-0.7c0-0.4-0.3-0.6-0.7-0.6c-0.3,0-0.5,0.1-0.8,0.3l-0.3-1.1c0.3-0.2,0.8-0.4,1.3-0.4c1.2-0.1,1.8,0.6,1.9,1.4
            c0,0.6-0.3,1.1-0.8,1.4l0,0c0.6,0.2,1.1,0.7,1.2,1.5c0.1,0.9-0.6,1.9-2,2c-0.5,0-1,0-1.3-0.2L106.1,209.1z"
                />
                <path
                  class="st31"
                  d="M110.8,208.7c0.3,0.1,0.6,0.2,0.9,0.2c0.6,0,0.9-0.4,0.8-0.8c0-0.6-0.6-0.8-1.2-0.8h-0.2l-0.1-1.1h0.1
            c0.5,0,1-0.2,1-0.7c0-0.4-0.3-0.6-0.7-0.6c-0.3,0-0.5,0.1-0.8,0.3l-0.3-1.1c0.3-0.2,0.8-0.4,1.3-0.4c1.2-0.1,1.8,0.6,1.9,1.4
            c0,0.6-0.3,1.1-0.8,1.4l0,0c0.6,0.2,1.1,0.7,1.2,1.5c0.1,0.9-0.6,1.9-2,2c-0.5,0-1,0-1.3-0.2L110.8,208.7z"
                />
                <polygon
                  class="st31"
                  points="113.1,231.6 113,231.6 112.2,232.4 111.6,231.4 112.8,230.3 114,229.9 115.9,235.7 114.5,236.1 	"
                />
                <path
                  class="st31"
                  d="M117.4,233.8c0.3,0.1,0.7,0,1-0.1c0.6-0.2,0.7-0.6,0.6-1c-0.2-0.6-0.8-0.6-1.3-0.5l-0.2,0.1l-0.3-1h0.1
            c0.4-0.2,0.9-0.4,0.7-0.9c-0.1-0.4-0.4-0.5-0.8-0.4c-0.3,0.1-0.5,0.2-0.7,0.4l-0.5-1c0.2-0.2,0.7-0.5,1.2-0.7
            c1.1-0.4,1.9,0.2,2.1,0.9c0.2,0.6,0,1.2-0.4,1.6l0,0c0.7,0,1.2,0.4,1.5,1.1c0.3,0.9-0.1,2-1.5,2.5c-0.5,0.2-1,0.2-1.3,0.1
            L117.4,233.8z"
                />
                <polygon
                  class="st31"
                  points="122,228.7 121.9,228.7 121.1,229.5 120.5,228.5 121.7,227.4 122.9,227 124.8,232.8 123.4,233.3 	"
                />
                <polygon
                  class="st31"
                  points="75.7,240.3 75.7,240.3 74.8,241.1 74.3,240.1 75.4,239 76.7,238.6 78.6,244.4 77.2,244.9 	"
                />
                <path
                  class="st31"
                  d="M80,242.5c0.3,0.1,0.7,0,1-0.1c0.6-0.2,0.7-0.6,0.6-1c-0.2-0.6-0.8-0.6-1.3-0.5l-0.2,0.1l-0.3-1h0.1
            c0.4-0.2,0.9-0.4,0.7-0.9c-0.1-0.4-0.4-0.5-0.8-0.4c-0.3,0.1-0.5,0.2-0.7,0.4l-0.5-1c0.2-0.2,0.7-0.5,1.2-0.7
            c1.1-0.4,1.9,0.2,2.1,0.9c0.2,0.6,0,1.2-0.4,1.6l0,0c0.7,0,1.2,0.4,1.5,1.1c0.3,0.9-0.1,2-1.5,2.5c-0.5,0.2-1,0.2-1.3,0.1L80,242.5
            z"
                />
                <polygon
                  class="st31"
                  points="84.6,237.4 84.6,237.4 83.7,238.3 83.2,237.2 84.3,236.1 85.6,235.7 87.5,241.5 86.1,242 	"
                />
                <path
                  class="st38"
                  d="M90.4,284.2l0.4-0.4l0.9-0.1c1.2-0.2,2.3-0.3,3-1c0.4-0.4,0.4-0.8,0.1-1.2c-0.3-0.3-0.6-0.3-0.8-0.4l0.4-0.6
            c0.3,0,0.7,0.2,1.1,0.6c0.8,0.8,0.6,1.6,0,2.2c-0.8,0.8-1.9,1-3,1.1l-0.6,0.1l0,0l1.3,1.3l-0.6,0.6L90.4,284.2z"
                />
                <path
                  class="st38"
                  d="M94.3,288.1c-0.8-0.8-0.2-2,0.9-3.2c1.2-1.3,2.5-1.7,3.2-1c0.8,0.8,0.2,2-0.9,3.1
            C96.1,288.6,94.9,288.7,94.3,288.1L94.3,288.1z M94.9,287.6c0.3,0.3,1-0.1,1.9-1.1c0.9-0.9,1.4-1.6,1-2c-0.3-0.3-1,0.1-2,1.1
            C95,286.6,94.6,287.3,94.9,287.6L94.9,287.6z"
                />
                <path
                  class="st38"
                  d="M97.2,290.9c-0.8-0.8-0.2-2,0.9-3.2c1.2-1.3,2.5-1.7,3.2-1c0.8,0.8,0.2,2-0.9,3.2
            C99,291.4,97.8,291.6,97.2,290.9L97.2,290.9z M97.8,290.4c0.3,0.3,1-0.1,1.9-1.1c0.9-0.9,1.4-1.6,1-2c-0.3-0.3-1,0.1-2,1.1
            C97.8,289.4,97.5,290.1,97.8,290.4L97.8,290.4z"
                />
                <polygon
                  class="st38"
                  points="104.7,289.8 105.4,290.5 101.8,294.2 102.9,295.3 102.4,295.8 100.6,294.1 	"
                />
                <polygon
                  class="st38"
                  points="106.7,296.3 105.7,295.3 104.4,296.7 105.6,297.8 105,298.4 103.2,296.6 107.3,292.4 109.1,294.1
            108.5,294.7 107.4,293.6 106.3,294.8 107.3,295.8 	"
                />
                <path
                  class="st38"
                  d="M106.6,299.9l3.2-5.2l0.7,0.7l-1.5,2.2c-0.4,0.5-0.8,1.2-1.3,1.8l0,0c0.6-0.5,1.2-0.9,1.8-1.3l2.2-1.6
            l0.7,0.7l-5.1,3.3L106.6,299.9z"
                />
                <polygon
                  class="st38"
                  points="112.6,302 111.6,301 110.2,302.4 111.4,303.5 110.8,304.1 109,302.3 113.1,298 114.9,299.7
            114.3,300.3 113.2,299.3 112.1,300.4 113.1,301.4 	"
                />
                <polygon
                  class="st38"
                  points="115.8,300.6 116.5,301.3 112.9,305 114.1,306.1 113.5,306.7 111.7,304.9 	"
                />
                <rect
                  x="121.4"
                  y="309.1"
                  transform="matrix(0.6985 -0.7156 0.7156 0.6985 -185.1539 180.5741)"
                  class="st38"
                  width="0.7"
                  height="1.8"
                />
                <path
                  class="st38"
                  d="M129.7,319l0.8,0.8l-0.9,1.3l0.7,0.6l3.3-5.1l-0.8-0.8l-5.1,3.3l0.7,0.6L129.7,319z M131.5,317.7
            c0.3-0.2,0.8-0.6,1.1-0.8l0,0c-0.2,0.3-0.6,0.8-0.8,1.1l-0.8,1.1l-0.7-0.7L131.5,317.7z"
                />
                <path
                  class="st38"
                  d="M133.5,321.5c0.1,0.1,0.1,0.1,0.2,0.2c0.4,0.4,0.9,0.6,1.5,0.6c0.4,0,0.8-0.2,1.2-0.6s0.6-0.8,0.5-1.2
            c0-0.5-0.3-0.9-0.8-1.4c-0.3-0.3-0.6-0.5-0.9-0.7l-4.1,4.2l0.7,0.7L133.5,321.5z M135.5,319.5c0.1,0,0.2,0.1,0.3,0.2
            c0.5,0.4,0.3,0.9-0.1,1.3c-0.5,0.5-1,0.5-1.5,0.1c-0.1-0.1-0.1-0.1-0.2-0.2L135.5,319.5z"
                />
                <path
                  class="st38"
                  d="M136.5,324.5c0.1,0.1,0.1,0.1,0.2,0.2c0.4,0.3,0.9,0.6,1.5,0.6c0.4,0,0.8-0.2,1.2-0.6s0.6-0.8,0.5-1.2
            c0-0.5-0.3-0.9-0.8-1.4c-0.3-0.3-0.6-0.5-0.9-0.7l-4.1,4.2l0.7,0.7L136.5,324.5z M138.5,322.5c0.1,0,0.2,0.1,0.3,0.2
            c0.5,0.4,0.3,0.9-0.1,1.3c-0.5,0.5-1,0.5-1.5,0.1c-0.1-0.1-0.1-0.1-0.2-0.2L138.5,322.5z"
                />
                <path
                  class="st38"
                  d="M139.7,327.3l0.2,0.1c0.3,0.3,0.3,0.7-0.1,1.3c-0.4,0.6-0.7,1.1-0.8,1.2l0.7,0.7c0.1-0.2,0.4-0.8,0.8-1.4
            c0.4-0.6,0.5-1,0.3-1.4l0,0c0.6,0.2,1.2,0.1,1.7-0.4c0.3-0.4,0.5-0.7,0.5-1.2s-0.3-0.9-0.8-1.3c-0.3-0.3-0.6-0.5-0.9-0.7l-4.1,4.2
            l0.7,0.6L139.7,327.3z M141.6,325.4c0.1,0,0.2,0.1,0.3,0.2c0.4,0.4,0.3,0.9-0.1,1.3c-0.4,0.4-1,0.5-1.4,0.1l-0.2-0.2L141.6,325.4z"
                />
                <path
                  class="st38"
                  d="M141.4,332.6c0.7,0.7,1.9,0.6,3.5-1c1.1-1.1,1.7-2.5,0.8-3.3s-2.2-0.4-3.5,0.9
            C141,330.4,140.6,331.7,141.4,332.6L141.4,332.6z M143,329.8c0.8-0.8,1.7-1.4,2.1-1c0.5,0.4-0.2,1.4-0.9,2.1
            c-0.8,0.8-1.7,1.5-2.2,1.1l0,0C141.6,331.6,142.2,330.7,143,329.8"
                />
                <path
                  class="st38"
                  d="M145,334.2c0.3-0.2,0.6-0.3,1-0.5l0,0c-0.2,0.4-0.3,0.7-0.5,1l-0.5,1.2l0.7,0.7l1.2-3l2.9-1.3l-0.7-0.7
            l-1.1,0.6c-0.3,0.2-0.5,0.3-0.9,0.5l0,0c0.2-0.3,0.3-0.6,0.4-0.9l0.6-1.2l-0.7-0.7l-1.2,2.9l-2.9,1.4l0.7,0.7L145,334.2z"
                />
                <rect
                  x="145.8"
                  y="335"
                  transform="matrix(0.6979 -0.7162 0.7162 0.6979 -195.3064 207.8854)"
                  class="st38"
                  width="5.9"
                  height="0.9"
                />
                <path
                  class="st38"
                  d="M150.2,337.8c0.5-0.5,1.1-1,1.6-1.5l0,0c-0.4,0.5-0.8,1.2-1.1,1.7l-1.2,2.1l0.5,0.4l2.1-1.3
            c0.5-0.3,1.1-0.7,1.6-1.1l0,0c-0.5,0.5-1,1.1-1.4,1.6l-1.5,1.7l0.6,0.6l3.9-4.5l-0.7-0.7l-2.1,1.3c-0.7,0.4-1.2,0.8-1.7,1.2l0,0
            c0.4-0.6,0.7-1.1,1.1-1.8l1.3-2.1l-0.7-0.7l-4.4,4l0.6,0.6L150.2,337.8z"
                />
                <path
                  class="st38"
                  d="M153.9,342.4l0.8,0.8l-0.8,1.3l0.7,0.6l3.3-5.1l-0.8-0.8l-5.1,3.3l0.7,0.6L153.9,342.4z M155.6,341.2
            c0.3-0.2,0.8-0.6,1.1-0.8l0,0c-0.2,0.3-0.6,0.8-0.8,1.1l-0.8,1.1l-0.7-0.7L155.6,341.2z"
                />
                <polygon
                  class="st38"
                  points="156,346.7 159.6,343 160.3,343.8 161,343.2 158.7,341 158.1,341.6 158.9,342.4 155.4,346 	"
                />
                <polygon
                  class="st38"
                  points="160,349.3 158.8,348.2 160.1,346.9 161.2,347.9 161.7,347.3 160.7,346.3 161.8,345.2 162.9,346.2
            163.5,345.6 161.7,343.9 157.6,348.2 159.4,349.9 	"
                />
                <path
                  class="st38"
                  d="M164.6,352.7c0.6-0.6,0.6-1.3,0.3-1.8l0,0c0.6,0.2,1.1,0.1,1.5-0.4c0.5-0.5,0.6-1.3-0.1-1.9
            c-0.3-0.3-0.7-0.5-1-0.5l-0.4,0.6c0.2,0,0.5,0.1,0.7,0.3c0.3,0.3,0.3,0.7,0,1c-0.4,0.4-1,0.2-1.3-0.1l-0.1-0.1l-0.5,0.5l0.1,0.1
            c0.4,0.4,0.6,1,0.1,1.5c-0.4,0.4-0.9,0.5-1.3,0c-0.2-0.2-0.4-0.5-0.4-0.7l-0.6,0.4c0.1,0.3,0.3,0.6,0.6,0.9
            C162.9,353.4,163.9,353.3,164.6,352.7"
                />
                <path
                  class="st38"
                  d="M166.9,353.7l0.2,0.1c0.3,0.3,0.3,0.7-0.1,1.3c-0.4,0.6-0.7,1.1-0.8,1.2l0.7,0.7c0.1-0.2,0.4-0.8,0.8-1.4
            c0.4-0.6,0.5-1,0.3-1.4l0,0c0.6,0.2,1.2,0.1,1.7-0.4c0.3-0.4,0.5-0.7,0.5-1.2s-0.3-0.9-0.8-1.3c-0.3-0.3-0.6-0.5-0.9-0.7l-4.1,4.2
            l0.7,0.6L166.9,353.7z M168.8,351.8c0.1,0,0.2,0.1,0.3,0.2c0.4,0.4,0.3,0.9-0.1,1.3c-0.4,0.4-1,0.5-1.4,0.1l-0.2-0.2L168.8,351.8z"
                />
                <path
                  class="st38"
                  d="M169.8,359.3c0.6,0,1.4-0.4,2.3-1.3c0.8-0.9,1.2-1.6,1.1-2.3c0-0.5-0.3-0.9-0.8-1.4c-0.3-0.3-0.6-0.5-0.8-0.7
            l-4.1,4.2c0.1,0.2,0.3,0.4,0.6,0.6C168.7,359,169.3,359.3,169.8,359.3 M171.9,354.8c0.1,0,0.1,0.1,0.2,0.2c0.6,0.6,0.3,1.4-0.6,2.4
            c-1.3,1.3-2.1,1.3-2.5,0.8c0,0-0.1-0.1-0.2-0.2L171.9,354.8z"
                />
                <path
                  class="st38"
                  d="M174.5,363.9c0.4,0,0.8-0.2,1.1-0.5c0.5-0.5,0.6-1.2,0.3-1.8l0,0c0.6,0.2,1.1,0.1,1.5-0.3
            c0.3-0.3,0.5-0.7,0.4-1.1c0-0.5-0.3-0.9-0.7-1.3c-0.3-0.3-0.6-0.6-0.9-0.7l-4.1,4.2c0.1,0.2,0.3,0.4,0.7,0.7
            C173.5,363.7,174,363.9,174.5,363.9 M176.5,359.3c0.1,0,0.2,0.1,0.3,0.2c0.4,0.4,0.3,0.8,0,1.2c-0.4,0.4-0.9,0.4-1.3,0.1l-0.2-0.2
            L176.5,359.3z M174.8,361l0.2,0.2c0.4,0.4,0.5,1,0,1.5s-1,0.4-1.4,0c-0.1-0.1-0.2-0.2-0.2-0.2L174.8,361z"
                />
                <path
                  class="st38"
                  d="M177,364.9l0.8,0.8L177,367l0.7,0.6l3.3-5.1l-0.8-0.8l-5.1,3.3l0.7,0.6L177,364.9z M178.8,363.7
            c0.3-0.2,0.8-0.6,1.1-0.8l0,0c-0.2,0.3-0.6,0.8-0.8,1.1l-0.8,1.1l-0.7-0.7L178.8,363.7z"
                />
                <path
                  class="st38"
                  d="M181.6,369.1c0.4-0.5,0.6-1.1,0.4-1.9c-0.2-0.7-0.2-1,0.1-1.3s0.7-0.3,1.1,0c0.2,0.2,0.3,0.5,0.4,0.7l0.7-0.5
            c0-0.2-0.2-0.5-0.5-0.8c-0.8-0.8-1.8-0.7-2.4,0c-0.5,0.5-0.5,1.2-0.4,2c0.1,0.6,0.1,1-0.2,1.3c-0.3,0.4-0.8,0.4-1.2,0
            c-0.2-0.2-0.4-0.6-0.5-0.8l-0.7,0.5c0,0.2,0.3,0.6,0.6,0.9C179.8,369.8,180.8,369.8,181.6,369.1"
                />
                <polygon
                  class="st38"
                  points="183.6,372.3 182.5,371.2 183.8,369.8 184.8,370.8 185.3,370.2 184.3,369.3 185.5,368.1 186.5,369.1
            187.1,368.6 185.4,366.9 181.2,371.1 183,372.9 	"
                />
                <polygon
                  class="st38"
                  points="190.8,372.7 188.9,378.6 194.8,376.7 	"
                />
                <path
                  class="st38"
                  d="M421.8,361.4c0.3-0.3,0.8-0.3,1.1,0.1c0.6,0.6,0.8,1.7,1,2.9l0.1,0.8l0.4,0.4l2-2l-0.6-0.6l-1.2,1.3l0,0
            l-0.1-0.6c-0.1-1-0.3-2.2-1.1-2.9c-0.6-0.6-1.4-0.8-2.2,0c-0.4,0.4-0.5,0.8-0.6,1.1l0.6,0.4C421.5,362,421.5,361.7,421.8,361.4"
                />
                <path
                  class="st38"
                  d="M428.3,361.8L428.3,361.8c0.6-0.6,0.5-1.7-1-3.1c-1.1-1.1-2.3-1.7-3.1-0.9c-0.7,0.7-0.3,1.9,1,3.1
            C426.4,362,427.6,362.5,428.3,361.8 M424.8,358.3c0.3-0.3,1,0.1,1.9,1s1.4,1.6,1.1,1.9l0,0c-0.3,0.3-1-0.1-1.9-1
            C424.9,359.3,424.5,358.6,424.8,358.3"
                />
                <path
                  class="st38"
                  d="M431,359L431,359c0.6-0.6,0.5-1.7-1-3.1c-1.1-1.1-2.3-1.7-3.1-0.9c-0.7,0.7-0.3,1.9,1,3.1
            C429.1,359.2,430.3,359.7,431,359 M427.5,355.5c0.3-0.3,1,0.1,1.9,1s1.4,1.6,1.1,1.9l0,0c-0.3,0.3-1-0.1-1.9-1
            C427.6,356.5,427.2,355.8,427.5,355.5"
                />
                <polygon
                  class="st38"
                  points="435.8,354 435.3,353.5 434.2,354.5 430.6,351.1 430,351.7 434.1,355.7 	"
                />
                <polygon
                  class="st38"
                  points="438.3,351.4 437.7,350.9 436.6,352 435.3,350.7 436.3,349.8 435.7,349.2 434.8,350.2 433.6,349.1
            434.7,348.1 434.1,347.5 432.4,349.2 436.6,353.2 	"
                />
                <path
                  class="st38"
                  d="M440.4,349.2l-3.2-5l-0.7,0.7l1.5,2.1c0.4,0.5,0.8,1.2,1.3,1.7l0,0c-0.6-0.4-1.2-0.9-1.7-1.2l-2.2-1.5
            l-0.7,0.7l5,3.1L440.4,349.2z"
                />
                <polygon
                  class="st38"
                  points="443.8,345.8 443.2,345.3 442.1,346.4 440.8,345.1 441.8,344.1 441.2,343.6 440.3,344.6 439.1,343.5
            440.1,342.4 439.6,341.9 437.9,343.6 442.1,347.6 	"
                />
                <polygon
                  class="st38"
                  points="446.3,343.2 445.7,342.7 444.7,343.8 441.1,340.3 440.5,341 444.6,345 	"
                />
                <polygon
                  class="st38"
                  points="451,334.6 450.5,334.1 449.3,335.4 449.7,335.9 	"
                />
                <path
                  class="st38"
                  d="M459.5,329.7l-0.9-1.3l0.8-0.8l1.3,0.8l0.6-0.6l-5-3.2l-0.7,0.8l3.2,4.9L459.5,329.7z M457.4,326.8
            c-0.2-0.3-0.5-0.7-0.8-1.1l0,0c0.3,0.2,0.8,0.5,1.1,0.8l1.1,0.8l-0.7,0.7L457.4,326.8z"
                />
                <path
                  class="st38"
                  d="M462.7,326.4l-1.6-1.6c0.1-0.1,0.1-0.1,0.2-0.2c0.3-0.3,0.6-0.9,0.5-1.4c0-0.4-0.2-0.8-0.6-1.2
            c-0.4-0.3-0.8-0.5-1.2-0.5c-0.5,0-0.9,0.3-1.3,0.7c-0.3,0.3-0.5,0.6-0.7,0.8l4.1,3.9L462.7,326.4z M460.7,324.2
            c-0.1,0.1-0.1,0.1-0.2,0.1l-1.4-1.4c0-0.1,0.1-0.2,0.2-0.3c0.4-0.4,0.9-0.3,1.3,0.1C461.1,323.2,461.1,323.8,460.7,324.2"
                />
                <path
                  class="st38"
                  d="M465.6,323.5l-1.6-1.6c0.1-0.1,0.1-0.1,0.2-0.2c0.3-0.3,0.6-0.9,0.5-1.4c0-0.4-0.2-0.8-0.6-1.2
            c-0.4-0.3-0.8-0.5-1.2-0.5c-0.5,0-0.9,0.3-1.3,0.7c-0.3,0.3-0.5,0.6-0.7,0.8l4.1,3.9L465.6,323.5z M463.6,321.3
            c-0.1,0.1-0.1,0.1-0.2,0.1L462,320c0-0.1,0.1-0.2,0.2-0.3c0.4-0.4,0.9-0.3,1.3,0.1C463.9,320.3,464,320.8,463.6,321.3"
                />
                <path
                  class="st38"
                  d="M468.4,320.6l-1.7-1.7l0.1-0.1c0.3-0.3,0.6-0.3,1.3,0.1c0.5,0.4,1,0.7,1.2,0.8l0.7-0.7
            c-0.2-0.1-0.7-0.4-1.3-0.8c-0.6-0.4-1-0.5-1.4-0.3l0,0c0.2-0.6,0.1-1.2-0.4-1.7c-0.3-0.3-0.7-0.5-1.1-0.5c-0.5,0-0.9,0.3-1.3,0.7
            c-0.3,0.3-0.5,0.6-0.7,0.9l4.1,3.9L468.4,320.6z M466.4,318.2l-0.2,0.2l-1.4-1.4c0-0.1,0.1-0.2,0.2-0.2c0.4-0.4,0.9-0.3,1.3,0.1
            C466.7,317.3,466.8,317.9,466.4,318.2"
                />
                <path
                  class="st38"
                  d="M471.8,317.2L471.8,317.2c0.7-0.7,0.6-1.9-0.9-3.4c-1.1-1.1-2.4-1.7-3.2-0.8c-0.8,0.8-0.4,2.1,0.8,3.3
            C469.7,317.6,471,318,471.8,317.2 M468.2,313.6c0.4-0.4,1.3,0.2,2.1,0.9c0.8,0.8,1.4,1.7,1,2.1l0,0c-0.4,0.4-1.3-0.1-2.1-0.9
            C468.4,314.9,467.8,314.1,468.2,313.6"
                />
                <path
                  class="st38"
                  d="M473.3,315.5l0.6-0.7l-0.6-1.1c-0.2-0.3-0.3-0.6-0.5-0.9l0,0c0.3,0.2,0.6,0.3,1,0.5l1.2,0.5l0.7-0.7l-2.9-1.2
            l-1.3-2.8l-0.6,0.6l0.6,1.1c0.2,0.3,0.3,0.5,0.5,0.8l0,0c-0.3-0.2-0.6-0.3-0.9-0.4l-1.1-0.5l-0.7,0.7l2.8,1.2L473.3,315.5z"
                />
                <polygon
                  class="st38"
                  points="472.8,307.8 477,311.8 476.3,312.5 472.2,308.5 	"
                />
                <path
                  class="st38"
                  d="M478.8,306.8c-0.5-0.4-1.1-1-1.5-1.4l0,0c0.4,0.5,0.8,1.1,1.1,1.6l1.3,2.1l-0.4,0.4l-2-1.2
            c-0.5-0.3-1.1-0.7-1.7-1.1l0,0c0.5,0.5,1,1,1.4,1.5l1.5,1.6l-0.6,0.6l-3.9-4.3l0.7-0.7l2.1,1.2c0.7,0.4,1.2,0.7,1.7,1.1l0,0
            c-0.4-0.5-0.7-1-1.2-1.7l-1.3-2l0.7-0.7l4.4,3.8l-0.6,0.6L478.8,306.8z"
                />
                <path
                  class="st38"
                  d="M481.4,305.2l0.9,1.3l-0.6,0.6l-3.2-4.9l0.7-0.8l5,3.2l-0.6,0.6l-1.3-0.8L481.4,305.2z M481.6,303.9l-1.1-0.8
            c-0.3-0.2-0.8-0.5-1.1-0.8l0,0c0.2,0.3,0.6,0.8,0.8,1.1l0.8,1.1L481.6,303.9z"
                />
                <polygon
                  class="st38"
                  points="481.3,300.3 480.6,301.1 480,300.5 482.1,298.4 482.7,298.9 482,299.7 485.5,303.1 484.8,303.8 	"
                />
                <polygon
                  class="st38"
                  points="486.6,298.2 485.7,299.1 487,300.4 488.1,299.3 488.7,299.8 486.9,301.6 482.8,297.6 484.5,295.9
            485,296.5 484,297.5 485.1,298.6 486.1,297.6 	"
                />
                <polygon
                  class="st38"
                  points="488.1,293.7 488.1,293.8 487.8,294.8 487.2,294.4 487.5,293.1 488.1,292.5 492.1,296.4 491.4,297
            "
                />
                <path
                  class="st38"
                  d="M492.6,294.4c0.2-0.1,0.6-0.3,0.8-0.5c0.4-0.4,0.4-0.8,0-1.2c-0.3-0.3-0.7-0.3-1.3-0.2
            c-0.7,0.2-1.5,0.1-1.9-0.3c-0.6-0.6-0.7-1.5,0-2.3c0.3-0.3,0.6-0.4,0.7-0.5l0.5,0.7c-0.2,0-0.4,0.2-0.6,0.4c-0.4,0.4-0.3,0.8,0,1
            c0.3,0.3,0.6,0.3,1.3,0.1c0.8-0.2,1.4,0,1.9,0.4c0.7,0.7,0.7,1.7,0,2.4c-0.3,0.3-0.7,0.5-0.9,0.6L492.6,294.4z"
                />
                <polygon
                  class="st38"
                  points="492.9,288.5 492.2,289.2 491.6,288.6 493.7,286.5 494.3,287.1 493.5,287.8 497.1,291.2 496.4,291.9
            "
                />
                <path
                  class="st38"
                  d="M495.7,284.5c0.2-0.3,0.4-0.6,0.7-0.9c0.4-0.4,0.8-0.7,1.2-0.7c0.4,0,0.7,0.1,1,0.4c0.4,0.4,0.5,0.9,0.3,1.5
            l0,0c0.6-0.3,1.2-0.2,1.7,0.2c0.3,0.3,0.5,0.7,0.5,1.1c0,0.5-0.2,1-0.8,1.6c-0.3,0.3-0.5,0.5-0.7,0.6L495.7,284.5z M498,285.5
            l0.2-0.2c0.3-0.3,0.3-0.9-0.1-1.2c-0.3-0.3-0.8-0.4-1.1,0c-0.1,0.1-0.2,0.2-0.2,0.3L498,285.5z M499.9,287.4c0.1,0,0.1-0.1,0.2-0.2
            c0.4-0.4,0.4-0.9,0-1.4c-0.5-0.5-1.1-0.4-1.4,0l-0.2,0.2L499.9,287.4z"
                />
                <path
                  class="st38"
                  d="M502.2,283.8l0.9,1.3l-0.6,0.6l-3.2-4.9l0.7-0.8l5,3.2l-0.6,0.6L503,283L502.2,283.8z M502.5,282.6l-1.1-0.7
            c-0.3-0.2-0.8-0.5-1.1-0.8l0,0c0.2,0.3,0.6,0.8,0.8,1.1l0.8,1.1L502.5,282.6z"
                />
                <path
                  class="st38"
                  d="M504.9,281.8c0.2-0.1,0.6-0.3,0.8-0.5c0.4-0.4,0.4-0.8,0-1.2c-0.3-0.3-0.7-0.3-1.3-0.2
            c-0.7,0.2-1.5,0.1-1.9-0.3c-0.6-0.6-0.7-1.5,0-2.3c0.3-0.3,0.6-0.4,0.7-0.5l0.5,0.7c-0.2,0-0.4,0.2-0.6,0.4c-0.4,0.4-0.3,0.8,0,1
            c0.3,0.3,0.6,0.3,1.3,0.1c0.9-0.2,1.5,0,1.9,0.4c0.7,0.7,0.7,1.7,0,2.4c-0.3,0.3-0.7,0.5-0.9,0.6L504.9,281.8z"
                />
                <polygon
                  class="st38"
                  points="508,276.3 507,277.3 508.3,278.6 509.4,277.5 510,278 508.3,279.8 504.1,275.8 505.8,274.1
            506.4,274.6 505.3,275.7 506.5,276.8 507.4,275.8 	"
                />
                <polygon
                  class="st38"
                  points="417.5,364.6 413.6,368.5 419.4,370.2 	"
                />
                <path
                  class="st31"
                  d="M345.1,331.8c0.1-0.2,0.4-0.5,0.6-0.7c0.4-0.4,0.7-0.6,1.1-0.6s0.7,0.1,1,0.4c0.4,0.4,0.5,0.9,0.3,1.4l0,0
            c0.3-0.2,0.7-0.1,1.2,0.3c0.5,0.3,0.9,0.6,1.1,0.7l-0.6,0.6c-0.1-0.1-0.6-0.3-1-0.6c-0.5-0.4-0.8-0.4-1.1-0.1l-0.1,0.1l1.4,1.4
            l-0.5,0.5L345.1,331.8z M347.2,332.8l0.1-0.1c0.3-0.3,0.3-0.8-0.1-1.1c-0.3-0.3-0.7-0.4-1.1-0.1c-0.1,0.1-0.1,0.1-0.2,0.2
            L347.2,332.8z"
                />
                <path
                  class="st31"
                  d="M350.6,331.2l0.7,1.1l-0.5,0.5l-2.7-4.2l0.6-0.6l4.2,2.7l-0.5,0.5l-1.1-0.7L350.6,331.2z M350.8,330.1
            l-0.9-0.6c-0.3-0.2-0.6-0.4-0.9-0.6l0,0c0.2,0.3,0.5,0.6,0.7,0.9l0.6,0.9L350.8,330.1z"
                />
                <path
                  class="st31"
                  d="M353.6,330l-1.4-1.4l-2.8-1.3l0.6-0.6l1.1,0.6c0.3,0.1,0.7,0.3,1,0.5l0,0c-0.2-0.3-0.4-0.6-0.6-1l-0.6-1
            l0.6-0.6l1.3,2.8l1.4,1.4L353.6,330z"
                />
                <path
                  class="st31"
                  d="M354.7,327.7c0.2-0.1,0.5-0.2,0.7-0.4c0.3-0.3,0.3-0.7,0-1s-0.6-0.3-1.1-0.2c-0.6,0.1-1.2,0.1-1.6-0.3
            c-0.5-0.5-0.6-1.3,0-2c0.2-0.2,0.5-0.4,0.6-0.4l0.4,0.6c-0.2,0-0.4,0.1-0.5,0.3c-0.3,0.3-0.2,0.7,0,0.9c0.3,0.3,0.5,0.2,1.1,0.1
            c0.7-0.2,1.2,0,1.6,0.4c0.6,0.6,0.6,1.4,0,2.1c-0.3,0.3-0.6,0.5-0.8,0.5L354.7,327.7z"
                />
                <path
                  class="st31"
                  d="M359.1,324.4c0.4-0.4,0.7-0.9,0.6-1.4c0-0.5-0.3-1.2-1-1.9c-0.7-0.7-1.3-0.9-1.9-0.9c-0.4,0-0.8,0.2-1.2,0.6
            c-0.2,0.2-0.4,0.5-0.5,0.7l3.4,3.3C358.7,324.8,358.9,324.6,359.1,324.4 M356.2,321.2c0.5-0.5,1.1-0.3,1.9,0.5c1.1,1,1,1.7,0.7,2.1
            l-0.1,0.1l-2.6-2.5C356.1,321.3,356.1,321.3,356.2,321.2"
                />
                <path
                  class="st31"
                  d="M362.1,321.3c0.6-0.6,0.5-1.4-0.4-2.2l-2.2-2.1l-0.5,0.6l2.3,2.2c0.6,0.6,0.6,0.9,0.3,1.1
            c-0.2,0.2-0.6,0.2-1.1-0.3l-2.3-2.2l-0.5,0.6l2.2,2.2C360.8,321.8,361.5,322,362.1,321.3"
                />
                <path
                  class="st31"
                  d="M363.8,318.9c0.5,0,0.9-0.2,1.2-0.5c0.2-0.2,0.5-0.6,0.5-0.8l-1.8-1.8l-0.9,0.9l0.5,0.4l0.4-0.4l1,1
            c0,0-0.1,0.1-0.2,0.2c-0.4,0.4-1,0.4-2-0.5c-1-1-0.9-1.7-0.5-2.1c0.2-0.2,0.3-0.3,0.5-0.3l-0.4-0.6c-0.2,0-0.4,0.2-0.6,0.4
            c-0.7,0.7-0.9,1.9,0.4,3.2C362.6,318.6,363.3,318.9,363.8,318.9"
                />
                <path
                  class="st31"
                  d="M367.3,316L367.3,316c0.6-0.6,0.5-1.6-0.8-2.9c-0.9-0.9-2-1.4-2.7-0.7c-0.7,0.7-0.3,1.8,0.7,2.8
            C365.5,316.4,366.6,316.7,367.3,316 M364.2,313c0.4-0.4,1.1,0.2,1.7,0.8c0.7,0.7,1.2,1.4,0.9,1.8l0,0c-0.4,0.4-1.1-0.1-1.8-0.8
            C364.4,314.1,363.9,313.4,364.2,313"
                />
                <path
                  class="st31"
                  d="M366,310.3l2.3,2.2c0.6,0.5,0.9,0.5,1.1,0.3s0.2-0.6-0.4-1.1l-2.3-2.2l0.5-0.6l2.2,2.1c0.9,0.9,1,1.6,0.4,2.2
            s-1.4,0.5-2.2-0.3l-2.2-2.2L366,310.3z"
                />
                <polygon
                  class="st31"
                  points="369.1,308.2 368.5,308.8 367.9,308.3 369.7,306.5 370.2,307 369.6,307.6 372.6,310.5 372,311.1 	"
                />
                <path
                  class="st31"
                  d="M400.4,225.1c0.2-0.3,0.4-0.6,0.7-0.9c0.4-0.4,0.8-0.7,1.2-0.7c0.4,0,0.7,0.1,1,0.4c0.4,0.4,0.5,0.9,0.3,1.5
            l0,0c0.6-0.3,1.2-0.2,1.7,0.2c0.3,0.3,0.5,0.7,0.5,1.1c0,0.5-0.2,1-0.8,1.6c-0.3,0.3-0.5,0.5-0.7,0.6L400.4,225.1z M402.7,226.1
            l0.2-0.2c0.3-0.3,0.3-0.9-0.1-1.2c-0.3-0.3-0.7-0.4-1.1,0c-0.1,0.1-0.2,0.2-0.2,0.3L402.7,226.1z M404.5,227.9
            c0.1,0,0.1-0.1,0.2-0.2c0.4-0.4,0.4-0.9,0-1.4c-0.5-0.5-1-0.4-1.4,0l-0.2,0.2L404.5,227.9z"
                />
                <path
                  class="st31"
                  d="M403.9,221.4l2.7,2.6c0.7,0.6,1.1,0.6,1.3,0.4c0.3-0.3,0.2-0.7-0.4-1.3l-2.7-2.6l0.6-0.6l2.6,2.5
            c1.1,1,1.1,1.9,0.5,2.6c-0.7,0.7-1.6,0.6-2.6-0.4l-2.6-2.5L403.9,221.4z"
                />
                <polygon
                  class="st31"
                  points="406.4,218.9 407,218.2 410.6,221.6 411.6,220.6 412.2,221.1 410.5,222.8 	"
                />
                <polygon
                  class="st31"
                  points="408.9,216.4 409.5,215.7 413,219.1 414.1,218.1 414.6,218.6 412.9,220.3 	"
                />
                <path
                  class="st31"
                  d="M411.3,213.9c0.2-0.3,0.4-0.5,0.7-0.8c0.4-0.4,0.8-0.7,1.3-0.7c0.4,0,0.8,0.2,1.2,0.5
            c0.4,0.4,0.6,0.8,0.6,1.2c0.1,0.5-0.2,1-0.5,1.4c-0.1,0.1-0.1,0.1-0.2,0.2l1.6,1.5l-0.6,0.6L411.3,213.9z M413.9,215.1
            c0.1,0,0.1-0.1,0.2-0.1c0.4-0.4,0.4-0.9-0.1-1.4c-0.4-0.4-0.8-0.5-1.3-0.1c-0.1,0.1-0.2,0.2-0.2,0.3L413.9,215.1z"
                />
                <polygon
                  class="st31"
                  points="417.9,211.5 416.9,212.5 418.2,213.8 419.3,212.7 419.9,213.2 418.2,214.9 414.1,211 415.7,209.3
            416.3,209.9 415.3,210.9 416.4,212 417.3,211 	"
                />
                <path
                  class="st31"
                  d="M420.7,212.4l-4.1-3.9l0.6-0.6l2.4,1c0.5,0.2,1.2,0.5,1.7,0.8l0,0c-0.6-0.5-1.2-1-1.9-1.7l-1.2-1.1l0.6-0.6
            l4.1,3.9l-0.6,0.6l-2.4-1c-0.5-0.2-1.2-0.5-1.7-0.8l0,0c0.5,0.4,1.1,1,1.9,1.8l1.1,1.1L420.7,212.4z"
                />
                <path
                  class="st31"
                  d="M170.3,207.2c0.3,0.2,0.6,0.4,0.9,0.7c0.4,0.4,0.7,0.8,0.7,1.2s-0.1,0.7-0.4,1c-0.4,0.4-0.9,0.5-1.5,0.3l0,0
            c0.3,0.6,0.2,1.2-0.2,1.7c-0.3,0.3-0.7,0.5-1.1,0.5c-0.5,0-1-0.2-1.6-0.8c-0.3-0.3-0.5-0.5-0.6-0.7L170.3,207.2z M167.5,211.3
            c0,0.1,0.1,0.1,0.2,0.2c0.4,0.4,0.9,0.4,1.4,0c0.5-0.5,0.4-1,0-1.4l-0.2-0.2L167.5,211.3z M169.3,209.4l0.2,0.2
            c0.3,0.3,0.9,0.3,1.2-0.1c0.3-0.3,0.4-0.7,0-1.1c-0.1-0.1-0.2-0.2-0.3-0.2L169.3,209.4z"
                />
                <path
                  class="st31"
                  d="M174,210.7l-2.6,2.7c-0.6,0.7-0.6,1.1-0.4,1.3c0.3,0.3,0.7,0.3,1.3-0.4l2.6-2.7l0.6,0.6l-2.5,2.6
            c-1,1-1.9,1.1-2.6,0.5c-0.7-0.7-0.6-1.6,0.4-2.6l2.5-2.6L174,210.7z"
                />
                <polygon
                  class="st31"
                  points="176.6,213.2 177.2,213.8 173.8,217.3 174.9,218.3 174.3,218.9 172.6,217.2 	"
                />
                <polygon
                  class="st31"
                  points="179.1,215.6 179.7,216.2 176.3,219.7 177.4,220.8 176.8,221.3 175.1,219.6 	"
                />
                <path
                  class="st31"
                  d="M181.5,218.1c0.3,0.2,0.5,0.4,0.8,0.7c0.4,0.4,0.7,0.8,0.7,1.3c0,0.4-0.2,0.8-0.5,1.2
            c-0.4,0.4-0.8,0.6-1.2,0.6c-0.5,0-1-0.2-1.4-0.5c-0.1-0.1-0.1-0.1-0.2-0.2l-1.5,1.6l-0.6-0.6L181.5,218.1z M180.3,220.6
            c0,0.1,0.1,0.1,0.1,0.2c0.4,0.4,0.9,0.4,1.4-0.1c0.4-0.4,0.5-0.8,0.1-1.3c-0.1-0.1-0.2-0.2-0.3-0.2L180.3,220.6z"
                />
                <polygon
                  class="st31"
                  points="183.9,224.6 182.9,223.6 181.7,224.9 182.8,226 182.2,226.6 180.5,224.9 184.4,220.8 186.1,222.4
            185.6,223 184.5,222 183.5,223.1 184.4,224 	"
                />
                <path
                  class="st31"
                  d="M183.1,227.4l4-4.1l0.6,0.6l-1,2.4c-0.2,0.5-0.5,1.2-0.8,1.7l0,0c0.5-0.6,1-1.2,1.7-1.9l1.1-1.1l0.6,0.6
            l-4,4.1l-0.6-0.6l1-2.4c0.2-0.5,0.5-1.2,0.8-1.7l0,0c-0.4,0.5-1,1.1-1.8,1.9l-1.1,1.1L183.1,227.4z"
                />
                <rect
                  x="435.6"
                  y="270"
                  transform="matrix(0.6966 -0.7175 0.7175 0.6966 -89.7847 407.0424)"
                  class="st6"
                  width="1.6"
                  height="79.4"
                />
                <polygon
                  class="st6"
                  points="441.7,333.9 384.8,278.6 383.7,279.7 440.6,335 	"
                />
                <rect
                  x="397.2"
                  y="300.5"
                  transform="matrix(0.6965 -0.7176 0.7176 0.6965 -117.9238 386.5831)"
                  class="st6"
                  width="1.6"
                  height="64.3"
                />
                <polygon
                  class="st6"
                  points="430.6,345.5 431.7,344.3 379.9,294 378.8,295.1 	"
                />
                <polygon
                  class="st6"
                  points="411.6,364.7 365.5,320 364.4,321.2 410.5,365.9 	"
                />
                <rect
                  x="377.1"
                  y="321"
                  transform="matrix(0.6965 -0.7175 0.7175 0.6965 -138.7045 378.3037)"
                  class="st6"
                  width="1.6"
                  height="64.2"
                />
                <polygon
                  class="st6"
                  points="391.7,384.9 340,334.7 338.9,335.8 390.6,386 	"
                />
                <path
                  class="st39"
                  d="M104.5,45.3c2.4,2.4,2.5,6.3,0.1,8.7s-6.3,2.5-8.7,0.1c-2.4-2.4-2.5-6.3-0.1-8.7
            C98.2,42.9,102.1,42.9,104.5,45.3"
                />
                <path
                  class="st31"
                  d="M100.2,56c-1.6,0-3.2-0.6-4.4-1.8c-1.2-1.2-1.9-2.8-1.9-4.4c0-1.7,0.6-3.3,1.8-4.5c2.4-2.5,6.5-2.5,9-0.1l0,0
            c2.5,2.4,2.6,6.4,0.1,8.9C103.5,55.4,101.9,56,100.2,56 M100.2,43.7c-1.6,0-3.1,0.6-4.3,1.8c-1.1,1.1-1.7,2.7-1.7,4.3
            s0.7,3.1,1.8,4.2c2.4,2.3,6.2,2.3,8.5-0.1c2.3-2.4,2.3-6.2-0.1-8.5l0,0C103.3,44.2,101.7,43.7,100.2,43.7"
                />
                <path
                  class="st40"
                  d="M104.5,45.3c2.4,2.4,2.5,6.3,0.1,8.7s-6.3,2.5-8.7,0.1c-2.4-2.4-2.5-6.3-0.1-8.7
            C98.2,42.9,102.1,42.9,104.5,45.3z"
                />
                <path
                  class="st41"
                  d="M100,51.3L100,51.3l1.9-1.9h0.1l2.7,1h0.1l0.6-1.4v-0.1l-0.5-0.1h-0.1l-0.3,0.8c0,0-0.1,0.1-0.1,0l-2.5-0.9
            h-0.1l-1.8,1.8h-0.1l-0.3-0.2v-0.1l1.3-1.3v-0.1l-0.4-0.4h-0.1l-1.3,1.3H99l-1.6-1.3h-0.1l-0.4,0.3v0.1L100,51.3z"
                />
                <path
                  class="st41"
                  d="M97.2,47c0.4,0.4,0.4,0.9,0,1.3c-0.4,0.4-0.9,0.4-1.3,0s-0.4-0.9,0-1.3C96.2,46.6,96.8,46.6,97.2,47"
                />
                <path
                  class="st41"
                  d="M103.4,50.3l-0.5,0.1c0,0-0.1,0,0,0.1l0.1,0.1l0,0c0.4,0.9,0.3,1.7-0.4,2.5c-0.4,0.4-0.9,0.7-1.6,0.7
            c-0.6,0-1.1-0.2-1.6-0.6c-0.7-0.6-0.9-1.4-0.6-2.3v-0.1c0,0,0-0.1-0.1-0.1l-0.4-0.3h-0.1v0.1v0.1c-0.4,1.1-0.1,2.1,0.7,2.9
            c0.6,0.5,1.2,0.8,2,0.8s1.4-0.3,2-0.8c0.4-0.4,0.7-0.9,0.8-1.5C103.9,51.4,103.8,50.8,103.4,50.3C103.5,50.3,103.5,50.2,103.4,50.3
            "
                />
                <path
                  class="st39"
                  d="M152.5,5.2c2.4,2.4,2.5,6.3,0.1,8.7s-6.3,2.5-8.7,0.1s-2.5-6.3-0.1-8.7C146.1,2.8,150,2.8,152.5,5.2"
                />
                <path
                  class="st31"
                  d="M148.2,15.9c-1.6,0-3.2-0.6-4.4-1.8s-1.9-2.8-1.9-4.4c0-1.7,0.6-3.3,1.8-4.5c2.4-2.5,6.5-2.6,9-0.1
            c2.5,2.4,2.6,6.4,0.1,8.9C151.5,15.2,149.8,15.9,148.2,15.9 M148.2,3.6c-1.6,0-3.1,0.6-4.3,1.8c-1.1,1.1-1.7,2.7-1.7,4.3
            s0.7,3.1,1.8,4.2c2.4,2.3,6.2,2.3,8.5-0.1s2.3-6.2-0.1-8.5C151.2,4.1,149.7,3.6,148.2,3.6"
                />
                <path
                  class="st40"
                  d="M152.5,5.2c2.4,2.4,2.5,6.3,0.1,8.7s-6.3,2.5-8.7,0.1s-2.5-6.3-0.1-8.7C146.1,2.8,150,2.8,152.5,5.2z"
                />
                <path
                  class="st41"
                  d="M147.9,11.1h0.1l1.8-1.9h0.1l2.8,1h0.1l0.6-1.4V8.7l-0.5-0.1h-0.1l-0.3,0.8c0,0-0.1,0.1-0.1,0l-2.5-0.9h-0.1
            l-1.8,1.8h-0.1l-0.3-0.2V10l1.3-1.3V8.6l-0.4-0.4h-0.1l-1.3,1.3H147l-1.6-1.3h-0.1l-0.4,0.3v0.1L147.9,11.1z"
                />
                <path
                  class="st41"
                  d="M145.1,6.9c0.4,0.4,0.4,0.9,0,1.3s-0.9,0.4-1.3,0c-0.4-0.4-0.4-0.9,0-1.3C144.2,6.5,144.7,6.5,145.1,6.9"
                />
                <path
                  class="st41"
                  d="M151.4,10.1l-0.5,0.1c0,0-0.1,0,0,0.1l0.1,0.1l0,0c0.4,0.9,0.3,1.7-0.4,2.5c-0.4,0.4-0.9,0.7-1.6,0.7
            c-0.6,0-1.1-0.2-1.6-0.6c-0.7-0.6-0.9-1.4-0.6-2.3v-0.1c0,0,0-0.1-0.1-0.1l-0.4-0.3h-0.1v0.1v0.1c-0.4,1.1-0.1,2.1,0.7,2.9
            c0.6,0.5,1.2,0.8,2,0.8s1.4-0.3,2-0.8c0.4-0.4,0.7-0.9,0.8-1.5C151.8,11.3,151.7,10.7,151.4,10.1C151.5,10.2,151.5,10.1,151.4,10.1
            "
                />
                <path
                  class="st39"
                  d="M41.7,160.1c2.4,2.4,2.5,6.3,0.1,8.7s-6.3,2.5-8.7,0.1s-2.5-6.3-0.1-8.7C35.3,157.7,39.2,157.7,41.7,160.1"
                />
                <path
                  class="st31"
                  d="M37.4,170.8c-1.7,0-3.2-0.6-4.4-1.8s-1.9-2.8-1.9-4.4c0-1.7,0.6-3.3,1.8-4.5s2.8-1.9,4.5-1.9h0.1
            c1.7,0,3.2,0.6,4.4,1.8s1.9,2.8,1.9,4.4c0,1.7-0.6,3.3-1.8,4.5C40.7,170.1,39.2,170.8,37.4,170.8L37.4,170.8 M37.4,158.5
            C37.3,158.5,37.3,158.5,37.4,158.5c-1.7,0-3.2,0.7-4.3,1.8s-1.7,2.7-1.7,4.3s0.7,3.1,1.8,4.2c1.1,1.1,2.6,1.7,4.2,1.7h0.1
            c1.6,0,3.1-0.7,4.2-1.8c1.1-1.1,1.7-2.7,1.7-4.3s-0.7-3.1-1.8-4.2C40.4,159.1,39,158.5,37.4,158.5"
                />
                <path
                  class="st40"
                  d="M41.7,160.1c2.4,2.4,2.5,6.3,0.1,8.7s-6.3,2.5-8.7,0.1s-2.5-6.3-0.1-8.7C35.3,157.7,39.2,157.7,41.7,160.1z"
                />
                <path
                  class="st41"
                  d="M37.1,166.1L37.1,166.1l1.9-1.9h0.1l2.7,1h0.1l0.6-1.4v-0.1l-0.5-0.1h-0.1l-0.3,0.8c0,0-0.1,0.1-0.1,0
            l-2.5-0.9h-0.1l-1.8,1.8H37l-0.3-0.2V165l1.3-1.3v-0.1l-0.4-0.4h-0.1l-1.3,1.3h-0.1l-1.6-1.3h-0.1l-0.4,0.3v0.1L37.1,166.1z"
                />
                <path
                  class="st41"
                  d="M34.3,161.8c0.4,0.4,0.4,0.9,0,1.3c-0.4,0.4-0.9,0.4-1.3,0c-0.4-0.4-0.4-0.9,0-1.3S34,161.4,34.3,161.8"
                />
                <path
                  class="st41"
                  d="M40.6,165l-0.5,0.1c0,0-0.1,0,0,0.1l0.1,0.1l0,0c0.4,0.9,0.3,1.7-0.4,2.5c-0.4,0.4-0.9,0.7-1.6,0.7
            c-0.6,0-1.1-0.2-1.6-0.6c-0.7-0.6-0.9-1.4-0.6-2.3v-0.1v-0.1l-0.4-0.3h-0.1v0.1v0.1c-0.4,1.1-0.1,2.1,0.7,2.9
            c0.6,0.5,1.2,0.8,2,0.8s1.4-0.3,2-0.8c0.4-0.4,0.7-0.9,0.8-1.5C41,166.1,40.9,165.6,40.6,165C40.7,165.1,40.7,165,40.6,165"
                />
                <path
                  class="st39"
                  d="M64.7,100c2.4,2.4,2.5,6.3,0.1,8.7c-2.4,2.4-6.3,2.5-8.7,0.1s-2.5-6.3-0.1-8.7C58.3,97.7,62.3,97.6,64.7,100"
                />
                <path
                  class="st31"
                  d="M60.4,110.7c-1.6,0-3.2-0.6-4.4-1.8c-1.2-1.2-1.9-2.8-1.9-4.4c0-1.7,0.6-3.3,1.8-4.5c2.4-2.5,6.5-2.5,9-0.1
            l0,0c2.5,2.4,2.6,6.4,0.1,8.9C63.7,110.1,62,110.7,60.4,110.7 M60.4,98.4c-1.6,0-3.1,0.6-4.3,1.8c-1.1,1.1-1.7,2.7-1.7,4.3
            c0,1.6,0.7,3.1,1.8,4.2c2.4,2.3,6.2,2.3,8.5-0.1c2.3-2.4,2.3-6.2-0.1-8.5C63.4,99,61.9,98.4,60.4,98.4"
                />
                <path
                  class="st40"
                  d="M64.7,100c2.4,2.4,2.5,6.3,0.1,8.7c-2.4,2.4-6.3,2.5-8.7,0.1s-2.5-6.3-0.1-8.7C58.3,97.7,62.3,97.6,64.7,100z
            "
                />
                <path
                  class="st41"
                  d="M60.2,106L60.2,106l1.9-1.9h0.1l2.7,1H65l0.6-1.4v-0.1l-0.5-0.2c0,0-0.1,0-0.1,0.1l-0.3,0.8
            c0,0-0.1,0.1-0.1,0l-2.5-0.9H62l-1.8,1.8h-0.1l-0.3-0.2v-0.1l1.3-1.3v-0.1l-0.4-0.4h-0.1l-1.3,1.3h-0.1l-1.6-1.3h-0.1l-0.4,0.3v0.1
            L60.2,106z"
                />
                <path
                  class="st41"
                  d="M57.3,101.7c0.4,0.4,0.4,0.9,0,1.3s-0.9,0.4-1.3,0c-0.4-0.4-0.4-0.9,0-1.3C56.4,101.4,57,101.4,57.3,101.7"
                />
                <path
                  class="st41"
                  d="M63.6,105l-0.5,0.1c0,0-0.1,0,0,0.1l0.1,0.1l0,0c0.4,0.9,0.3,1.7-0.4,2.5c-0.4,0.4-1,0.7-1.6,0.7
            s-1.1-0.2-1.6-0.6c-0.7-0.6-0.9-1.4-0.6-2.3v-0.1v-0.1l-0.4-0.3h-0.1v0.1v0.1c-0.4,1.1-0.1,2.1,0.7,2.9c0.6,0.5,1.2,0.8,2,0.8
            s1.4-0.3,2-0.8c0.4-0.4,0.7-0.9,0.8-1.5C64,106.1,63.9,105.6,63.6,105C63.7,105,63.7,105,63.6,105"
                />
                <path
                  class="st38"
                  d="M137.9,57.5c0.2,0,0.4-0.1,0.6-0.3c0.3-0.3,0.3-0.7,0-1c-0.4-0.4-0.8-0.4-1.2-0.1l-0.1,0.1l-0.4-0.4l0.1-0.1
            c0.2-0.2,0.4-0.6,0.1-1c-0.3-0.3-0.6-0.3-0.8-0.1c-0.2,0.1-0.2,0.3-0.3,0.5l-0.5-0.3c0-0.2,0.2-0.5,0.4-0.7
            c0.5-0.5,1.1-0.3,1.5,0.1c0.3,0.3,0.4,0.8,0.2,1.2l0,0c0.4-0.2,0.9-0.1,1.3,0.4c0.5,0.5,0.5,1.3-0.1,1.9c-0.2,0.2-0.5,0.3-0.7,0.4
            L137.9,57.5z"
                />
                <path
                  class="st38"
                  d="M141.7,55.2c-0.6,0.5-1.5,0-2.4-1c-0.9-1.1-1.2-2-0.6-2.5c0.6-0.6,1.6,0.1,2.4,1
            C142.1,53.9,142.2,54.8,141.7,55.2L141.7,55.2z M141.3,54.7c0.2-0.2-0.1-0.8-0.8-1.6s-1.2-1.2-1.4-1c-0.3,0.2,0,0.8,0.7,1.6
            C140.5,54.6,141.1,55,141.3,54.7L141.3,54.7z"
                />
                <path
                  class="st38"
                  d="M144.4,53c-0.6,0.5-1.5,0-2.4-1c-0.9-1.1-1.2-2-0.6-2.6c0.7-0.5,1.5,0.1,2.3,1
            C144.8,51.8,144.9,52.6,144.4,53L144.4,53z M144,52.5c0.2-0.2-0.1-0.8-0.7-1.6c-0.7-0.8-1.2-1.2-1.4-1c-0.3,0.2,0,0.8,0.7,1.6
            C143.2,52.4,143.7,52.8,144,52.5L144,52.5z"
                />
                <polygon
                  class="st38"
                  points="144.3,46.9 144.9,46.5 147.4,49.6 148.3,48.9 148.7,49.4 147.3,50.6 	"
                />
                <polygon
                  class="st38"
                  points="149.7,45.9 148.8,46.6 149.8,47.7 150.7,47 151.1,47.5 149.6,48.7 146.7,45 148.2,43.9 148.6,44.4
            147.7,45.1 148.5,46.1 149.3,45.4 	"
                />
                <path
                  class="st38"
                  d="M152.7,46.3l-3.6-3.2l0.6-0.5l1.6,1.5c0.4,0.4,0.8,0.8,1.2,1.2l0,0c-0.3-0.5-0.6-1-0.8-1.5l-1-1.9l0.6-0.5
            l2,4.3L152.7,46.3z"
                />
                <polygon
                  class="st38"
                  points="155.3,41.7 154.4,42.4 155.3,43.6 156.3,42.9 156.6,43.4 155.1,44.5 152.4,40.7 153.8,39.6
            154.2,40.2 153.3,40.8 154.1,41.9 154.9,41.2 	"
                />
                <polygon
                  class="st38"
                  points="155,38.7 155.6,38.3 157.9,41.7 158.9,41 159.2,41.5 157.7,42.6 	"
                />
                <line class="st42" x1="390.7" y1="386.2" x2="391.8" y2="385" />
                <polygon
                  class="st31"
                  points="446.2,308.1 446.2,308.1 445.1,307.7 445.7,306.7 447.3,307.2 448.2,308.1 443.9,312.5 442.9,311.5
            "
                />
                <path
                  class="st31"
                  d="M448.6,315.3l-1.3-1.3l0,0h0.5c1,0,2.1-0.1,2.9-1c0.6-0.6,1-1.6-0.1-2.6c-0.4-0.4-0.9-0.7-1.3-0.7l-0.6,1
            c0.3,0.1,0.6,0.2,0.9,0.4c0.3,0.3,0.3,0.7,0,1c-0.5,0.5-1.4,0.7-2.7,0.8l-1,0.1l-0.7,0.7l2.5,2.5L448.6,315.3z"
                />
                <path
                  class="st31"
                  d="M450,318.4l0.9,0.9l1-1l0.4,0.4l0.8-0.8l-0.4-0.4l2.5-2.6l-1-1l-4.1,1.3l-0.7,0.7l1.5,1.5L450,318.4z
            M451.1,315.9l1.2-0.4c0.3-0.1,0.6-0.2,0.9-0.3l0,0c-0.2,0.2-0.5,0.4-0.7,0.6l-0.7,0.8L451.1,315.9L451.1,315.9z"
                />
                <polygon
                  class="st31"
                  points="434.4,322.6 438.7,318.2 437.8,317.3 436.2,316.8 435.6,317.8 436.7,318.2 436.7,318.2 433.4,321.6
            "
                />
                <path
                  class="st31"
                  d="M439.1,325.4l-1.3-1.3l0,0h0.5c1,0,2.1-0.1,2.9-1c0.6-0.6,1-1.6-0.1-2.6c-0.4-0.4-0.9-0.7-1.3-0.7l-0.6,1
            c0.3,0.1,0.6,0.2,0.9,0.4c0.3,0.3,0.3,0.7,0,1c-0.5,0.5-1.4,0.7-2.7,0.8l-1,0.1l-0.7,0.7l2.5,2.5L439.1,325.4z"
                />
                <path
                  class="st31"
                  d="M442.5,328.7l-1.3-1.3l0,0h0.5c1,0,2.1-0.1,2.9-1c0.6-0.6,1-1.6-0.1-2.6c-0.4-0.4-0.9-0.7-1.3-0.7l-0.6,1
            c0.3,0.1,0.6,0.2,0.9,0.4c0.3,0.3,0.3,0.7,0,1c-0.5,0.5-1.4,0.7-2.7,0.8l-1,0.1l-0.7,0.7l2.5,2.5L442.5,328.7z"
                />
                <polygon
                  class="st31"
                  points="424.5,333.3 428.8,328.9 427.9,328 426.3,327.5 425.7,328.5 426.8,328.9 426.8,328.9 423.5,332.3
            "
                />
                <path
                  class="st31"
                  d="M429.2,336.1l-1.3-1.3l0,0h0.5c1,0,2.1-0.1,2.9-1c0.6-0.6,1-1.6-0.1-2.6c-0.4-0.4-0.9-0.7-1.3-0.7l-0.6,1
            c0.3,0.1,0.6,0.2,0.9,0.4c0.3,0.3,0.3,0.7,0,1c-0.5,0.5-1.4,0.7-2.7,0.8l-1,0.1l-0.7,0.7l2.5,2.5L429.2,336.1z"
                />
                <path
                  class="st31"
                  d="M430.4,339.2c0.7,0.7,2,0.6,3.6-1c0.9-0.9,2-2.4,0.8-3.5c-1-1-2.5-0.2-3.6,0.9
            C430.3,336.7,429.4,338.2,430.4,339.2L430.4,339.2z M432.3,336.7c1-1,1.4-1.2,1.7-1c0.2,0.2-0.2,0.7-1.1,1.6c-1,1-1.4,1.3-1.6,1.1
            l0,0C431.1,338.1,431.3,337.7,432.3,336.7"
                />
                <polygon
                  class="st31"
                  points="414.9,343.9 419.2,339.5 418.3,338.6 416.8,338.1 416.1,339 417.2,339.4 417.3,339.4 413.9,342.9
            "
                />
                <polygon
                  class="st31"
                  points="418.3,347.1 422.6,342.7 421.7,341.8 420.1,341.3 419.5,342.3 420.6,342.7 420.6,342.7 417.3,346.1
            "
                />
                <path
                  class="st31"
                  d="M423.6,349.7c0.5-0.5,0.6-1.2,0.4-1.8l0,0c0.8,0.2,1.3-0.1,1.5-0.4c0.7-0.7,0.5-1.7-0.1-2.3l0,0
            c-0.7-0.7-1.8-0.9-2.5-0.1c-0.3,0.3-0.5,0.8-0.4,1.5l0,0c-0.6-0.1-1.2,0-1.7,0.5c-0.8,0.8-0.6,1.8,0.2,2.6
            C421.6,350.4,422.7,350.6,423.6,349.7 M423.9,346.1c0.2-0.2,0.5-0.4,0.8-0.2l0,0c0.2,0.2,0,0.6-0.2,0.8c-0.2,0.2-0.6,0.4-0.8,0.3
            C423.5,346.7,423.6,346.3,423.9,346.1 M421.8,348c0.3-0.3,0.7-0.4,1-0.4c0.1,0.3,0.1,0.8-0.3,1.2c-0.3,0.3-0.7,0.5-0.9,0.2l0,0
            C421.3,348.8,421.5,348.4,421.8,348"
                />
                <polygon
                  class="st31"
                  points="404.6,354.1 408.9,349.7 408,348.8 406.5,348.3 405.8,349.2 406.9,349.6 407,349.6 403.6,353.1 	"
                />
                <polygon
                  class="st31"
                  points="408,357.3 412.3,352.9 411.4,352 409.8,351.5 409.2,352.5 410.3,352.9 410.3,352.9 407,356.3 	"
                />
                <path
                  class="st31"
                  d="M413.5,359.7c0.8-0.8,0.9-1.8,0.3-2.4c-0.3-0.3-0.6-0.4-1-0.3l0,0c0.6-0.4,1.3-0.5,1.9-0.1
            c0.2,0.1,0.3,0.2,0.4,0.3l0.8-0.8c-0.1-0.1-0.3-0.2-0.5-0.4c-0.4-0.3-1-0.5-1.6-0.5c-0.8,0-1.8,0.3-2.8,1.3
            c-1.1,1.1-1.2,2.4-0.4,3.2C411.6,360.9,412.8,360.4,413.5,359.7 M411.8,358.1c0.2-0.2,0.4-0.4,0.5-0.4c0.2-0.1,0.4-0.1,0.5,0
            c0.3,0.2,0,0.7-0.3,0.9c-0.4,0.4-0.9,0.8-1.1,0.6l0,0C411.1,359,411.4,358.5,411.8,358.1"
                />
                <polygon
                  class="st31"
                  points="394.5,364 398.8,359.6 397.9,358.7 396.4,358.2 395.7,359.2 396.8,359.6 396.9,359.6 393.5,363 	"
                />
                <polygon
                  class="st31"
                  points="397.9,367.3 402.2,362.9 401.3,362 399.7,361.5 399.1,362.5 400.2,362.8 400.2,362.9 396.9,366.3
            "
                />
                <path
                  class="st31"
                  d="M400.6,369.9l0.9,0.9l1-1l0.4,0.4l0.8-0.8l-0.4-0.4l2.5-2.6l-1-1l-4.1,1.3l-0.7,0.7l1.5,1.5L400.6,369.9z
            M401.7,367.5l1.2-0.4c0.3-0.1,0.6-0.2,0.9-0.3l0,0c-0.2,0.2-0.5,0.4-0.7,0.6l-0.7,0.7L401.7,367.5L401.7,367.5z"
                />
                <polygon
                  class="st31"
                  points="385.1,374.8 389.4,370.4 388.4,369.5 386.9,369 386.3,370 387.4,370.3 387.4,370.4 384,373.8 	"
                />
                <polygon
                  class="st31"
                  points="388.4,378 392.7,373.6 391.8,372.7 390.2,372.2 389.6,373.2 390.7,373.6 390.7,373.6 387.4,377 	"
                />
                <path
                  class="st31"
                  d="M393.1,380.8l-1.3-1.3l0,0h0.5c1,0,2.1-0.1,2.9-1c0.6-0.6,1-1.6-0.1-2.6c-0.4-0.4-0.9-0.7-1.3-0.7l-0.6,1
            c0.3,0.1,0.6,0.2,0.9,0.4c0.3,0.3,0.3,0.7,0,1c-0.5,0.5-1.4,0.7-2.7,0.8l-1,0.1l-0.7,0.7l2.5,2.5L393.1,380.8z"
                />
                <polygon
                  class="st31"
                  points="375.4,384.5 379.6,380.1 378.7,379.2 377.2,378.7 376.5,379.7 377.7,380 377.7,380.1 374.3,383.5
            "
                />
                <polygon
                  class="st31"
                  points="378.7,387.8 383,383.4 382.1,382.5 380.5,382 379.9,382.9 381,383.3 381,383.3 377.7,386.7 	"
                />
                <path
                  class="st31"
                  d="M381.3,390.4c0.7,0.7,2,0.6,3.6-1c0.9-0.9,2-2.4,0.8-3.5c-1-1-2.5-0.2-3.6,0.9
            C381.1,387.8,380.2,389.3,381.3,390.4L381.3,390.4z M383.2,387.8c1-1,1.4-1.2,1.7-1c0.2,0.2-0.2,0.7-1,1.6c-1,1-1.4,1.3-1.6,1.1
            l0,0C381.9,389.3,382.2,388.8,383.2,387.8"
                />
                <polygon
                  class="st38"
                  points="161.7,31.1 168.3,34.8 162.6,38.6 	"
                />
                <polygon class="st38" points="67.3,158 74.3,156 73,162.6 	" />
                <path
                  class="st31"
                  d="M289.6,340.6L289.6,340.6L289.6,340.6L289.6,340.6z"
                />
                <polygon
                  class="st31"
                  points="474.8,156.3 474.8,156.3 474,157.2 473.3,156.3 474.4,155 475.5,154.5 478.1,160.1 476.8,160.7 	"
                />
                <path
                  class="st31"
                  d="M479.3,158c0.3,0,0.7,0,0.9-0.2c0.5-0.2,0.7-0.7,0.5-1c-0.3-0.6-0.8-0.5-1.4-0.3l-0.2,0.1l-0.4-1h0.1
            c0.4-0.2,0.9-0.5,0.6-1c-0.2-0.3-0.5-0.4-0.9-0.3c-0.2,0.1-0.5,0.3-0.6,0.5l-0.6-0.9c0.2-0.3,0.6-0.6,1.1-0.8
            c1.1-0.5,1.9-0.1,2.2,0.7c0.3,0.6,0.1,1.2-0.2,1.6l0,0c0.7,0,1.3,0.3,1.6,1c0.4,0.8,0.1,2-1.2,2.6c-0.5,0.2-0.9,0.3-1.3,0.3
            L479.3,158z"
                />
                <path
                  class="st31"
                  d="M483.2,150.9c0.8-0.4,1.8-0.2,2.2,0.7c0.1,0.3,0.3,0.9-0.2,1.5l0,0c0.6,0,1.2,0.4,1.5,1
            c0.5,1.1-0.1,2.1-1,2.5c-1,0.4-2,0.2-2.5-0.8c-0.3-0.7-0.2-1.3,0.2-1.8l0,0c-0.6-0.1-1-0.5-1.2-0.9
            C481.7,152.3,482.3,151.4,483.2,150.9L483.2,150.9z M483.5,151.8c-0.3,0.1-0.3,0.5-0.1,0.8c0.1,0.3,0.4,0.5,0.8,0.5
            c0.2-0.2,0.1-0.6,0-0.8C484.1,152,483.8,151.7,483.5,151.8L483.5,151.8z M485.3,155.8c0.3-0.2,0.3-0.6,0.1-1
            c-0.2-0.5-0.7-0.7-1-0.7c-0.1,0.3-0.2,0.6,0,1C484.7,155.6,485,156,485.3,155.8L485.3,155.8z"
                />
                <polygon
                  class="st6"
                  points="353.8,18.1 346,16.2 336.7,39 352.6,54.4 378.8,27.6 	"
                />
                <polygon
                  class="st31"
                  points="224.2,303.7 222.6,306.2 222.6,306.2 225.1,304.5 225.7,305.1 222.2,307.3 221.5,306.6 223.6,303.1
            "
                />
                <polygon
                  class="st31"
                  points="223.1,308.2 225.9,305.3 226.5,305.9 223.7,308.7 	"
                />
                <path
                  class="st31"
                  d="M225.5,308.7L225.5,308.7c-0.3,0.4-0.4,0.6-0.1,0.9c0.2,0.2,0.5,0.2,0.7,0c0.3-0.3,0.2-0.5,0-1
            c-0.3-0.7-0.4-1.1,0.1-1.6c0.5-0.6,1.2-0.5,1.7,0s0.7,1.1,0.1,1.6l-0.1,0.1l-0.6-0.5c0.3-0.3,0.3-0.5,0.1-0.7
            c-0.3-0.3-0.5-0.2-0.7,0s-0.2,0.3-0.1,0.7l0.3,0.6c0.2,0.6,0.1,0.9-0.2,1.3c-0.6,0.6-1.2,0.5-1.8-0.1c-0.7-0.6-0.6-1.2-0.1-1.7
            l0.1-0.1L225.5,308.7z"
                />
                <polygon
                  class="st31"
                  points="226.2,311.2 229,308.4 229.6,308.9 226.8,311.8 	"
                />
                <polygon
                  class="st31"
                  points="231.7,310.9 231.2,311.4 230.6,310.8 228.3,313.2 227.7,312.6 230,310.3 229.4,309.6 229.9,309.2
            "
                />
                <path
                  class="st31"
                  d="M232.9,312c0.9,0.8,0.4,1.6-0.5,2.4c-0.8,0.9-1.5,1.4-2.4,0.5c-0.9-0.8-0.4-1.6,0.5-2.4
            C231.3,311.7,232,311.2,232.9,312 M230.4,314.5c0.3,0.3,0.7,0.1,1.4-0.7c0.7-0.8,1-1.1,0.6-1.4c-0.3-0.3-0.7-0.1-1.4,0.7
            C230.3,313.9,230.1,314.2,230.4,314.5"
                />
                <path
                  class="st31"
                  d="M234.2,313.3l1.1,1c0.5,0.5,0.5,1,0,1.5c-0.4,0.4-0.8,0.5-1.2,0.2l0,0c0.3,0.4,0.2,0.7-0.4,1.3
            c-0.3,0.3-0.4,0.5-0.4,0.6l0,0l-0.6-0.6c0-0.1,0.1-0.3,0.2-0.4l0.5-0.6c0.2-0.2,0.2-0.5,0-0.7l-0.3-0.3l-1.2,1.2l-0.6-0.6
            L234.2,313.3z M233.5,315.1l0.2,0.2c0.3,0.3,0.5,0.3,0.8,0s0.2-0.5,0-0.8l-0.3-0.3L233.5,315.1z"
                />
                <path
                  class="st31"
                  d="M234.9,317.9L234.9,317.9c-0.3,0.3-0.4,0.6-0.1,0.9c0.2,0.2,0.5,0.2,0.7,0c0.3-0.3,0.2-0.5,0-1
            c-0.3-0.7-0.4-1.1,0.1-1.6c0.5-0.6,1.2-0.5,1.7,0s0.7,1.1,0.1,1.6l-0.1,0.1l-0.6-0.5c0.3-0.3,0.3-0.5,0.1-0.7
            c-0.3-0.3-0.5-0.2-0.7,0s-0.2,0.3-0.1,0.7l0.3,0.6c0.2,0.6,0.2,0.9-0.2,1.3c-0.6,0.6-1.2,0.5-1.8-0.1c-0.7-0.6-0.6-1.2-0.1-1.7
            l0.1-0.1L234.9,317.9z"
                />
                <path
                  class="st31"
                  d="M238.5,318.6c-0.4,0.4-0.8,0.6-1.3,0.3l0.3-0.3c0.2,0.1,0.4,0,0.5-0.1l0.1-0.1l-0.2-0.2l0.6-0.6l0.5,0.5
            L238.5,318.6z"
                />
                <path
                  class="st31"
                  d="M240.5,319.5l0.9,0.9c0.8,0.8,0.4,1.5-0.4,2.3c-1,1-1.6,1.3-2.4,0.5l-0.9-0.9L240.5,319.5z M238.7,322.4
            l0.3,0.2c0.4,0.4,0.7,0.2,1.5-0.6c0.6-0.6,0.9-1,0.5-1.5l-0.2-0.2L238.7,322.4z"
                />
                <path
                  class="st31"
                  d="M243.3,322.2l-1.9,2c-0.3,0.3-0.4,0.6-0.1,0.8c0.3,0.3,0.5,0.1,0.8-0.2l1.9-2l0.6,0.6l-1.9,2
            c-0.7,0.7-1.3,0.5-1.8,0s-0.8-1,0-1.8l1.9-2L243.3,322.2z"
                />
                <path
                  class="st31"
                  d="M245.3,325.8c0.2-0.2,0.4-0.6,0.1-0.8c-0.3-0.3-0.7-0.1-1.4,0.6s-1,1.2-0.7,1.5c0.1,0.1,0.5,0.2,0.8-0.1
            l0.3-0.3l-0.4-0.4l0.4-0.4l0.9,0.9l-1.5,1.5l-0.4-0.4l0.3-0.3l0,0c-0.4,0.1-0.6,0-0.9-0.3c-0.7-0.7-0.3-1.3,0.6-2.3
            c0.9-1,1.6-1.2,2.4-0.5c0.6,0.6,0.6,1.2,0,1.8L245.3,325.8z"
                />
                <path
                  class="st31"
                  d="M248.1,326.7c0.9,0.8,0.4,1.6-0.5,2.4c-0.8,0.9-1.5,1.4-2.4,0.5c-0.9-0.8-0.4-1.6,0.5-2.4
            C246.5,326.4,247.2,325.9,248.1,326.7 M245.6,329.3c0.3,0.3,0.7,0.1,1.4-0.7c0.7-0.8,1-1.1,0.6-1.4c-0.3-0.3-0.7-0.1-1.4,0.7
            C245.5,328.6,245.3,328.9,245.6,329.3"
                />
                <path
                  class="st31"
                  d="M249.9,328.6l-1.9,2c-0.3,0.3-0.4,0.6-0.1,0.8c0.3,0.3,0.5,0.1,0.8-0.2l1.9-2l0.6,0.6l-1.9,2
            c-0.7,0.7-1.3,0.5-1.8,0s-0.8-1,0-1.8l1.9-2L249.9,328.6z"
                />
                <polygon
                  class="st31"
                  points="253.2,331.8 252.7,332.2 252.1,331.6 249.8,334 249.2,333.4 251.5,331.1 250.9,330.5 251.3,330 	"
                />
                <path
                  class="st26"
                  d="M299.6,443.5c-8.6,0-16.3-1.1-22.8-2.6c-20.9-4.8-33.9-14.6-34.5-15l-3.3-2.5l13.9-21.9
            c-5.7-3.5-15.8-9.8-20.1-14.1c-5.5-5.5-137.9-137.6-139.2-139l-0.4-0.4l-0.3-0.5c-0.6-1-14.2-25.5-7.6-61.7
            c6.6-35.8,30.9-63.5,31.9-64.6l0.2-0.2L224.2,15.5h117.7l33,3.1l1.1,0.9c4.1,3.5,101.8,84.9,123,119.9c9.7,16,26,74.3-7.7,120.4
            l-0.4,0.5L358.4,395.9l-9.2,6.3L362,423l-3.7,2.4C336.8,439.2,316.5,443.5,299.6,443.5 M251.2,421c4.9,3,14.8,8.2,28.1,11.2
            c24.1,5.5,47.8,1.4,70.6-12.1l-12.6-20.6l15.5-10.6l131.7-134.7c30.4-41.9,15.6-96.2,7.1-110.3C472.1,112.2,382.2,36.3,371.3,27.2
            l-30-2.8H227.9l-104,102.8c-1.5,1.8-23.7,27.9-29.7,60.2c-5.6,30.2,4.5,51.7,6.3,55.2c8.8,8.7,133.4,133.1,138.7,138.5
            c4.2,4.2,17.5,12.3,22.3,15.1l4,2.3L251.2,421z"
                />
                <text
                  transform="matrix(0.7092 -0.705 0.7071 0.7071 150.1662 98.0228)"
                  class="st14 st15 st43"
                >
                  W
                </text>
                <text
                  transform="matrix(0.7092 -0.705 0.7071 0.7071 152.8932 95.3118)"
                  class="st14 st15 st43"
                >
                  ALK
                </text>
                <text
                  transform="matrix(0.7092 -0.705 0.7071 0.7071 158.612 89.6277)"
                  class="st14 st15 st43"
                >
                  W
                </text>
                <text
                  transform="matrix(0.7092 -0.705 0.7071 0.7071 161.3388 86.9173)"
                  class="st14 st15 st43"
                >
                  A
                </text>
                <text
                  transform="matrix(0.7092 -0.705 0.7071 0.7071 163.1808 85.0877)"
                  class="st14 st15 st43"
                >
                  Y
                </text>
                <path
                  class="st30"
                  d="M293.7,108.8v-0.2l-3.4-6.2l-3.9-7.2l3.2,15.4l0.5,2.1l-0.7-0.5l-32.7-20.8l28.7,29.6l-20.8,8.9l16.1-1.4
            l4.8-0.4C285.3,123.5,286.5,115.5,293.7,108.8"
                />
                <polygon
                  class="st30"
                  points="334.7,119.2 304.9,114.5 313.9,89.5 295.9,108.3 295.9,108.3 295.3,113 302.7,108 299.3,116.8
            322.5,121.9 299.3,124.3 305.1,133.6 296.1,127.1 291.6,154.4 288.5,129.2 285.7,132.3 291.2,181.3 298.7,132.8 311,142.6
            316,146.6 321.3,150.8 317.6,145.6 314.1,140.8 304.4,127.2 331.4,124.7 338.8,124 347.8,123.2 355.1,122.5 348.4,121.4
            340.8,120.2 	"
                />
                <polygon
                  class="st30"
                  points="294.3,180.4 294.3,178.4 293.6,178.4 293.6,178.1 295.3,178.1 295.3,178.4 294.6,178.4 294.6,180.4
            "
                />
                <path
                  class="st30"
                  d="M295.9,180.4v-2.2h0.5l0.5,1.6c0.1,0.1,0.1,0.3,0.1,0.3c0-0.1,0.1-0.2,0.1-0.4l0.5-1.6h0.4v2.2h-0.3v-1.9
            l-0.7,1.9h-0.3l-0.7-1.9v1.9L295.9,180.4L295.9,180.4z"
                />
                <path
                  class="st39"
                  d="M127.1,118.9c2.4,2.4,2.5,6.3,0.1,8.7c-2.4,2.4-6.3,2.5-8.7,0.1c-2.4-2.4-2.5-6.3-0.1-8.7
            C120.8,116.6,124.7,116.5,127.1,118.9"
                />
                <path
                  class="st31"
                  d="M122.8,129.6c-1.6,0-3.2-0.6-4.4-1.8c-1.2-1.2-1.9-2.8-1.9-4.4c0-1.7,0.6-3.3,1.8-4.5
            c1.2-1.2,2.8-1.9,4.5-1.9h0.1c1.7,0,3.2,0.6,4.4,1.8l0,0c2.5,2.4,2.6,6.4,0.1,8.9C126.1,129,124.5,129.6,122.8,129.6 M122.8,117.3
            L122.8,117.3c-1.7,0-3.2,0.7-4.3,1.8c-1.1,1.1-1.7,2.7-1.7,4.3c0,1.6,0.7,3.1,1.8,4.2c2.4,2.3,6.2,2.3,8.5-0.1s2.3-6.2-0.1-8.5l0,0
            C125.9,117.9,124.4,117.3,122.8,117.3"
                />
                <path
                  class="st41"
                  d="M122.6,124.9L122.6,124.9l1.9-1.9h0.1l2.7,1h0.1l0.6-1.4v-0.1l-0.5-0.1h-0.1l-0.3,0.8c0,0-0.1,0.1-0.1,0
            l-2.5-0.9h-0.1l-1.8,1.8h-0.1l-0.3-0.2v-0.1l1.3-1.3v-0.1l-0.4-0.4H123l-1.3,1.4h-0.1l-1.6-1.3h-0.1l-0.4,0.3v0.1L122.6,124.9z"
                />
                <path
                  class="st41"
                  d="M119.8,120.6c0.4,0.4,0.4,0.9,0,1.3s-0.9,0.4-1.3,0s-0.4-0.9,0-1.3C118.8,120.3,119.4,120.3,119.8,120.6"
                />
                <path
                  class="st41"
                  d="M126,123.9l-0.5,0.1c0,0-0.1,0,0,0.1l0.1,0.1l0,0c0.4,0.9,0.3,1.7-0.4,2.5c-0.4,0.4-0.9,0.7-1.6,0.7
            c-0.6,0-1.1-0.2-1.6-0.6c-0.7-0.6-0.9-1.4-0.6-2.3v-0.1c0,0,0-0.1-0.1-0.1l-0.4-0.3h-0.1v0.1v0.1c-0.4,1.1-0.1,2.1,0.7,2.9
            c0.6,0.5,1.2,0.8,2,0.8s1.4-0.3,2-0.8c0.4-0.4,0.7-0.9,0.8-1.5C126.5,125,126.4,124.5,126,123.9C126.1,123.9,126.1,123.9,126,123.9
            "
                />
                <path
                  class="st40"
                  d="M127.1,118.9c2.4,2.4,2.5,6.3,0.1,8.7c-2.4,2.4-6.3,2.5-8.7,0.1c-2.4-2.4-2.5-6.3-0.1-8.7
            C120.8,116.6,124.7,116.5,127.1,118.9z"
                />
                <text
                  transform="matrix(0.7177 0.6965 -0.6986 0.7155 420.0184 66.2597)"
                  class="st14 st15 st44"
                >
                  W
                </text>
                <text
                  transform="matrix(0.7177 0.6965 -0.6986 0.7155 422.7816 68.9413)"
                  class="st14 st15 st44"
                >
                  ALK
                </text>
                <text
                  transform="matrix(0.7177 0.6965 -0.6986 0.7155 428.5682 74.5556)"
                  class="st14 st15 st44"
                >
                  W
                </text>
                <text
                  transform="matrix(0.7177 0.6965 -0.6986 0.7155 431.3273 77.2345)"
                  class="st14 st15 st44"
                >
                  A
                </text>
                <text
                  transform="matrix(0.7177 0.6965 -0.6986 0.7155 433.1935 79.0457)"
                  class="st14 st15 st44"
                >
                  Y
                </text>
                <text
                  transform="matrix(0.74 0.673 -0.6751 0.7377 393.6992 24.7193)"
                  class="st14 st15 st16"
                >
                  R
                </text>
                <text
                  transform="matrix(0.74 0.673 -0.6751 0.7377 396.5117 27.2772)"
                  class="st14 st15 st16"
                >
                  A
                </text>
                <text
                  transform="matrix(0.74 0.673 -0.6751 0.7377 399.3973 29.9015)"
                  class="st14 st15 st16"
                >
                  Y
                </text>
                <text
                  transform="matrix(0.74 0.673 -0.6751 0.7377 401.9873 32.257)"
                  class="st14 st15 st16"
                >
                  S
                </text>
                <text
                  transform="matrix(0.74 0.673 -0.6751 0.7377 404.6511 34.6796)"
                  class="st14 st15 st16"
                ></text>
                <text
                  transform="matrix(0.74 0.673 -0.6751 0.7377 405.8359 35.7571)"
                  class="st14 st15 st16"
                >
                  S
                </text>
                <text
                  transform="matrix(0.74 0.673 -0.6751 0.7377 408.4252 38.112)"
                  class="st14 st15 st16"
                >
                  CORE
                </text>
                <text
                  transform="matrix(0.74 0.673 -0.6751 0.7377 419.3034 48.0052)"
                  class="st14 st15 st16"
                >
                  B
                </text>
                <text
                  transform="matrix(0.74 0.673 -0.6751 0.7377 422.1152 50.5625)"
                  class="st14 st15 st16"
                >
                  OAR
                </text>
                <text
                  transform="matrix(0.74 0.673 -0.6751 0.7377 430.6251 58.3019)"
                  class="st14 st15 st16"
                >
                  D
                </text>
                <polygon
                  class="st6"
                  points="177.9,104.2 167,93.6 173.2,87.2 184.1,97.8 	"
                />
                <polygon
                  class="st32"
                  points="177.9,104.2 167,93.6 173.2,87.2 184.1,97.8 	"
                />
                <polygon
                  class="st6"
                  points="158.3,124.3 147.4,113.7 153.6,107.3 164.5,117.9 	"
                />
                <polygon
                  class="st32"
                  points="158.3,124.3 147.4,113.7 153.6,107.3 164.5,117.9 	"
                />
                <polygon
                  class="st6"
                  points="138.6,144.5 127.7,133.9 133.9,127.5 144.8,138.1 	"
                />
                <polygon
                  class="st32"
                  points="138.6,144.5 127.7,133.9 133.9,127.5 144.8,138.1 	"
                />
                <polygon
                  class="st6"
                  points="197.6,84.1 186.6,73.5 192.8,67.2 203.8,77.8 	"
                />
                <polygon
                  class="st32"
                  points="197.6,84.1 186.6,73.5 192.8,67.2 203.8,77.8 	"
                />
                <polygon
                  class="st6"
                  points="390.3,70.4 401,59.6 407.3,65.7 396.7,76.6 	"
                />
                <polygon
                  class="st32"
                  points="390.3,70.4 401,59.6 407.3,65.7 396.7,76.6 	"
                />
                <polygon
                  class="st6"
                  points="410.7,90.2 421.3,79.3 427.7,85.5 417,96.3 	"
                />
                <polygon
                  class="st32"
                  points="410.7,90.2 421.3,79.3 427.7,85.5 417,96.3 	"
                />
                <polygon
                  class="st6"
                  points="430.9,109.8 441.5,98.9 447.9,105.1 437.3,116 	"
                />
                <polygon
                  class="st32"
                  points="430.9,109.8 441.5,98.9 447.9,105.1 437.3,116 	"
                />
                <polygon
                  class="st6"
                  points="451.3,129.6 461.9,118.7 468.3,124.9 457.6,135.8 	"
                />
                <polygon
                  class="st32"
                  points="451.3,129.6 461.9,118.7 468.3,124.9 457.6,135.8 	"
                />
                <polygon
                  class="st6"
                  points="465.2,147.8 479.1,139.2 483.8,146.8 469.9,155.3 	"
                />
                <polygon
                  class="st31"
                  points="368.4,45.7 368.4,45.7 368,46.8 367,46.2 367.5,44.6 368.5,43.7 372.9,48 371.9,49 	"
                />
                <path
                  class="st31"
                  d="M373,40.9l-1.1,1.2l0.6,0.7l0.1-0.1c0.2-0.2,0.6-0.5,1.1-0.5s1,0.2,1.4,0.6c0.8,0.8,1,2.1,0,3.2
            c-0.3,0.3-0.7,0.6-1,0.7l-0.7-0.9c0.3-0.1,0.5-0.3,0.8-0.5c0.4-0.4,0.4-0.9,0-1.3c-0.5-0.5-1.1-0.2-1.6,0.2
            c-0.1,0.1-0.2,0.2-0.3,0.3l-2.1-2.5l1.9-1.9L373,40.9z"
                />
                <path
                  class="st31"
                  d="M378.8,42.1c-1,1.1-2.6,0.2-3.6-0.8c-1.2-1.1-1.9-2.6-0.9-3.6c1.1-1.2,2.6,0,3.5,0.8
            C379.4,40,379.5,41.3,378.8,42.1L378.8,42.1z M377.9,41.2c0.2-0.2-0.1-0.6-1.1-1.6c-0.9-0.9-1.4-1.3-1.6-1c-0.2,0.2,0,0.7,1,1.7
            C377.2,41.2,377.6,41.4,377.9,41.2L377.9,41.2z"
                />
                <polygon
                  class="st31"
                  points="384.3,60.5 384.3,60.5 383.9,61.6 382.9,61 383.4,59.4 384.3,58.5 388.7,62.8 387.7,63.8 	"
                />
                <path
                  class="st31"
                  d="M391.4,60.1l-1-1l-1.5,1.5l-0.7-0.7l-1.3-4.1l1-1l2.6,2.5l0.4-0.4l0.8,0.8l-0.4,0.4l1,1L391.4,60.1z
            M389.6,58.3l-0.8-0.7c-0.2-0.2-0.4-0.5-0.6-0.7l0,0c0.1,0.3,0.2,0.6,0.3,0.9l0.4,1.2l0,0L389.6,58.3z"
                />
                <path
                  class="st31"
                  d="M390.2,52.4c0.6-0.6,1.6-0.8,2.3-0.1c0.3,0.2,0.6,0.7,0.4,1.5l0,0c0.6-0.2,1.3-0.1,1.8,0.4
            c0.9,0.8,0.7,1.9,0,2.7s-1.8,0.9-2.6,0.2c-0.5-0.5-0.6-1.2-0.5-1.7l0,0c-0.6,0.1-1.1-0.1-1.5-0.4C389.3,54.2,389.4,53.2,390.2,52.4
            L390.2,52.4z M390.8,53.1c-0.2,0.2-0.1,0.6,0.2,0.8c0.2,0.2,0.6,0.3,1,0.2c0.1-0.2-0.1-0.6-0.3-0.8C391.4,53.1,391,52.9,390.8,53.1
            L390.8,53.1z M393.9,56.2c0.3-0.3,0.1-0.6-0.2-0.9c-0.4-0.4-0.9-0.4-1.2-0.3c0,0.3,0.1,0.6,0.4,1C393.2,56.3,393.7,56.5,393.9,56.2
            L393.9,56.2z"
                />
                <polygon
                  class="st31"
                  points="404.2,80.4 404.2,80.4 403.8,81.6 402.9,80.9 403.4,79.4 404.3,78.5 408.7,82.7 407.7,83.8 	"
                />
                <path
                  class="st31"
                  d="M411.3,80l-1-1l-1.5,1.5l-0.7-0.7l-1.3-4.1l1-1l2.6,2.5l0.4-0.4l0.8,0.8l-0.4,0.4l1,1L411.3,80z M409.5,78.3
            l-0.8-0.7c-0.2-0.2-0.4-0.5-0.6-0.7l0,0c0.1,0.3,0.2,0.6,0.3,0.9l0.4,1.2l0,0L409.5,78.3z"
                />
                <path
                  class="st31"
                  d="M411.9,72.2c-0.1,0.1-0.2,0.3-0.3,0.4c-0.4,0.6-0.3,1.3,0.1,1.9l0,0c0-0.3,0-0.7,0.3-1
            c0.6-0.6,1.5-0.5,2.4,0.3c0.7,0.7,1.2,1.9,0.3,2.9c-0.8,0.9-2.1,0.7-3.2-0.4c-1-1-1.3-2-1.3-2.8c0-0.6,0.2-1.2,0.5-1.6
            c0.2-0.3,0.3-0.4,0.4-0.5L411.9,72.2z M413.9,76.1c0.3-0.3-0.1-0.7-0.6-1.1c-0.3-0.2-0.7-0.5-0.9-0.3c-0.1,0.1-0.1,0.3,0,0.5
            c0,0.1,0.2,0.2,0.4,0.5C413.1,76,413.6,76.3,413.9,76.1L413.9,76.1z"
                />
                <polygon
                  class="st31"
                  points="424.8,100 424.8,100 424.5,101.1 423.5,100.5 424,98.9 424.9,98 429.3,102.3 428.3,103.3 	"
                />
                <path
                  class="st31"
                  d="M431.9,99.6l-1-1l-1.5,1.5l-0.7-0.7l-1.3-4.1l1-1l2.6,2.5l0.4-0.4l0.8,0.8l-0.4,0.4l1,1L431.9,99.6z
            M430.1,97.8l-0.8-0.7c-0.2-0.2-0.4-0.5-0.6-0.7l0,0c0.1,0.3,0.2,0.6,0.3,0.9l0.4,1.2l0,0L430.1,97.8z"
                />
                <path
                  class="st31"
                  d="M435.2,96.2l-1-1l-1.5,1.5L432,96l-1.3-4.1l1-1l2.6,2.5l0.4-0.4l0.8,0.8l-0.4,0.4l1,1L435.2,96.2z
            M433.4,94.5l-0.8-0.7c-0.2-0.2-0.4-0.5-0.6-0.7l0,0c0.1,0.3,0.2,0.6,0.3,0.9l0.4,1.2l0,0L433.4,94.5z"
                />
                <polygon
                  class="st31"
                  points="445.1,119 445.1,119 444.8,120.1 443.8,119.5 444.3,117.9 445.2,117 449.6,121.3 448.6,122.3 	"
                />
                <path
                  class="st31"
                  d="M452.2,118.6l-1-1l-1.5,1.5l-0.7-0.7l-1.3-4.1l1-1l2.6,2.5l0.4-0.4l0.8,0.8l-0.4,0.4l1,1L452.2,118.6z
            M450.4,116.8l-0.8-0.7c-0.2-0.2-0.4-0.5-0.6-0.7l0,0c0.1,0.3,0.2,0.6,0.3,0.9l0.4,1.2l0,0L450.4,116.8z"
                />
                <path
                  class="st31"
                  d="M454.1,116.7l-0.7-0.7l-0.1-1c-0.1-1.3-0.3-2.2-0.8-2.7c-0.3-0.3-0.7-0.3-1,0c-0.2,0.3-0.4,0.6-0.4,0.9
            l-1-0.6c0.1-0.4,0.3-0.9,0.7-1.3c1-1.1,2-0.7,2.7-0.1c0.8,0.8,0.9,1.9,1,2.9v0.5l0,0l1.3-1.3l0.9,0.9L454.1,116.7z"
                />
                <polygon
                  class="st31"
                  points="463.6,137.8 463.5,137.8 463.2,138.9 462.2,138.3 462.7,136.7 463.6,135.8 468,140.1 467,141.1 	"
                />
                <path
                  class="st31"
                  d="M470.7,137.4l-1-1l-1.5,1.5l-0.7-0.7l-1.3-4.1l1-1l2.6,2.5l0.4-0.4l0.8,0.8l-0.4,0.4l1,1L470.7,137.4z
            M468.8,135.6l-0.8-0.7c-0.2-0.2-0.4-0.5-0.6-0.7l0,0c0.1,0.3,0.2,0.6,0.3,0.9l0.4,1.2l0,0L468.8,135.6z"
                />
                <path
                  class="st31"
                  d="M473.9,134.2c-1.1,1.1-2.6,0.2-3.6-0.8c-1.2-1.1-1.9-2.6-0.9-3.6c1.1-1.2,2.6,0,3.5,0.8
            C474.5,132.1,474.6,133.4,473.9,134.2L473.9,134.2z M473,133.3c0.2-0.2-0.1-0.6-1.1-1.6c-0.9-0.9-1.4-1.3-1.6-1
            c-0.2,0.2,0,0.7,1,1.7C472.3,133.3,472.8,133.5,473,133.3L473,133.3z"
                />
                <polygon
                  class="st31"
                  points="219.1,45.7 219.1,45.7 218,45.3 218.6,44.4 220.2,44.9 221.1,45.8 216.8,50.2 215.8,49.2 	"
                />
                <path
                  class="st31"
                  d="M219.5,52.8l1-1l-1.5-1.5l0.7-0.7l4.1-1.3l1,1l-2.5,2.6l0.4,0.4l-0.8,0.8l-0.4-0.4l-1,1L219.5,52.8z
            M221.3,51l0.7-0.8c0.2-0.2,0.5-0.4,0.7-0.6l0,0c-0.3,0.1-0.6,0.2-0.9,0.3l-1.2,0.4l0,0L221.3,51z"
                />
                <path
                  class="st31"
                  d="M222.6,54.2c0.2,0.2,0.3,0.3,0.5,0.4c0.2,0.1,0.4,0.2,0.7,0.2s0.7-0.1,1.1-0.4l0,0c-0.3,0-0.5-0.1-0.8-0.3
            c-0.6-0.6-0.6-1.5,0.2-2.4c0.7-0.7,2-1.1,2.9-0.2c0.8,0.8,0.6,2-0.5,3.1c-1,1-2.1,1.4-2.9,1.4c-0.5,0-1.1-0.2-1.6-0.6
            c-0.2-0.1-0.3-0.3-0.4-0.4L222.6,54.2z M226.4,52.2c-0.2-0.2-0.6,0-1,0.4c-0.3,0.3-0.6,0.8-0.3,1c0.1,0.1,0.3,0.1,0.4,0.1
            c0.1-0.1,0.2-0.2,0.6-0.5C226.4,52.9,226.6,52.4,226.4,52.2L226.4,52.2z"
                />
                <polygon
                  class="st31"
                  points="203.2,60.9 203.2,60.9 202.1,60.5 202.7,59.5 204.3,60 205.2,60.9 200.9,65.3 199.9,64.3 	"
                />
                <path
                  class="st31"
                  d="M203.6,68l1-1l-1.5-1.5l0.7-0.7l4.1-1.3l1,1l-2.5,2.6l0.4,0.4l-0.8,0.8l-0.4-0.4l-1,1L203.6,68z M205.4,66.2
            l0.7-0.8c0.2-0.2,0.5-0.4,0.7-0.6l0,0c-0.3,0.1-0.6,0.2-0.9,0.3l-1.2,0.4l0,0L205.4,66.2z"
                />
                <polygon
                  class="st31"
                  points="212.5,68 211.8,68.7 206.8,71.1 205.8,70.1 210.5,67.9 210.5,67.9 209.1,66.5 210,65.5 	"
                />
                <polygon
                  class="st31"
                  points="183.3,81 183.3,81 182.2,80.6 182.8,79.6 184.4,80.1 185.3,81 181,85.4 180,84.4 	"
                />
                <path
                  class="st31"
                  d="M183.7,88.1l1-1l-1.5-1.5l0.7-0.7l4.1-1.3l1,1l-2.5,2.6l0.4,0.4l-0.8,0.8l-0.4-0.4l-1,1L183.7,88.1z
            M185.5,86.2l0.7-0.8c0.2-0.2,0.5-0.4,0.7-0.6l0,0c-0.3,0.1-0.6,0.2-0.9,0.3l-1.2,0.4l0,0L185.5,86.2z"
                />
                <path
                  class="st31"
                  d="M191.5,88.8l-1.2-1.1l-0.7,0.6l0.1,0.1c0.2,0.2,0.5,0.6,0.5,1.1s-0.2,1-0.6,1.4c-0.8,0.8-2.1,1-3.2,0
            c-0.3-0.3-0.6-0.7-0.7-1l0.9-0.7c0.1,0.3,0.3,0.5,0.5,0.8c0.4,0.4,0.9,0.4,1.3,0c0.5-0.5,0.2-1.1-0.2-1.6c-0.1-0.1-0.2-0.2-0.3-0.3
            l2.5-2.1l1.9,1.9L191.5,88.8z"
                />
                <polygon
                  class="st31"
                  points="163.3,101.2 163.3,101.2 162.2,100.8 162.8,99.9 164.3,100.4 165.3,101.3 161,105.7 159.9,104.7 	"
                />
                <path
                  class="st31"
                  d="M163.7,108.3l1-1l-1.5-1.5l0.7-0.7l4.1-1.3l1,1l-2.5,2.6l0.4,0.4l-0.8,0.8l-0.4-0.4l-1,1L163.7,108.3z
            M165.5,106.5l0.7-0.8c0.2-0.2,0.5-0.4,0.7-0.6l0,0c-0.3,0.1-0.6,0.2-0.9,0.3l-1.2,0.4l0,0L165.5,106.5z"
                />
                <path
                  class="st31"
                  d="M166.7,109.3c0.1,0.3,0.3,0.6,0.5,0.8c0.4,0.4,0.9,0.4,1.2,0.1c0.4-0.5,0.2-1-0.2-1.4l-0.1-0.1l0.7-0.8
            l0.1,0.1c0.3,0.3,0.8,0.6,1.2,0.2c0.3-0.3,0.2-0.6-0.1-0.9c-0.2-0.2-0.4-0.3-0.7-0.4l0.6-0.9c0.3,0.1,0.8,0.3,1.2,0.7
            c0.8,0.8,0.7,1.7,0.2,2.3c-0.4,0.4-1,0.5-1.6,0.4l0,0c0.3,0.6,0.2,1.3-0.3,1.8c-0.6,0.7-1.8,0.8-2.9-0.2c-0.4-0.4-0.6-0.8-0.7-1.1
            L166.7,109.3z"
                />
                <polygon
                  class="st31"
                  points="143.9,121.1 143.9,121.1 142.7,120.7 143.4,119.7 144.9,120.2 145.9,121.1 141.6,125.5 140.5,124.5
            "
                />
                <path
                  class="st31"
                  d="M144.3,128.2l1-1l-1.5-1.5l0.7-0.7l4.1-1.3l1,1l-2.5,2.6l0.4,0.4l-0.8,0.8l-0.4-0.4l-1,1L144.3,128.2z
            M146,126.4l0.7-0.7c0.2-0.2,0.5-0.4,0.7-0.6l0,0c-0.3,0.1-0.6,0.2-0.9,0.3l-1.2,0.4l0,0L146,126.4z"
                />
                <polygon
                  class="st31"
                  points="150.6,127.6 150.6,127.6 149.5,127.2 150.1,126.2 151.6,126.7 152.6,127.6 148.3,132 147.2,131 	"
                />
                <polygon
                  class="st31"
                  points="124.1,139.3 124.1,139.3 123,138.9 123.6,137.9 125.2,138.4 126.1,139.3 121.8,143.7 120.8,142.7
            "
                />
                <path
                  class="st31"
                  d="M124.1,144.1c0.1,0.3,0.3,0.6,0.5,0.8c0.4,0.4,0.9,0.4,1.2,0.1c0.4-0.5,0.2-1-0.2-1.4l-0.1-0.1l0.7-0.8
            l0.1,0.1c0.3,0.3,0.8,0.6,1.2,0.2c0.3-0.3,0.2-0.6-0.1-0.9c-0.2-0.2-0.4-0.3-0.7-0.4l0.6-0.9c0.3,0.1,0.8,0.3,1.2,0.7
            c0.8,0.8,0.7,1.7,0.2,2.3c-0.4,0.4-1,0.5-1.6,0.4l0,0c0.3,0.6,0.2,1.3-0.3,1.8c-0.6,0.7-1.8,0.8-2.9-0.2c-0.4-0.4-0.6-0.8-0.7-1.1
            L124.1,144.1z"
                />
                <path
                  class="st31"
                  d="M127.6,147.8c0.2,0.2,0.3,0.3,0.5,0.4c0.2,0.1,0.4,0.2,0.7,0.2s0.7-0.1,1.1-0.4l0,0c-0.3,0-0.5-0.1-0.8-0.3
            c-0.6-0.6-0.6-1.5,0.2-2.4c0.7-0.7,2-1.1,2.9-0.2c0.8,0.8,0.6,2-0.5,3.1c-1,1-2.1,1.4-2.9,1.4c-0.5,0-1.1-0.2-1.6-0.6
            c-0.2-0.1-0.3-0.3-0.4-0.4L127.6,147.8z M131.4,145.8c-0.2-0.2-0.6,0-1,0.4c-0.3,0.3-0.6,0.8-0.3,1c0.1,0.1,0.3,0.1,0.4,0.1
            c0.1-0.1,0.2-0.2,0.6-0.5C131.4,146.4,131.6,146,131.4,145.8L131.4,145.8z"
                />
                <polygon
                  class="st6"
                  points="150.2,148.1 142.3,140.7 141.3,141.9 149.1,149.3 	"
                />
                <polygon
                  class="st6"
                  points="169.7,127.9 161.7,120.4 160.8,121.7 168.5,129 	"
                />
                <polygon
                  class="st6"
                  points="189.3,107.6 181.4,100.2 180.4,101.4 188.2,108.8 	"
                />
                <polygon
                  class="st6"
                  points="208.8,87.6 200.9,80.1 200,81.4 207.7,88.7 	"
                />
                <polygon
                  class="st6"
                  points="229.5,68.2 215.6,55.2 214.7,56.5 228.4,69.4 	"
                />
                <polygon
                  class="st6"
                  points="363.6,62 364.8,63.1 380.5,46.6 379.3,45.4 	"
                />
                <polygon
                  class="st6"
                  points="384.1,81.8 385.2,82.9 393.7,74.3 392.5,73.1 	"
                />
                <polygon
                  class="st6"
                  points="404.4,101.5 405.6,102.6 414,94 412.9,92.8 	"
                />
                <polygon
                  class="st6"
                  points="424.8,121.4 425.9,122.4 434.4,113.8 433.2,112.6 	"
                />
                <polygon
                  class="st6"
                  points="445.1,141.2 446.2,142.3 454.7,133.5 453.6,132.3 	"
                />
                <polygon
                  class="st6"
                  points="137.1,196.3 93,196.8 92.8,198.4 137.1,197.9 	"
                />
                <polygon
                  class="st6"
                  points="135.2,184.4 117.2,177.4 116.6,178.8 135.6,186.2 	"
                />
                <path
                  class="st30"
                  d="M479.8,184.2c-1.6-17.1-12.1-30.3-12.1-30.3l-5,3.1l3.1,15.3l2.1,35.8l8.3,4.4
            C476.1,212.5,481.6,203.7,479.8,184.2"
                />
                <polygon
                  class="st6"
                  points="452.1,193.1 502.7,192.4 502.6,190.6 452,191.5 	"
                />
                <polygon
                  class="st6"
                  points="454.9,178.5 498,160.5 497.5,158.9 454.3,177.1 	"
                />
                <path
                  class="st40"
                  d="M508.9,172c2.4,2.4,2.5,6.3,0.1,8.7s-6.3,2.5-8.7,0.1c-2.4-2.4-2.5-6.3-0.1-8.7
            C502.6,169.7,506.5,169.6,508.9,172z"
                />
                <path
                  class="st39"
                  d="M508.9,172c2.4,2.4,2.5,6.3,0.1,8.7s-6.3,2.5-8.7,0.1c-2.4-2.4-2.5-6.3-0.1-8.7
            C502.6,169.7,506.5,169.6,508.9,172"
                />
                <path
                  class="st31"
                  d="M504.6,182.7c-1.6,0-3.2-0.6-4.4-1.8c-2.5-2.4-2.6-6.4-0.1-8.9c2.4-2.5,6.5-2.5,9-0.1l0,0
            c2.5,2.4,2.6,6.4,0.1,8.9C507.9,182.1,506.3,182.7,504.6,182.7 M504.6,170.4c-1.6,0-3.1,0.6-4.3,1.8c-2.3,2.4-2.3,6.2,0.1,8.5
            s6.2,2.3,8.5-0.1c2.3-2.4,2.3-6.2-0.1-8.5l0,0C507.6,171,506.1,170.4,504.6,170.4"
                />
                <path
                  class="st41"
                  d="M504.4,178h0.1l1.8-1.9h0.1l2.7,1h0.1l0.6-1.4v-0.1l-0.5-0.1h-0.1l-0.3,0.8c0,0-0.1,0.1-0.1,0l-2.5-0.9h-0.1
            l-1.8,1.8h-0.1L504,177v-0.1l1.3-1.3v-0.1l-0.4-0.4h-0.1l-1.3,1.3h-0.1l-1.6-1.3h-0.1l-0.4,0.3v0.1L504.4,178z"
                />
                <path
                  class="st41"
                  d="M501.6,173.7c0.4,0.4,0.4,0.9,0,1.3c-0.4,0.4-0.9,0.4-1.3,0s-0.4-0.9,0-1.3
            C500.6,173.4,501.2,173.4,501.6,173.7"
                />
                <path
                  class="st41"
                  d="M507.8,177l-0.5,0.1c0,0-0.1,0,0,0.1l0.1,0.1l0,0c0.4,0.9,0.3,1.7-0.4,2.5c-0.4,0.4-0.9,0.7-1.6,0.7
            c-0.6,0-1.1-0.2-1.6-0.6c-0.7-0.6-0.9-1.4-0.6-2.3v-0.1c0,0,0-0.1-0.1-0.1l-0.4-0.3h-0.1v0.1v0.1c-0.4,1.1-0.1,2.1,0.7,2.9
            c0.6,0.5,1.2,0.8,2,0.8s1.4-0.3,2-0.8c0.4-0.4,0.7-0.9,0.8-1.5C508.2,178.1,508.2,177.5,507.8,177C507.9,177,507.9,177,507.8,177"
                />
                <path
                  class="st40"
                  d="M485.5,249.3c2.4,2.4,2.5,6.3,0.1,8.7s-6.3,2.5-8.7,0.1c-2.4-2.4-2.5-6.3-0.1-8.7
            C479.1,247,483,246.9,485.5,249.3z"
                />
                <path
                  class="st39"
                  d="M485.5,249.3c2.4,2.4,2.5,6.3,0.1,8.7s-6.3,2.5-8.7,0.1c-2.4-2.4-2.5-6.3-0.1-8.7
            C479.1,247,483,246.9,485.5,249.3"
                />
                <path
                  class="st31"
                  d="M481.2,260c-1.6,0-3.2-0.6-4.4-1.8c-2.5-2.4-2.6-6.4-0.1-8.9c2.4-2.5,6.5-2.5,9-0.1s2.6,6.4,0.1,8.9
            C484.5,259.4,482.8,260,481.2,260 M481.2,247.7c-1.6,0-3.1,0.6-4.3,1.8c-2.3,2.4-2.3,6.2,0.1,8.5c2.4,2.3,6.2,2.2,8.5-0.1
            c2.3-2.4,2.3-6.2-0.1-8.5C484.2,248.3,482.7,247.7,481.2,247.7"
                />
                <path
                  class="st41"
                  d="M480.9,255.3h0.1l1.8-1.9h0.1l2.7,1h0.1l0.6-1.4v-0.1l-0.5-0.1h-0.1l-0.3,0.8c0,0-0.1,0.1-0.1,0l-2.5-0.9
            h-0.1l-1.8,1.8h-0.1l-0.3-0.2v-0.1l1.3-1.3v-0.1l-0.4-0.4h-0.1l-1.3,1.3h-0.1l-1.6-1.3h-0.1l-0.4,0.3v0.1L480.9,255.3z"
                />
                <path
                  class="st41"
                  d="M478.1,251c0.4,0.4,0.4,0.9,0,1.3c-0.4,0.4-0.9,0.4-1.3,0s-0.4-0.9,0-1.3C477.2,250.7,477.8,250.7,478.1,251"
                />
                <path
                  class="st41"
                  d="M484.4,254.3l-0.5,0.1c0,0-0.1,0,0,0.1l0.1,0.1l0,0c0.4,0.9,0.3,1.7-0.4,2.5c-0.4,0.4-0.9,0.7-1.6,0.7
            c-0.6,0-1.1-0.2-1.6-0.6c-0.7-0.6-0.9-1.4-0.6-2.3v-0.1c0,0,0-0.1-0.1-0.1l-0.4-0.3h-0.1v0.1v0.1c-0.4,1.1-0.1,2.1,0.7,2.9
            c0.6,0.5,1.2,0.8,2,0.8s1.4-0.3,2-0.8c0.4-0.4,0.7-0.9,0.8-1.5C484.8,255.4,484.7,254.9,484.4,254.3
            C484.5,254.3,484.5,254.3,484.4,254.3"
                />
                <path
                  class="st40"
                  d="M422.8,319.4c2.4,2.4,2.5,6.3,0.1,8.7c-2.4,2.4-6.3,2.5-8.7,0.1c-2.4-2.4-2.5-6.3-0.1-8.7
            C416.4,317.1,420.3,317,422.8,319.4z"
                />
                <path
                  class="st39"
                  d="M422.8,319.4c2.4,2.4,2.5,6.3,0.1,8.7c-2.4,2.4-6.3,2.5-8.7,0.1c-2.4-2.4-2.5-6.3-0.1-8.7
            C416.4,317.1,420.3,317,422.8,319.4"
                />
                <path
                  class="st31"
                  d="M418.5,330.1c-1.6,0-3.2-0.6-4.4-1.8c-2.5-2.4-2.6-6.4-0.1-8.9c2.4-2.5,6.5-2.5,9-0.1l0,0
            c2.5,2.4,2.6,6.4,0.1,8.9C421.8,329.5,420.1,330.1,418.5,330.1 M418.5,317.8c-1.6,0-3.1,0.6-4.3,1.8c-2.3,2.4-2.3,6.2,0.1,8.5
            s6.2,2.2,8.5-0.1c2.3-2.4,2.3-6.2-0.1-8.5l0,0C421.5,318.4,420,317.8,418.5,317.8"
                />
                <path
                  class="st41"
                  d="M418.2,325.4h0.1l1.8-1.9h0.1l2.7,1h0.1l0.6-1.4V323l-0.5-0.1H423l-0.3,0.8c0,0-0.1,0.1-0.1,0l-2.5-0.9H420
            l-1.8,1.8h-0.1l-0.3-0.2v-0.1l1.3-1.3v-0.1l-0.4-0.4h-0.1l-1.3,1.3h-0.1l-1.6-1.3h-0.1l-0.4,0.3v0.1L418.2,325.4z"
                />
                <path
                  class="st41"
                  d="M415.4,321.1c0.4,0.4,0.4,0.9,0,1.3s-0.9,0.4-1.3,0s-0.4-0.9,0-1.3C414.5,320.8,415,320.7,415.4,321.1"
                />
                <path
                  class="st41"
                  d="M421.7,324.4l-0.5,0.1c0,0-0.1,0,0,0.1l0.1,0.1l0,0c0.4,0.9,0.3,1.7-0.4,2.5c-0.4,0.4-0.9,0.7-1.6,0.7
            c-0.6,0-1.1-0.2-1.6-0.6c-0.7-0.6-0.9-1.4-0.6-2.3v-0.1c0,0,0-0.1-0.1-0.1l-0.4-0.3h-0.1v0.1v0.1c-0.4,1.1-0.1,2.1,0.7,2.9
            c0.6,0.5,1.2,0.8,2,0.8s1.4-0.3,2-0.8c0.4-0.4,0.7-0.9,0.8-1.5C422.1,325.5,422,324.9,421.7,324.4
            C421.8,324.4,421.8,324.4,421.7,324.4"
                />
                <path
                  class="st40"
                  d="M348.2,390.4c2.4,2.4,2.5,6.3,0.1,8.7c-2.4,2.4-6.3,2.5-8.7,0.1c-2.4-2.4-2.5-6.3-0.1-8.7
            C341.8,388.1,345.8,388,348.2,390.4z"
                />
                <path
                  class="st39"
                  d="M348.2,390.4c2.4,2.4,2.5,6.3,0.1,8.7c-2.4,2.4-6.3,2.5-8.7,0.1c-2.4-2.4-2.5-6.3-0.1-8.7
            C341.8,388.1,345.8,388,348.2,390.4"
                />
                <path
                  class="st31"
                  d="M343.9,401.1c-1.6,0-3.2-0.6-4.4-1.8c-2.5-2.4-2.6-6.4-0.1-8.9c2.4-2.5,6.5-2.5,9-0.1l0,0
            c2.5,2.4,2.6,6.4,0.1,8.9C347.2,400.5,345.5,401.1,343.9,401.1 M343.9,388.8c-1.6,0-3.1,0.6-4.3,1.8c-2.3,2.4-2.3,6.2,0.1,8.5
            s6.2,2.2,8.5-0.1c2.3-2.4,2.3-6.2-0.1-8.5l0,0C346.9,389.4,345.4,388.8,343.9,388.8"
                />
                <path
                  class="st41"
                  d="M343.7,396.4h0.1l1.8-1.9h0.1l2.7,1h0.1l0.6-1.4V394l-0.5-0.1h-0.1l-0.3,0.8c0,0-0.1,0.1-0.1,0l-2.5-0.9h-0.1
            l-1.8,1.8h-0.1l-0.3-0.2v-0.1l1.3-1.3v-0.1l-0.4-0.4h-0.1l-1.3,1.3h-0.1l-1.6-1.3H341l-0.4,0.3v0.1L343.7,396.4z"
                />
                <path
                  class="st41"
                  d="M340.8,392.1c0.4,0.4,0.4,0.9,0,1.3s-0.9,0.4-1.3,0s-0.4-0.9,0-1.3C339.9,391.8,340.5,391.8,340.8,392.1"
                />
                <path
                  class="st41"
                  d="M347.1,395.4l-0.5,0.1c0,0-0.1,0,0,0.1l0.1,0.1l0,0c0.4,0.9,0.3,1.7-0.4,2.5c-0.4,0.4-0.9,0.7-1.6,0.7
            c-0.6,0-1.1-0.2-1.6-0.6c-0.7-0.6-0.9-1.4-0.6-2.3v-0.1c0,0,0-0.1-0.1-0.1l-0.4-0.3h-0.1v0.1v0.1c-0.4,1.1-0.1,2.1,0.7,2.9
            c0.6,0.5,1.2,0.8,2,0.8s1.4-0.3,2-0.8c0.4-0.4,0.7-0.9,0.8-1.5C347.5,396.5,347.5,395.9,347.1,395.4
            C347.2,395.4,347.2,395.4,347.1,395.4"
                />
                <path
                  class="st40"
                  d="M261.8,390.6c2.4,2.4,2.5,6.3,0.1,8.7c-2.4,2.4-6.3,2.5-8.7,0.1s-2.5-6.3-0.1-8.7
            C255.5,388.3,259.4,388.2,261.8,390.6z"
                />
                <path
                  class="st39"
                  d="M261.8,390.6c2.4,2.4,2.5,6.3,0.1,8.7c-2.4,2.4-6.3,2.5-8.7,0.1s-2.5-6.3-0.1-8.7
            C255.5,388.3,259.4,388.2,261.8,390.6"
                />
                <path
                  class="st31"
                  d="M257.5,401.3c-1.6,0-3.2-0.6-4.4-1.8c-2.5-2.4-2.6-6.4-0.1-8.9c2.4-2.5,6.5-2.5,9-0.1l0,0
            c2.5,2.4,2.6,6.4,0.1,8.9C260.8,400.7,259.2,401.3,257.5,401.3 M257.5,389c-1.6,0-3.1,0.6-4.3,1.8c-2.3,2.4-2.3,6.2,0.1,8.5
            c2.4,2.3,6.2,2.3,8.5-0.1s2.3-6.2-0.1-8.5l0,0C260.5,389.6,259,389,257.5,389"
                />
                <path
                  class="st41"
                  d="M257.3,396.6h0.1l1.8-1.9h0.1l2.7,1h0.1l0.6-1.4v-0.1l-0.5-0.1h-0.1l-0.3,0.8c0,0-0.1,0.1-0.1,0l-2.5-0.9
            h-0.1l-1.8,1.8h-0.1l-0.3-0.2v-0.1l1.3-1.3v-0.1l-0.4-0.4h-0.1l-1.3,1.3h-0.1l-1.6-1.3h-0.1l-0.4,0.3v0.1L257.3,396.6z"
                />
                <path
                  class="st41"
                  d="M254.5,392.3c0.4,0.4,0.4,0.9,0,1.3s-0.9,0.4-1.3,0c-0.4-0.4-0.4-0.9,0-1.3C253.5,392,254.1,392,254.5,392.3"
                />
                <path
                  class="st41"
                  d="M260.7,395.6l-0.5,0.1c0,0-0.1,0,0,0.1l0.1,0.1l0,0c0.4,0.9,0.3,1.7-0.4,2.5c-0.4,0.4-0.9,0.7-1.6,0.7
            c-0.6,0-1.1-0.2-1.6-0.6c-0.7-0.6-0.9-1.4-0.6-2.3v-0.1c0,0,0-0.1-0.1-0.1l-0.4-0.3h-0.1v0.1v0.1c-0.4,1.1-0.1,2.1,0.7,2.9
            c0.6,0.5,1.2,0.8,2,0.8s1.4-0.3,2-0.8c0.4-0.4,0.7-0.9,0.8-1.5C261.1,396.7,261.1,396.1,260.7,395.6
            C260.8,395.6,260.8,395.6,260.7,395.6"
                />
                <path
                  class="st40"
                  d="M195.9,331.2c2.4,2.4,2.5,6.3,0.1,8.7c-2.4,2.4-6.3,2.5-8.7,0.1s-2.5-6.3-0.1-8.7
            C189.5,328.9,193.4,328.8,195.9,331.2z"
                />
                <path
                  class="st39"
                  d="M195.9,331.2c2.4,2.4,2.5,6.3,0.1,8.7c-2.4,2.4-6.3,2.5-8.7,0.1s-2.5-6.3-0.1-8.7
            C189.5,328.9,193.4,328.8,195.9,331.2"
                />
                <path
                  class="st31"
                  d="M191.5,341.9c-1.6,0-3.2-0.6-4.4-1.8c-2.5-2.4-2.6-6.4-0.1-8.9c2.4-2.5,6.5-2.5,9-0.1l0,0
            c2.5,2.4,2.6,6.4,0.1,8.9C194.8,341.3,193.2,341.9,191.5,341.9 M191.5,329.6c-1.6,0-3.1,0.6-4.3,1.8c-2.3,2.4-2.3,6.2,0.1,8.5
            c2.4,2.3,6.2,2.3,8.5-0.1s2.3-6.2-0.1-8.5l0,0C194.6,330.2,193.1,329.6,191.5,329.6"
                />
                <path
                  class="st41"
                  d="M191.3,337.2h0.1l1.8-1.9h0.1l2.7,1h0.1l0.6-1.4v-0.1l-0.5-0.1h-0.1l-0.3,0.8c0,0-0.1,0.1-0.1,0l-2.5-0.9
            h-0.1l-1.8,1.8h-0.1l-0.3-0.2v-0.1l1.3-1.3v-0.1l-0.4-0.4h-0.1l-1.3,1.3h-0.1l-1.6-1.3h-0.1l-0.4,0.3v0.1L191.3,337.2z"
                />
                <path
                  class="st41"
                  d="M188.5,332.9c0.4,0.4,0.4,0.9,0,1.3s-0.9,0.4-1.3,0c-0.4-0.4-0.4-0.9,0-1.3
            C187.5,332.6,188.1,332.6,188.5,332.9"
                />
                <path
                  class="st41"
                  d="M194.8,336.2l-0.5,0.1c0,0-0.1,0,0,0.1l0.1,0.1l0,0c0.4,0.9,0.3,1.7-0.4,2.5c-0.4,0.4-0.9,0.7-1.6,0.7
            c-0.6,0-1.1-0.2-1.6-0.6c-0.7-0.6-0.9-1.4-0.6-2.3v-0.1c0,0,0-0.1-0.1-0.1l-0.4-0.3h-0.1v0.1v0.1c-0.4,1.1-0.1,2.1,0.7,2.9
            c0.6,0.5,1.2,0.8,2,0.8s1.4-0.3,2-0.8c0.4-0.4,0.7-0.9,0.8-1.5C195.2,337.3,195.1,336.7,194.8,336.2
            C194.9,336.2,194.8,336.2,194.8,336.2"
                />
                <path
                  class="st40"
                  d="M156,291.3c2.4,2.4,2.5,6.3,0.1,8.7c-2.4,2.4-6.3,2.5-8.7,0.1s-2.5-6.3-0.1-8.7
            C149.7,288.9,153.6,288.9,156,291.3z"
                />
                <path
                  class="st39"
                  d="M156,291.3c2.4,2.4,2.5,6.3,0.1,8.7c-2.4,2.4-6.3,2.5-8.7,0.1s-2.5-6.3-0.1-8.7
            C149.7,288.9,153.6,288.9,156,291.3"
                />
                <path
                  class="st31"
                  d="M151.7,302c-1.6,0-3.2-0.6-4.4-1.8c-2.5-2.4-2.6-6.4-0.1-8.9c2.4-2.5,6.5-2.5,9-0.1l0,0
            c2.5,2.4,2.6,6.4,0.1,8.9C155,301.3,153.4,302,151.7,302 M151.7,289.7c-1.6,0-3.1,0.6-4.3,1.8c-2.3,2.4-2.3,6.2,0.1,8.5
            c2.4,2.3,6.2,2.2,8.5-0.1c2.3-2.4,2.3-6.2-0.1-8.5l0,0C154.7,290.2,153.2,289.7,151.7,289.7"
                />
                <path
                  class="st41"
                  d="M151.5,297.3h0.1l1.8-1.9h0.1l2.7,1h0.1l0.6-1.4v-0.1l-0.5-0.1h-0.1l-0.3,0.8c0,0-0.1,0.1-0.1,0l-2.5-0.9
            h-0.1l-1.8,1.8h-0.1l-0.3-0.2v-0.1l1.3-1.3v-0.1l-0.4-0.4h-0.1l-1.3,1.3h-0.1l-1.6-1.3h-0.1l-0.4,0.3v0.1L151.5,297.3z"
                />
                <path
                  class="st41"
                  d="M148.7,293c0.4,0.4,0.4,0.9,0,1.3s-0.9,0.4-1.3,0c-0.4-0.4-0.4-0.9,0-1.3C147.7,292.6,148.3,292.6,148.7,293"
                />
                <path
                  class="st41"
                  d="M154.9,296.3l-0.5,0.1c0,0-0.1,0,0,0.1l0.1,0.1l0,0c0.4,0.9,0.3,1.7-0.4,2.5c-0.4,0.4-0.9,0.7-1.6,0.7
            c-0.6,0-1.1-0.2-1.6-0.6c-0.7-0.6-0.9-1.4-0.6-2.3v-0.1c0,0,0-0.1-0.1-0.1l-0.4-0.3h-0.1v0.1v0.1c-0.4,1.1-0.1,2.1,0.7,2.9
            c0.6,0.5,1.2,0.8,2,0.8s1.4-0.3,2-0.8c0.4-0.4,0.7-0.9,0.8-1.5C155.3,297.3,155.3,296.8,154.9,296.3
            C155,296.3,155,296.2,154.9,296.3"
                />
                <path
                  class="st40"
                  d="M121.3,254.3c2.4,2.4,2.5,6.3,0.1,8.7s-6.3,2.5-8.7,0.1c-2.4-2.4-2.5-6.3-0.1-8.7
            C114.9,252,118.8,251.9,121.3,254.3z"
                />
                <path
                  class="st39"
                  d="M121.3,254.3c2.4,2.4,2.5,6.3,0.1,8.7s-6.3,2.5-8.7,0.1c-2.4-2.4-2.5-6.3-0.1-8.7
            C114.9,252,118.8,251.9,121.3,254.3"
                />
                <path
                  class="st31"
                  d="M117,265c-1.6,0-3.2-0.6-4.4-1.8c-2.5-2.4-2.6-6.4-0.1-8.9c2.4-2.5,6.5-2.5,9-0.1l0,0
            c2.5,2.4,2.6,6.4,0.1,8.9C120.3,264.4,118.6,265,117,265 M117,252.7c-1.6,0-3.1,0.6-4.3,1.8c-2.3,2.4-2.3,6.2,0.1,8.5
            s6.2,2.3,8.5-0.1s2.3-6.2-0.1-8.5l0,0C120,253.3,118.5,252.7,117,252.7"
                />
                <path
                  class="st41"
                  d="M116.7,260.3L116.7,260.3l1.9-1.9h0.1l2.7,1h0.1l0.6-1.4v-0.1l-0.5-0.1h-0.1l-0.3,0.8c0,0-0.1,0.1-0.1,0
            l-2.5-0.9h-0.1l-1.8,1.8h-0.1l-0.3-0.2v-0.1l1.3-1.3v-0.1l-0.4-0.4h-0.1l-1.3,1.3h-0.1l-1.6-1.3H114l-0.4,0.3v0.1L116.7,260.3z"
                />
                <path
                  class="st41"
                  d="M113.9,256c0.4,0.4,0.4,0.9,0,1.3s-0.9,0.4-1.3,0s-0.4-0.9,0-1.3C113,255.7,113.6,255.7,113.9,256"
                />
                <path
                  class="st41"
                  d="M120.2,259.3l-0.5,0.1c0,0-0.1,0,0,0.1l0.1,0.1l0,0c0.4,0.9,0.3,1.7-0.4,2.5c-0.4,0.4-0.9,0.7-1.6,0.7
            c-0.6,0-1.1-0.2-1.6-0.6c-0.7-0.6-0.9-1.4-0.6-2.3v-0.1c0,0,0-0.1-0.1-0.1l-0.4-0.3H115v0.1v0.1c-0.4,1.1-0.1,2.1,0.7,2.9
            c0.6,0.5,1.2,0.8,2,0.8s1.4-0.3,2-0.8c0.4-0.4,0.7-0.9,0.8-1.5C120.6,260.4,120.5,259.8,120.2,259.3
            C120.3,259.3,120.3,259.3,120.2,259.3"
                />
                <path
                  class="st40"
                  d="M97.6,179.1c2.4,2.4,2.5,6.3,0.1,8.7s-6.3,2.5-8.7,0.1c-2.4-2.4-2.5-6.3-0.1-8.7
            C91.3,176.8,95.2,176.7,97.6,179.1z"
                />
                <path
                  class="st39"
                  d="M97.6,179.1c2.4,2.4,2.5,6.3,0.1,8.7s-6.3,2.5-8.7,0.1c-2.4-2.4-2.5-6.3-0.1-8.7
            C91.3,176.8,95.2,176.7,97.6,179.1"
                />
                <path
                  class="st31"
                  d="M93.3,189.8c-1.6,0-3.2-0.6-4.4-1.8c-2.5-2.4-2.6-6.4-0.1-8.9c2.4-2.5,6.5-2.5,9-0.1l0,0
            c2.5,2.4,2.6,6.4,0.1,8.9C96.6,189.2,95,189.8,93.3,189.8 M93.3,177.5c-1.6,0-3.1,0.6-4.3,1.8c-2.3,2.4-2.3,6.2,0.1,8.5
            s6.2,2.2,8.5-0.1c2.3-2.4,2.3-6.2-0.1-8.5l0,0C96.4,178.1,94.8,177.5,93.3,177.5"
                />
                <path
                  class="st41"
                  d="M93.1,185.1L93.1,185.1l1.9-1.9h0.1l2.7,1h0.1l0.6-1.4v-0.1l-0.5-0.1h-0.1l-0.3,0.8c0,0-0.1,0.1-0.1,0
            l-2.5-0.9h-0.1l-1.8,1.8H93l-0.3-0.2V184l1.3-1.3v-0.1l-0.4-0.4h-0.1l-1.3,1.3h-0.1l-1.6-1.3h-0.1l-0.4,0.3v0.1L93.1,185.1z"
                />
                <path
                  class="st41"
                  d="M90.3,180.8c0.4,0.4,0.4,0.9,0,1.3c-0.4,0.4-0.9,0.4-1.3,0s-0.4-0.9,0-1.3C89.3,180.5,89.9,180.5,90.3,180.8"
                />
                <path
                  class="st41"
                  d="M96.5,184.1l-0.5,0.1c0,0-0.1,0,0,0.1l0.1,0.1l0,0c0.4,0.9,0.3,1.7-0.4,2.5c-0.4,0.4-0.9,0.7-1.6,0.7
            c-0.6,0-1.1-0.2-1.6-0.6c-0.7-0.6-0.9-1.4-0.6-2.3v-0.1c0,0,0-0.1-0.1-0.1l-0.4-0.3h-0.1v0.1v0.1c-0.4,1.1-0.1,2.1,0.7,2.9
            c0.6,0.5,1.2,0.8,2,0.8s1.4-0.3,2-0.8c0.4-0.4,0.7-0.9,0.8-1.5C97,185.2,96.9,184.7,96.5,184.1C96.6,184.1,96.6,184.1,96.5,184.1"
                />
                <path
                  class="st31"
                  d="M534.8,285.4l0.7-0.7l1-0.1c1.3-0.1,2.2-0.2,2.7-0.8c0.3-0.3,0.3-0.7,0-1s-0.6-0.4-0.9-0.5l0.6-1
            c0.4,0.1,0.9,0.4,1.3,0.8c1,1.1,0.7,2,0.1,2.6c-0.8,0.8-1.9,0.9-2.9,0.9h-0.5l0,0l1.3,1.3l-0.9,0.9L534.8,285.4z"
                />
                <text
                  transform="matrix(-0.2435 0.9671 -0.9701 -0.2427 458.4178 168.6035)"
                  class="st14 st15 st45"
                >
                  P
                </text>
                <text
                  transform="matrix(-0.2435 0.9671 -0.9701 -0.2427 457.8567 170.8403)"
                  class="st14 st15 st45"
                >
                  A
                </text>
                <text
                  transform="matrix(-0.2435 0.9671 -0.9701 -0.2427 457.1832 173.5152)"
                  class="st14 st15 st45"
                >
                  P
                </text>
                <text
                  transform="matrix(-0.2435 0.9671 -0.9701 -0.2427 456.6201 175.7515)"
                  class="st14 st15 st45"
                >
                  A JOHN’S
                </text>
                <text
                  transform="matrix(-0.2435 0.9671 -0.9701 -0.2427 452.7905 166.4996)"
                  class="st14 st15 st45"
                >
                  BULLPEN BOX
                </text>
                <path
                  class="st38"
                  d="M169.1,317.1c0.2-0.1,0.4-0.3,0.6-0.5l0,0c-0.1,0.2-0.3,0.5-0.4,0.7l-1.2,2l0.6,0.5l3.6-2.5l-0.7-0.7
            l-1.7,1.3c-0.2,0.2-0.5,0.4-0.7,0.6l0,0l1.6-2.6l-0.5-0.5l-1.7,1.2c-0.3,0.2-0.5,0.4-0.7,0.6l0,0c0.2-0.2,0.4-0.5,0.6-0.7l1.1-1.8
            l-0.7-0.6l-2.3,3.8l0.6,0.5L169.1,317.1z"
                />
                <path
                  class="st38"
                  d="M170.6,321.2L170.6,321.2l-0.2,0.2l0.6,0.6l2-2.1l-0.6-0.6l-0.2,0.3l0,0c0.1-0.2,0.1-0.5-0.1-0.7
            c-0.5-0.5-1.3,0.2-1.6,0.5s-0.9,1.2-0.4,1.7C170.1,321.2,170.4,321.2,170.6,321.2 M171,319.9c0.1-0.1,0.5-0.6,0.8-0.4
            c0.2,0.2-0.2,0.7-0.3,0.8c-0.1,0.1-0.5,0.6-0.8,0.4C170.5,320.5,170.9,320.1,171,319.9"
                />
                <polygon
                  class="st38"
                  points="175.1,319.5 174.5,318.9 171.4,322.3 172,322.9 	"
                />
                <polygon
                  class="st38"
                  points="173.9,322.8 173.9,322.8 173.4,324.2 174.1,324.8 174.6,323 176,322.6 175.3,321.9 174.2,322.4
            174.2,322.4 176.1,320.3 175.5,319.8 172.3,323.2 172.9,323.7 	"
                />
                <polygon
                  class="st38"
                  points="176.2,325.6 177,325 177,325 176.6,325.7 176.1,326.7 176.6,327.1 179.2,325.6 178.6,325
            177.4,325.8 177.2,326 177.1,326 178,324.5 177.5,324 176,324.9 176,324.9 176.9,323.4 176.2,322.8 174.9,325.5 175.4,326 	"
                />
                <path
                  class="st38"
                  d="M178.7,328.6L178.7,328.6l-0.2,0.2l0.6,0.6l2-2.1l-0.6-0.6l-0.2,0.3l0,0c0.1-0.2,0.1-0.5-0.2-0.7
            c-0.5-0.5-1.3,0.2-1.6,0.5s-0.9,1.2-0.4,1.7C178.2,328.7,178.5,328.7,178.7,328.6 M179.1,327.4c0.1-0.1,0.5-0.6,0.8-0.4
            c0.2,0.2-0.2,0.7-0.3,0.8c-0.1,0.1-0.5,0.6-0.8,0.4C178.5,328,178.9,327.5,179.1,327.4"
                />
                <polygon
                  class="st38"
                  points="183.2,329.2 182.5,328.6 181.1,329.6 181.1,329.6 181.4,329.2 181.9,328.1 181.3,327.5 180,330.2
            178.6,330.9 179.3,331.5 	"
                />
                <path
                  class="st38"
                  d="M394.9,355.2l-1.4-1.9c-0.2-0.2-0.3-0.4-0.5-0.6l0,0c0.2,0.1,0.5,0.3,0.7,0.4l2,1.2l0.5-0.6l-2.6-3.6
            l-0.6,0.7l1.3,1.7c0.2,0.2,0.4,0.4,0.6,0.7l0,0l-2.6-1.5l-0.5,0.5l1.2,1.7c0.2,0.3,0.4,0.5,0.6,0.7l0,0c-0.2-0.2-0.5-0.4-0.8-0.5
            L391,353l-0.6,0.7l3.9,2.2L394.9,355.2z"
                />
                <path
                  class="st38"
                  d="M395.9,352c0.3,0.3,1.2,0.9,1.7,0.4c0.2-0.2,0.2-0.5,0.1-0.7l0,0l0.2,0.2l0.6-0.7l-2.2-1.9l-0.6,0.6l0.3,0.2
            l0,0c-0.2-0.1-0.5-0.1-0.7,0.2C394.8,350.9,395.5,351.6,395.9,352 M396.1,350.6c0.2-0.2,0.7,0.2,0.8,0.3c0.1,0.1,0.6,0.5,0.4,0.7
            s-0.7-0.2-0.8-0.3C396.3,351.2,395.9,350.8,396.1,350.6"
                />
                <rect
                  x="396.9"
                  y="346.7"
                  transform="matrix(0.6637 -0.748 0.748 0.6637 -127.4081 414.5576)"
                  class="st38"
                  width="0.9"
                  height="4.6"
                />
                <polygon
                  class="st38"
                  points="400.2,349.3 399.2,348.4 399.2,348.4 400.6,348.8 401.2,348.1 399.4,347.6 399,346.3 398.4,347
            398.8,348 398.8,348.1 396.7,346.2 396.2,346.9 399.6,349.9 	"
                />
                <polygon
                  class="st38"
                  points="402.5,346.8 401.9,346 401.4,345.2 401.4,345.2 402.1,345.6 403.1,346.1 403.5,345.6 401.9,343
            401.4,343.6 402.2,344.8 402.4,345.1 402.4,345.1 400.8,344.2 400.3,344.8 401.3,346.2 401.3,346.2 399.8,345.4 399.2,346
            402,347.3 	"
                />
                <path
                  class="st38"
                  d="M403.2,343.8c0.3,0.3,1.2,0.9,1.7,0.4c0.2-0.2,0.2-0.5,0.1-0.7l0,0l0.2,0.2l0.6-0.6l-2.2-1.9l-0.6,0.6
            l0.3,0.2l0,0c-0.2-0.1-0.5-0.1-0.7,0.2C402.1,342.7,402.8,343.5,403.2,343.8 M403.4,342.4c0.2-0.2,0.7,0.2,0.8,0.3
            c0.1,0.1,0.6,0.5,0.4,0.7s-0.7-0.2-0.8-0.3C403.6,343,403.2,342.6,403.4,342.4"
                />
                <polygon
                  class="st38"
                  points="407.3,343.5 407.9,342.8 405.5,339 404.9,339.6 405.9,341 405.9,341 405.5,340.8 404.4,340.3
            403.8,340.9 406.5,342.1 	"
                />
                <polygon
                  class="st31"
                  points="354.8,401.5 354.8,401.5 353.9,400.9 354.7,400.2 356,401 356.6,402 351.7,405 351,403.8 	"
                />
                <path
                  class="st31"
                  d="M358.5,405c-0.7-1.1-2.2-0.8-3.5,0c-1.1,0.7-2.3,1.8-1.6,3l0,0c0.5,0.8,1.7,1,3.5,0
            C357.8,407.4,359.2,406.3,358.5,405 M356.1,406.8c-1.1,0.7-1.6,0.8-1.7,0.6l0,0c-0.2-0.3,0.2-0.6,1.3-1.3c1.1-0.7,1.6-0.8,1.8-0.5
            C357.6,405.8,357.1,406.2,356.1,406.8"
                />
                <path
                  class="st31"
                  d="M359.2,410.1c-0.2-0.3-0.5-0.5-0.8-0.5l0,0c0.6-0.2,1.3-0.1,1.7,0.4c0.1,0.1,0.2,0.3,0.3,0.4l0.9-0.6
            c-0.1-0.1-0.2-0.3-0.4-0.5c-0.3-0.3-0.8-0.7-1.4-0.8c-0.8-0.2-1.7-0.2-2.9,0.5c-1.3,0.8-1.7,1.8-1.1,2.8s1.8,0.9,2.7,0.4
            C359.2,411.6,359.6,410.8,359.2,410.1 M357.6,411c-0.5,0.3-1,0.6-1.2,0.2l0,0c-0.1-0.2,0.2-0.6,0.7-0.9c0.3-0.2,0.4-0.2,0.5-0.2
            c0.2,0,0.4,0,0.4,0.2C358.3,410.5,357.9,410.9,357.6,411"
                />
                <path
                  class="st29"
                  d="M265.1,397.7l-14,23.4c0,0,17.5,10.1,30.6,12c10.1,1.5,18.1,1.7,23.3,1.4c10.4-0.6,11.4-1.2,19.3-3
            c9.4-2.2,25.5-11,25.5-11l-13.5-22.7c0,0-13.4,2.7-19.4,4.3c-6,1.6-11.8,2-16.4,2s-14.4-1-18.1-2
            C278.9,401,265.1,397.7,265.1,397.7"
                />
                <path
                  class="st39"
                  d="M476.6,109.7c2.4,2.4,2.5,6.3,0.1,8.7c-2.4,2.4-6.3,2.5-8.7,0.1c-2.4-2.4-2.5-6.3-0.1-8.7
            S474.2,107.3,476.6,109.7"
                />
                <path
                  class="st31"
                  d="M472.3,120.4c-1.7,0-3.2-0.6-4.4-1.8c-2.5-2.4-2.6-6.4-0.1-8.9c1.2-1.2,2.8-1.9,4.5-1.9s3.3,0.6,4.5,1.8
            c2.5,2.4,2.6,6.4,0.1,8.9C475.7,119.7,474.1,120.4,472.3,120.4C472.4,120.4,472.4,120.4,472.3,120.4 M472.3,108.1L472.3,108.1
            c-1.7,0-3.2,0.7-4.3,1.8c-2.3,2.4-2.3,6.2,0.1,8.5c1.1,1.1,2.6,1.7,4.2,1.7h0.1c1.6,0,3.1-0.7,4.2-1.8c2.3-2.4,2.3-6.2-0.1-8.5
            C475.4,108.7,473.9,108.1,472.3,108.1"
                />
                <path
                  class="st41"
                  d="M472.1,115.7h0.1l1.8-1.9h0.1l2.7,1h0.1l0.6-1.4v-0.1l-0.5-0.2h-0.1l-0.3,0.8c0,0-0.1,0.1-0.1,0L474,113h-0.1
            l-1.7,1.8h-0.1l-0.3-0.2v-0.1l1.3-1.3v-0.1l-0.4-0.4h-0.1l-1.3,1.3h-0.1l-1.6-1.3h-0.1l-0.4,0.3v0.1L472.1,115.7z"
                />
                <path
                  class="st41"
                  d="M469.3,111.4c0.4,0.4,0.4,0.9,0,1.3s-1,0.4-1.3,0c-0.4-0.4-0.4-0.9,0-1.3
            C468.3,111.1,468.9,111.1,469.3,111.4"
                />
                <path
                  class="st41"
                  d="M475.5,114.7l-0.5,0.1c0,0-0.1,0,0,0.1l0.1,0.1l0,0c0.4,0.9,0.3,1.7-0.4,2.5c-0.4,0.4-0.9,0.7-1.6,0.7
            c-0.6,0-1.1-0.2-1.6-0.6c-0.7-0.6-0.9-1.4-0.6-2.3v-0.1c0,0,0-0.1-0.1-0.1l-0.4-0.3h-0.1v0.1v0.1c-0.4,1.1-0.1,2.1,0.7,2.9
            c0.6,0.5,1.2,0.8,2,0.8s1.4-0.3,2-0.8c0.4-0.4,0.7-0.9,0.8-1.5C476,115.8,475.9,115.3,475.5,114.7
            C475.6,114.7,475.6,114.7,475.5,114.7"
                />
                <path
                  class="st40"
                  d="M476.6,109.7c2.4,2.4,2.5,6.3,0.1,8.7c-2.4,2.4-6.3,2.5-8.7,0.1c-2.4-2.4-2.5-6.3-0.1-8.7
            S474.2,107.3,476.6,109.7z"
                />
                <path
                  class="st6"
                  d="M220.6,41c0.5,0.6,11.6,10.8,12.2,11.4c0.3-0.8,12.5-16.1,12.6-16.3c-0.1-0.2-16.4-15.5-16.4-15.5
            s-11.8,14.3-13,15.6"
                />
                <polygon
                  class="st6"
                  points="370.8,406 369.6,406.9 359.4,394.9 360.5,393.9 	"
                />
                <polygon
                  class="st6"
                  points="391.9,385 390.8,386.2 379,374.9 380.2,373.7 	"
                />
                <polygon
                  class="st6"
                  points="357.8,415.8 356.4,416.6 348.2,402.9 349.7,402 	"
                />
                <polygon
                  class="st6"
                  points="411.8,364.7 410.6,365.9 398.9,354.6 400,353.4 	"
                />
                <polygon
                  class="st6"
                  points="431.7,344.2 430.5,345.4 418.8,334.1 419.9,332.9 	"
                />
                <polygon
                  class="st6"
                  points="451.9,323.6 450.7,324.8 439,313.5 440.1,312.3 	"
                />
                <polygon
                  class="st6"
                  points="471.7,302.9 470.5,304.1 458.9,292.9 460,291.7 	"
                />
                <polygon
                  class="st6"
                  points="487.5,282.6 486.4,283.8 477,274.7 478.1,273.5 	"
                />
                <polygon
                  class="st6"
                  points="90.1,261.2 89.3,260 98.9,253.6 99.7,254.8 	"
                />
                <polygon
                  class="st6"
                  points="113.7,285.7 112.7,284.7 121.1,276.1 122.1,277.1 	"
                />
                <polygon
                  class="st6"
                  points="133.2,305.2 132.2,304.2 140.7,295.5 141.7,296.5 	"
                />
                <polygon
                  class="st6"
                  points="153.3,325.2 152.2,324.2 160.7,315.5 161.8,316.5 	"
                />
                <polygon
                  class="st6"
                  points="173.4,345.2 172.4,344.2 180.9,335.5 181.9,336.5 	"
                />
                <polygon
                  class="st6"
                  points="193.4,365.4 192.4,364.4 200.8,355.7 201.9,356.6 	"
                />
                <polygon
                  class="st6"
                  points="213.7,385.6 212.7,384.7 221.2,375.9 222.2,376.9 	"
                />
                <polygon
                  class="st6"
                  points="240.3,408.1 239.1,407.3 245.6,397 246.8,397.8 	"
                />
                <polygon
                  class="st6"
                  points="244.1,416.6 242.9,415.8 251.9,401.3 253.1,402.1 	"
                />
                <polygon
                  class="st6"
                  points="124.2,161.7 111.2,153.7 116,146.2 128.9,154.2 	"
                />
                <path
                  class="st6"
                  d="M130.9,167.3c0,0.2,5.9,24.7,5.9,24.7l0.2,11.6l3.7,11.4l7.5,10.8c0,0,10.1,9.7,10.3,10
            c0.2-0.2,9.4-9.6,9.7-9.9c-0.2-0.2-15.7-15.2-15.7-15.2s-11.2-53.2-11.3-53.9C140.7,157.2,131,167.2,130.9,167.3"
                />
                <path
                  class="st30"
                  d="M158.5,236.2l-0.2-0.2c-0.2-0.2-10.3-10-10.3-10l-7.6-10.9l-3.7-11.5l-0.2-11.6c0,0-5.9-24.4-5.9-24.6v-0.2
            l0.1-0.1c0.1-0.1,4.9-5,7.9-8.1l2.8-2.8l0.1,0.6c0.1,0.6,10.7,51.3,11.3,53.8c1.1,1.1,15.4,14.9,15.6,15.1l0.2,0.2l-0.2,0.2
            c-0.2,0.2-9.4,9.6-9.7,9.9L158.5,236.2z M148.4,225.6c0,0,8.5,8.2,10.1,9.7c1.3-1.3,7.9-8.1,9.2-9.4c-1.9-1.9-15.5-15-15.5-15
            l-0.1-0.1v-0.1c0,0-9.9-47.4-11.2-53.3l-1.9,2c-2.8,2.8-7,7.2-7.8,8c0.5,2.2,5.9,24.5,5.9,24.5l0.2,11.6l3.7,11.3L148.4,225.6z"
                />
                <path
                  class="st27"
                  d="M238.2,457.8l-0.7-0.5C237.7,457.5,238,457.7,238.2,457.8L238.2,457.8z"
                />
                <path
                  class="st27"
                  d="M401.6,424.1L401.6,424.1c0.4-0.4,0.8-0.8,1.2-1.3C402.4,423.3,402,423.7,401.6,424.1"
                />
                <path
                  class="st27"
                  d="M408.9,416.6L408.9,416.6c0.4-0.4,0.8-0.8,1.2-1.3C409.7,415.8,409.3,416.2,408.9,416.6"
                />
                <path
                  class="st27"
                  d="M410.2,415.4L410.2,415.4l-1.2,1.3l0,0C409.3,416.2,409.7,415.8,410.2,415.4"
                />
                <path
                  class="st27"
                  d="M416.3,409.1L416.3,409.1c0.4-0.4,0.8-0.8,1.2-1.3C417.1,408.2,416.7,408.7,416.3,409.1"
                />
                <path
                  class="st27"
                  d="M424.9,400.3c-0.4,0.4-0.8,0.8-1.2,1.3l0,0C424.1,401.1,424.5,400.7,424.9,400.3"
                />
                <path
                  class="st27"
                  d="M431,394.1L431,394.1c0.4-0.4,0.8-0.8,1.2-1.3C431.8,393.2,431.4,393.7,431,394.1"
                />
                <path
                  class="st27"
                  d="M438.4,386.5L438.4,386.5c0.4-0.4,0.8-0.8,1.2-1.3C439.2,385.7,438.8,386.1,438.4,386.5"
                />
                <path
                  class="st27"
                  d="M439.6,385.2L439.6,385.2l-1.2,1.3l0,0C438.8,386.1,439.2,385.7,439.6,385.2"
                />
                <path
                  class="st27"
                  d="M445.7,379L445.7,379c0.4-0.4,0.8-0.8,1.2-1.3C446.5,378.2,446.1,378.6,445.7,379"
                />
                <path
                  class="st27"
                  d="M461.6,362.7L461.6,362.7c-0.4,0.4-0.8,0.8-1.2,1.3l0,0C460.8,363.5,461.2,363.1,461.6,362.7"
                />
                <path
                  class="st27"
                  d="M461.6,362.7L461.6,362.7l-1.2,1.3l0,0C460.8,363.5,461.2,363.1,461.6,362.7"
                />
                <path
                  class="st27"
                  d="M469,355.2c-0.4,0.4-0.8,0.8-1.2,1.3C468.1,356,468.6,355.6,469,355.2L469,355.2z"
                />
                <path
                  class="st27"
                  d="M475.1,348.9L475.1,348.9c0.4-0.4,0.8-0.8,1.2-1.3C476,348,475.5,348.4,475.1,348.9"
                />
                <path
                  class="st27"
                  d="M476.4,347.6L476.4,347.6l-1.2,1.3l0,0C475.5,348.4,476,348,476.4,347.6"
                />
                <path
                  class="st27"
                  d="M482.5,341.4L482.5,341.4c0.4-0.4,0.8-0.8,1.2-1.3C483.3,340.5,482.9,340.9,482.5,341.4"
                />
                <path
                  class="st27"
                  d="M483.7,340.1L483.7,340.1l-1.2,1.3l0,0C482.9,340.9,483.3,340.5,483.7,340.1"
                />
                <path
                  class="st27"
                  d="M489.8,333.8L489.8,333.8c0.4-0.4,0.8-0.8,1.2-1.3C490.7,332.9,490.3,333.4,489.8,333.8"
                />
                <path
                  class="st27"
                  d="M504.5,318.8L504.5,318.8c0.4-0.4,0.8-0.8,1.2-1.3C505.3,317.9,504.9,318.4,504.5,318.8"
                />
                <path
                  class="st27"
                  d="M505.7,317.5L505.7,317.5l-1.2,1.3l0,0C504.9,318.4,505.3,317.9,505.7,317.5"
                />
                <path
                  class="st27"
                  d="M511.9,311.2L511.9,311.2c0.4-0.4,0.8-0.8,1.2-1.3C512.7,310.4,512.3,310.8,511.9,311.2"
                />
                <path
                  class="st27"
                  d="M519.2,303.7L519.2,303.7c0.4-0.4,0.8-0.8,1.2-1.3C520,302.9,519.6,303.3,519.2,303.7"
                />
                <path
                  class="st27"
                  d="M388.1,438L388.1,438l-1.2,1.3l0,0l0.1-0.1C387.3,438.8,387.7,438.4,388.1,438"
                />
                <polygon
                  class="st6"
                  points="483.7,340.1 482.4,341.4 482.5,341.4 	"
                />
                <polygon
                  class="st6"
                  points="460.4,363.9 460.4,363.9 461.6,362.7 461.6,362.7 	"
                />
                <polygon
                  class="st6"
                  points="476.4,347.6 476.4,347.6 475.1,348.9 475.1,348.9 	"
                />
                <polygon
                  class="st6"
                  points="505.7,317.5 504.5,318.8 504.5,318.8 	"
                />
                <polygon
                  class="st19"
                  points="444.7,406.7 444.3,406.3 437.5,413.3 437.8,413.5 	"
                />
                <polygon
                  class="st19"
                  points="525.6,323.7 525.2,323.4 518.3,330.5 518.7,330.9 	"
                />
                <path
                  class="st6"
                  d="M74.1,298.1l-13.2,14l154.2,150.6c0,0,31.6,33.6,88.3,34.2c47,0.5,74.5-22.8,88.6-36.9l158.9-163.4L536.2,282
            L375.8,447c0,0-15.6,13.5-27,16.4c-11.5,2.9-30.3,6.2-44.1,6.2c-13.8,0-44.9,4.4-75.8-22L74.1,298.1z"
                />
                <path
                  class="st6"
                  d="M62.6,312.6c0.3,0.3,5.8,5.7,6.1,5.9c0.3-0.3,12.3-12.6,12.5-12.8c-2.8-2.7-3.3-3.2-6.1-5.9
            C75,299.8,62.8,312.3,62.6,312.6 M70.2,320c0.3,0.3,5.8,5.6,6,5.8c0.3-0.3,12.3-12.6,12.5-12.8c-0.1-0.1-3.6-3.5-6-5.8
            C82.5,307.4,70.5,319.7,70.2,320"
                />
                <path
                  class="st14"
                  d="M76.2,326.1l-0.1-0.1c-0.1-0.1-1.1-1.1-2.3-2.2c-1.6-1.6-3.6-3.5-3.7-3.6L70,320l0.1-0.1
            c0.1-0.1,3.5-3.6,6.7-6.9c2.9-3,5.7-5.8,5.8-5.9l0.1-0.1l0.1,0.1c2.4,2.4,5.9,5.8,6,5.8l0.1,0.1l-0.1,0.1
            c-0.3,0.3-12.3,12.6-12.5,12.8L76.2,326.1z M70.5,320c0.5,0.5,2.2,2.1,3.6,3.5c1,0.9,1.8,1.8,2.1,2.1c1.3-1.3,11-11.3,12.3-12.6
            c-0.7-0.6-3.6-3.5-5.7-5.6c-0.6,0.6-3.1,3.2-5.7,5.8C74.2,316.2,71.2,319.3,70.5,320 M68.7,318.8l-0.1-0.1
            c-0.2-0.2-2.4-2.4-4.2-4.1l-2.1-2l0.1-0.1c0.2-0.2,6.2-6.3,9.7-9.9c1.6-1.7,2.8-2.9,2.8-2.9l0.1-0.1l6.4,6.2l-0.1,0.1
            c-0.1,0.1-4,4.1-7.4,7.6c-2.6,2.7-5,5.1-5.1,5.3H68.7z M62.8,312.6l1.8,1.7c1.5,1.5,3.5,3.4,4,3.9c0.5-0.6,2.7-2.7,5-5.1
            c3.1-3.2,6.6-6.7,7.3-7.5l-5.8-5.6c-0.4,0.4-1.4,1.4-2.7,2.8C69.1,306.1,63.8,311.6,62.8,312.6"
                />
                <path
                  class="st6"
                  d="M77.8,327.4c0.3,0.3,5.8,5.6,6.1,5.9c0.3-0.3,12.3-12.6,12.5-12.8c-3-2.9-5.9-5.8-6.1-5.9
            C90.1,314.8,78.1,327.1,77.8,327.4 M85.5,334.8c0.2,0.2,5.7,5.6,6,5.8c0.3-0.3,12.5-12.8,12.5-12.8c-1-1-4.6-4.5-6-5.8
            C97.7,322.2,85.7,334.5,85.5,334.8 M93,342.1c0.2,0.2,5.7,5.6,6,5.8c0.3-0.3,12.3-12.6,12.5-12.8c-0.2-0.2-3.1-3-6-5.8
            C105.6,329.3,93.3,341.9,93,342.1"
                />
                <path
                  class="st14"
                  d="M99.1,348.2l-1.9-1.8c-1.7-1.7-4.1-4-4.3-4.1l-0.1-0.1l0.1-0.1c0.2-0.2,4.3-4.4,7.8-7.9
            c4.8-4.9,4.8-4.9,4.8-4.9l0.1-0.1l0.1,0.1c2.9,2.8,5.9,5.7,6,5.8l0.1,0.1l-0.1,0.1c-0.3,0.3-12.3,12.6-12.5,12.8L99.1,348.2z
            M93.3,342.1c0.6,0.5,2.6,2.5,4.1,4l1.6,1.6c1.3-1.3,11-11.3,12.3-12.6c-0.6-0.6-3.2-3.1-5.7-5.6c-0.5,0.5-2.5,2.5-4.6,4.8
            C97.8,337.6,94.1,341.4,93.3,342.1 M91.5,340.9l-0.1-0.1c-0.3-0.3-5.8-5.6-6-5.8l-0.1-0.1l4-4.1c3.6-3.7,8.5-8.7,8.6-8.9l0.1-0.1
            l6.2,6v0.1C104.2,328,104.2,328,91.5,340.9L91.5,340.9z M85.7,334.8c0.8,0.8,4.9,4.8,5.7,5.6c1.3-1.4,11-11.3,12.3-12.6l-5.7-5.6
            c-0.8,0.8-5.2,5.3-8.5,8.7L85.7,334.8z M83.9,333.5l-0.1-0.1c-0.3-0.3-5.8-5.6-6.1-5.9l-0.1-0.1l0.1-0.1
            C78,327,90,314.7,90.2,314.5l0.1-0.1l0.1,0.1c0.2,0.1,3,2.9,6.1,5.9l0.1,0.1l-0.1,0.1c-0.3,0.3-12.2,12.5-12.5,12.8L83.9,333.5z
            M78.1,327.4c0.8,0.8,5,4.8,5.8,5.6c1.3-1.3,11-11.3,12.3-12.6c-2.7-2.7-5.2-5-5.8-5.6C89.1,316.1,79.3,326,78.1,327.4"
                />
                <path
                  class="st6"
                  d="M100.6,349.5c0.3,0.3,5.9,5.7,6.1,5.9c0.3-0.3,12.3-12.6,12.5-12.8c-3-2.9-5.9-5.8-6.1-5.9
            C112.9,336.9,100.9,349.2,100.6,349.5 M108.3,356.9c0.3,0.3,5.8,5.6,6,5.8c0.3-0.3,12.3-12.6,12.5-12.8c-0.8-0.8-4.4-4.3-6-5.8
            C120.6,344.3,108.5,356.6,108.3,356.9 M115.8,364.3c0.2,0.2,5.8,5.7,6.1,5.9c0.3-0.3,12.3-12.6,12.5-12.8c-0.2-0.2-3.2-3.1-6.1-5.9
            C128.1,351.7,116.1,364,115.8,364.3"
                />
                <path
                  class="st14"
                  d="M121.9,370.4l-0.1-0.1c-0.2-0.2-3.4-3.3-5.1-4.9l-1.2-1.1l0.1-0.1c0.3-0.3,12.3-12.6,12.5-12.8l0.1-0.1
            l6.4,6.2l-0.1,0.1C134.2,357.9,122.2,370.2,121.9,370.4L121.9,370.4z M116.1,364.3l0.9,0.9c1.5,1.5,4.3,4.1,4.9,4.8
            c1.3-1.3,11-11.3,12.3-12.6l-5.8-5.6C127.1,353,117.4,363,116.1,364.3 M114.3,363l-0.1-0.1c-0.1-0.1-1.5-1.5-3-2.9s-2.9-2.8-3.1-3
            l-0.1-0.1l0.1-0.1c0.3-0.3,12.5-12.7,12.5-12.8l0.1-0.1l0.1,0.1c0.9,0.9,2.6,2.5,4,3.8l2.2,2.1v0.1c-0.3,0.3-12.3,12.6-12.5,12.8
            L114.3,363z M108.5,356.9c0.4,0.4,1.7,1.6,2.9,2.8c1.2,1.2,2.4,2.3,2.8,2.7c1.3-1.3,11-11.3,12.3-12.6l-1.9-1.9
            c-1.3-1.3-2.9-2.8-3.8-3.7C119.6,345.6,109.8,355.6,108.5,356.9 M106.7,355.7l-0.1-0.1c-0.1-0.1-1.1-1-2.2-2.2
            c-1.7-1.6-3.7-3.6-3.9-3.8l-0.1-0.1l0.1-0.1c0.2-0.2,12.2-12.5,12.5-12.8l0.1-0.1l0.1,0.1c0.2,0.1,3.1,3,6.1,5.9l0.1,0.1l-0.1,0.1
            c-0.1,0.1-12.3,12.6-12.5,12.8L106.7,355.7z M100.9,349.5c0.5,0.5,2.3,2.2,3.7,3.6c0.9,0.9,1.8,1.7,2.1,2
            c1.3-1.3,11-11.3,12.3-12.6c-2.7-2.6-5.2-5-5.8-5.6C111.9,338.2,102.1,348.2,100.9,349.5"
                />
                <path
                  class="st6"
                  d="M191.9,438.1c0.2,0.2,5.8,5.7,6.1,5.9c0.3-0.3,12.3-12.6,12.5-12.8c-3-3-6-5.8-6.1-5.9
            C204.2,425.5,192.2,437.8,191.9,438.1 M199.6,445.5c0.3,0.3,5.8,5.6,6,5.8c0.3-0.3,12.3-12.6,12.5-12.8c-0.9-0.9-4-3.9-6-5.8
            C211.9,432.9,199.8,445.2,199.6,445.5 M207.1,452.9c0.3,0.3,7.8,7.5,8.1,7.8c0.3-0.3,11-13.9,11.2-14.2c-0.2-0.2-1.7-1.5-1.7-1.5
            s-2.7-2.7-5.1-4.9C219.4,440.3,207.4,452.6,207.1,452.9"
                />
                <path
                  class="st14"
                  d="M215.2,461l-0.2-0.1c-0.1-0.1-2.1-2-4-3.9c-2-1.9-3.9-3.8-4-3.9l-0.1-0.1l0.1-0.1c0.1-0.1,2.3-2.3,12-12.3
            l0.7-0.7l4.8,4.7c0.2,0.2,0.4,0.3,0.4,0.3s1.4,1.3,1.7,1.5l0.1,0.1l-0.1,0.1c-0.1,0.1-2,2.6-4.3,5.4c-3.1,3.9-6.8,8.6-6.9,8.8
            L215.2,461z M207.4,452.9c0.5,0.5,2.2,2.1,3.9,3.8c1.7,1.6,3.3,3.2,3.9,3.7c0.7-0.9,4-5.1,6.8-8.6c2-2.5,3.7-4.7,4.2-5.3
            c-0.4-0.4-1.6-1.4-1.6-1.4l-4.9-4.8l-0.4,0.4C210.7,449.5,208,452.3,207.4,452.9 M205.6,451.6l-2.2-2.1c-1.7-1.6-3.8-3.7-4-3.9
            l-0.1-0.1l0.1-0.1c0.3-0.3,12.3-12.6,12.5-12.8l0.1-0.1l6.3,6.1l-0.1,0.1c-0.3,0.3-12.3,12.6-12.5,12.8L205.6,451.6z M199.8,445.5
            c0.5,0.5,2.4,2.3,3.8,3.7l1.9,1.8c1.3-1.3,11-11.3,12.3-12.6l-5.7-5.6C210.8,434.2,201.1,444.2,199.8,445.5 M198,444.3l-0.1-0.1
            c-0.2-0.2-3.3-3.2-5-4.9l-1.2-1.2l0.1-0.1c0.1-0.1,12.2-12.5,12.5-12.8l0.1-0.1l0.1,0.1c0.1,0.1,3,3,6.1,5.9l0.1,0.1l-0.1,0.1
            c-0.2,0.2-12.3,12.6-12.5,12.8L198,444.3z M192.2,438.1l0.9,0.9c1.5,1.5,4.2,4.1,4.9,4.7c1.3-1.3,11-11.3,12.3-12.6
            c-2.7-2.6-5.2-5-5.8-5.6C203.2,426.8,193.4,436.8,192.2,438.1"
                />
                <polygon
                  class="st6"
                  points="181.3,402.7 168.6,415.6 183.1,429.9 195.9,417.1 	"
                />
                <path
                  class="st14"
                  d="M183.1,430.2l-0.1-0.1l-14.7-14.5l0.1-0.1l12.9-13l0.1,0.1l14.7,14.5l-0.1,0.1L183.1,430.2z M168.8,415.6
            l14.3,14.1l12.5-12.6L181.3,403L168.8,415.6z"
                />
                <path
                  class="st6"
                  d="M161.5,408.6c0.3,0.2,5.8,5.6,6,5.8c0.3-0.3,12.3-12.6,12.5-12.8c-0.3-0.3-5.8-5.6-6-5.8
            C173.8,396,161.8,408.3,161.5,408.6"
                />
                <path
                  class="st14"
                  d="M167.5,414.7l-0.6-0.6c-1.4-1.3-5.3-5.2-5.5-5.4l-0.1-0.1l0.1-0.1c0.2-0.2,6.5-6.6,10.1-10.3l2.6-2.7l0.1,0.1
            c0.3,0.2,5.8,5.6,6,5.8l0.1,0.1l-0.1,0.1c-0.3,0.3-12.3,12.6-12.5,12.8L167.5,414.7z M161.8,408.6c0.7,0.7,4.1,4,5.4,5.2l0.3,0.3
            c1.3-1.3,11-11.3,12.3-12.6c-0.8-0.8-4.9-4.8-5.7-5.6l-2.3,2.4C168.4,401.8,162.7,407.6,161.8,408.6"
                />
                <path
                  class="st6"
                  d="M184.3,430.7c0.3,0.3,5.8,5.6,6,5.8c0.3-0.3,12.3-12.6,12.5-12.8c-0.3-0.2-5.3-5.1-6-5.8
            C196.6,418.2,184.6,430.5,184.3,430.7"
                />
                <path
                  class="st14"
                  d="M190.4,436.8l-0.1-0.1c-0.3-0.3-5.7-5.6-6-5.8l-0.1-0.1l0.1-0.1c0.1-0.1,12.3-12.6,12.5-12.8l0.1-0.1l1.3,1.3
            c1.7,1.7,4.6,4.5,4.8,4.7l0.1,0.1L203,424c-0.1,0.1-2.5,2.6-5.2,5.3C194.4,432.8,190.6,436.7,190.4,436.8L190.4,436.8z
            M184.6,430.7c0.8,0.8,4.9,4.8,5.7,5.6c0.7-0.7,4.2-4.2,7.2-7.4c2.4-2.4,4.5-4.6,5.1-5.2c-0.6-0.6-3.1-3-4.7-4.5l-1.1-1
            C195.6,419.5,185.9,429.5,184.6,430.7"
                />
                <path
                  class="st6"
                  d="M227.6,471.2c3.1,2.3,6.2,4.4,9.4,6.4c0.2-0.4,8.4-17,8.5-17.3c-2.7-1.6-5.3-3.2-7.8-4.9
            C237.5,455.7,227.8,470.9,227.6,471.2"
                />
                <path
                  class="st14"
                  d="M237.1,477.9l-0.2-0.1c-3.2-2-6.4-4.1-9.4-6.4l-0.1-0.1l0.1-0.1c0.2-0.3,9.9-15.5,10.1-15.9l0.1-0.2l0.2,0.1
            c2.5,1.7,5.1,3.4,7.8,4.9l0.2,0.1l-0.1,0.2c-0.2,0.3-8.4,16.9-8.5,17.3L237.1,477.9z M227.9,471.2c2.9,2.2,6,4.3,9.1,6.1
            c0.9-1.8,7.6-15.3,8.4-17c-2.6-1.5-5.1-3.1-7.5-4.7C236.8,457.2,228.9,469.7,227.9,471.2"
                />
                <path
                  class="st6"
                  d="M216.8,462.2c0.1,0.1,0.1,0.1,0.1,0.1l2.1,1.9c2.2,2,4.5,3.9,6.9,5.7c0.2-0.4,10-15.6,10.1-15.8
            c-2.6-1.9-5.3-4-7.9-6.2C227.8,448.2,217,461.9,216.8,462.2"
                />
                <path
                  class="st14"
                  d="M225.9,470.2l-0.2-0.1c-2.5-1.9-4.8-3.8-6.9-5.7c0,0-1.5-1.3-2-1.7l0,0l-0.4-0.4l0.1-0.1
            c0.2-0.3,11.1-14.1,11.3-14.3l0.1-0.2l0.2,0.1c2.5,2.1,5.1,4.2,7.9,6.2l0.1,0.1l-0.1,0.2c-0.1,0.1-4.5,7-7.4,11.6
            C227.1,468.2,226,470,225.9,470.2L225.9,470.2z M217,462.2c0.2,0.2,0.8,0.7,2.1,1.8c2.1,1.9,4.3,3.7,6.7,5.6c0.3-0.5,1.3-2.1,2.6-4
            c2.7-4.2,6.6-10.4,7.3-11.5c-2.6-1.9-5.2-3.9-7.6-6C226.9,449.6,218,461,217,462.2"
                />
                <path
                  class="st6"
                  d="M238.9,478.7c3,1.8,6,3.4,8.9,4.8c0.2-0.4,7-18,7.1-18.4c-2.5-1.1-5-2.4-7.5-3.8
            C247.3,461.7,239.1,478.4,238.9,478.7"
                />
                <path
                  class="st14"
                  d="M247.9,483.8l-0.2-0.1c-2.9-1.4-6-3-9-4.8l-0.2-0.1l0.1-0.2c0.1-0.2,3.2-6.5,5.6-11.4
            c1.6-3.2,2.9-5.8,2.9-5.9l0.1-0.2l0.2,0.1c2.5,1.4,5,2.6,7.5,3.8l0.2,0.1l-0.1,0.2c-0.1,0.4-7.1,18.2-7.1,18.4V483.8z M239.1,478.7
            c2.9,1.7,5.8,3.2,8.6,4.6c0.7-1.8,6.3-16.3,7-18c-2.4-1.1-4.8-2.3-7.2-3.6c-0.3,0.7-1.5,3-2.8,5.7
            C242.5,471.9,239.6,477.6,239.1,478.7"
                />
                <path
                  class="st6"
                  d="M123.5,371.7c0.3,0.2,5.8,5.6,6,5.8c0.3-0.3,12.3-12.6,12.5-12.8c-2.5-2.4-5.9-5.8-6-5.8
            C135.8,359.1,123.8,371.4,123.5,371.7 M131.1,379c0.3,0.3,5.8,5.6,6,5.8c0.3-0.3,12.5-12.8,12.5-12.8c-2.8-2.7-3.2-3.2-6-5.8
            C143.4,366.5,131.3,378.8,131.1,379 M138.6,386.4c0.3,0.3,5.8,5.6,6.1,5.9c0.3-0.3,12.3-12.6,12.5-12.8c-0.1-0.1-3.6-3.5-6.1-5.9
            C151.2,373.6,138.9,386.1,138.6,386.4"
                />
                <path
                  class="st14"
                  d="M144.7,392.6l-0.1-0.1c-0.3-0.3-5.8-5.6-6.1-5.9l-0.1-0.1l0.1-0.1c0.1-0.2,3.8-3.9,7.2-7.3
            c5.4-5.5,5.4-5.5,5.5-5.6h0.1l0.1,0.1c3.8,3.7,6,5.8,6.1,5.9l0.1,0.1l-0.1,0.1c-0.3,0.3-12.5,12.8-12.5,12.8L144.7,392.6z
            M138.9,386.4c0.8,0.8,5,4.8,5.8,5.6c1.3-1.3,11-11.3,12.3-12.6c-0.7-0.7-3.8-3.7-5.8-5.6c-0.6,0.6-2.8,2.9-5.2,5.4
            C142.9,382.3,139.6,385.7,138.9,386.4 M137.1,385.2L137,385c-0.2-0.2-2.6-2.6-4.4-4.2l-1.8-1.7l0.1-0.1c0.2-0.2,4-4.1,7.4-7.6
            c2.7-2.7,5.1-5.2,5.2-5.3l0.1-0.1l6.3,6.1l-0.1,0.1c0,0-12.3,12.6-12.5,12.8L137.1,385.2z M131.3,379l1.5,1.5
            c1.5,1.5,3.7,3.5,4.2,4.1c1.3-1.3,11-11.3,12.3-12.6l-5.7-5.6c-0.5,0.6-2.7,2.7-5,5.1C135.5,374.8,132.1,378.3,131.3,379
            M129.5,377.8l-2.1-2.1c-1.7-1.6-3.9-3.7-4-3.9l-0.1-0.1l0.1-0.1c0.2-0.2,4.6-4.7,8.1-8.3c2.3-2.4,4.3-4.4,4.4-4.5l0.1-0.1l6.3,6.1
            l-0.1,0.1c-0.1,0.1-12.3,12.6-12.5,12.8L129.5,377.8z M123.8,371.7c0.5,0.5,2.4,2.3,3.9,3.8l1.9,1.8c1.3-1.3,11-11.3,12.3-12.6
            l-5.7-5.6c-0.5,0.5-2.3,2.3-4.3,4.4C128.5,366.8,124.5,370.9,123.8,371.7"
                />
                <path
                  class="st6"
                  d="M391.9,432.1L391.9,432.1c0,0-2.7,2.7-2.9,2.9c0.3,0.3,12.5,12.1,12.8,12.4c0.2-0.2,5.6-5.7,5.9-6
            c-0.3-0.3-12.5-12.2-12.8-12.4C394.6,429.3,391.9,432.1,391.9,432.1"
                />
                <path
                  class="st14"
                  d="M401.8,447.7l-0.1-0.1c-0.4-0.3-12.6-12.2-12.8-12.4l-0.1-0.1l0.1-0.1c0.2-0.2,2.9-2.9,2.9-2.9s2.7-2.8,3-3.1
            l0.1-0.1l0.1,0.1c0.1,0.1,3.4,3.3,6.5,6.3s6.1,5.9,6.3,6.1l0.1,0.1l-0.1,0.1c-0.2,0.2-2.6,2.7-4.3,4.4c-0.8,0.9-1.5,1.5-1.6,1.6
            L401.8,447.7z M389.3,435c1.3,1.3,11.2,10.9,12.5,12.2c0.2-0.2,0.8-0.8,1.4-1.5c1.5-1.5,3.6-3.7,4.2-4.3c-0.6-0.6-3.4-3.3-6.1-5.9
            c-2.8-2.8-5.7-5.6-6.4-6.2c-0.6,0.6-2.8,2.9-2.9,2.9C392,432.2,389.8,434.4,389.3,435"
                />
                <path
                  class="st6"
                  d="M371.7,451.3c0.2,0.3,10.2,15,10.4,15.4c2.9-2.4,5.6-4.9,8.1-7.4c0,0,0.4-0.5,0.7-0.7
            c-0.2-0.3-11.3-13.6-11.6-13.9C376.8,447.1,374.3,449.3,371.7,451.3"
                />
                <path
                  class="st14"
                  d="M382.1,467l-0.1-0.2c-0.1-0.2-2-3-4.2-6.1c-2.9-4.3-6.2-9.1-6.3-9.3l-0.1-0.1l0.1-0.1c2.6-2,5.1-4.2,7.6-6.6
            l0.1-0.1l0.1,0.2c0.1,0.1,11.3,13.6,11.6,13.9l0.1,0.1l-0.8,0.8c-2.4,2.4-5.2,4.9-8.1,7.4L382.1,467z M372,451.3
            c0.6,0.9,3.5,5.2,6.2,9.1c1.9,2.8,3.6,5.3,4,6c2.9-2.4,5.5-4.9,7.9-7.3l0.6-0.6c-1.1-1.4-10.1-12.1-11.3-13.6
            C376.9,447.3,374.4,449.4,372,451.3"
                />
                <path
                  class="st6"
                  d="M403.8,419.9c0.3,0.3,12.5,12.1,12.8,12.4c0.3-0.3,5.7-5.8,5.9-6c-0.3-0.3-12.5-12.2-12.8-12.4
            C409.4,414.1,404.1,419.6,403.8,419.9"
                />
                <path
                  class="st14"
                  d="M416.6,432.5l-0.1-0.1c-0.3-0.3-12.5-12.1-12.8-12.4l-0.1-0.1l0.1-0.1c0.2-0.2,5.6-5.7,5.9-6l0.1-0.1l0.1,0.1
            c0.3,0.3,12.5,12.2,12.8,12.4l0.1,0.1l-0.1,0.1c-0.1,0.1-2.2,2.3-3.9,4L416.6,432.5z M404.1,419.9c1.3,1.3,11.2,10.9,12.5,12.2
            l1.9-1.9c1.4-1.5,3.2-3.3,3.7-3.8c-1.3-1.3-11.2-10.9-12.5-12.2C408.9,415,404.9,419,404.1,419.9"
                />
                <path
                  class="st6"
                  d="M362.3,457.9c0.2,0.3,8.7,16.6,8.9,16.9c3-2,6.1-4.3,9.2-6.8c-0.2-0.3-10.2-15.1-10.5-15.5
            C367.5,454.5,364.9,456.3,362.3,457.9"
                />
                <path
                  class="st14"
                  d="M371.2,475.1l-1.7-3.2c-2.5-4.8-7.2-13.7-7.3-13.9l-0.1-0.2l0.1-0.1c2.6-1.6,5.1-3.4,7.6-5.3l0.2-0.1l0.1,0.2
            c0.1,0.2,2.9,4.3,5.7,8.4c2.4,3.6,4.7,6.9,4.8,7.1l0.1,0.1l-0.1,0.1c-3.1,2.5-6.1,4.8-9.2,6.8L371.2,475.1z M362.6,458
            c0.6,1.2,4.9,9.3,7.3,13.7l1.5,2.9c2.9-2,5.9-4.2,8.8-6.5c-0.5-0.7-2.5-3.8-4.7-6.9c-2.5-3.6-5-7.4-5.5-8.2
            C367.5,454.7,365.1,456.4,362.6,458"
                />
                <path
                  class="st6"
                  d="M386.6,437.5L386.6,437.5l-3.4,3.5l-0.4,0.4l-0.5,0.5l-0.3,0.3c0,0-0.9,0.9-1.1,1c0.2,0.3,11.2,13.5,11.5,13.8
            c0.3-0.3,7.6-7.7,7.8-8c-0.3-0.3-12.5-12.1-12.8-12.4C387.3,436.8,386.6,437.5,386.6,437.5"
                />
                <path
                  class="st14"
                  d="M392.4,457.3l-0.1-0.2c-0.3-0.3-11.4-13.7-11.5-13.8l-0.1-0.1l0.1-0.1c0.2-0.1,1-1,1.1-1l5.6-5.7l0.1,0.1
            c0.1,0.1,12.5,12.1,12.8,12.4l0.1,0.1l-0.1,0.1c-0.3,0.3-7.5,7.7-7.8,8L392.4,457.3z M381.2,443.2c1.1,1.3,10,12,11.3,13.5
            c1-1,6.6-6.7,7.5-7.7c-1.3-1.3-11.2-10.9-12.5-12.2l-4.6,4.7l0,0c-0.1,0.1-0.2,0.3-0.5,0.5l-0.3,0.3
            C382.1,442.3,381.5,443,381.2,443.2"
                />
                <path
                  class="st6"
                  d="M401.5,422.2L401.5,422.2c0,0-4.9,5-5.1,5.3c0.3,0.3,12.5,12.2,12.8,12.4c0.3-0.3,5.7-5.8,5.9-6.1
            c-0.3-0.3-12.5-12.2-12.8-12.4C402.2,421.6,401.5,422.2,401.5,422.2"
                />
                <path
                  class="st14"
                  d="M409.2,440.2L409,440c-0.1-0.1-2.4-2.3-5-4.8c-3.5-3.4-7.7-7.5-7.8-7.6l-0.1-0.1l0.1-0.1
            c0.3-0.3,5-5.1,5.1-5.3l0,0l0.9-0.9l0.1,0.1c0.3,0.3,12.7,12.3,12.8,12.4l0.1,0.1l-0.1,0.1c-0.2,0.3-5.7,5.8-5.9,6.1V440.2z
            M396.6,427.5c0.8,0.7,4.5,4.4,7.7,7.5c2.3,2.2,4.3,4.2,4.8,4.7c0.8-0.8,4.9-5,5.7-5.8c-1.3-1.2-11.2-10.9-12.5-12.2l-0.6,0.7l0,0
            C401.7,422.3,397.5,426.6,396.6,427.5"
                />
                <path
                  class="st6"
                  d="M350.1,464.6c0.1,0.3,7.5,17.7,7.7,18.1c3.9-2,7.8-4.2,11.6-6.7c-0.2-0.3-8.8-16.6-9-17
            C357,461.2,353.5,463,350.1,464.6"
                />
                <path
                  class="st14"
                  d="M357.7,483l-0.1-0.2c-0.1-0.1-7.5-17.7-7.7-18.1l-0.1-0.2l0.2-0.1c3.4-1.6,6.9-3.5,10.3-5.6l0.2-0.1l0.1,0.2
            c0.1,0.3,4.8,9,7.3,13.8l1.8,3.4l-0.1,0.1c-3.8,2.4-7.7,4.7-11.6,6.7L357.7,483z M350.4,464.7c0.7,1.7,6.8,15.9,7.5,17.7
            c3.8-1.9,7.6-4.1,11.3-6.5l-1.6-3.1c-2.3-4.4-6.5-12.3-7.2-13.6C357,461.4,353.7,463.2,350.4,464.7"
                />
                <path
                  class="st6"
                  d="M411.2,412.3c0.3,0.3,12.5,12.2,12.8,12.4c0.3-0.3,5.7-5.8,5.9-6.1c-0.3-0.3-12.5-12.1-12.8-12.4
            C416.9,406.5,411.4,412,411.2,412.3"
                />
                <path
                  class="st14"
                  d="M424,425l-0.1-0.1c-0.1-0.1-1.3-1.3-3-3c-3.8-3.7-9.6-9.3-9.8-9.5l-0.1-0.1l0.1-0.1c0.2-0.3,5.7-5.8,5.9-6.1
            l0.1-0.1l0.1,0.1c0.1,0.1,12.5,12.1,12.8,12.4l0.1,0.1l-0.1,0.1c-0.2,0.2-5.7,5.8-5.9,6.1L424,425z M411.5,412.3
            c0.9,0.9,6.1,5.9,9.6,9.3c1.4,1.4,2.5,2.4,2.9,2.8c0.8-0.8,4.9-5,5.7-5.8c-1.3-1.3-11.2-10.9-12.5-12.2
            C416.3,407.3,412.3,411.5,411.5,412.3"
                />
                <path
                  class="st6"
                  d="M469.7,352.6c0.3,0.3,12.5,12.2,12.8,12.4c0.3-0.3,21.5-22.2,21.8-22.5c-0.3-0.3-12.5-12.2-12.8-12.4
            c-0.2,0.3-21.5,22-21.8,22.2"
                />
                <path
                  class="st14"
                  d="M482.5,365.3l-0.1-0.1c-0.4-0.4-12.6-12.2-12.8-12.4l0.3-0.3l-0.2-0.2c0.3-0.3,21.6-22.1,21.8-22.2l0.1-0.1
            l0.1,0.1c0.3,0.3,12.7,12.3,12.8,12.4l0.1,0.1l-0.1,0.1c-0.1,0.1-6.9,7.1-12.9,13.3c-4.6,4.8-8.8,9-8.9,9.2L482.5,365.3z
            M469.9,352.5c0.8,0.7,11.3,10.9,12.6,12.3c0.8-0.8,4.5-4.7,8.8-9c5.6-5.7,11.8-12.2,12.8-13.2c-1.3-1.2-11.2-10.9-12.5-12.2
            C489.7,332.3,470.4,351.9,469.9,352.5"
                />
                <path
                  class="st6"
                  d="M514.9,306.1c0.3,0.3,12.5,12.2,12.8,12.4c0.3-0.3,5.8-5.9,5.9-6c-0.3-0.3-12.5-12.2-12.8-12.4
            C520.5,300.4,515.2,305.8,514.9,306.1"
                />
                <path
                  class="st14"
                  d="M527.7,318.8l-0.1-0.1c-0.1-0.1-3.3-3.2-6.4-6.2c-3.1-3-6.3-6.1-6.4-6.2l-0.1-0.1l0.1-0.1
            c0.3-0.3,5.6-5.7,5.9-6l0.1-0.1l3,3c3.7,3.6,9.7,9.4,9.9,9.6l0.1,0.1l-0.1,0.1c0,0-0.7,0.7-1.5,1.6c-1.7,1.7-4.1,4.2-4.3,4.4
            L527.7,318.8z M515.2,306.1c0.7,0.6,3.5,3.4,6.3,6.1s5.6,5.4,6.3,6.1c0.6-0.6,2.7-2.7,4.2-4.3c0.6-0.7,1.2-1.2,1.4-1.4
            c-0.9-0.9-6.3-6.1-9.8-9.5l-2.8-2.7C520,301.2,516,305.3,515.2,306.1"
                />
                <path
                  class="st6"
                  d="M507.5,313.7c0.3,0.3,12.5,12.2,12.8,12.4c0.2-0.2,5.7-5.8,5.9-6.1c-0.3-0.3-12.5-12.2-12.8-12.4
            C513.2,307.9,507.7,313.5,507.5,313.7"
                />
                <path
                  class="st14"
                  d="M520.3,326.4l-0.1-0.1c-0.3-0.3-12.7-12.3-12.8-12.4l-0.1-0.1l0.1-0.1c0.2-0.2,3.1-3.1,4.8-4.9l1.3-1.3
            l0.1,0.1c0.1,0.1,12.5,12.1,12.8,12.4l0.1,0.1l-0.1,0.1c-0.1,0.1-1.9,2-3.5,3.6c-1.2,1.3-2.3,2.4-2.4,2.5L520.3,326.4z
            M507.7,313.7c1.3,1.2,11.2,10.9,12.5,12.2c0.3-0.4,1.3-1.3,2.3-2.4c1.4-1.4,2.9-3,3.3-3.4c-1.3-1.3-11.2-10.9-12.5-12.2l-1,1.1
            C510.8,310.5,508.3,313.1,507.7,313.7"
                />
                <path
                  class="st6"
                  d="M522.3,298.5c0.3,0.3,12.5,12.2,12.8,12.4c0.2-0.2,5.7-5.8,5.9-6.1c-0.3-0.3-12.6-12.3-12.8-12.4
            C525.4,295.3,522.5,298.4,522.3,298.5"
                />
                <path
                  class="st6"
                  d="M426,397.1c0.3,0.3,12.5,12.1,12.8,12.4c0.3-0.3,5.6-5.8,5.9-6c-0.3-0.3-12.5-12.1-12.8-12.4
            C431.6,391.4,426.3,396.9,426,397.1"
                />
                <path
                  class="st14"
                  d="M438.8,409.8l-0.1-0.1c-0.1-0.1-3.3-3.2-6.4-6.2s-6.3-6.1-6.4-6.2l-0.1-0.1l0.1-0.1c0.3-0.3,5.6-5.7,5.9-6
            l0.1-0.1l0.1,0.1c0.3,0.3,12.5,12.2,12.8,12.4l0.1,0.1l-0.1,0.1c-0.3,0.3-5.6,5.7-5.9,6L438.8,409.8z M426.3,397.1
            c0.7,0.6,3.5,3.4,6.3,6.1s5.6,5.4,6.3,6.1c0.8-0.8,4.8-4.9,5.6-5.7c-1.3-1.3-11.2-10.9-12.5-12.2
            C431.1,392.2,427.1,396.3,426.3,397.1"
                />
                <path
                  class="st6"
                  d="M433.4,389.6c0.3,0.3,12.5,12.2,12.8,12.4c0.3-0.3,5.7-5.8,5.9-6.1c-0.3-0.3-12.5-12.2-12.8-12.4
            C439.1,383.7,433.7,389.3,433.4,389.6"
                />
                <path
                  class="st14"
                  d="M446.2,402.3l-0.1-0.1c-0.3-0.3-12.5-12.2-12.8-12.4l-0.1-0.1l0.1-0.1c0.3-0.3,5.7-5.8,5.9-6.1l0.1-0.1l1,1
            c2.9,2.8,11.7,11.3,11.9,11.6l0.1,0.1l-0.1,0.1c-0.3,0.3-5.7,5.8-5.9,6.1H446.2z M433.7,389.6c1.3,1.3,11.2,10.9,12.5,12.2
            c0.8-0.8,4.9-5,5.7-5.8c-1.2-1.1-9.1-8.8-11.8-11.4l-0.7-0.7C438.5,384.6,434.5,388.7,433.7,389.6"
                />
                <path
                  class="st6"
                  d="M418.6,404.7c0.3,0.3,12.5,12.2,12.8,12.4c0.3-0.3,5.6-5.8,5.9-6c-0.3-0.3-12.5-12.1-12.8-12.4
            C424.2,398.9,418.8,404.5,418.6,404.7"
                />
                <path
                  class="st14"
                  d="M431.4,417.4l-5.2-5.1l-7.8-7.6l0.1-0.1c0.2-0.2,5.6-5.7,5.9-6l0.1-0.1l0.1,0.1c0.3,0.3,12.7,12.3,12.8,12.4
            l0.1,0.1l-0.1,0.1c-0.1,0.1-1.6,1.7-3.1,3.2c-1.3,1.4-2.6,2.7-2.7,2.8L431.4,417.4z M418.9,404.7l12.5,12.2
            c0.4-0.4,1.5-1.5,2.6-2.7c1.3-1.3,2.6-2.6,3-3.1c-1.3-1.2-11.2-10.9-12.5-12.2C423.7,399.8,419.7,403.9,418.9,404.7"
                />
                <path
                  class="st6"
                  d="M455.7,366.8c0,0,12.5,12.2,12.8,12.4c0.3-0.3,5.6-5.7,5.9-6c-0.3-0.3-12.5-12.2-12.8-12.4
            C461.4,360.9,458.6,363.8,455.7,366.8 M448.2,374.4c0.3,0.3,12.5,12.2,12.8,12.4c0.3-0.3,5.7-5.8,5.9-6.1
            c-0.3-0.3-12.8-12.4-12.8-12.4C452.5,370,448.5,374.1,448.2,374.4"
                />
                <path
                  class="st14"
                  d="M461,387.1l-0.1-0.1c-0.3-0.3-12.5-12.2-12.8-12.4l-0.1-0.1l0.1-0.1c0.1-0.1,1.2-1.2,2.4-2.5l3.7-3.8l0.1,0.1
            c0,0,12.4,12.1,12.8,12.4l0.1,0.1l-0.1,0.1c-0.2,0.2-3.2,3.3-4.9,5L461,387.1z M448.5,374.4c1.3,1.3,11.2,10.9,12.5,12.2l0.9-1
            c1.5-1.5,4.1-4.2,4.7-4.8c-1.3-1.3-11.2-10.9-12.5-12.2l-3.4,3.5C449.7,373.1,448.8,374,448.5,374.4 M468.5,379.4l-0.1-0.1
            c-0.1-0.1-2.1-2.1-4.6-4.4c-8.2-8-8.2-8-8.3-8l-0.1-0.1l0.8-0.8c2.7-2.7,5-5.2,5.2-5.3l0.1-0.1l0.1,0.1
            c0.1,0.1,12.5,12.1,12.8,12.4l0.1,0.1l-0.1,0.1C474.1,373.6,468.8,379,468.5,379.4L468.5,379.4z M455.9,366.7
            c0.8,0.8,4.8,4.7,8.1,7.9c2.1,2,3.9,3.8,4.4,4.3c0.8-0.8,4.8-4.9,5.6-5.7c-1.3-1.3-11.2-10.9-12.5-12.2c-0.6,0.6-2.7,2.8-5,5.2
            L455.9,366.7z"
                />
                <path
                  class="st6"
                  d="M440.8,381.9c0.3,0.3,12.5,12.2,12.8,12.4c0.2-0.2,5.6-5.7,5.9-6c-0.3-0.3-12.5-12.2-12.8-12.4
            C446.4,376.2,441.1,381.7,440.8,381.9"
                />
                <path
                  class="st14"
                  d="M453.7,394.6l-0.1-0.1c-0.2-0.2-5.9-5.7-9.6-9.3c-1.8-1.7-3.1-3-3.2-3.1l-0.1-0.1l6.1-6.3l13.1,12.7l-0.1,0.1
            c-0.1,0.1-1.4,1.5-2.8,2.9c-1.4,1.5-2.9,3-3,3.1L453.7,394.6z M441.1,381.9c0.4,0.4,1.6,1.5,3,3c3.5,3.4,8.6,8.3,9.5,9.2
            c0.4-0.4,1.7-1.7,2.9-3c1.2-1.2,2.3-2.3,2.7-2.7l-12.5-12.2L441.1,381.9z"
                />
                <path
                  class="st6"
                  d="M463.1,359.2c0.3,0.3,12.5,12.2,12.8,12.4c0.2-0.2,5.6-5.7,5.9-6c-0.3-0.3-12.5-12.1-12.8-12.4
            C468.7,353.5,463.3,358.9,463.1,359.2"
                />
                <path
                  class="st14"
                  d="M475.9,371.9l-0.1-0.1c-0.2-0.2-6.8-6.6-10.4-10.1l-2.6-2.5l0.1-0.1c0.2-0.2,2.5-2.6,4.2-4.3l1.8-1.9l0.1,0.1
            c0.2,0.2,12.4,12,12.8,12.4l0.1,0.1l-0.1,0.1c-0.3,0.3-5.6,5.8-5.9,6V371.9z M463.3,359.2l2.3,2.2c3.3,3.2,9.2,9,10.2,9.9
            c0.8-0.8,4.8-4.9,5.6-5.7c-1.3-1.2-11.2-10.9-12.5-12.2l-1.6,1.6C465.9,356.6,463.9,358.6,463.3,359.2"
                />
                <path
                  class="st6"
                  d="M500.1,321.3c0.3,0.3,12.5,12.1,12.8,12.4c0.3-0.3,5.6-5.7,5.9-6c-0.3-0.3-12.5-12.2-12.8-12.4
            C505.7,315.5,500.3,321,500.1,321.3"
                />
                <path
                  class="st14"
                  d="M512.9,334l-0.1-0.1c-0.1-0.1-2.2-2.2-4.7-4.6c-3.6-3.5-7.9-7.7-8.1-7.8l-0.1-0.1l0.1-0.1
            c0.3-0.3,5.6-5.7,5.9-6l0.1-0.1l0.1,0.1c0.2,0.1,4,3.9,7.5,7.3c2.7,2.7,5.2,5,5.3,5.2l0.1,0.1l-1.4,1.5c-1.7,1.7-4.4,4.5-4.6,4.7
            L512.9,334z M500.3,321.3c0.8,0.8,4.7,4.5,7.9,7.7c2.2,2.1,4.1,3.9,4.6,4.4c0.6-0.6,2.9-3,4.4-4.5l1.2-1.2c-0.6-0.6-2.8-2.7-5.2-5
            c-3.1-3-6.6-6.4-7.3-7.1C505.1,316.4,501.2,320.5,500.3,321.3"
                />
                <path
                  class="st6"
                  d="M492.7,328.8c0.3,0.3,12.5,12.2,12.8,12.4c0.3-0.3,5.6-5.7,5.9-6c-0.3-0.3-12.5-12.1-12.8-12.4
            C498.3,323.1,493,328.6,492.7,328.8"
                />
                <path
                  class="st14"
                  d="M505.5,341.5l-0.1-0.1c-0.1-0.1-2.6-2.6-5.4-5.3c-3.4-3.3-7.2-7-7.4-7.2l-0.1-0.1l0.5-0.5
            c1.3-1.3,5.2-5.4,5.5-5.6l0.1-0.1l0.1,0.1c0.1,0.1,3.3,3.2,6.4,6.2s6.3,6.1,6.4,6.2l0.1,0.1l-0.1,0.1c-0.3,0.3-5.6,5.7-5.9,6
            L505.5,341.5z M493,328.8c0.7,0.7,4.1,4,7.3,7c2.4,2.4,4.7,4.6,5.3,5.1c0.8-0.8,4.8-4.9,5.6-5.7c-0.7-0.6-3.5-3.4-6.3-6.1
            s-5.6-5.4-6.3-6.1c-0.7,0.8-4.1,4.2-5.3,5.5L493,328.8z"
                />
                <path
                  class="st38"
                  d="M512.2,317.4l1-1l-1.5-1.5l0.7-0.7l4.1-1.3l1,1l-2.5,2.6l0.4,0.4l-0.8,0.8l-0.4-0.4l-1,1L512.2,317.4z
            M514,315.5l0.7-0.8c0.2-0.2,0.5-0.4,0.7-0.6l0,0c-0.3,0.1-0.6,0.2-0.9,0.4l-1.2,0.4l0,0L514,315.5z"
                />
                <path
                  class="st38"
                  d="M519.8,309.5l1-1l-1.5-1.5l0.7-0.7l4.1-1.3l1,1l-2.5,2.6l0.4,0.4l-0.8,0.8l-0.4-0.4l-1,1L519.8,309.5z
            M521.6,307.7l0.7-0.8c0.2-0.2,0.5-0.4,0.7-0.6l0,0c-0.3,0.1-0.6,0.2-0.9,0.4L521,307l0,0L521.6,307.7z"
                />
                <path
                  class="st38"
                  d="M523.2,312.7l1-1l-1.5-1.5l0.7-0.7l4.1-1.3l1,1l-2.5,2.6l0.4,0.4l-0.8,0.8l-0.4-0.4l-1,1L523.2,312.7z
            M525,310.9l0.7-0.8c0.2-0.2,0.5-0.4,0.7-0.6l0,0c-0.3,0.1-0.6,0.2-0.9,0.4l-1.2,0.4l0,0L525,310.9z"
                />
                <path
                  class="st38"
                  d="M514.1,319.2l0.7-0.7l1-0.1c1.3-0.2,2.2-0.3,2.7-0.8c0.3-0.3,0.3-0.7,0-1s-0.6-0.4-0.9-0.4l0.6-1
            c0.4,0.1,0.9,0.4,1.3,0.7c1.1,1,0.7,2,0.1,2.7c-0.8,0.8-1.9,0.9-2.9,1h-0.5l0,0l1.3,1.3l-0.9,0.9L514.1,319.2z"
                />
                <path
                  class="st38"
                  d="M504.8,325l1-1l-1.5-1.5l0.7-0.7l4.1-1.3l1,1l-2.5,2.6l0.4,0.4l-0.8,0.8l-0.4-0.4l-1,1L504.8,325z
            M506.6,323.2l0.7-0.8c0.2-0.2,0.5-0.4,0.7-0.6l0,0c-0.3,0.1-0.6,0.2-0.9,0.3l-1.2,0.4l0,0L506.6,323.2z"
                />
                <path
                  class="st38"
                  d="M508,328.2c-1.1-1.1-0.2-2.6,0.8-3.6c1.1-1.2,2.6-1.9,3.6-0.9c1.2,1.1,0,2.6-0.9,3.5
            C510.1,328.8,508.8,329,508,328.2L508,328.2z M508.9,327.4c0.2,0.2,0.6-0.1,1.6-1.1c0.9-0.9,1.3-1.4,1.1-1.6c-0.2-0.2-0.7,0-1.7,1
            C508.9,326.7,508.7,327.1,508.9,327.4L508.9,327.4z"
                />
                <path
                  class="st38"
                  d="M497.1,330.2c0.1,0.3,0.3,0.6,0.5,0.8c0.4,0.4,0.9,0.4,1.2,0.1c0.4-0.5,0.2-1-0.2-1.4l-0.1-0.1l0.7-0.8
            l0.1,0.1c0.3,0.3,0.8,0.6,1.2,0.2c0.3-0.3,0.2-0.6-0.1-0.9c-0.2-0.2-0.4-0.3-0.7-0.4l0.7-0.9c0.3,0.1,0.8,0.3,1.2,0.7
            c0.8,0.8,0.7,1.7,0.2,2.3c-0.4,0.4-1,0.6-1.6,0.4l0,0c0.3,0.6,0.2,1.3-0.3,1.8c-0.6,0.7-1.9,0.8-2.9-0.2c-0.4-0.4-0.6-0.8-0.7-1.1
            L497.1,330.2z"
                />
                <path
                  class="st38"
                  d="M505.2,331.2c0.6,0.6,0.8,1.6,0.1,2.3c-0.2,0.3-0.7,0.6-1.5,0.4l0,0c0.2,0.6,0.1,1.3-0.4,1.8
            c-0.9,0.9-2,0.7-2.7,0c-0.8-0.7-1-1.8-0.2-2.6c0.5-0.5,1.2-0.6,1.8-0.5l0,0c-0.1-0.6,0.1-1.1,0.4-1.5
            C503.4,330.4,504.5,330.5,505.2,331.2L505.2,331.2z M501.4,335c0.3,0.3,0.7,0.1,0.9-0.2c0.4-0.4,0.4-0.9,0.3-1.2
            c-0.3,0-0.6,0.1-1,0.4C501.3,334.3,501.1,334.8,501.4,335L501.4,335z M504.5,331.9c-0.2-0.2-0.6-0.1-0.8,0.2
            c-0.2,0.3-0.3,0.6-0.2,1c0.2,0.1,0.6-0.1,0.8-0.3C504.5,332.5,504.7,332.1,504.5,331.9L504.5,331.9z"
                />
                <path
                  class="st38"
                  d="M481.4,354.7c0.3-0.1,0.6-0.3,0.8-0.5c0.4-0.4,0.4-0.9,0.1-1.2c-0.4-0.5-1-0.2-1.4,0.1l-0.1,0.1l-0.7-0.8
            l0.1-0.1c0.3-0.3,0.6-0.8,0.3-1.2c-0.3-0.3-0.6-0.3-0.9,0c-0.2,0.2-0.3,0.4-0.4,0.7l-0.9-0.7c0.1-0.3,0.4-0.8,0.8-1.1
            c0.9-0.8,1.8-0.7,2.3-0.1c0.4,0.5,0.5,1.1,0.3,1.6l0,0c0.6-0.3,1.3-0.1,1.8,0.4c0.6,0.7,0.7,1.9-0.3,2.9c-0.4,0.4-0.8,0.6-1.1,0.7
            L481.4,354.7z"
                />
                <path
                  class="st38"
                  d="M489.3,346.5c0.3-0.1,0.6-0.3,0.8-0.5c0.4-0.4,0.4-0.9,0.1-1.2c-0.4-0.5-1-0.2-1.4,0.1l-0.1,0.1l-0.7-0.8
            l0.1-0.1c0.3-0.3,0.6-0.8,0.3-1.2c-0.3-0.3-0.6-0.3-0.9,0c-0.2,0.2-0.3,0.4-0.4,0.7l-0.9-0.7c0.1-0.3,0.4-0.8,0.8-1.1
            c0.9-0.8,1.8-0.7,2.3-0.1c0.4,0.4,0.5,1.1,0.3,1.6l0,0c0.6-0.3,1.3-0.1,1.8,0.4c0.6,0.7,0.7,1.9-0.3,2.9c-0.4,0.4-0.8,0.6-1.1,0.7
            L489.3,346.5z"
                />
                <path
                  class="st38"
                  d="M467.4,360.7c0.1,0.3,0.3,0.6,0.5,0.8c0.4,0.4,0.9,0.4,1.2,0.1c0.4-0.5,0.2-1-0.2-1.4l-0.1-0.1l0.7-0.8
            l0.1,0.1c0.3,0.3,0.8,0.6,1.2,0.2c0.3-0.3,0.2-0.6-0.1-0.9c-0.2-0.2-0.4-0.3-0.7-0.4l0.6-0.9c0.3,0.1,0.8,0.3,1.2,0.7
            c0.8,0.8,0.7,1.7,0.2,2.3c-0.4,0.4-1,0.6-1.6,0.4l0,0c0.3,0.6,0.2,1.3-0.3,1.8c-0.6,0.7-1.9,0.8-2.9-0.2c-0.4-0.4-0.6-0.8-0.7-1.1
            L467.4,360.7z"
                />
                <path
                  class="st38"
                  d="M471,366.1c-1.1-1.1-0.2-2.6,0.8-3.6c1.1-1.2,2.6-1.9,3.6-0.9c1.2,1.1,0,2.6-0.8,3.5
            C473.1,366.8,471.8,366.9,471,366.1L471,366.1z M471.9,365.3c0.2,0.2,0.6-0.1,1.6-1.1c0.9-0.9,1.3-1.4,1.1-1.6
            c-0.2-0.2-0.7,0-1.7,1C471.9,364.6,471.7,365,471.9,365.3L471.9,365.3z"
                />
                <path
                  class="st38"
                  d="M459,369l0.7-0.7l1-0.1c1.3-0.2,2.2-0.3,2.7-0.8c0.3-0.3,0.3-0.7,0-1s-0.6-0.4-0.9-0.4l0.6-1
            c0.4,0.1,0.9,0.4,1.3,0.7c1.1,1,0.7,2,0.1,2.7c-0.8,0.8-1.9,0.9-2.9,1h-0.5l0,0l1.3,1.3l-0.9,0.9L459,369z"
                />
                <path
                  class="st38"
                  d="M468.2,369.2c0.6,0.6,0.8,1.6,0.1,2.3c-0.2,0.3-0.7,0.6-1.5,0.4l0,0c0.2,0.6,0.1,1.3-0.4,1.8
            c-0.9,0.9-2,0.7-2.7,0c-0.8-0.7-1-1.8-0.2-2.6c0.5-0.5,1.2-0.6,1.8-0.5l0,0c-0.1-0.6,0.1-1.1,0.4-1.5
            C466.4,368.3,467.4,368.5,468.2,369.2L468.2,369.2z M464.3,373c0.3,0.3,0.7,0.1,0.9-0.2c0.4-0.4,0.4-0.9,0.3-1.2
            c-0.3,0-0.6,0.1-1,0.4C464.3,372.3,464.1,372.7,464.3,373L464.3,373z M467.4,369.8c-0.2-0.2-0.6-0.1-0.8,0.2
            c-0.2,0.3-0.3,0.6-0.2,1c0.2,0.1,0.6-0.1,0.8-0.3C467.5,370.4,467.7,370.1,467.4,369.8L467.4,369.8z"
                />
                <path
                  class="st38"
                  d="M451.5,376.7l0.7-0.7l1-0.1c1.3-0.2,2.2-0.3,2.7-0.8c0.3-0.3,0.3-0.7,0-1s-0.6-0.4-0.9-0.4l0.6-1
            c0.4,0.1,0.9,0.4,1.3,0.7c1.1,1,0.7,2,0.1,2.7c-0.8,0.8-1.9,0.9-2.9,1h-0.5l0,0l1.3,1.3l-0.9,0.9L451.5,376.7z"
                />
                <path
                  class="st38"
                  d="M460.8,378.6c-0.1-0.1-0.3-0.2-0.4-0.3c-0.6-0.4-1.3-0.3-1.9,0.1l0,0c0.3,0,0.7,0,1,0.3
            c0.6,0.6,0.5,1.5-0.3,2.4c-0.7,0.7-2,1.2-2.9,0.3c-0.9-0.8-0.7-2.1,0.4-3.2c1-1,2-1.3,2.8-1.3c0.6,0,1.2,0.2,1.6,0.5
            c0.3,0.2,0.4,0.3,0.5,0.4L460.8,378.6z M457,380.6c0.3,0.3,0.7-0.1,1.2-0.6c0.2-0.3,0.5-0.7,0.3-0.9c-0.1-0.1-0.3-0.1-0.5,0
            c-0.1,0-0.2,0.2-0.5,0.4C457,379.9,456.7,380.4,457,380.6L457,380.6z"
                />
                <path
                  class="st38"
                  d="M444.2,384.2l0.7-0.7l1-0.1c1.3-0.2,2.2-0.3,2.7-0.8c0.3-0.3,0.3-0.7,0-1s-0.6-0.4-0.9-0.4l0.6-1
            c0.4,0.1,0.9,0.3,1.3,0.7c1.1,1,0.7,2,0.1,2.7c-0.8,0.8-1.9,0.9-2.9,1h-0.5l0,0l1.3,1.3l-0.9,0.9L444.2,384.2z"
                />
                <path
                  class="st38"
                  d="M449,388.8l1-1l-1.5-1.5l0.7-0.7l4.1-1.3l1,1l-2.5,2.6l0.4,0.4l-0.8,0.8l-0.4-0.4l-1,1L449,388.8z M450.8,387
            l0.7-0.8c0.2-0.2,0.5-0.4,0.7-0.6l0,0c-0.3,0.1-0.6,0.2-0.9,0.3l-1.2,0.4l0,0L450.8,387z"
                />
                <path
                  class="st38"
                  d="M436.7,391.8l0.7-0.7l1-0.1c1.3-0.2,2.2-0.3,2.7-0.8c0.3-0.3,0.3-0.7,0-1s-0.6-0.4-0.9-0.4l0.6-1
            c0.4,0.1,0.9,0.4,1.3,0.7c1.1,1,0.7,2,0.1,2.7c-0.8,0.8-1.9,0.9-2.9,1h-0.5l0,0l1.3,1.3l-0.9,0.9L436.7,391.8z"
                />
                <path
                  class="st38"
                  d="M440.1,395l0.7-0.7l1-0.1c1.3-0.2,2.2-0.3,2.7-0.8c0.3-0.3,0.3-0.7,0-1s-0.6-0.4-0.9-0.4l0.6-1
            c0.4,0.1,0.9,0.4,1.3,0.7c1.1,1,0.7,2,0.1,2.7c-0.8,0.8-1.9,0.9-2.9,1h-0.5l0,0l1.3,1.3l-0.9,0.9L440.1,395z"
                />
                <path
                  class="st38"
                  d="M429.3,399.3l0.7-0.7l1-0.1c1.3-0.2,2.2-0.3,2.7-0.8c0.3-0.3,0.3-0.7,0-1s-0.6-0.4-0.9-0.4l0.6-1
            c0.4,0.1,0.9,0.4,1.3,0.7c1.1,1,0.7,2,0.1,2.7c-0.8,0.8-1.9,0.9-2.9,1h-0.5l0,0l1.3,1.3l-0.9,0.9L429.3,399.3z"
                />
                <path
                  class="st38"
                  d="M434,404c-1.1-1.1-0.2-2.6,0.8-3.6c1.1-1.2,2.6-1.9,3.6-0.9c1.2,1.1,0,2.6-0.9,3.5
            C436.1,404.6,434.8,404.7,434,404L434,404z M434.9,403.1c0.2,0.2,0.6-0.1,1.6-1.1c0.9-0.9,1.3-1.4,1.1-1.6c-0.2-0.2-0.7,0-1.7,1
            S434.7,402.9,434.9,403.1L434.9,403.1z"
                />
                <polygon
                  class="st38"
                  points="426.3,404.5 426.3,404.5 425.2,404.2 425.8,403.2 427.4,403.7 428.3,404.6 424,409 422.9,408 	"
                />
                <path
                  class="st38"
                  d="M431.1,407.2c0.6,0.6,0.8,1.6,0.1,2.3c-0.2,0.3-0.7,0.6-1.5,0.4l0,0c0.2,0.6,0.1,1.3-0.4,1.8
            c-0.9,0.9-2,0.7-2.7,0c-0.8-0.7-1-1.8-0.2-2.6c0.5-0.5,1.2-0.6,1.8-0.5l0,0c-0.1-0.6,0.1-1.1,0.4-1.5
            C429.3,406.3,430.3,406.4,431.1,407.2L431.1,407.2z M427.3,411c0.3,0.3,0.7,0,0.9-0.2c0.4-0.4,0.4-0.9,0.3-1.2
            c-0.3,0-0.6,0.1-1,0.4C427.2,410.3,427,410.7,427.3,411L427.3,411z M430.4,407.8c-0.2-0.2-0.6-0.1-0.8,0.2c-0.2,0.3-0.3,0.6-0.2,1
            c0.2,0.1,0.6-0.1,0.8-0.3C430.4,408.4,430.6,408,430.4,407.8L430.4,407.8z"
                />
                <polygon
                  class="st38"
                  points="418.9,412.1 418.9,412.1 417.8,411.7 418.4,410.8 420,411.3 420.9,412.2 416.6,416.6 415.5,415.6
            "
                />
                <path
                  class="st38"
                  d="M423.8,416.5c-0.1-0.1-0.3-0.2-0.4-0.3c-0.6-0.4-1.3-0.3-1.9,0.1l0,0c0.3,0,0.7,0,1,0.3
            c0.6,0.6,0.5,1.5-0.3,2.4c-0.7,0.7-2,1.2-2.9,0.3c-0.9-0.8-0.7-2.1,0.4-3.2c1-1,2-1.3,2.8-1.3c0.6,0,1.2,0.2,1.6,0.5
            c0.3,0.2,0.4,0.4,0.5,0.4L423.8,416.5z M419.9,418.5c0.3,0.3,0.7-0.1,1.2-0.6c0.2-0.3,0.5-0.7,0.3-0.9c-0.1-0.1-0.3-0.1-0.5,0
            c-0.1,0-0.2,0.2-0.5,0.4C420,417.8,419.7,418.3,419.9,418.5L419.9,418.5z"
                />
                <polygon
                  class="st38"
                  points="411.5,419.7 411.5,419.7 410.4,419.3 411,418.3 412.5,418.9 413.5,419.8 409.2,424.2 408.1,423.2
            "
                />
                <path
                  class="st38"
                  d="M411.9,426.8l1-1l-1.5-1.5l0.7-0.7l4.1-1.3l1,1l-2.5,2.6l0.4,0.4l-0.8,0.8l-0.4-0.4l-1,1L411.9,426.8z
            M413.7,425l0.7-0.8c0.2-0.2,0.5-0.4,0.7-0.6l0,0c-0.3,0.1-0.6,0.2-0.9,0.3l-1.2,0.4l0,0L413.7,425z"
                />
                <polygon
                  class="st38"
                  points="404.1,427.3 404.1,427.3 403,426.9 403.6,425.9 405.2,426.4 406.1,427.3 401.8,431.7 400.7,430.7
            "
                />
                <path
                  class="st38"
                  d="M403.1,433l0.7-0.7l1-0.1c1.3-0.2,2.2-0.3,2.7-0.8c0.3-0.3,0.3-0.7,0-1s-0.6-0.4-0.9-0.4l0.6-1
            c0.4,0.1,0.9,0.4,1.3,0.7c1.1,1,0.7,2,0.1,2.7c-0.8,0.8-1.9,0.9-2.9,1h-0.5l0,0l1.3,1.3l-0.9,0.9L403.1,433z"
                />
                <polygon
                  class="st38"
                  points="396.7,434.9 396.7,434.8 395.6,434.5 396.2,433.5 397.8,434 398.7,434.9 394.4,439.3 393.3,438.3
            "
                />
                <path
                  class="st38"
                  d="M397,441.9c-1.1-1.1-0.2-2.6,0.8-3.6c1.1-1.2,2.6-1.9,3.6-0.9c1.2,1.1,0,2.6-0.8,3.5
            C399,442.6,397.7,442.7,397,441.9L397,441.9z M397.9,441.1c0.2,0.2,0.6-0.1,1.6-1.1c0.9-0.9,1.3-1.4,1.1-1.6c-0.2-0.2-0.7,0-1.7,1
            S397.6,440.8,397.9,441.1L397.9,441.1z"
                />
                <path
                  class="st38"
                  d="M392.1,444.1c0.6,0.6,0.8,1.6,0.1,2.3c-0.2,0.3-0.7,0.6-1.5,0.4l0,0c0.2,0.6,0.1,1.3-0.4,1.8
            c-0.9,0.9-2,0.7-2.7,0c-0.8-0.7-1-1.8-0.2-2.6c0.5-0.5,1.2-0.6,1.8-0.5l0,0c-0.1-0.6,0.1-1.1,0.4-1.5
            C390.3,443.3,391.4,443.4,392.1,444.1L392.1,444.1z M388.3,447.9c0.3,0.3,0.7,0.1,0.9-0.2c0.4-0.4,0.4-0.9,0.3-1.2
            c-0.3,0-0.6,0.1-1,0.4C388.2,447.2,388.1,447.7,388.3,447.9L388.3,447.9z M391.4,444.8c-0.2-0.2-0.6-0.1-0.8,0.2
            c-0.2,0.3-0.3,0.6-0.2,1c0.2,0.1,0.6-0.1,0.8-0.3C391.5,445.4,391.7,445,391.4,444.8L391.4,444.8z"
                />
                <path
                  class="st38"
                  d="M382.8,455c-0.1-0.1-0.2-0.3-0.4-0.4c-0.6-0.5-1.2-0.5-1.9-0.1l0,0c0.3,0,0.7,0.1,0.9,0.4
            c0.5,0.7,0.3,1.6-0.6,2.3c-0.8,0.7-2.1,1-2.9-0.1c-0.8-0.9-0.5-2.2,0.7-3.2c1.1-0.9,2.1-1.1,3-1c0.6,0.1,1.2,0.4,1.6,0.7
            c0.3,0.2,0.4,0.4,0.5,0.5L382.8,455z M378.8,456.5c0.3,0.3,0.8-0.1,1.2-0.4c0.3-0.2,0.6-0.6,0.4-0.9c-0.1-0.1-0.3-0.2-0.5-0.1
            c-0.1,0-0.3,0.1-0.5,0.3C378.9,455.8,378.6,456.3,378.8,456.5L378.8,456.5z"
                />
                <path
                  class="st38"
                  d="M92.9,336.1c0.3-0.1,0.6-0.3,0.8-0.5c0.4-0.4,0.4-0.9,0.1-1.2c-0.5-0.4-1-0.2-1.4,0.2l-0.1,0.1l-0.8-0.7
            l0.1-0.1c0.3-0.3,0.6-0.8,0.2-1.2c-0.3-0.3-0.6-0.2-0.9,0.1c-0.2,0.2-0.3,0.4-0.4,0.7l-0.9-0.6c0.1-0.3,0.3-0.8,0.7-1.2
            c0.8-0.8,1.7-0.7,2.3-0.2c0.4,0.4,0.6,1,0.4,1.6l0,0c0.6-0.3,1.3-0.2,1.8,0.3c0.7,0.6,0.8,1.8-0.2,2.9c-0.4,0.4-0.8,0.6-1.1,0.7
            L92.9,336.1z"
                />
                <path
                  class="st38"
                  d="M80.9,317.9c0.3-0.1,0.6-0.3,0.8-0.5c0.4-0.4,0.4-0.9,0.1-1.2c-0.5-0.4-1-0.2-1.4,0.2l-0.1,0.1l-0.8-0.7
            l0.1-0.1c0.3-0.3,0.6-0.8,0.2-1.2c-0.3-0.3-0.6-0.2-0.9,0.1c-0.2,0.2-0.3,0.4-0.4,0.7l-0.9-0.6c0.1-0.3,0.3-0.8,0.7-1.2
            c0.8-0.8,1.7-0.7,2.3-0.2c0.4,0.4,0.6,1,0.4,1.6l0,0c0.6-0.3,1.3-0.2,1.8,0.3c0.7,0.6,0.8,1.9-0.2,2.9c-0.4,0.4-0.8,0.6-1.1,0.7
            L80.9,317.9z"
                />
                <path
                  class="st38"
                  d="M96.6,332.6c0.2-0.2,0.3-0.3,0.4-0.5s0.2-0.4,0.2-0.7c0-0.3-0.1-0.7-0.4-1.1l0,0c0,0.3-0.1,0.6-0.3,0.8
            c-0.6,0.6-1.6,0.6-2.4-0.2c-0.7-0.7-1.1-2-0.2-2.9c0.8-0.8,2-0.6,3.1,0.5c1.1,1,1.4,2.1,1.4,2.9c0,0.5-0.2,1.1-0.6,1.6
            c-0.1,0.2-0.3,0.3-0.4,0.4L96.6,332.6z M94.6,328.8c-0.2,0.2,0,0.6,0.4,1c0.3,0.3,0.8,0.6,1,0.3c0.1-0.1,0.1-0.3,0.1-0.4
            c-0.1-0.1-0.2-0.2-0.5-0.6C95.2,328.8,94.8,328.6,94.6,328.8L94.6,328.8z"
                />
                <path
                  class="st38"
                  d="M100.5,343.4c0.3-0.1,0.6-0.3,0.8-0.5c0.4-0.4,0.4-0.9,0.1-1.2c-0.5-0.4-1-0.2-1.4,0.2l-0.1,0.1l-0.8-0.7
            l0.1-0.1c0.3-0.3,0.6-0.8,0.2-1.2c-0.3-0.3-0.6-0.2-0.9,0.1c-0.2,0.2-0.3,0.4-0.4,0.7l-0.9-0.6c0.1-0.3,0.3-0.8,0.7-1.2
            c0.8-0.8,1.7-0.7,2.3-0.2c0.4,0.4,0.6,1,0.4,1.6l0,0c0.6-0.3,1.3-0.2,1.8,0.3c0.7,0.6,0.8,1.8-0.2,2.9c-0.4,0.4-0.8,0.6-1.1,0.7
            L100.5,343.4z"
                />
                <polygon
                  class="st38"
                  points="102.8,334.2 103.5,334.8 105.8,339.8 104.9,340.9 102.7,336.1 102.6,336.1 101.2,337.6 100.3,336.7
            "
                />
                <path
                  class="st38"
                  d="M108.2,350.9c0.3-0.1,0.6-0.3,0.8-0.5c0.4-0.4,0.4-0.9,0.1-1.2c-0.5-0.4-1-0.2-1.4,0.2l-0.1,0.1l-0.8-0.7
            l0.1-0.1c0.3-0.3,0.6-0.8,0.2-1.2c-0.3-0.3-0.6-0.2-0.9,0.1c-0.2,0.2-0.3,0.4-0.4,0.7l-0.9-0.6c0.1-0.3,0.3-0.8,0.7-1.2
            c0.8-0.8,1.7-0.7,2.3-0.2c0.4,0.4,0.6,1,0.4,1.6l0,0c0.6-0.3,1.3-0.2,1.8,0.3c0.7,0.6,0.8,1.8-0.2,2.9c-0.4,0.4-0.8,0.6-1.1,0.7
            L108.2,350.9z"
                />
                <path
                  class="st38"
                  d="M111.2,342.8l-1.1,1.2l0.6,0.7l0.1-0.1c0.2-0.2,0.6-0.5,1.1-0.5s1,0.2,1.4,0.6c0.9,0.8,1,2.1,0,3.2
            c-0.3,0.3-0.8,0.6-1,0.7l-0.7-1c0.3-0.1,0.5-0.3,0.8-0.5c0.4-0.4,0.4-0.9,0-1.3c-0.6-0.5-1.2-0.2-1.6,0.2c-0.1,0.1-0.2,0.2-0.3,0.3
            l-2.1-2.5l1.9-1.9L111.2,342.8z"
                />
                <path
                  class="st38"
                  d="M73.3,305.6l-1.1,1.2l0.6,0.7l0.1-0.1c0.2-0.2,0.6-0.5,1.1-0.5s1,0.2,1.4,0.6c0.9,0.8,1,2.1,0,3.2
            c-0.3,0.3-0.8,0.6-1,0.7l-0.7-1c0.3-0.1,0.5-0.3,0.8-0.5c0.4-0.4,0.4-0.9,0-1.3c-0.6-0.5-1.2-0.2-1.6,0.2c-0.1,0.1-0.2,0.2-0.3,0.3
            l-2.1-2.5l1.9-1.9L73.3,305.6z"
                />
                <path
                  class="st38"
                  d="M115.7,358.1c0.3-0.1,0.6-0.3,0.8-0.5c0.4-0.4,0.4-0.9,0.1-1.2c-0.5-0.4-1-0.2-1.4,0.2l-0.1,0.1l-0.8-0.7
            l0.1-0.1c0.3-0.3,0.6-0.8,0.2-1.2c-0.3-0.3-0.6-0.2-0.9,0.1c-0.2,0.2-0.3,0.4-0.4,0.7l-0.9-0.6c0.1-0.3,0.3-0.8,0.7-1.2
            c0.8-0.8,1.7-0.7,2.3-0.2c0.4,0.4,0.6,1,0.4,1.6l0,0c0.6-0.3,1.3-0.2,1.8,0.3c0.7,0.6,0.8,1.9-0.2,2.9c-0.4,0.4-0.8,0.6-1.1,0.7
            L115.7,358.1z"
                />
                <path
                  class="st38"
                  d="M118.9,354.8c0.3-0.1,0.6-0.3,0.8-0.5c0.4-0.4,0.4-0.9,0.1-1.2c-0.5-0.4-1-0.2-1.4,0.2l-0.1,0.1l-0.8-0.7
            l0.1-0.1c0.3-0.3,0.6-0.8,0.2-1.2c-0.3-0.3-0.6-0.2-0.9,0.1c-0.2,0.2-0.3,0.4-0.4,0.7l-0.9-0.6c0.1-0.3,0.3-0.8,0.7-1.2
            c0.8-0.8,1.7-0.7,2.3-0.2c0.4,0.4,0.6,1,0.4,1.6l0,0c0.6-0.3,1.3-0.2,1.8,0.3c0.7,0.6,0.8,1.8-0.2,2.9c-0.4,0.4-0.8,0.6-1.1,0.7
            L118.9,354.8z"
                />
                <path
                  class="st38"
                  d="M123.4,365.6c0.3-0.1,0.6-0.3,0.8-0.5c0.4-0.4,0.4-0.9,0.1-1.2c-0.5-0.4-1-0.2-1.4,0.2l-0.1,0.1l-0.8-0.7
            l0.1-0.1c0.3-0.3,0.6-0.8,0.2-1.2c-0.3-0.3-0.6-0.2-0.9,0.1c-0.2,0.2-0.3,0.4-0.4,0.7l-0.9-0.6c0.1-0.3,0.3-0.8,0.7-1.2
            c0.8-0.8,1.7-0.7,2.3-0.2c0.4,0.4,0.6,1,0.4,1.6l0,0c0.6-0.3,1.3-0.2,1.8,0.3c0.7,0.6,0.8,1.8-0.2,2.9c-0.4,0.4-0.8,0.6-1.1,0.7
            L123.4,365.6z"
                />
                <polygon
                  class="st38"
                  points="125,358.9 125,358.9 124.6,360.1 123.7,359.4 124.2,357.9 125.1,356.9 129.5,361.2 128.5,362.3 	"
                />
                <polygon
                  class="st38"
                  points="86.8,322.3 86.8,322.3 86.4,323.4 85.4,322.8 85.9,321.2 86.9,320.3 91.3,324.6 90.3,325.6 	"
                />
                <path
                  class="st38"
                  d="M131.8,374.1l-0.7-0.7l-0.1-1c-0.2-1.3-0.3-2.2-0.8-2.7c-0.3-0.3-0.7-0.3-1.1,0c-0.3,0.3-0.4,0.6-0.4,0.9
            l-1-0.6c0.1-0.4,0.4-0.9,0.7-1.3c1-1.1,2-0.7,2.7-0.1c0.8,0.8,0.9,1.9,1,2.9v0.5l0,0l1.3-1.3l0.9,0.9L131.8,374.1z"
                />
                <path
                  class="st38"
                  d="M134.6,369.6c0.2-0.2,0.3-0.3,0.4-0.5c0.1-0.2,0.2-0.4,0.2-0.7c0-0.3-0.1-0.7-0.4-1.1l0,0
            c0,0.3-0.1,0.6-0.3,0.8c-0.6,0.6-1.6,0.6-2.4-0.2c-0.7-0.7-1.1-2-0.2-2.9c0.8-0.9,2-0.6,3.1,0.5c1.1,1,1.4,2.1,1.4,2.9
            c0,0.5-0.2,1.1-0.6,1.6c-0.1,0.2-0.3,0.3-0.4,0.4L134.6,369.6z M132.7,365.8c-0.2,0.2,0,0.6,0.4,1c0.3,0.3,0.8,0.6,1,0.3
            c0.1-0.1,0.1-0.3,0.1-0.4c-0.1-0.1-0.2-0.2-0.5-0.6C133.3,365.7,132.9,365.6,132.7,365.8L132.7,365.8z"
                />
                <path
                  class="st38"
                  d="M139.4,381.4l-0.7-0.7l-0.1-1c-0.2-1.3-0.3-2.2-0.8-2.7c-0.3-0.3-0.7-0.3-1,0s-0.4,0.6-0.4,0.9l-1-0.6
            c0.1-0.4,0.3-0.9,0.7-1.3c1-1.1,2-0.7,2.7-0.1c0.8,0.8,0.9,1.9,1,2.9v0.5l0,0l1.3-1.3l0.9,0.9L139.4,381.4z"
                />
                <polygon
                  class="st38"
                  points="140.8,371.1 141.5,371.8 143.9,376.8 142.9,377.8 140.7,373.1 140.7,373.1 139.3,374.5 138.3,373.6
            "
                />
                <path
                  class="st38"
                  d="M146.9,388.7l-0.7-0.7l-0.1-1c-0.2-1.3-0.3-2.2-0.8-2.7c-0.3-0.3-0.7-0.3-1,0s-0.4,0.6-0.4,0.9l-1-0.6
            c0.1-0.4,0.4-0.9,0.7-1.3c1-1.1,2-0.7,2.7-0.1c0.8,0.8,0.9,1.9,1,2.9v0.5l0,0l1.3-1.3l0.9,0.9L146.9,388.7z"
                />
                <path
                  class="st38"
                  d="M149,379.5l-1.1,1.2l0.6,0.7l0.1-0.1c0.2-0.2,0.6-0.5,1.1-0.5s1,0.2,1.4,0.6c0.9,0.8,1,2.1,0,3.2
            c-0.3,0.3-0.8,0.6-1,0.7l-0.7-1c0.3-0.1,0.5-0.3,0.8-0.5c0.4-0.4,0.4-0.9,0-1.3c-0.6-0.5-1.2-0.2-1.6,0.2c-0.1,0.1-0.2,0.2-0.3,0.3
            l-2.1-2.5l1.9-1.9L149,379.5z"
                />
                <polygon
                  class="st38"
                  points="167.4,406.6 167.4,406.6 167,407.7 166,407.1 166.5,405.6 167.5,404.6 171.9,408.9 170.9,410 	"
                />
                <path
                  class="st38"
                  d="M172.7,406.5c0.2-0.2,0.3-0.3,0.4-0.5c0.1-0.2,0.2-0.4,0.2-0.7c0-0.3-0.1-0.7-0.4-1.1l0,0
            c0,0.3-0.1,0.6-0.3,0.8c-0.6,0.6-1.6,0.6-2.4-0.2c-0.7-0.7-1.1-2-0.2-2.9c0.8-0.9,2-0.6,3.1,0.5c1.1,1,1.4,2.1,1.4,2.9
            c0,0.5-0.2,1.1-0.6,1.6c-0.1,0.2-0.3,0.3-0.4,0.4L172.7,406.5z M170.7,402.7c-0.2,0.2,0,0.6,0.4,1c0.3,0.3,0.8,0.6,1,0.4
            c0.1-0.1,0.1-0.3,0.1-0.4c-0.1-0.1-0.2-0.2-0.5-0.6C171.3,402.6,170.9,402.5,170.7,402.7L170.7,402.7z"
                />
                <polygon
                  class="st38"
                  points="190.2,428.3 190.1,428.3 189.8,429.4 188.8,428.8 189.3,427.2 190.2,426.3 194.6,430.6 193.6,431.6
            "
                />
                <path
                  class="st38"
                  d="M194.7,423.5l-1.1,1.2l0.6,0.7l0.1-0.1c0.2-0.2,0.6-0.5,1.1-0.5s1,0.2,1.4,0.6c0.9,0.8,1,2.1,0,3.2
            c-0.3,0.3-0.8,0.6-1,0.7l-0.7-1c0.3-0.1,0.5-0.3,0.8-0.5c0.4-0.4,0.4-0.9,0-1.3c-0.6-0.5-1.2-0.2-1.6,0.2c-0.1,0.1-0.2,0.2-0.3,0.3
            l-2.1-2.5l1.9-1.9L194.7,423.5z"
                />
                <polygon
                  class="st38"
                  points="198.4,434.9 198.3,434.9 198,436 197,435.4 197.5,433.8 198.4,432.9 202.8,437.2 201.8,438.2 	"
                />
                <polygon
                  class="st38"
                  points="201.6,431.5 201.6,431.5 201.3,432.6 200.3,432 200.8,430.5 201.7,429.5 206.1,433.8 205.1,434.9
            "
                />
                <path
                  class="st38"
                  d="M209.2,444.7c0.2-0.2,0.3-0.3,0.4-0.5c0.1-0.2,0.2-0.4,0.2-0.7c0-0.3-0.1-0.7-0.4-1.1l0,0
            c0,0.3-0.1,0.6-0.3,0.8c-0.6,0.6-1.6,0.6-2.4-0.2c-0.7-0.7-1.1-2-0.2-2.9c0.8-0.9,2-0.6,3.1,0.5c1.1,1,1.4,2.1,1.4,2.9
            c0,0.5-0.2,1.1-0.6,1.6c-0.1,0.2-0.3,0.3-0.4,0.4L209.2,444.7z M207.2,440.9c-0.2,0.2,0,0.6,0.4,1c0.3,0.3,0.8,0.6,1,0.3
            c0.1-0.1,0.1-0.3,0.1-0.4c-0.1-0.1-0.2-0.2-0.5-0.6C207.8,440.9,207.4,440.7,207.2,440.9L207.2,440.9z"
                />
                <polygon
                  class="st38"
                  points="216,446.9 216.7,447.6 219.1,452.6 218.1,453.6 215.9,448.9 215.9,448.9 214.5,450.3 213.5,449.4
            "
                />
                <path
                  class="st38"
                  d="M225.8,456.9l-1,1.2l0.6,0.6l0.1-0.1c0.2-0.2,0.6-0.5,1.1-0.6s1,0.1,1.4,0.5c0.9,0.8,1.2,2,0.3,3.2
            c-0.3,0.4-0.7,0.7-1,0.8l-0.8-0.9c0.2-0.1,0.5-0.3,0.7-0.6c0.4-0.5,0.3-0.9-0.1-1.3c-0.6-0.5-1.2-0.1-1.6,0.4
            c-0.1,0.1-0.2,0.2-0.3,0.3l-2.3-2.3l1.7-2.1L225.8,456.9z"
                />
                <path
                  class="st38"
                  d="M237.3,469.6c0.3-0.1,0.5-0.4,0.7-0.7c0.3-0.5,0.2-0.9-0.1-1.2c-0.5-0.3-1,0-1.3,0.5l-0.1,0.1l-0.9-0.6
            l0.1-0.1c0.2-0.4,0.4-0.9,0-1.2c-0.3-0.2-0.7-0.1-0.9,0.2c-0.1,0.2-0.2,0.5-0.2,0.8l-1-0.5c0-0.3,0.2-0.8,0.5-1.3
            c0.6-1,1.6-1.1,2.2-0.6c0.5,0.3,0.7,0.9,0.7,1.5l0,0c0.5-0.4,1.2-0.5,1.9,0c0.8,0.5,1.2,1.7,0.4,2.9c-0.3,0.5-0.6,0.8-0.9,0.9
            L237.3,469.6z"
                />
                <polygon
                  class="st38"
                  points="245.4,473.4 245.4,473.4 245.4,474.6 244.3,474.3 244.3,472.7 244.9,471.5 250.4,474.2 249.8,475.5
            "
                />
                <path
                  class="st38"
                  d="M368.1,464.5l1.1-0.8l-1.2-1.8l0.8-0.6l4.3-0.5l0.8,1.2l-3,2l0.3,0.5l-1,0.7l-0.3-0.5l-1.1,0.8L368.1,464.5z
            M370.2,463l0.9-0.6c0.2-0.2,0.5-0.3,0.8-0.5l0,0c-0.3,0.1-0.6,0.1-0.9,0.2l-1.2,0.1l0,0L370.2,463z"
                />
                <path
                  class="st38"
                  d="M355.3,469.6l0.9-0.5l1,0.2c1.3,0.2,2.2,0.4,2.9,0c0.4-0.2,0.5-0.6,0.3-1c-0.2-0.3-0.5-0.5-0.7-0.7l0.9-0.8
            c0.3,0.2,0.7,0.6,1,1.1c0.7,1.3,0.1,2.2-0.7,2.6c-1,0.6-2.1,0.3-3.1,0.1l-0.5-0.1l0,0l0.9,1.6l-1.1,0.6L355.3,469.6z"
                />
                <polygon
                  class="st6"
                  points="146.1,393.6 160,407.1 172.6,394.2 158.7,380.8 	"
                />
                <path
                  class="st14"
                  d="M160,407.4l-14.2-13.8l12.9-13.1l0.1,0.1l14,13.6l-0.1,0.1L160,407.4z M146.3,393.6l13.7,13.3l12.3-12.6
            l-13.6-13.2L146.3,393.6z"
                />
                <path
                  class="st38"
                  d="M158.4,399.3l-0.7-0.7l-0.1-1c-0.2-1.3-0.3-2.2-0.8-2.7c-0.3-0.3-0.7-0.3-1,0s-0.4,0.6-0.4,0.9l-1-0.6
            c0.1-0.4,0.3-0.9,0.7-1.3c1-1.1,2-0.7,2.7-0.1c0.8,0.8,0.9,1.9,1,2.9v0.5l0,0l1.3-1.3l0.9,0.9L158.4,399.3z"
                />
                <path
                  class="st38"
                  d="M160.8,394.9c0.3-0.1,0.6-0.3,0.8-0.5c0.4-0.4,0.4-0.9,0.1-1.2c-0.5-0.4-1-0.2-1.4,0.2l-0.1,0.1l-0.8-0.7
            l0.1-0.1c0.3-0.3,0.6-0.8,0.2-1.2c-0.3-0.3-0.6-0.2-0.9,0.1c-0.2,0.2-0.3,0.4-0.4,0.7l-0.9-0.6c0.1-0.3,0.3-0.8,0.7-1.2
            c0.8-0.8,1.7-0.7,2.3-0.2c0.4,0.4,0.6,1,0.4,1.6l0,0c0.6-0.3,1.3-0.2,1.8,0.3c0.7,0.6,0.8,1.8-0.2,2.9c-0.4,0.4-0.8,0.6-1.1,0.7
            L160.8,394.9z"
                />
                <path
                  class="st38"
                  d="M485.1,352.5l-0.7-0.7l-0.1-1c-0.2-1.3-0.3-2.2-0.8-2.7c-0.3-0.3-0.7-0.3-1,0s-0.4,0.6-0.4,0.9l-1-0.6
            c0.1-0.4,0.4-0.9,0.7-1.3c1-1.1,2-0.7,2.7-0.1c0.8,0.8,0.9,1.9,1,2.9v0.5l0,0l1.3-1.3l0.9,0.9L485.1,352.5z"
                />
                <path
                  class="st38"
                  d="M492,338.8c-0.1,0.1-0.2,0.3-0.3,0.5c-0.4,0.7-0.2,1.3,0.2,1.9l0,0c-0.1-0.3,0-0.7,0.2-1
            c0.5-0.6,1.5-0.6,2.4,0.2c0.8,0.7,1.3,1.9,0.5,2.9c-0.8,0.9-2,0.9-3.2-0.1c-1.1-0.9-1.5-1.9-1.5-2.7c0-0.6,0.1-1.2,0.4-1.7
            c0.2-0.3,0.3-0.5,0.4-0.6L492,338.8z M494.2,342.4c0.3-0.3-0.2-0.7-0.6-1.1c-0.3-0.2-0.7-0.5-1-0.2c-0.1,0.1-0.1,0.3,0,0.5
            c0,0.1,0.2,0.2,0.4,0.4C493.5,342.5,494,342.7,494.2,342.4L494.2,342.4z"
                />
                <polygon
                  class="st38"
                  points="489,350 488.4,350.3 484.6,342.9 485.1,342.6 	"
                />
                <path
                  class="st20"
                  d="M347.9,462.4l-6.3-15.4c-25.5,12.2-52.6,12.6-78.3,0.6l-6,15.8l-8.6,21.6c16.7,7,34.3,12.4,53.5,12.4
            c20.1,0,35.5-4.1,55.1-12.2L347.9,462.4z"
                />
                <path
                  class="st31"
                  d="M237.1,448.1c0.3-0.4,0.7-0.4,1-0.2c0.6,0.4,0.9,1.3,1.3,2.5l0.3,1l0.8,0.6l2-2.9l-1.1-0.7l-1,1.5l0,0
            l-0.1-0.5c-0.2-1-0.5-2-1.5-2.7c-0.7-0.5-1.8-0.7-2.6,0.6c-0.3,0.5-0.5,1-0.5,1.4l1.1,0.4C236.8,448.7,236.9,448.4,237.1,448.1"
                />
                <path
                  class="st31"
                  d="M240.6,446.4c1.2,0.8,2.8,1.4,3.6,0.2l0,0c0.6-0.8,0.2-2.1-1.6-3.3c-1-0.7-2.7-1.6-3.6-0.2
            C238.3,444.1,239.3,445.5,240.6,446.4 M240.1,443.7c0.2-0.3,0.7,0,1.8,0.7c1.1,0.8,1.5,1.1,1.4,1.4l0,0c-0.2,0.3-0.7,0.1-1.8-0.7
            C240.2,444.4,239.9,443.9,240.1,443.7"
                />
                <path
                  class="st31"
                  d="M243.7,441.9c0.4-0.5,0.9-1,1.5-0.5c0.4,0.3,0.5,0.8,0.2,1.3c-0.2,0.3-0.4,0.5-0.7,0.6l0.8,0.8
            c0.2-0.1,0.6-0.5,0.9-0.9c0.8-1.2,0.4-2.4-0.5-3.1c-0.5-0.3-1-0.5-1.5-0.4s-0.9,0.5-1,0.7l-0.1,0.1l-0.7-0.6l0.9-1.3l-1-0.7
            l-1.5,2.2l2.5,2.1C243.6,442.2,243.6,442,243.7,441.9"
                />
                <path
                  class="st31"
                  d="M255,457l-0.8,1.6l0,0l-0.2-0.5c-0.3-0.9-0.8-1.9-1.8-2.5c-0.8-0.4-1.8-0.4-2.5,0.9c-0.3,0.5-0.3,1.1-0.3,1.4
            l1.1,0.3c0-0.3,0-0.6,0.2-1s0.6-0.5,1-0.3c0.7,0.3,1.1,1.2,1.6,2.3l0.4,0.9l0.9,0.4l1.6-3.1L255,457z"
                />
                <path
                  class="st31"
                  d="M257.6,454.9c-0.7,1.3-2.4,0.9-3.6,0.3c-1.5-0.7-2.6-1.9-2-3.1c0.7-1.4,2.5-0.8,3.6-0.3
            C257.6,452.7,258.1,453.9,257.6,454.9L257.6,454.9z M256.5,454.3c0.1-0.3-0.3-0.6-1.5-1.2c-1.1-0.6-1.7-0.8-1.9-0.5
            c-0.1,0.3,0.2,0.6,1.5,1.3C255.8,454.5,256.3,454.6,256.5,454.3L256.5,454.3z"
                />
                <path
                  class="st31"
                  d="M257.7,451.6c0.3-0.2,0.5-0.4,0.6-0.7c0.3-0.5,0.1-0.9-0.3-1.1c-0.6-0.3-1,0.1-1.3,0.6l-0.1,0.2l-0.9-0.5
            l0.1-0.1c0.2-0.4,0.3-1-0.1-1.2c-0.3-0.2-0.7,0-0.8,0.3c-0.1,0.2-0.2,0.5-0.2,0.8l-1.1-0.3c0-0.3,0.1-0.9,0.3-1.3
            c0.5-1,1.4-1.2,2.1-0.9c0.5,0.3,0.8,0.8,0.8,1.4l0,0c0.5-0.4,1.2-0.6,1.8-0.2c0.8,0.4,1.3,1.5,0.7,2.8c-0.2,0.5-0.6,0.8-0.8,1
            L257.7,451.6z"
                />
                <path
                  class="st31"
                  d="M281.2,471.8c0.4-0.1,1-0.1,1.9-0.1s1.5,0.2,1.9,0.5s0.7,0.8,0.7,1.4s-0.2,1.1-0.6,1.5
            c-0.5,0.4-1.2,0.7-2,0.7c-0.2,0-0.4,0-0.5,0v2.2h-1.4V471.8z M282.6,474.6c0.1,0,0.3,0,0.5,0c0.8,0,1.2-0.4,1.2-1s-0.4-0.9-1.1-0.9
            c-0.3,0-0.5,0-0.6,0V474.6z"
                />
                <path
                  class="st31"
                  d="M286.6,471.8c0.5-0.1,1.1-0.1,1.9-0.1c0.9,0,1.6,0.1,2,0.5c0.4,0.3,0.6,0.7,0.6,1.3c0,0.8-0.6,1.3-1.1,1.5
            l0,0c0.4,0.2,0.7,0.6,0.8,1.2c0.2,0.7,0.4,1.5,0.5,1.8h-1.4c-0.1-0.2-0.2-0.7-0.4-1.5c-0.2-0.8-0.4-1-1-1H288v2.4h-1.4V471.8z
            M288,474.5h0.6c0.7,0,1.1-0.3,1.1-0.9s-0.4-0.9-1-0.9c-0.3,0-0.5,0-0.6,0v1.8H288z"
                />
                <polygon
                  class="st31"
                  points="295.8,475.3 293.5,475.3 293.5,476.8 296.1,476.8 296.1,477.9 292.1,477.9 292.1,471.7 295.9,471.7
            295.9,472.9 293.5,472.9 293.5,474.2 295.8,474.2 	"
                />
                <path
                  class="st31"
                  d="M297.1,476.5c0.4,0.2,1,0.4,1.6,0.4s1-0.3,1-0.7c0-0.4-0.3-0.6-1-0.9c-1-0.4-1.7-0.9-1.7-1.9
            c0-1.1,0.9-1.9,2.4-1.9c0.7,0,1.2,0.1,1.6,0.3l-0.3,1.1c-0.2-0.1-0.7-0.3-1.3-0.3c-0.6,0-0.9,0.3-0.9,0.6c0,0.4,0.3,0.6,1.2,0.9
            c1.1,0.4,1.6,1,1.6,1.9c0,1-0.8,1.9-2.5,1.9c-0.7,0-1.4-0.2-1.8-0.4L297.1,476.5z"
                />
                <path
                  class="st31"
                  d="M302.1,476.5c0.4,0.2,1,0.4,1.6,0.4s1-0.3,1-0.7c0-0.4-0.3-0.6-1-0.9c-1-0.4-1.7-0.9-1.7-1.9
            c0-1.1,0.9-1.9,2.4-1.9c0.7,0,1.2,0.1,1.6,0.3l-0.3,1.1c-0.2-0.1-0.7-0.3-1.3-0.3c-0.6,0-0.9,0.3-0.9,0.6c0,0.4,0.3,0.6,1.2,0.9
            c1.1,0.4,1.6,1,1.6,1.9c0,1-0.8,1.9-2.5,1.9c-0.7,0-1.4-0.2-1.8-0.4L302.1,476.5z"
                />
                <path
                  class="st31"
                  d="M308.9,471.8c0.4-0.1,1.1-0.1,1.8-0.1c0.9,0,1.4,0.1,1.8,0.3c0.4,0.2,0.7,0.7,0.7,1.2s-0.3,1.1-1,1.3l0,0
            c0.7,0.2,1.2,0.7,1.2,1.5c0,0.6-0.3,1-0.6,1.3c-0.5,0.4-1.2,0.6-2.5,0.6c-0.7,0-1.2,0-1.5-0.1v-6L308.9,471.8L308.9,471.8z
            M310.3,474.2h0.5c0.8,0,1.1-0.3,1.1-0.8s-0.4-0.7-1-0.7c-0.3,0-0.5,0-0.6,0V474.2z M310.3,476.9c0.1,0,0.3,0,0.5,0
            c0.6,0,1.2-0.2,1.2-0.9c0-0.6-0.6-0.9-1.3-0.9h-0.5L310.3,476.9L310.3,476.9z"
                />
                <path
                  class="st31"
                  d="M317.2,478c-1.8,0-2.9-1.4-2.9-3.2c0-1.9,1.2-3.3,3-3.3c1.9,0,3,1.4,3,3.1C320.2,476.8,319,478,317.2,478
            L317.2,478z M317.2,476.9c1,0,1.5-0.9,1.5-2.1c0-1.1-0.5-2.1-1.5-2.1s-1.5,0.9-1.5,2.1S316.3,476.9,317.2,476.9L317.2,476.9z"
                />
                <path
                  class="st31"
                  d="M324.1,477.9l-0.6-1.1c-0.2-0.4-0.4-0.8-0.6-1.1l0,0c-0.1,0.4-0.3,0.7-0.5,1.1l-0.5,1.1h-1.6l1.8-3.2
            l-1.7-3.1h1.6l0.5,1.1c0.2,0.4,0.3,0.7,0.5,1l0,0c0.1-0.4,0.3-0.7,0.4-1l0.5-1.1h1.6l-1.8,3l1.9,3.2h-1.5L324.1,477.9L324.1,477.9z
            "
                />
                <path
                  class="st31"
                  d="M362.3,440.5l-1-1.5l0,0l0.5,0.1c1,0.2,2.1,0.3,3-0.4c0.7-0.5,1.3-1.4,0.4-2.6c-0.3-0.5-0.8-0.8-1.1-1
            l-0.8,0.8c0.3,0.1,0.6,0.3,0.8,0.6c0.3,0.4,0.2,0.8-0.2,1c-0.6,0.4-1.5,0.4-2.8,0.3l-1-0.1l-0.8,0.6l2,2.9L362.3,440.5z"
                />
                <path
                  class="st31"
                  d="M362.9,443.8c0.6,0.9,1.9,1,3.7-0.2c1-0.7,2.4-1.9,1.5-3.3c-0.8-1.1-2.4-0.7-3.7,0.2
            C363.3,441.2,362.1,442.5,362.9,443.8L362.9,443.8z M365.3,441.6c1.2-0.8,1.7-0.9,1.8-0.7c0.2,0.3-0.3,0.7-1.4,1.4
            c-1.1,0.8-1.6,1-1.8,0.7l0,0C363.8,442.8,364.1,442.4,365.3,441.6"
                />
                <path
                  class="st31"
                  d="M368.5,448c1-0.6,1.3-1.5,0.8-2.2c-0.2-0.3-0.5-0.5-0.9-0.5l0,0c0.7-0.3,1.3-0.2,1.9,0.3
            c0.1,0.1,0.3,0.3,0.4,0.4l1-0.7c-0.1-0.1-0.2-0.3-0.4-0.5c-0.4-0.4-0.9-0.7-1.5-0.8c-0.8-0.2-1.9-0.1-3,0.7c-1.3,0.9-1.7,2.1-1,3.1
            C366.3,448.7,367.6,448.5,368.5,448 M367.1,446c0.3-0.2,0.5-0.3,0.5-0.3c0.2,0,0.4,0,0.5,0.1c0.2,0.3-0.2,0.7-0.4,0.9
            c-0.5,0.3-1,0.7-1.2,0.3l0,0C366.3,446.8,366.6,446.4,367.1,446"
                />
                <path
                  class="st31"
                  d="M344.8,447.1l0.9-0.4l1,0.2c1.3,0.3,2.1,0.5,2.8,0.2c0.4-0.2,0.5-0.6,0.3-1c-0.2-0.3-0.4-0.6-0.7-0.7l0.9-0.7
            c0.3,0.2,0.7,0.6,1,1.1c0.6,1.3,0,2.1-0.8,2.5c-1,0.5-2.1,0.2-3-0.1l-0.5-0.2l0,0l0.8,1.6l-1.2,0.6L344.8,447.1z"
                />
                <path
                  class="st31"
                  d="M347.6,453c-0.6-1.4,0.7-2.4,2-3c1.5-0.7,3.1-0.9,3.7,0.4c0.7,1.5-0.9,2.5-2,3C349.3,454.3,348,454,347.6,453
            L347.6,453z M348.7,452.5c0.1,0.3,0.6,0.1,1.9-0.5c1.1-0.5,1.7-0.9,1.6-1.2c-0.1-0.3-0.7-0.2-1.9,0.4
            C348.9,451.9,348.6,452.2,348.7,452.5L348.7,452.5z"
                />
                <path
                  class="st31"
                  d="M349.7,457.3l1.2-0.6l-0.9-1.9l0.9-0.4l4.3,0.2l0.6,1.3l-3.3,1.5l0.2,0.5l-1,0.5l-0.3-0.5l-1.2,0.6
            L349.7,457.3z M352,456.2l0.9-0.5c0.3-0.1,0.6-0.2,0.9-0.3l0,0c-0.3,0-0.6,0-1,0h-1.2l0,0L352,456.2z"
                />
                <line class="st46" x1="70.2" y1="268.6" x2="57.8" y2="281.3" />
                <polygon
                  class="st6"
                  points="57.6,282.6 56.4,281.4 70.5,267.2 71.7,268.4 	"
                />
                <polygon
                  class="st47"
                  points="256.4,465.8 254.8,465.3 262,446.9 263.5,447.5 	"
                />
                <polygon
                  class="st47"
                  points="350.2,464.4 348.7,465 341.1,446.8 342.6,446.2 	"
                />
                <polygon
                  class="st6"
                  points="548.4,271.2 547.2,272.3 533.3,257.9 534.5,256.8 	"
                />
                <polygon
                  class="st38"
                  points="179.4,417.6 179.4,417.6 179.1,418.7 178.1,418.1 178.6,416.6 179.5,415.6 183.9,419.9 182.9,421
            "
                />
                <polygon
                  class="st38"
                  points="183.3,411.7 184,412.4 186.4,417.4 185.4,418.4 183.2,413.7 183.2,413.7 181.8,415.1 180.8,414.2
            "
                />
                <path
                  class="st6"
                  d="M336.4,470.2c0.1,0.3,5.5,18.4,5.7,18.8c4.2-1.4,8.7-2.9,12.8-4.8c-0.1-0.3-7-17.8-7.1-18.2
            C344,467.6,340,469.1,336.4,470.2"
                />
                <path
                  class="st48"
                  d="M336.4,470.2c0.1,0.3,5.5,18.4,5.7,18.8c4.2-1.4,8.7-2.9,12.8-4.8c-0.1-0.3-7-17.8-7.1-18.2
            C344,467.6,340,469.1,336.4,470.2"
                />
                <path
                  class="st38"
                  d="M87.8,328l-1-1l-1.6,1.6l-0.7-0.7l-1.4-4.2l1-1.1l2.7,2.6l0.4-0.4l0.9,0.8l-0.4,0.4l1,1L87.8,328z
            M85.9,326.2l-0.8-0.8c-0.2-0.2-0.4-0.5-0.6-0.7l0,0c0.1,0.3,0.2,0.6,0.4,0.9l0.4,1.2l0,0L85.9,326.2z"
                />
                <path
                  class="st38"
                  d="M79.8,320.7l-1-1l-1.6,1.6l-0.7-0.7l-1.4-4.2l1-1.1l2.7,2.6l0.4-0.4l0.9,0.8l-0.4,0.4l1,1L79.8,320.7z
            M77.9,318.9l-0.8-0.8c-0.2-0.2-0.4-0.5-0.6-0.7l0,0c0.1,0.3,0.2,0.6,0.4,0.9l0.4,1.2l0,0L77.9,318.9z"
                />
                <path
                  class="st38"
                  d="M72.6,313.3l-1-1l-1.6,1.6l-0.7-0.7l-1.4-4.2l1-1.1l2.7,2.6l0.4-0.4l0.9,0.8l-0.4,0.4l1,1L72.6,313.3z
            M70.7,311.4l-0.8-0.8c-0.2-0.2-0.4-0.5-0.6-0.7l0,0c0.1,0.3,0.2,0.6,0.4,0.9l0.4,1.2l0,0L70.7,311.4z"
                />
                <path
                  class="st40"
                  d="M562.6,261.8c2.4,2.4,2.5,6.3,0.1,8.7c-2.4,2.4-6.3,2.5-8.7,0.1s-2.5-6.3-0.1-8.7
            C556.2,259.5,560.1,259.4,562.6,261.8z"
                />
                <path
                  class="st39"
                  d="M562.6,261.8c2.4,2.4,2.5,6.3,0.1,8.7c-2.4,2.4-6.3,2.5-8.7,0.1s-2.5-6.3-0.1-8.7
            C556.2,259.5,560.1,259.4,562.6,261.8"
                />
                <path
                  class="st31"
                  d="M558.2,272.5c-1.6,0-3.2-0.6-4.4-1.8c-2.5-2.4-2.6-6.4-0.1-8.9c2.4-2.5,6.5-2.5,9-0.1l0,0
            c2.5,2.4,2.6,6.4,0.1,8.9C561.5,271.9,559.9,272.5,558.2,272.5 M558.2,260.2c-1.6,0-3.1,0.6-4.3,1.8c-2.3,2.4-2.3,6.2,0.1,8.5
            c2.4,2.3,6.2,2.3,8.5-0.1s2.3-6.2-0.1-8.5l0,0C561.3,260.8,559.8,260.2,558.2,260.2"
                />
                <path
                  class="st41"
                  d="M558,267.8L558,267.8l1.9-1.9h0.1l2.7,1h0.1l0.6-1.4v-0.1l-0.5-0.1h-0.1l-0.3,0.8c0,0-0.1,0.1-0.1,0l-2.5-0.9
            h-0.1L558,267h-0.1l-0.3-0.2v-0.1l1.3-1.3v-0.1l-0.4-0.4h-0.1l-1.3,1.3H557l-1.6-1.3h-0.1l-0.4,0.3v0.1L558,267.8z"
                />
                <path
                  class="st41"
                  d="M555.2,263.5c0.4,0.4,0.4,0.9,0,1.3s-0.9,0.4-1.3,0c-0.4-0.4-0.4-0.9,0-1.3
            C554.2,263.2,554.8,263.2,555.2,263.5"
                />
                <path
                  class="st41"
                  d="M561.5,266.8l-0.5,0.1c0,0-0.1,0,0,0.1l0.1,0.1l0,0c0.4,0.9,0.3,1.7-0.4,2.5c-0.4,0.4-0.9,0.7-1.6,0.7
            c-0.6,0-1.1-0.2-1.6-0.6c-0.7-0.6-0.9-1.4-0.6-2.3v-0.1c0,0,0-0.1-0.1-0.1l-0.4-0.3h-0.1v0.1v0.1c-0.4,1.1-0.1,2.1,0.7,2.9
            c0.6,0.5,1.2,0.8,2,0.8s1.4-0.3,2-0.8c0.4-0.4,0.7-0.9,0.8-1.5C561.9,267.9,561.8,267.3,561.5,266.8
            C561.6,266.8,561.5,266.8,561.5,266.8"
                />
                <path
                  class="st39"
                  d="M49.3,270.8c2.4,2.4,2.5,6.3,0.1,8.7c-2.4,2.4-6.3,2.5-8.7,0.1s-2.5-6.3-0.1-8.7
            C42.9,268.5,46.9,268.4,49.3,270.8"
                />
                <path
                  class="st31"
                  d="M45,281.5c-1.7,0-3.2-0.6-4.4-1.8c-2.5-2.4-2.6-6.4-0.1-8.9c1.2-1.2,2.8-1.9,4.5-1.9h0.1
            c1.7,0,3.2,0.6,4.4,1.8c1.2,1.2,1.9,2.8,1.9,4.4c0,1.7-0.6,3.3-1.8,4.5C48.4,280.8,46.8,281.5,45,281.5L45,281.5 M45,269.2
            L45,269.2c-1.7,0-3.2,0.7-4.3,1.8c-2.3,2.4-2.3,6.2,0.1,8.5c1.1,1.1,2.6,1.7,4.2,1.7h0.1c1.6,0,3.1-0.7,4.2-1.8
            c1.1-1.1,1.7-2.7,1.7-4.3c0-1.6-0.7-3.1-1.8-4.2C48.1,269.8,46.6,269.2,45,269.2"
                />
                <path
                  class="st40"
                  d="M49.3,270.8c2.4,2.4,2.5,6.3,0.1,8.7c-2.4,2.4-6.3,2.5-8.7,0.1s-2.5-6.3-0.1-8.7
            C42.9,268.5,46.9,268.4,49.3,270.8z"
                />
                <path
                  class="st41"
                  d="M44.8,276.8L44.8,276.8l1.9-1.9h0.1l2.7,1h0.1l0.6-1.4v-0.1l-0.5-0.2h-0.1l-0.3,0.8c0,0-0.1,0.1-0.1,0
            l-2.5-0.9h-0.1l-1.8,1.8h-0.1l-0.3-0.2v-0.1l1.3-1.3v-0.1l-0.4-0.4h-0.1l-1.3,1.4h-0.1l-1.6-1.3h-0.1l-0.4,0.3v0.1L44.8,276.8z"
                />
                <path
                  class="st41"
                  d="M41.9,272.5c0.4,0.4,0.4,0.9,0,1.3s-0.9,0.4-1.3,0c-0.4-0.4-0.4-0.9,0-1.3C41,272.1,41.6,272.1,41.9,272.5"
                />
                <path
                  class="st41"
                  d="M48.2,275.8l-0.5,0.1c0,0-0.1,0,0,0.1l0.1,0.1l0,0c0.4,0.9,0.3,1.7-0.4,2.5c-0.4,0.4-0.9,0.7-1.6,0.7
            c-0.6,0-1.1-0.2-1.6-0.6c-0.7-0.6-0.9-1.4-0.6-2.3v-0.1v-0.1l-0.4-0.3h-0.1v0.1v0.1c-0.4,1.1-0.1,2.1,0.7,2.9
            c0.6,0.5,1.2,0.8,2,0.8s1.4-0.3,2-0.8c0.4-0.4,0.7-0.9,0.8-1.5C48.6,276.9,48.5,276.3,48.2,275.8C48.3,275.8,48.3,275.7,48.2,275.8
            "
                />
                <path
                  class="st14"
                  d="M534.9,311.5l-0.1-0.1l-13-12.6l0.1-0.1l14.5-15l0.1,0.1l13,12.6l-0.1,0.1L534.9,311.5z M522.2,298.8
            l12.7,12.2l14.2-14.6l-12.7-12.2L522.2,298.8z"
                />
                <text
                  transform="matrix(0.7512 0.6607 -0.6627 0.7489 221.2947 29.9996)"
                  class="st14 st15 st49"
                >
                  Centerfield
                </text>
                <text
                  transform="matrix(0.7512 0.6607 -0.6627 0.7489 220.8651 39.1573)"
                  class="st14 st15 st49"
                >
                  DEC
                </text>
                <text
                  transform="matrix(0.7512 0.6607 -0.6627 0.7489 227.1751 44.7071)"
                  class="st14 st15 st49"
                >
                  K
                </text>
                <text
                  transform="matrix(-0.2103 -0.9748 0.9778 -0.2096 149.5251 227.2298)"
                  class="st14 st15 st50"
                >
                  SEMINOLE HARD ROCK TAMPA
                </text>
                <text
                  transform="matrix(-0.2103 -0.9748 0.9778 -0.2096 150.3534 207.7485)"
                  class="st14 st15 st50"
                >
                  162 LANDING
                </text>
                <polygon
                  class="st6"
                  points="417.4,272.5 460.7,314.5 461.8,313.3 418.5,271.4 	"
                />
                <text
                  transform="matrix(0.7082 -0.706 0.7082 0.706 348.4246 37.8428)"
                  class="st51 st15 st52"
                >
                  R
                </text>
                <text
                  transform="matrix(0.7082 -0.706 0.7082 0.706 350.4075 35.8662)"
                  class="st51 st15 st52"
                >
                  A
                </text>
                <text
                  transform="matrix(0.7082 -0.706 0.7082 0.706 352.2488 34.0303)"
                  class="st51 st15 st52"
                >
                  YS
                </text>
                <text
                  transform="matrix(0.7082 -0.706 0.7082 0.706 351.4619 42.9258)"
                  class="st51 st15 st52"
                >
                  TOUCH
                </text>
                <text
                  transform="matrix(0.7082 -0.706 0.7082 0.706 351.4824 51.0137)"
                  class="st51 st15 st52"
                >
                  EXPERIENCE
                </text>
                <path
                  class="st51"
                  d="M72.4,146.3c-0.5-0.2-1.2-0.2-1.4,0.4c-0.2,0.7,0.3,1.2,2,1.8c1.6,0.6,2.6,0.8,2.9,0c0.1-0.3,0-1-0.7-1.2
            c-0.3-0.1-0.4-0.1-0.7-0.2c-0.1,0.4-0.2,0.5-0.3,0.9c-0.4-0.1-0.6-0.2-1-0.3c0.3-0.9,0.5-1.3,0.8-2.2c1.4,0.5,2.1,0.8,3.5,1.3
            c-0.1,0.4-0.2,0.6-0.4,1c-0.2-0.1-0.4-0.1-0.6-0.2l0,0c0.4,0.5,0.5,1,0.2,1.7c-0.6,1.7-1.9,1.6-4.2,0.8c-2.2-0.8-3.2-1.7-2.5-3.5
            c0.5-1.5,1.5-1.9,2.9-1.4C72.7,145.6,72.6,145.8,72.4,146.3"
                />
                <path
                  class="st51"
                  d="M72.9,139.3c0.4,0.2,0.6,0.3,1.1,0.4c-0.2,0.6-0.4,0.9-0.6,1.5c2.2,0.8,3.3,1.3,5.4,2.1
            c-0.2,0.5-0.3,0.8-0.5,1.3c-2.2-0.8-3.3-1.2-5.5-2.1c-0.2,0.6-0.3,0.9-0.6,1.5l-1.1-0.4C71.9,142,72.2,141.1,72.9,139.3"
                />
                <path
                  class="st51"
                  d="M74.7,135c0.4,0.2,0.6,0.3,1.1,0.5c-0.4,1-0.6,1.4-1,2.4c0.6,0.2,0.9,0.4,1.5,0.6c0.4-0.9,0.6-1.3,0.9-2.2
            c0.4,0.2,0.6,0.3,1.1,0.4c-0.4,0.9-0.6,1.3-0.9,2.2c0.7,0.3,1,0.4,1.7,0.7c0.4-1,0.6-1.5,1-2.4c0.4,0.2,0.6,0.3,1.1,0.5
            c-0.6,1.5-0.9,2.2-1.6,3.7c-2.6-1-3.9-1.6-6.5-2.6C73.7,137.2,74.1,136.5,74.7,135"
                />
                <path
                  class="st51"
                  d="M76,131.9c0.7-1.5,1-2.2,1.7-3.7c0.4,0.2,0.6,0.3,1,0.5c-0.4,0.9-0.7,1.4-1.1,2.4c0.6,0.3,0.9,0.4,1.5,0.7
            c0.4-0.9,0.6-1.3,1-2.2c0.4,0.2,0.6,0.3,1,0.5c-0.4,0.9-0.6,1.3-1,2.2c1.1,0.5,1.7,0.7,2.8,1.2c-0.2,0.5-0.4,0.8-0.6,1.3
            C79.8,133.6,78.6,133.1,76,131.9"
                />
                <path
                  class="st51"
                  d="M84.3,130.5c-2.5-1.2-3.8-1.8-6.3-3c0.3-0.5,0.4-0.8,0.6-1.3c2.5,1.2,3.8,1.8,6.3,3
            C84.7,129.8,84.6,130,84.3,130.5"
                />
                <path
                  class="st51"
                  d="M79.9,123.7c2,0.2,3,0.3,5.1,0.6l0,0c-1.7-0.9-2.6-1.3-4.3-2.2c0.2-0.5,0.4-0.7,0.6-1.2
            c2.5,1.3,3.7,1.9,6.2,3.2c-0.3,0.6-0.4,0.9-0.7,1.4c-2.1-0.3-3.1-0.4-5.2-0.6l0,0c1.8,0.9,2.6,1.3,4.4,2.2
            c-0.2,0.5-0.3,0.7-0.6,1.2c-2.5-1.2-3.8-1.8-6.3-3C79.4,124.6,79.6,124.3,79.9,123.7"
                />
                <path
                  class="st51"
                  d="M82.4,118.8c0.3-0.6,0.5-1,0.9-1.6c2.8,0.6,4.2,1,7.1,1.7c-0.3,0.5-0.4,0.8-0.7,1.3c-0.6-0.2-0.9-0.2-1.5-0.4
            c-0.4,0.7-0.5,1-0.9,1.7c0.5,0.4,0.7,0.6,1.2,1c-0.3,0.5-0.4,0.8-0.7,1.3C85.6,121.7,84.5,120.7,82.4,118.8 M86.4,120.6
            c0.3-0.5,0.4-0.7,0.7-1.2c-1.2-0.4-1.9-0.5-3.1-0.9l0,0C84.9,119.4,85.4,119.8,86.4,120.6"
                />
                <path
                  class="st51"
                  d="M85.3,113.5c2,0.3,3,0.5,5,0.8l0,0c-1.7-1-2.5-1.4-4.2-2.4c0.3-0.5,0.4-0.7,0.7-1.2c2.4,1.4,3.6,2.1,6,3.5
            c-0.3,0.6-0.5,0.8-0.8,1.4c-2-0.4-3.1-0.5-5.1-0.9l0,0c1.7,1,2.6,1.4,4.3,2.4c-0.3,0.5-0.4,0.7-0.6,1.1c-2.4-1.4-3.7-2-6.1-3.4
            C84.8,114.4,85,114.1,85.3,113.5"
                />
                <path
                  class="st51"
                  d="M91,108.5c-0.9-0.5-1.4-0.6-1.7,0c-0.4,0.6,0.1,1.1,1.8,2.2c1.8,1.1,2.3,1,2.6,0.5c0.3-0.4,0.2-0.9-1-1.7
            c0.3-0.5,0.5-0.7,0.8-1.2c1.3,0.8,2.2,1.8,1.2,3.4c-1.1,1.8-2.5,1.3-4.4,0.2c-1.8-1.1-3-2.1-1.9-4c1.1-1.8,2.4-1.1,3.3-0.6
            C91.4,107.7,91.3,108,91,108.5"
                />
                <path
                  class="st51"
                  d="M96.2,108.9c-2.4-1.5-3.6-2.2-5.9-3.7c0.3-0.5,0.5-0.7,0.8-1.2c2.4,1.5,3.5,2.2,5.9,3.7
            C96.6,108.2,96.5,108.4,96.2,108.9"
                />
                <path
                  class="st51"
                  d="M92.4,101.8c0.4-0.6,0.6-0.9,1-1.5c2.8,0.9,4.1,1.4,6.9,2.3c-0.3,0.5-0.5,0.7-0.8,1.2
            c-0.6-0.2-0.8-0.3-1.4-0.5c-0.4,0.6-0.6,0.9-1,1.6c0.4,0.4,0.6,0.6,1.1,1.1c-0.3,0.5-0.5,0.7-0.8,1.2
            C95.3,105.1,94.3,104,92.4,101.8 M96.2,104c0.3-0.5,0.5-0.7,0.8-1.2c-1.2-0.5-1.8-0.7-3-1.1l0,0C94.8,102.7,95.3,103.1,96.2,104"
                />
                <path
                  class="st51"
                  d="M100.6,102.2c-2.3-1.6-3.5-2.4-5.8-3.9c0.3-0.5,0.5-0.7,0.8-1.2c1.9,1.3,2.9,2,4.8,3.3
            c0.6-0.8,0.9-1.2,1.5-2.1c0.4,0.3,0.6,0.4,0.9,0.7C101.9,100.3,101.4,100.9,100.6,102.2"
                />
                <path
                  class="st51"
                  d="M98.9,92.4c0.6-0.8,0.9-1.2,1.5-2.1c0.9-1.2,2-1,2.9-0.3c1.2,0.9,1.1,2,0.3,3.1c-0.2,0.2-0.3,0.4-0.5,0.6
            c0.9,0.7,1.3,1,2.2,1.7c-0.3,0.5-0.5,0.7-0.8,1.1C102.3,94.9,101.2,94.1,98.9,92.4 M102.3,93.1c0.2-0.2,0.2-0.3,0.4-0.5
            c0.3-0.5,0.3-1-0.3-1.4c-0.5-0.4-1-0.4-1.5,0.2c-0.1,0.2-0.2,0.3-0.4,0.5C101.3,92.4,101.7,92.6,102.3,93.1"
                />
                <path
                  class="st51"
                  d="M102.6,87.5c0.4-0.6,0.7-0.9,1.1-1.4c2.7,1.1,4,1.7,6.7,2.9c-0.4,0.5-0.6,0.7-0.9,1.2
            c-0.5-0.3-0.8-0.4-1.4-0.7c-0.5,0.6-0.7,0.9-1.2,1.5c0.4,0.5,0.6,0.7,1,1.2c-0.4,0.5-0.5,0.7-0.9,1.2
            C105.3,91,104.4,89.8,102.6,87.5 M106.2,90c0.3-0.4,0.5-0.7,0.9-1.1c-1.2-0.6-1.7-0.8-2.9-1.4l0,0C105,88.5,105.4,89,106.2,90"
                />
                <path
                  class="st51"
                  d="M105.3,84.2c0.7-0.8,1-1.3,1.7-2.1c0.8-0.9,1.7-1.1,2.6-0.3c0.7,0.6,0.9,1.3,0.5,2l0,0
            c0.7-0.7,1.2-0.4,2.4,0.5c0.6,0.5,0.9,0.7,1.2,0.6l0,0c-0.4,0.5-0.6,0.7-1,1.2c-0.2,0-0.5-0.2-0.7-0.3c-0.4-0.3-0.6-0.5-1.1-0.8
            c-0.4-0.3-0.9-0.4-1.2,0.1c-0.2,0.2-0.3,0.4-0.5,0.6c0.9,0.7,1.4,1.1,2.3,1.9c-0.4,0.4-0.5,0.7-0.9,1.1
            C108.6,86.8,107.5,85.9,105.3,84.2 M108.6,85c0.2-0.2,0.2-0.3,0.4-0.5c0.4-0.5,0.5-1-0.1-1.5c-0.5-0.4-1-0.3-1.4,0.2
            c-0.2,0.2-0.3,0.3-0.4,0.5C107.6,84.2,108,84.5,108.6,85"
                />
                <path
                  class="st51"
                  d="M111.6,76.7c0.3,0.3,0.5,0.5,0.9,0.8c-0.4,0.5-0.6,0.7-1.1,1.2c1.8,1.5,2.6,2.3,4.4,3.8
            c-0.4,0.4-0.6,0.6-0.9,1.1c-1.8-1.5-2.7-2.3-4.4-3.8c-0.4,0.5-0.6,0.7-1,1.2c-0.4-0.3-0.5-0.4-0.9-0.7
            C109.8,78.8,110.4,78.1,111.6,76.7"
                />
                <path
                  class="st51"
                  d="M112.8,75.4c1.1,0.4,1.6,0.7,2.6,1.1l0,0c-0.5-1-0.8-1.5-1.3-2.6c0.4-0.5,0.6-0.7,1.1-1.2
            c0.7,1.7,1.1,2.6,1.8,4.2c0.8,0.7,1.2,1.1,2,1.9c-0.4,0.4-0.6,0.6-1,1.1c-0.8-0.7-1.2-1.1-2-1.8c-1.8-0.6-2.6-0.9-4.4-1.4
            C112.2,76.1,112.4,75.9,112.8,75.4"
                />
                <path
                  class="st51"
                  d="M117.4,70.5c0.7-0.7,1-1,1.7-1.7c1.4-1.5,2.7-0.8,4.1,0.7c1.7,1.8,2.1,2.9,0.8,4.3c-0.6,0.6-0.9,1-1.6,1.6
            C120.4,73.4,119.4,72.4,117.4,70.5 M122.7,73.6c0.2-0.2,0.3-0.3,0.4-0.5c0.7-0.7,0.4-1.3-0.9-2.6c-1.1-1.1-1.8-1.6-2.6-0.8
            c-0.2,0.2-0.3,0.3-0.4,0.4C120.6,71.5,121.3,72.2,122.7,73.6"
                />
                <path
                  class="st51"
                  d="M124.4,63.5c0.3,0.3,0.5,0.5,0.8,0.8c-0.8,0.7-1.1,1.1-1.9,1.8c0.5,0.5,0.7,0.7,1.1,1.2c0.7-0.7,1-1,1.8-1.7
            c0.3,0.3,0.5,0.5,0.8,0.8c-0.7,0.7-1.1,1-1.7,1.7c0.5,0.5,0.8,0.8,1.3,1.3c0.8-0.7,1.1-1.1,1.9-1.8c0.3,0.3,0.5,0.5,0.8,0.8
            c-1.2,1.1-1.8,1.7-2.9,2.8c-2-2-2.9-3-4.9-5C122.6,65.2,123.2,64.7,124.4,63.5"
                />
                <path
                  class="st51"
                  d="M128.9,62.6c-0.7-0.7-1.1-0.9-1.6-0.5c-0.5,0.5-0.2,1.1,1.2,2.6c1.4,1.5,1.9,1.6,2.4,1.2
            c0.4-0.4,0.5-0.8-0.5-1.9c0.4-0.4,0.6-0.6,1.1-1c1,1.1,1.6,2.3,0.2,3.6c-1.6,1.4-2.8,0.5-4.3-1s-2.3-2.8-0.7-4.3
            c1.6-1.4,2.7-0.4,3.4,0.3C129.6,62,129.4,62.2,128.9,62.6"
                />
                <path
                  class="st51"
                  d="M130.2,58.3c0.7,0.8,1.1,1.3,1.9,2.1l0,0c-0.2-1.3-0.3-2-0.4-3.3c0.5-0.4,0.7-0.6,1.2-1
            c0.2,1.4,0.3,2.1,0.4,3.6c1.7,0.6,2.6,1,4.3,1.6c-0.5,0.4-0.7,0.6-1.2,1c-1.2-0.5-1.8-0.7-3-1.2c0,0.4,0.1,0.6,0.1,0.9
            c0.5,0.6,0.8,0.9,1.4,1.6c-0.4,0.4-0.6,0.6-1.1,0.9c-1.9-2.1-2.8-3.1-4.7-5.2C129.6,58.8,129.8,58.6,130.2,58.3"
                />
                <text
                  transform="matrix(0.7025 -0.7116 0.7138 0.7003 132.7059 102.2137)"
                  class="st31 st15 st53"
                >
                  LEFT FIELD LEDGE
                </text>
                <!-- <text
                  transform="matrix(0.7025 -0.7116 0.7138 0.7003 121.0863 101.2761)"
                  class="st31 st15 st53"
                >
                  LOUISIANA HOT SAUCE
                </text> -->
                <path
                  class="st40"
                  d="M452.6,287.9c2.4,2.4,2.5,6.3,0.1,8.7c-2.4,2.4-6.3,2.5-8.7,0.1c-2.4-2.4-2.5-6.3-0.1-8.7
            C446.2,285.6,450.2,285.6,452.6,287.9z"
                />
                <path
                  class="st39"
                  d="M452.6,287.9c2.4,2.4,2.5,6.3,0.1,8.7c-2.4,2.4-6.3,2.5-8.7,0.1c-2.4-2.4-2.5-6.3-0.1-8.7
            C446.2,285.6,450.2,285.6,452.6,287.9"
                />
                <path
                  class="st31"
                  d="M448.3,298.7c-1.6,0-3.2-0.6-4.4-1.8c-2.5-2.4-2.6-6.4-0.1-8.9c2.4-2.5,6.5-2.5,9-0.1l0,0
            c2.5,2.4,2.6,6.4,0.1,8.9C451.6,298,449.9,298.7,448.3,298.7 M448.3,286.4c-1.6,0-3.1,0.6-4.3,1.8c-2.3,2.4-2.3,6.2,0.1,8.5
            s6.2,2.3,8.5-0.1s2.3-6.2-0.1-8.5C451.3,286.9,449.8,286.4,448.3,286.4"
                />
                <path
                  class="st41"
                  d="M448.1,293.9h0.1l1.8-1.9h0.1l2.7,1h0.1l0.6-1.4v-0.1l-0.5-0.1h-0.1l-0.3,0.8c0,0-0.1,0.1-0.1,0l-2.5-0.9
            h-0.1l-1.8,1.8H448l-0.3-0.2v-0.1l1.3-1.3v-0.1l-0.4-0.4h-0.1l-1.3,1.3h-0.1l-1.6-1.3h-0.1l-0.4,0.3v0.1L448.1,293.9z"
                />
                <path
                  class="st41"
                  d="M445.2,289.7c0.4,0.4,0.4,0.9,0,1.3s-0.9,0.4-1.3,0s-0.4-0.9,0-1.3C444.3,289.3,444.9,289.3,445.2,289.7"
                />
                <path
                  class="st41"
                  d="M451.5,292.9L451,293c0,0-0.1,0,0,0.1l0.1,0.1l0,0c0.4,0.9,0.3,1.7-0.4,2.5c-0.4,0.4-0.9,0.7-1.6,0.7
            c-0.6,0-1.1-0.2-1.6-0.6c-0.7-0.6-0.9-1.4-0.6-2.3v-0.1c0,0,0-0.1-0.1-0.1l-0.4-0.3h-0.1v0.1v0.1c-0.4,1.1-0.1,2.1,0.7,2.9
            c0.6,0.5,1.2,0.8,2,0.8s1.4-0.3,2-0.8c0.4-0.4,0.7-0.9,0.8-1.5C451.9,294,451.9,293.5,451.5,292.9
            C451.6,293,451.6,292.9,451.5,292.9"
                />
                <path
                  class="st29"
                  d="M409.1,253.7l-8.8,9l-4.1-9c0,0,13.1-5.2,13.2-5.1C409.6,248.7,409.1,253.7,409.1,253.7"
                />
                <path
                  class="st54"
                  d="M461.1,157.3l-7.1-7.2l-13.8,27.7c0,0,3.6,5.6,2.7,20.1c0,0-2,7.4-3.2,9.6c-2.5,4.4-12.9,15.3-12.9,15.3
            l15.1,14.6l26.9-29.4c0,0,4.5-11.9-5.3-52.2L461.1,157.3z"
                />
                <path
                  class="st55"
                  d="M441.9,237.9l-15.6-15.1l0.2-0.2c0.1-0.1,10.5-10.9,12.9-15.2c1.2-2.1,3.1-9.4,3.2-9.5
            c0.9-14.1-2.6-19.8-2.7-19.9l-0.1-0.2l0.1-0.2l14-28.1l7.2,7.3l2.6-1.6l0.1,0.4c9.7,40,5.5,51.9,5.3,52.4l-0.1,0.1L441.9,237.9z
            M427.2,222.7l14.7,14.2l26.7-29.1c0.3-0.9,3.9-13.5-5.3-51.5l-2.3,1.4l-7-7l-13.5,27.1c0.6,1,3.5,6.9,2.7,20.1
            c-0.1,0.4-2,7.5-3.2,9.7C437.7,211.7,428.8,221.1,427.2,222.7"
                />
                <text
                  transform="matrix(-0.2435 0.9671 -0.9701 -0.2427 459.1822 183.7341)"
                  class="st56 st15 st57"
                >
                  P
                </text>
                <text
                  transform="matrix(-0.2435 0.9671 -0.9701 -0.2427 458.6088 186.0192)"
                  class="st56 st15 st57"
                >
                  A
                </text>
                <text
                  transform="matrix(-0.2435 0.9671 -0.9701 -0.2427 457.9211 188.7508)"
                  class="st56 st15 st57"
                >
                  P
                </text>
                <text
                  transform="matrix(-0.2435 0.9671 -0.9701 -0.2427 457.3439 191.035)"
                  class="st56 st15 st57"
                >
                  A JOHN’S
                </text>
                <text
                  transform="matrix(-0.2435 0.9671 -0.9701 -0.2427 453.433 181.586)"
                  class="st56 st15 st57"
                >
                  BULLPEN BOX
                </text>
                <path
                  class="st28"
                  d="M239.7,426.1c5,3,10.4,5.7,16,8c0.1-0.4,7.4-19.1,7.5-19.3c-0.2-0.2-4.2-4.3-4.2-4.3s2.3-6,2.5-6.4
            c-0.3-0.1-5.9-2.5-6.2-2.7C255.1,401.7,239.9,425.7,239.7,426.1"
                />
                <path
                  class="st25"
                  d="M255.8,434.3l-0.2-0.1c-5.6-2.3-11-5-16-8l-0.2-0.1l0.1-0.2c0.1-0.2,4.1-6.4,8-12.6c3.8-6,7.5-11.9,7.6-12
            l0.1-0.1l0.1,0.1c0.3,0.1,5.8,2.5,6.2,2.7l0.2,0.1l-2.5,6.4c0.6,0.6,4,4,4.1,4.2l0.1,0.1v0.1c-0.1,0.2-3.3,8.6-5.5,14.1
            c-1.1,2.9-1.9,5-2,5.2L255.8,434.3z M240,426c4.9,3,10.2,5.6,15.6,7.8c0.2-0.6,1-2.5,1.9-5c2-5.2,5-13,5.4-14
            c-0.6-0.6-4.1-4.2-4.1-4.2l-0.1-0.1l2.5-6.3c-0.9-0.4-5-2.2-5.9-2.5c-0.6,0.9-4,6.4-7.5,11.9C244.2,419.2,240.6,425,240,426"
                />
                <path
                  class="st28"
                  d="M261.5,410c0.2,0.2,4.2,4.2,4.2,4.2s-7.8,20.3-8,20.6c5.4,2.1,10.9,3.8,16.6,5.1c0.1-0.4,5.4-30,5.5-30.4
            c-5.6-1.1-11.1-2.7-16.4-4.7C263.3,405.2,261.5,409.8,261.5,410"
                />
                <path
                  class="st25"
                  d="M274.5,440.2h-0.2c-5.7-1.3-11.3-3-16.7-5.1l-0.2-0.1l0.1-0.2c0.1-0.4,7.3-18.9,7.9-20.5
            c-0.6-0.6-4-4-4.1-4.2l-0.1-0.1v-0.1c0.1-0.2,1.9-4.8,2-5.1l0.1-0.2l0.2,0.1c5.3,2,10.8,3.5,16.4,4.6h0.2v0.2c0,0.2-1.5,8.5-3,16.3
            c-1.3,7.1-2.5,13.8-2.5,14L274.5,440.2z M257.9,434.8c5.2,2,10.7,3.7,16.3,5c0.2-1.2,1.3-7.4,2.5-13.8c1.3-7.3,2.7-14.9,2.9-16.2
            c-5.5-1.1-10.9-2.6-16.1-4.6c-0.3,0.8-1.6,4.1-1.9,4.8c0.6,0.6,4.1,4.2,4.1,4.2l0.1,0.1v0.1C265.8,414.3,258.7,432.8,257.9,434.8"
                />
                <path
                  class="st28"
                  d="M290.7,442.4c4,0.3,8.2,0.5,12.3,0.4c0-0.4-0.3-23.1-0.3-23.1l-2.8-6c0,0,0-1.8,0-2.1c-2.4,0-5-0.1-7.5-0.3
            C292.3,411.6,290.7,442.1,290.7,442.4"
                />
                <path
                  class="st25"
                  d="M300.4,443c-3.3,0-6.5-0.1-9.8-0.4h-0.2v-0.2c0-0.2,0.6-10.9,1-19.7c0.3-6.1,0.6-11.4,0.6-11.5V411h0.2
            c2.6,0.2,5.1,0.3,7.5,0.3h0.2v0.2c0,0.3,0,1.8,0,2.1c0.7,1.5,2.3,5.1,2.7,5.9h0.1v0.3c0,0,0.3,22.7,0.3,23.1v0.2h-0.2
            C302.1,443,301.3,443,300.4,443 M290.9,442.3c3.9,0.3,8,0.4,11.9,0.4c0-2.2-0.3-22.9-0.3-22.9l0,0c-0.2-0.3-0.5-1.1-1.4-2.9
            l-1.4-3.1c0,0,0-1.4,0-2c-2.3,0-4.7-0.1-7.2-0.3c-0.1,1-0.3,5.8-0.6,11.4C291.5,431,291,440.8,290.9,442.3"
                />
                <path
                  class="st28"
                  d="M302,411.5c0,0.3,0,1.7,0,1.7l2.8,6c0,0,0.3,23.1,0.3,23.5c8.3-0.3,16.5-1.5,24.4-3.6
            c-0.1-0.4-6.2-20.9-6.2-20.9l-4.1-6.2c0,0-0.4-1.9-0.5-2.2C313.2,410.9,307.6,411.4,302,411.5"
                />
                <path
                  class="st25"
                  d="M305,442.9v-0.2c0-0.4-0.3-22.4-0.3-23.5c-0.7-1.5-2.4-5.3-2.7-5.9h-0.1v-0.1c0,0,0-1.4,0-1.7v-0.2h0.2
            c5.6-0.1,11.2-0.7,16.7-1.7h0.2l0.5,2.4c1.3,2,3.7,5.6,4.1,6.1l0,0v0.1c0.1,0.2,6.1,20.5,6.2,20.9l0.1,0.2h-0.2
            c-8,2-16.2,3.2-24.5,3.6L305,442.9z M302.2,413.2c0.2,0.4,0.8,1.7,2.7,6v0.1c0,0.2,0.3,21.1,0.3,23.3c8.1-0.3,16.2-1.5,24-3.5
            c-0.6-2.1-6.1-20.5-6.2-20.7l0,0c-0.3-0.4-1.1-1.6-4.1-6.2v-0.1l-0.4-2.1c-5.4,1-10.9,1.5-16.4,1.6
            C302.2,412.2,302.2,413.2,302.2,413.2L302.2,413.2z"
                />
                <path
                  class="st28"
                  d="M320.8,409.5c0,0.2,0.4,1.8,0.4,1.8l4.1,6.2c0,0,6.2,20.8,6.3,21.2c4.8-1.3,9.5-2.9,14.1-4.8
            c-0.1-0.3-8.7-20.8-8.7-20.8s2.9-1.5,3.2-1.6c-0.1-0.3-2.7-6.5-2.9-6.8C332,406.7,326.5,408.3,320.8,409.5"
                />
                <path
                  class="st25"
                  d="M331.5,438.9l-0.1-0.2l-6.3-21.2c-1.3-2-3.7-5.6-4-6.1l0,0v-0.1c0,0-0.3-1.6-0.4-1.8v-0.2h0.2
            c5.6-1.1,11.2-2.7,16.5-4.8l0.2-0.1l0.1,0.2c0.1,0.3,2.7,6.5,2.9,6.8l0.1,0.2l-0.2,0.1c-0.2,0.1-2.4,1.2-3,1.5
            c0.8,1.9,8.5,20.3,8.6,20.6l0.1,0.2l-0.2,0.1c-4.6,1.9-9.3,3.5-14.1,4.8H331.5z M321.4,411.2c0.3,0.4,1.1,1.6,4.1,6.1l0,0l6.3,21.1
            c4.7-1.3,9.3-2.9,13.7-4.7c-0.8-2-8.6-20.6-8.6-20.6l-0.1-0.2l0.2-0.1c0,0,2.4-1.2,3-1.5c-0.4-0.9-2.3-5.5-2.7-6.5
            c-5.2,2-10.7,3.6-16.2,4.7C321.1,410.1,321.4,411.2,321.4,411.2L321.4,411.2z"
                />
                <path
                  class="st28"
                  d="M339.4,403.9c0.1,0.3,3.6,8.6,3.6,8.6s-2.9,1.5-3.2,1.6c0.1,0.3,7.7,18.5,7.9,18.9c4.7-2.1,9.3-4.5,13.7-7.1
            c-0.2-0.3-16.2-24.2-16.4-24.5C344.7,401.5,339.7,403.7,339.4,403.9"
                />
                <path
                  class="st25"
                  d="M347.6,433.2l-0.1-0.2c-0.1-0.1-1.3-3-2.7-6.5c-2.2-5.4-5.1-12.2-5.2-12.4l-0.1-0.2l0.1-0.1
            c0.3-0.1,2.4-1.2,3-1.5c-0.5-1.1-3.4-8.2-3.6-8.5l-0.1-0.2l1.7-0.8c1.6-0.7,3.9-1.7,4.1-1.8l0.1-0.1l0.1,0.1
            c0.1,0.2,16.2,24.2,16.4,24.5l0.1,0.2l-0.2,0.1c-4.4,2.7-9.1,5.1-13.8,7.1L347.6,433.2z M340.1,414.2c0.4,1.1,3,7.2,5.1,12.2
            c1.3,3.1,2.4,5.7,2.7,6.4c4.6-2,9.1-4.3,13.4-6.9c-1.4-2-15-22.4-16.2-24.2c-0.6,0.2-2.5,1.1-3.9,1.7l-1.4,0.6
            c0.5,1.2,3.6,8.5,3.6,8.5l0.1,0.2l-0.2,0.1C343.1,412.7,340.7,413.8,340.1,414.2"
                />
                <path
                  class="st28"
                  d="M276.4,440.4c4.1,0.8,8.2,1.5,12.1,1.9c0-0.4,1.6-30.9,1.6-31.2c-2.7-0.3-5.5-0.6-8.3-1.1
            C281.9,410.3,276.5,440,276.4,440.4"
                />
                <path
                  class="st25"
                  d="M288.7,442.5h-0.2c-4-0.4-8.1-1-12.2-1.9h-0.2v-0.2c0.1-0.4,5.5-30.2,5.5-30.4v-0.2h0.2
            c2.7,0.5,5.5,0.9,8.2,1.1h0.2v0.2c0,0.2-0.5,8.8-0.9,17c-0.4,7.2-0.7,14-0.7,14.2L288.7,442.5z M276.6,440.3
            c4,0.8,7.9,1.4,11.8,1.8c0.1-1.2,0.4-7.4,0.7-14c0.4-7.5,0.8-15.5,0.9-16.8c-2.6-0.3-5.3-0.6-7.9-1.1
            C281.6,412.5,277,437.9,276.6,440.3"
                />
                <path
                  class="st51"
                  d="M251.3,428.1l1.2,0.8l-0.6,1.4L246,426l0.8-1.8l7,1.7l-0.6,1.4l-1.4-0.4L251.3,428.1z M250.5,426.7l-1.3-0.4
            c-0.4-0.1-1.1-0.3-1.6-0.5l0,0c0.4,0.2,1.1,0.7,1.4,0.9l1.1,0.7L250.5,426.7z"
                />
                <path
                  class="st51"
                  d="M253.5,423.2l1.2,0.8l-0.6,1.4l-5.9-4.3l0.8-1.8l7,1.7l-0.6,1.4L254,422L253.5,423.2z M252.8,421.7l-1.3-0.4
            c-0.4-0.1-1.1-0.3-1.6-0.5l0,0c0.4,0.2,1.1,0.7,1.4,0.9l1.1,0.7L252.8,421.7z"
                />
                <path
                  class="st51"
                  d="M255.7,418.2l1.2,0.8l-0.6,1.4l-5.9-4.3l0.8-1.8l7,1.7l-0.6,1.4l-1.4-0.4L255.7,418.2z M255,416.8l-1.3-0.4
            c-0.4-0.1-1.1-0.3-1.6-0.5l0,0c0.4,0.2,1.1,0.7,1.4,0.9l1.1,0.7L255,416.8z"
                />
                <path
                  class="st51"
                  d="M263.5,435.2c0-0.5,0.2-1.1,0.3-1.7c0.2-0.6,0.4-1.3,1-1.7c0.4-0.3,1-0.3,1.4-0.2c0.6,0.2,1.1,0.6,1.2,1.4
            l0,0c0.5-0.7,1.2-0.9,1.9-0.7c0.6,0.2,1,0.5,1.2,0.9c0.3,0.5,0.4,1.3,0,2.6c-0.1,0.5-0.3,1-0.5,1.3L263.5,435.2z M266.6,434.4
            l0.1-0.2c0.1-0.4-0.2-0.8-0.7-0.9c-0.4-0.1-0.8,0-1,0.4c0,0.1-0.1,0.2-0.1,0.3L266.6,434.4z M269.5,435.2c0-0.1,0.1-0.2,0.1-0.2
            c0.1-0.4,0-0.9-0.6-1.1s-1,0.1-1.1,0.6l-0.1,0.3L269.5,435.2z"
                />
                <path
                  class="st51"
                  d="M265.1,429.5c0-0.5,0.2-1.1,0.3-1.7c0.2-0.6,0.4-1.3,1-1.7c0.4-0.3,1-0.3,1.4-0.2c0.6,0.2,1.1,0.6,1.2,1.4
            l0,0c0.5-0.7,1.2-0.9,1.9-0.7c0.6,0.2,1,0.5,1.2,0.9c0.3,0.5,0.4,1.3,0,2.6c-0.1,0.5-0.3,1-0.5,1.3L265.1,429.5z M268.2,428.7
            l0.1-0.3c0.1-0.4-0.2-0.8-0.7-0.9c-0.4-0.1-0.8,0-1,0.4c0,0.1-0.1,0.2-0.1,0.3L268.2,428.7z M271.2,429.6c0-0.1,0.1-0.2,0.1-0.2
            c0.1-0.4,0-0.9-0.6-1.1s-1,0.1-1.1,0.6l-0.1,0.3L271.2,429.6z"
                />
                <path
                  class="st51"
                  d="M266.8,423.8c0-0.5,0.2-1.1,0.3-1.7c0.2-0.6,0.4-1.3,1-1.7c0.4-0.3,1-0.3,1.4-0.2c0.6,0.2,1.1,0.6,1.2,1.4
            l0,0c0.5-0.7,1.2-0.9,1.9-0.7c0.6,0.2,1,0.5,1.2,0.9c0.3,0.5,0.4,1.3,0,2.6c-0.1,0.5-0.3,1-0.5,1.3L266.8,423.8z M269.9,423.1
            l0.1-0.3c0.1-0.4-0.2-0.8-0.7-0.9c-0.4-0.1-0.8,0-1,0.4c0,0.1-0.1,0.2-0.1,0.3L269.9,423.1z M272.8,423.9c0-0.1,0.1-0.2,0.1-0.2
            c0.1-0.4,0-0.9-0.6-1.1s-1,0.1-1.1,0.6l-0.1,0.3L272.8,423.9z"
                />
                <path
                  class="st51"
                  d="M286.2,437.3c0.1,0.2,0.1,0.6,0,1.1c-0.3,2-2.1,2.5-3.9,2.2c-2.6-0.4-3.4-2.1-3.2-3.6c0.1-0.5,0.2-0.8,0.3-1
            l1.3,0.5c-0.1,0.1-0.2,0.3-0.2,0.6c-0.1,0.8,0.4,1.5,2,1.8c1.5,0.2,2.2-0.2,2.3-1c0-0.2,0-0.5,0-0.6H286.2z"
                />
                <path
                  class="st51"
                  d="M286.9,432.8c0.1,0.2,0.1,0.6,0,1.1c-0.3,2-2.1,2.5-3.9,2.2c-2.6-0.4-3.4-2.1-3.2-3.6c0.1-0.5,0.2-0.8,0.3-1
            l1.3,0.5c-0.1,0.1-0.2,0.3-0.2,0.6c-0.1,0.8,0.4,1.5,2,1.8c1.5,0.2,2.2-0.2,2.3-1c0-0.2,0-0.5,0-0.6H286.9z"
                />
                <path
                  class="st51"
                  d="M287.7,428.4c0.1,0.2,0.1,0.6,0,1.1c-0.3,2-2.1,2.5-3.9,2.2c-2.6-0.4-3.4-2.1-3.2-3.6c0.1-0.5,0.2-0.8,0.3-1
            l1.3,0.5c-0.1,0.1-0.2,0.3-0.2,0.6c-0.1,0.8,0.4,1.5,2,1.8c1.5,0.2,2.2-0.2,2.3-1c0-0.2,0-0.5,0-0.6H287.7z"
                />
                <path
                  class="st51"
                  d="M293.6,440.6c-0.1-0.4-0.1-0.9-0.1-1.5c0-1,0.3-1.6,0.7-2.1c0.6-0.6,1.6-0.9,2.9-0.8c1.4,0,2.4,0.4,3,1.1
            c0.4,0.5,0.6,1.2,0.6,2.3c0,0.5-0.1,1-0.1,1.2L293.6,440.6z M299.4,439.1c0,0,0-0.1,0-0.2c0-0.6-0.6-1-2.4-1.1
            c-1.3,0-2.2,0.2-2.2,1c0,0.1,0,0.2,0,0.2L299.4,439.1z"
                />
                <path
                  class="st51"
                  d="M293.8,434.7c-0.1-0.4-0.1-0.9-0.1-1.5c0-1,0.3-1.6,0.7-2.1c0.6-0.6,1.6-0.9,2.9-0.8c1.4,0,2.4,0.4,3,1.1
            c0.4,0.5,0.6,1.2,0.6,2.3c0,0.5-0.1,1-0.1,1.2L293.8,434.7z M299.5,433.2c0,0,0-0.1,0-0.2c0-0.6-0.6-1-2.4-1.1
            c-1.3,0-2.2,0.2-2.2,1c0,0.1,0,0.2,0,0.2L299.5,433.2z"
                />
                <path
                  class="st51"
                  d="M293.9,428.8c-0.1-0.4-0.1-0.9-0.1-1.5c0-1,0.3-1.6,0.7-2.1c0.6-0.6,1.6-0.9,2.9-0.8c1.4,0,2.4,0.4,3,1.1
            c0.4,0.5,0.6,1.2,0.6,2.3c0,0.5-0.1,1-0.1,1.2L293.9,428.8z M299.7,427.3c0,0,0-0.1,0-0.2c0-0.6-0.6-1-2.4-1.1
            c-1.3,0-2.2,0.2-2.2,0.9c0,0.1,0,0.2,0,0.2L299.7,427.3z"
                />
                <polygon
                  class="st51"
                  points="316.7,436.1 316.9,437.7 318.5,437.4 318.2,435.7 319.6,435.5 320.1,438.8 313.1,439.9 312.6,436.7
            314,436.5 314.3,438.1 315.6,437.9 315.3,436.3 	"
                />
                <polygon
                  class="st51"
                  points="315.9,431.3 316.1,432.9 317.7,432.6 317.4,430.9 318.8,430.7 319.4,434 312.4,435.1 311.8,431.9
            313.2,431.7 313.5,433.3 314.8,433.1 314.6,431.5 	"
                />
                <polygon
                  class="st51"
                  points="315.1,426.5 315.4,428.1 317,427.8 316.7,426.1 318.1,425.9 318.6,429.2 311.6,430.3 311.1,427.1
            312.5,426.9 312.7,428.5 314,428.3 313.8,426.8 	"
                />
                <polygon
                  class="st51"
                  points="334.4,435.2 333.3,432.1 334.7,431.7 335.2,433.2 336.6,432.7 336.2,431.3 337.4,430.8 337.9,432.3
            340.6,431.4 341.1,432.9 	"
                />
                <polygon
                  class="st51"
                  points="332.8,430.6 331.8,427.5 333.1,427.1 333.6,428.6 335.1,428.1 334.6,426.7 335.9,426.2 336.4,427.7
            339,426.8 339.6,428.3 	"
                />
                <polygon
                  class="st51"
                  points="331.3,426 330.2,422.9 331.5,422.5 332.1,424 333.5,423.5 333,422.1 334.3,421.6 334.8,423.1
            337.5,422.2 338,423.7 	"
                />
                <path
                  class="st51"
                  d="M354.5,423c0.3,0.2,0.7,0.8,1,1.2c0.4,0.8,0.5,1.5,0.3,2.1c-0.2,0.9-1,1.7-2.1,2.2c-2.2,1.2-3.9,0.4-4.7-1
            c-0.3-0.5-0.4-0.9-0.4-1.2l1.4-0.4c0,0.2,0.1,0.5,0.3,0.8c0.5,0.8,1.3,1.1,2.8,0.3c1.3-0.7,1.5-1.5,1.3-2c0-0.1-0.1-0.1-0.1-0.1
            l-1.3,0.7l0.2,0.5l-1.2,0.6l-1-1.7L354.5,423z"
                />
                <path
                  class="st51"
                  d="M351.8,418c0.2,0.2,0.7,0.8,1,1.2c0.4,0.8,0.5,1.5,0.3,2.1c-0.2,0.9-1,1.7-2.1,2.2c-2.2,1.2-3.9,0.4-4.7-1
            c-0.3-0.5-0.4-0.9-0.4-1.2l1.4-0.4c0,0.2,0.1,0.5,0.3,0.8c0.5,0.8,1.3,1.1,2.8,0.3c1.3-0.7,1.5-1.5,1.3-2c0-0.1-0.1-0.1-0.1-0.1
            l-1.3,0.7l0.2,0.4l-1.2,0.6l-1-1.8L351.8,418z"
                />
                <path
                  class="st51"
                  d="M349,413c0.2,0.2,0.7,0.8,1,1.2c0.4,0.8,0.5,1.5,0.3,2.1c-0.2,0.9-1,1.7-2.1,2.2c-2.2,1.2-3.9,0.4-4.7-1
            c-0.3-0.5-0.4-0.9-0.4-1.2l1.4-0.4c0,0.2,0.1,0.5,0.2,0.8c0.5,0.8,1.3,1.1,2.8,0.3c1.3-0.7,1.5-1.5,1.3-2c0-0.1-0.1-0.1-0.1-0.1
            l-1.3,0.7l0.2,0.5l-1.2,0.6l-1-1.7L349,413z"
                />
                <text
                  transform="matrix(0.6871 -0.7263 0.7285 0.685 528.4153 303.9426)"
                  class="st38 st15 st58"
                >
                  PRESS LEVEL
                </text>
                <text
                  transform="matrix(0.6871 -0.7263 0.7285 0.685 531.9493 306.4935)"
                  class="st38 st15 st58"
                >
                  P
                </text>
                <text
                  transform="matrix(0.6871 -0.7263 0.7285 0.685 533.1171 305.2591)"
                  class="st38 st15 st58"
                >
                  A
                </text>
                <text
                  transform="matrix(0.6871 -0.7263 0.7285 0.685 534.4908 303.8069)"
                  class="st38 st15 st58"
                >
                  R
                </text>
                <text
                  transform="matrix(0.6871 -0.7263 0.7285 0.685 535.866 302.3534)"
                  class="st38 st15 st58"
                >
                  TY
                </text>
                <text
                  transform="matrix(0.6871 -0.7263 0.7285 0.685 538.3397 299.7385)"
                  class="st38 st15 st58"
                ></text>
                <text
                  transform="matrix(0.6871 -0.7263 0.7285 0.685 538.8203 299.2305)"
                  class="st38 st15 st58"
                >
                  AREA
                </text>
                <text
                  transform="matrix(0.9432 -0.3393 0.3403 0.9403 339.4262 474.7336)"
                  class="st38 st15 st59"
                >
                  PRESS
                </text>
                <text
                  transform="matrix(0.9432 -0.3393 0.3403 0.9403 342.5346 478.2004)"
                  class="st38 st15 st59"
                >
                  B
                </text>
                <text
                  transform="matrix(0.9432 -0.3393 0.3403 0.9403 344.4212 477.5217)"
                  class="st38 st15 st59"
                >
                  O
                </text>
                <text
                  transform="matrix(0.9432 -0.3393 0.3403 0.9403 346.213 476.8771)"
                  class="st38 st15 st59"
                >
                  X
                </text>
                <text
                  transform="matrix(0.9432 -0.3393 0.3403 0.9403 342.9017 482.6524)"
                  class="st38 st15 st59"
                >
                  SUITE
                </text>
                <text
                  transform="matrix(0.7348 0.6786 -0.6807 0.7326 196.3488 383.994)"
                  class="st38 st15 st60"
                >
                  REPUBLIC BANK DRAFT ROOM
                </text>
                <rect
                  x="264.2"
                  y="1.5"
                  class="st26"
                  width="51.2"
                  height="30.5"
                />
                <path
                  class="st29"
                  d="M315.6,32.3h-51.8V1.2h51.8V32.3z M264.5,31.7H315V1.8h-50.5V31.7z"
                />
                <rect
                  x="520.8"
                  y="191.4"
                  transform="matrix(0.9891 -0.1473 0.1473 0.9891 -23.0529 80.1002)"
                  class="st6"
                  width="17"
                  height="8.6"
                />
                <path
                  class="st14"
                  d="M536.9,190.4l1.2,8.1l-16.5,2.5l-1.2-8.1L536.9,190.4z M537.2,190l-17.2,2.6l1.3,8.8l17.2-2.6L537.2,190z"
                />
                <polygon
                  class="st6"
                  points="523.1,211.7 539.9,209.1 541,216.5 524.2,219.1 	"
                />
                <path
                  class="st14"
                  d="M539.8,209.3l1.1,7.1l-16.5,2.5l-1.1-7.1L539.8,209.3z M540,208.9l-17.2,2.6l1.2,7.7l17.2-2.6L540,208.9z"
                />
                <polygon
                  class="st6"
                  points="521.7,202.5 538.5,200 539.7,207.8 522.9,210.3 	"
                />
                <path
                  class="st14"
                  d="M538.4,200.2l1.1,7.4l-16.5,2.5l-1.1-7.5L538.4,200.2z M538.7,199.8l-17.2,2.6l1.2,8.2l17.2-2.6L538.7,199.8z
            "
                />
                <polygon
                  class="st6"
                  points="524.4,220.4 541.2,217.8 542.6,226.7 525.7,229.2 	"
                />
                <path
                  class="st14"
                  d="M541.1,218l1.3,8.6l-16.5,2.5l-1.3-8.5L541.1,218z M541.4,217.6l-17.2,2.6l1.4,9.2l17.2-2.6L541.4,217.6z"
                />
                <path
                  class="st38"
                  d="M528.3,194l-1.5,0.2v0.8c0.1,0,0.1,0,0.2,0c0.2,0,0.7,0,1.1,0.3c0.4,0.3,0.6,0.7,0.7,1.2
            c0.2,1.1-0.4,2.2-1.8,2.4c-0.4,0.1-0.9,0-1.2-0.1v-1.1c0.2,0.1,0.5,0.1,0.9,0.1c0.6-0.1,0.8-0.5,0.7-0.9c-0.1-0.7-0.7-0.8-1.4-0.7
            c-0.1,0-0.3,0-0.4,0.1l-0.1-3l2.5-0.4L528.3,194z"
                />
                <path
                  class="st38"
                  d="M531.2,192.3c0.8-0.1,1.7,0.3,1.8,1.2c0,0.3,0,0.9-0.6,1.3l0,0c0.6,0.2,1,0.7,1.1,1.3c0.2,1.1-0.6,1.8-1.6,2
            c-1,0.1-1.9-0.3-2-1.3c-0.1-0.7,0.2-1.2,0.6-1.6l0,0c-0.5-0.2-0.8-0.7-0.9-1.1C529.5,193.1,530.2,192.4,531.2,192.3L531.2,192.3z
            M531.3,193.2c-0.3,0-0.4,0.4-0.3,0.7c0,0.3,0.3,0.6,0.6,0.7c0.2-0.1,0.3-0.5,0.2-0.8C531.7,193.5,531.6,193.1,531.3,193.2
            L531.3,193.2z M531.9,197.3c0.3-0.1,0.4-0.5,0.4-0.8c-0.1-0.5-0.4-0.8-0.7-0.9c-0.2,0.2-0.3,0.5-0.3,0.9
            C531.3,196.9,531.5,197.3,531.9,197.3L531.9,197.3z"
                />
                <path
                  class="st38"
                  d="M529.7,203.6l-1.5,0.2v0.8c0.1,0,0.1,0,0.2,0c0.2,0,0.7,0,1.1,0.3c0.4,0.3,0.6,0.7,0.7,1.2
            c0.2,1.1-0.4,2.2-1.8,2.4c-0.4,0.1-0.9,0-1.2-0.1v-1.1c0.2,0.1,0.5,0.1,0.9,0.1c0.6-0.1,0.8-0.5,0.7-0.9c-0.1-0.7-0.7-0.8-1.4-0.7
            c-0.1,0-0.3,0-0.4,0.1l-0.1-3l2.5-0.4L529.7,203.6z"
                />
                <path
                  class="st38"
                  d="M534,202.8c-0.1,0-0.3,0.1-0.5,0.1c-0.7,0.2-1,0.8-1,1.5l0,0c0.2-0.3,0.4-0.5,0.8-0.5
            c0.8-0.1,1.4,0.5,1.6,1.6c0.1,1-0.2,2.1-1.4,2.3c-1.1,0.2-2-0.6-2.2-2.1c-0.2-1.3,0.1-2.2,0.6-2.8c0.3-0.4,0.9-0.8,1.3-0.9
            c0.3-0.1,0.5-0.1,0.6-0.2L534,202.8z M533.3,206.8c0.4-0.1,0.3-0.6,0.2-1.2c-0.1-0.3-0.2-0.8-0.6-0.7c-0.1,0-0.3,0.1-0.3,0.3
            c0,0.1,0,0.3,0,0.6C532.8,206.3,533,206.8,533.3,206.8L533.3,206.8z"
                />
                <path
                  class="st38"
                  d="M531,212.4l-1.5,0.2v0.8c0.1,0,0.1,0,0.2,0c0.2,0,0.7,0,1.1,0.3c0.4,0.3,0.6,0.7,0.7,1.2
            c0.2,1.1-0.4,2.2-1.8,2.4c-0.4,0.1-0.9,0-1.2-0.1v-1.1c0.2,0.1,0.5,0.1,0.9,0.1c0.6-0.1,0.8-0.5,0.7-0.9c-0.1-0.7-0.7-0.8-1.4-0.7
            c-0.1,0-0.3,0-0.4,0.1l-0.1-3l2.5-0.4L531,212.4z"
                />
                <path
                  class="st38"
                  d="M534.8,216.5l-0.2-1.3l-2,0.3l-0.1-0.9l1.4-3.8l1.3-0.2l0.5,3.4l0.5-0.1l0.2,1.1l-0.5,0.1l0.2,1.3
            L534.8,216.5z M534.4,214.2l-0.1-1c0-0.3-0.1-0.6-0.1-0.9l0,0c-0.1,0.3-0.1,0.5-0.2,0.9l-0.4,1.1l0,0L534.4,214.2z"
                />
                <path
                  class="st38"
                  d="M532.4,221.8l-1.5,0.2v0.8c0.1,0,0.1,0,0.2,0c0.2,0,0.7,0,1.1,0.3c0.4,0.3,0.6,0.7,0.7,1.2
            c0.2,1.1-0.4,2.2-1.8,2.4c-0.4,0.1-0.9,0-1.2-0.1v-1.1c0.2,0.1,0.5,0.1,0.9,0.1c0.6-0.1,0.8-0.5,0.7-0.9c-0.1-0.7-0.7-0.8-1.4-0.7
            c-0.1,0-0.3,0-0.4,0.1l-0.1-3l2.5-0.4L532.4,221.8z"
                />
                <path
                  class="st38"
                  d="M534.3,226.1l-0.1-0.9l0.5-0.8c0.6-1.1,1-1.8,0.9-2.5c-0.1-0.4-0.3-0.6-0.8-0.6c-0.3,0-0.6,0.2-0.8,0.4
            l-0.4-1c0.3-0.2,0.8-0.5,1.3-0.5c1.4-0.2,1.9,0.6,2,1.4c0.2,1.1-0.4,1.9-0.9,2.7l-0.3,0.4l0,0l1.7-0.3l0.2,1.2L534.3,226.1z"
                />
                <polygon
                  class="st6"
                  points="51.4,236 56.4,188.7 75,190.4 69.6,239.2 	"
                />
                <path
                  class="st14"
                  d="M56.5,188.9l18.2,1.7L69.4,239l-17.8-3.1L56.5,188.9z M56.2,188.5l-5,47.7l18.5,3.2l5.4-49.1L56.2,188.5z"
                />
                <path
                  class="st38"
                  d="M61.3,227.2l-1.7-0.2l-0.2,0.9c0.1,0,0.1,0,0.2,0c0.2,0,0.8,0.2,1.1,0.6c0.3,0.4,0.5,0.9,0.4,1.5
            c-0.1,1.2-1,2.2-2.5,2c-0.5,0-1-0.2-1.2-0.4l0.3-1.2c0.2,0.1,0.6,0.3,0.9,0.3c0.6,0.1,1-0.3,1-0.8c0.1-0.8-0.6-1.1-1.3-1.1
            c-0.2,0-0.3,0-0.4,0l0.6-3.2l2.8,0.3L61.3,227.2z"
                />
                <path
                  class="st38"
                  d="M62.6,230.9c0.3,0.2,0.6,0.3,0.9,0.3c0.6,0,0.9-0.3,0.9-0.7c0-0.7-0.5-0.9-1.1-0.9h-0.2v-1.1h0.1
            c0.5,0,1-0.1,1.1-0.6c0-0.4-0.2-0.6-0.7-0.6c-0.3,0-0.6,0.1-0.8,0.2l-0.1-1.1c0.3-0.2,0.8-0.3,1.4-0.3c1.2,0,1.8,0.8,1.7,1.6
            c0,0.6-0.4,1.1-0.9,1.4l0,0c0.6,0.3,1,0.8,1,1.6c0,0.9-0.8,1.9-2.3,1.9c-0.6,0-1-0.2-1.3-0.3L62.6,230.9z"
                />
                <polygon
                  class="st14"
                  points="62,222.1 57.8,221.7 57.9,220.8 61.4,221.2 61.5,219.6 62.2,219.7 	"
                />
                <polygon
                  class="st14"
                  points="58.2,216.6 58.9,216.6 58.8,218.1 59.8,218.2 59.9,216.8 60.6,216.9 60.5,218.3 61.6,218.4
            61.8,216.8 62.5,216.9 62.2,219.3 58,218.9 	"
                />
                <polygon
                  class="st14"
                  points="58.3,216.1 58.5,213.7 59.2,213.7 59.1,215.3 60.1,215.4 60.2,213.9 60.9,214 60.8,215.4 62.6,215.6
            62.5,216.4 	"
                />
                <polygon
                  class="st14"
                  points="58.8,210.8 59.5,210.9 59.4,211.8 62.9,212.1 62.8,213 59.3,212.7 59.2,213.6 58.5,213.5 	"
                />
                <polygon
                  class="st14"
                  points="58.9,209 59.2,206.6 59.9,206.7 59.7,208.2 60.7,208.3 60.8,206.9 61.5,206.9 61.4,208.4 63.2,208.5
            63.2,209.4 	"
                />
                <rect
                  x="60.9"
                  y="203.9"
                  transform="matrix(9.150484e-02 -0.9958 0.9958 9.150484e-02 -149.4186 248.2277)"
                  class="st14"
                  width="0.9"
                  height="4.2"
                />
                <polygon
                  class="st14"
                  points="59.6,202.3 60.3,202.4 60.1,203.9 61.1,204 61.2,202.6 61.9,202.6 61.8,204.1 62.9,204.2 63.1,202.6
            63.8,202.6 63.6,205.1 59.3,204.7 	"
                />
                <polygon
                  class="st14"
                  points="63.8,202.2 59.6,201.8 59.7,201 63.2,201.3 63.3,199.8 64,199.8 	"
                />
                <path
                  class="st14"
                  d="M59.9,199l0.1-1.4c0.1-1.2,0.9-1.3,2.2-1.2c1.5,0.1,2.1,0.5,2,1.7l-0.1,1.4L59.9,199z M63.5,198.5v-0.4
            c0.1-0.6-0.3-0.7-1.4-0.9c-1-0.1-1.5-0.1-1.5,0.6v0.4L63.5,198.5z"
                />
                <polygon
                  class="st14"
                  points="63.7,217.6 64.4,217.6 64.3,218.6 67.8,218.9 67.7,219.7 64.2,219.4 64.1,220.3 63.4,220.3 	"
                />
                <polygon
                  class="st14"
                  points="63.9,214.8 64.6,214.9 64.5,216.4 65.5,216.5 65.6,215 66.3,215.1 66.2,216.5 67.3,216.6 67.4,215.1
            68.1,215.1 67.9,217.6 63.7,217.2 	"
                />
                <path
                  class="st14"
                  d="M64,214.3l0.1-1.6c0.1-0.7,0.5-1.1,1.2-1c0.6,0.1,0.9,0.3,1,0.8l0,0c0.1-0.6,0.5-0.6,1.3-0.6
            c0.4,0,0.7,0,0.8-0.1l0,0l-0.1,0.9c-0.1,0.1-0.3,0.1-0.5,0.1l-0.8-0.1c-0.3,0-0.5,0.1-0.6,0.5v0.5l1.8,0.2l-0.1,0.9L64,214.3z
            M65.9,213.6v-0.4c0-0.4-0.1-0.7-0.6-0.7c-0.4,0-0.6,0.2-0.6,0.5v0.4L65.9,213.6z"
                />
                <path
                  class="st14"
                  d="M64.3,211l0.1-1.6c0.1-0.7,0.5-1.1,1.2-1c0.6,0.1,0.9,0.3,1,0.8l0,0c0.1-0.6,0.5-0.6,1.3-0.6
            c0.4,0,0.7,0,0.8-0.1l0,0l-0.1,0.9c-0.1,0.1-0.3,0.1-0.5,0.1l-0.8-0.1c-0.3,0-0.5,0.1-0.6,0.5v0.5l1.8,0.2l-0.1,0.9L64.3,211z
            M66.2,210.3v-0.4c0-0.4-0.1-0.7-0.6-0.7c-0.4,0-0.6,0.2-0.6,0.5v0.4L66.2,210.3z"
                />
                <path
                  class="st14"
                  d="M64.6,206.8l0.1-1.1L69,205l-0.1,0.9L68,206l-0.1,1.1l0.9,0.3l-0.1,0.9L64.6,206.8z M67.3,207l0.1-0.8
            l-1.9,0.2l0,0L67.3,207z"
                />
                <path
                  class="st14"
                  d="M66.5,202.7c-0.6-0.1-0.9,0-0.9,0.4s0.4,0.6,1.6,0.7c1.3,0.1,1.5,0,1.6-0.4c0-0.3-0.1-0.6-1-0.6l0.1-0.9
            c0.9,0.1,1.7,0.4,1.6,1.5c-0.1,1.3-1,1.4-2.3,1.2c-1.3-0.1-2.2-0.4-2.1-1.7c0.1-1.2,1-1.2,1.6-1.2L66.5,202.7z"
                />
                <polygon
                  class="st14"
                  points="65.4,198.8 66.1,198.8 65.9,200.4 66.9,200.4 67.1,199 67.8,199.1 67.6,200.5 68.8,200.6 68.9,199
            69.6,199.1 69.4,201.5 65.2,201.2 	"
                />
                <path
                  class="st61"
                  d="M271.3,20.6h1.5c0.9,0,1.4,0,1.7,0.1c0.4,0.1,0.8,0.3,1.1,0.6c0.3,0.3,0.4,0.7,0.4,1.2s-0.1,0.9-0.4,1.2
            c-0.3,0.3-0.6,0.5-1.1,0.7c-0.3,0.1-1,0.1-1.9,0.1h-0.5V28h-0.8L271.3,20.6L271.3,20.6z M272.1,21.4v2.5h1.3c0.5,0,0.9,0,1.1-0.1
            s0.4-0.2,0.6-0.5c0.1-0.2,0.2-0.4,0.2-0.7c0-0.3-0.1-0.5-0.2-0.7s-0.3-0.4-0.5-0.4c-0.2-0.1-0.6-0.1-1.1-0.1
            C273.5,21.4,272.1,21.4,272.1,21.4z"
                />
                <path
                  class="st61"
                  d="M280.7,20.4c1.1,0,2.1,0.4,2.9,1.1c0.8,0.8,1.2,1.7,1.2,2.8c0,1.1-0.4,2-1.2,2.8c-0.8,0.8-1.7,1.1-2.8,1.1
            c-1.1,0-2.1-0.4-2.8-1.1c-0.8-0.8-1.2-1.7-1.2-2.8c0-0.7,0.2-1.4,0.5-2s0.8-1.1,1.4-1.4C279.3,20.6,280,20.4,280.7,20.4
            M280.7,21.2c-0.6,0-1.1,0.1-1.6,0.4s-0.9,0.7-1.2,1.2c-0.3,0.5-0.4,1-0.4,1.6c0,0.9,0.3,1.6,0.9,2.3c0.6,0.6,1.4,0.9,2.2,0.9
            c0.6,0,1.1-0.1,1.6-0.4s0.9-0.7,1.2-1.2c0.3-0.5,0.4-1,0.4-1.6s-0.1-1.1-0.4-1.6s-0.7-0.9-1.2-1.2
            C281.8,21.3,281.3,21.2,280.7,21.2"
                />
                <path
                  class="st61"
                  d="M286.1,20.6h1.5c0.8,0,1.4,0,1.7,0.1c0.4,0.1,0.8,0.3,1.1,0.7c0.3,0.3,0.4,0.7,0.4,1.2c0,0.4-0.1,0.8-0.3,1.1
            c-0.2,0.3-0.5,0.5-0.8,0.7c-0.4,0.2-0.9,0.2-1.5,0.2l2.7,3.5H290l-2.7-3.5h-0.4v3.5h-0.8V20.6z M286.8,21.4v2.5h1.3
            c0.5,0,0.9,0,1.1-0.1s0.4-0.2,0.6-0.5c0.1-0.2,0.2-0.4,0.2-0.7c0-0.3-0.1-0.5-0.2-0.7s-0.3-0.4-0.5-0.4c-0.2-0.1-0.6-0.1-1.1-0.1
            C288.2,21.4,286.8,21.4,286.8,21.4z"
                />
                <path
                  class="st61"
                  d="M299.2,22l-0.6,0.5c-0.3-0.4-0.7-0.7-1.2-1c-0.5-0.2-1-0.3-1.5-0.3c-0.6,0-1.2,0.1-1.7,0.4s-0.9,0.7-1.2,1.2
            c-0.3,0.5-0.4,1-0.4,1.6c0,0.9,0.3,1.7,0.9,2.3c0.6,0.6,1.4,0.9,2.4,0.9c1.1,0,1.9-0.4,2.6-1.2l0.6,0.4c-0.4,0.5-0.8,0.8-1.4,1.1
            c-0.6,0.3-1.2,0.4-1.9,0.4c-1.3,0-2.4-0.4-3.1-1.3c-0.6-0.7-1-1.6-1-2.7s0.4-2,1.2-2.8c0.8-0.7,1.7-1.1,2.9-1.1
            c0.7,0,1.3,0.1,1.9,0.4C298.4,21.1,298.8,21.5,299.2,22"
                />
                <polygon
                  class="st61"
                  points="300.7,20.6 301.5,20.6 301.5,23.8 305.3,23.8 305.3,20.6 306,20.6 306,28.1 305.3,28.1 305.3,24.5
            301.5,24.5 301.5,28.1 300.7,28.1 	"
                />
                <path
                  class="st61"
                  d="M298.1,10.7c0-0.2-0.2-0.4-0.3-0.4c-0.3,0-0.5,0.3-0.5,0.6c0,0.2,0.1,0.3,0.4,0.3
            C297.9,11.3,298.1,11,298.1,10.7"
                />
                <path
                  class="st61"
                  d="M303.9,19.5c-0.1,0-0.2,0-0.3,0.1c-0.1,0.1-0.1,0.2-0.1,0.3c0,0.1,0,0.2,0.1,0.3c0.1,0.1,0.2,0.1,0.3,0.1
            c0.1,0,0.2,0,0.3-0.1c0.1-0.1,0.1-0.2,0.1-0.3c0-0.1,0-0.2-0.1-0.3C304.1,19.5,304,19.5,303.9,19.5 M304.1,20.1
            c-0.1,0.1-0.1,0.1-0.2,0.1s-0.2,0-0.2-0.1c-0.1-0.1-0.1-0.1-0.1-0.2s0-0.2,0.1-0.2c0.1-0.1,0.1-0.1,0.2-0.1s0.2,0,0.2,0.1
            c0.1,0.1,0.1,0.1,0.1,0.2C304.2,19.9,304.1,20,304.1,20.1"
                />
                <path
                  class="st61"
                  d="M312.1,5.6L289,10.1c-0.1,0.1-0.2,0.4-0.4,0.7l22.3-4.3l-4.5,6.8c-0.1,0.1-0.2,0.1-0.3,0.1
            c-0.1,0-0.1,0-0.2-0.1c0,0-0.1-0.1-0.1-0.2c0-0.3,0.3-0.7,0.6-0.8c0-0.2-0.1-0.3-0.4-0.3s-0.8,0.2-1.6,1.4c0.3-0.5,0.4-0.7,0.4-1
            c0-0.2-0.1-0.4-0.5-0.4c-0.6,0-0.9,0.5-1.7,1.5c-0.5,0.6-1.1,1.2-1.7,1.2c-0.2,0-0.3-0.1-0.3-0.3s0.1-0.5,0.2-0.7
            c0.8-0.1,1.9-0.7,1.9-1.4c0-0.3-0.2-0.4-0.5-0.4c-0.4,0-0.9,0.2-1.4,0.7s-1.4,1.3-1.8,1.6c0.2-0.3,0.3-0.6,0.3-1c0-0.3,0-0.6,0-0.9
            v-0.1c0.2,0,0.3-0.2,0.3-0.3s-0.1-0.2-0.3-0.2c-0.2,0-0.4,0.2-0.5,0.5c-0.3,0.3-0.7,0.7-1,1.1c-0.9,0.9-1.5,1.4-1.8,1.4
            c-0.1,0-0.1,0-0.1-0.1c0-0.2,0.3-0.6,0.5-1c0,0,0.2-0.4,0.9-1.5h-0.8c-0.1,0.1-0.3,0.4-0.3,0.5c-0.6,0.8-1.7,2.1-2.6,2.1
            c-0.3,0-0.4-0.1-0.4-0.3s0.1-0.4,0.2-0.6c1.1-0.2,1.9-0.9,1.9-1.4c0-0.3-0.2-0.4-0.5-0.4c-1,0-1.8,1-2.1,1.6
            c-0.2-0.1-0.4-0.2-0.5-0.4c0.3-0.5,0.5-1,0.5-1.1s-0.1-0.1-0.2-0.1c-0.2,0-0.3,0.1-0.3,0.2c-0.1,0.2-0.2,0.5-0.2,0.9
            c-0.2,0.6-1.1,1.7-1.7,1.7c-0.1,0-0.2-0.1-0.2-0.1c0-0.2,0.2-0.6,0.6-1.2c0.1-0.1,0.5-0.9,0.8-1.2h-0.8c-0.2,0.3-0.4,0.6-0.6,0.9
            c-0.9,1.2-1.5,1.7-1.8,1.7c-0.1,0-0.1,0-0.1-0.1s0-0.2,0.1-0.3c0.3-0.5,0.9-1.4,1.4-2.1h-0.8c-0.1,0.1-0.4,0.5-0.5,0.7
            c-1.2,1.5-1.7,1.9-2,1.9c-0.1,0-0.1-0.1-0.1-0.1c0-0.2,0.3-0.7,0.8-1.6c0.1-0.2,1.3-2.2,2-3.2l-0.9,0.1c0,0-0.1,0.2-0.3,0.5
            c0,0,0,0.1-0.1,0.1l-11.9-4.5l-2.3,3.6l0,0h-0.1c-1.4,0-2.3,0.6-2.3,1.5c0,0.7,0.6,1.1,1.7,1.1c0.8,0,1.4-0.2,1.8-0.5
            c-0.7,1-1.6,2.3-1.9,2.9c-0.2,0.3-0.3,0.5-0.3,0.7c0,0.3,0.3,0.5,0.7,0.5c0.5,0,0.9-0.3,1.3-1l0.2-0.2c0,0,0,0.1,0,0.2
            c0,0.5,0.3,0.9,1.3,0.9c1.3,0,2.6-0.7,3.8-1.9l0.3-0.2c-0.4,0.5-0.5,0.9-0.5,1.1c0,0.3,0.2,0.4,0.5,0.4c0.5,0,1-0.4,1.4-0.8
            l0.2-0.2c-0.1,0.2-0.2,0.4-0.2,0.6c0,0.2,0.1,0.4,0.5,0.4c0.6,0,1.2-0.5,1.7-1c-0.1,0.2-0.1,0.4-0.1,0.5c0,0.3,0.2,0.5,0.6,0.5
            c0.5,0,0.9-0.2,1.4-0.8c0.1-0.1,0.2-0.2,0.3-0.3c-0.1,0.2-0.2,0.4-0.2,0.7s0.2,0.5,0.5,0.5c0.7,0,1.4-0.8,1.8-1.2
            c-0.2,0.3-0.3,0.5-0.3,0.8s0.2,0.5,0.5,0.5c0.6,0,1.2-0.6,1.7-1.1c-0.1,0.2-0.2,0.4-0.2,0.7s0.2,0.5,0.6,0.5c0.3,0,0.7-0.1,1.2-0.5
            c0.4-0.4,0.7-0.8,1-1.2c0.1,0.2,0.3,0.3,0.5,0.4c-0.1,0.2-0.1,0.4-0.1,0.6c0,0.4,0.3,0.7,0.8,0.7c0.9,0,1.7-0.8,2.2-1.3
            c-0.2,0.4-0.3,0.7-0.3,0.9c0,0.3,0.2,0.5,0.5,0.5c0.6,0,1.3-0.6,1.8-1.2c0.2-0.2,0.7-0.6,1.3-1.3c0,0.2-0.1,0.5-0.1,0.7
            c-0.2,1.2-0.6,1.6-1,1.6s-0.3-0.4-0.6-0.4c-0.1,0-0.2,0.1-0.2,0.2c0,0.2,0.3,0.4,0.7,0.4c0.8,0,1.4-0.5,1.9-0.9
            c0.2-0.2,0.5-0.4,0.7-0.7c-0.2,0.3-0.3,0.6-0.3,0.9c0,0.4,0.2,0.7,0.8,0.7c1,0,1.8-0.9,2.2-1.5c0.6-0.7,1-1.3,1.3-1.3
            c0.1,0,0.1,0,0.1,0.1s-0.1,0.3-0.2,0.5c-0.5,0.9-1.2,1.9-1.3,2.1h0.8c0.4-0.6,1.5-2,2-2.5c-0.1,0.2-0.2,0.4-0.2,0.6
            c0,0.3,0.2,0.5,0.6,0.5c0.2,0,0.4,0,0.5-0.1l-0.1-0.2l0.2,0.1l0.1,0.3c-0.1,0.1-0.4,0.2-0.7,0.2l0,0l-3.7,5.7l-17.5-3.4l-16.9,2.7
            l4.2-6.5c-0.2,0-0.4-0.1-0.6-0.2l-4.9,7.5l18.1-2.9l17.8,3.5L312.1,5.6z M302.3,12.2c0.1,0,0.1,0.1,0.1,0.1c0,0.5-0.8,1.2-1.4,1.3
            C301.4,12.7,301.9,12.2,302.3,12.2 M294.7,12.2c0.1,0,0.1,0.1,0.1,0.1c0,0.5-0.8,1.2-1.4,1.3C293.8,12.9,294.3,12.2,294.7,12.2
            M273,11.7c-0.1,0-0.2,0-0.3,0c-0.1,0-0.1,0-0.2,0l1.2-1.8c-0.1,0-0.2,0-0.3,0c-0.2,0-0.3,0-0.4,0l-1.1,1.7
            c-0.1-0.1-0.3-0.1-0.4-0.2c-0.1-0.1-0.2-0.3-0.2-0.5c0-0.7,0.8-1.2,2-1.2c0.9,0,1.7,0.2,2.2,0.4l-0.5,0.8
            C274.7,11,274.1,11.6,273,11.7 M273.6,15c-0.2,0.1-0.3,0.2-0.4,0.2s-0.1,0-0.1-0.1s0-0.2,0.2-0.4c0.2-0.3,2.8-4.1,3-4.4
            c0.2,0.1,0.4,0.2,0.5,0.3c-0.4,0.6-1,1.5-1.6,2.4C274.5,14,274,14.7,273.6,15 M276.7,12.1h0.3c0.7,0,0.8,0.4,0.8,0.8
            c0,0.9-0.9,2.4-2.3,2.4c-0.6,0-0.8-0.3-0.8-0.7c0-0.7,0.7-1.5,1.7-1.5v-0.2c-0.3,0-0.8,0.1-1.1,0.3c0.6-0.8,1.4-2.1,1.7-2.5
            c0.2,0.1,0.4,0.3,0.6,0.4l0.1-0.2c-0.1-0.1-0.3-0.3-0.6-0.4c0.3-0.4,0.8-1,1.4-1c0.4,0,0.5,0.2,0.5,0.5c0,0.4-0.4,1.2-1.1,1.6
            c-0.3,0.2-0.8,0.2-1.4,0.2l-0.2,0.3C276.5,12.1,276.6,12.1,276.7,12.1 M282.1,14.7c-0.1,0-0.1,0-0.1-0.1v-0.1
            c0.1-0.2,0.2-0.5,0.5-0.9c0,0,0.2-0.4,1-1.5l-0.9,0.1c0,0-0.7,1.1-1,1.4c-0.5,0.6-1.1,1.2-1.4,1.2c-0.1,0-0.1-0.1-0.1-0.1
            c0-0.1,0-0.2,0.2-0.4c0.2-0.4,1.4-2.1,1.4-2.1l-0.9,0.1c-0.1,0.1-0.3,0.4-0.4,0.5c-0.5,0.6-1.5,1.6-2.3,2c0.4-0.4,0.7-1,0.7-1.6
            c0-0.7-0.4-0.9-0.7-1c0.4-0.1,1-0.3,1.4-0.7c0.3-0.3,0.5-0.8,0.5-1.2c0-0.5-0.3-0.9-1.1-0.9c-0.7,0-1.3,0.4-1.9,1.1
            c-0.2-0.1-0.4-0.2-0.5-0.3c0.2-0.3,0.4-0.5,0.5-0.6h-1c-0.1,0.1-0.1,0.2-0.2,0.3c-0.4-0.1-0.8-0.3-1.3-0.3c-0.1,0-0.3,0-0.4-0.1
            l1.9-2.9l11.4,4.3l-0.1,0.1c-0.3,0.5-0.6,1-0.8,1.3c-0.1-0.2-0.3-0.3-0.6-0.3c-0.7,0-1.4,0.5-1.9,1.1
            C283.6,13.5,282.7,14.7,282.1,14.7 M285.1,14.1c-0.4,0.4-0.7,0.6-0.8,0.6c-0.2,0-0.2-0.1-0.2-0.2c0-0.3,0.4-1,0.8-1.5
            c0.4-0.6,0.8-0.8,1.1-0.8c0.2,0,0.3,0.1,0.3,0.3c0,0,0,0.1,0,0.2C285.9,13.2,285.4,13.7,285.1,14.1"
                />
                <path
                  class="st61"
                  d="M304.1,19.8C304.1,19.7,304,19.7,304.1,19.8c-0.1-0.1-0.1-0.1-0.2-0.1h-0.2v0.4h0.1v-0.2h0.1l0.1,0.2h0.1
            l-0.1-0.2C304,19.9,304.1,19.8,304.1,19.8 M303.9,19.8L303.9,19.8l-0.1-0.1h0.1C303.9,19.7,304,19.7,303.9,19.8
            C304,19.8,303.9,19.8,303.9,19.8"
                />
                <polygon
                  class="st61"
                  points="270,7.5 270.3,7.5 270.3,8.8 270.5,8.8 270.5,7.5 270.8,7.5 270.8,7.3 270,7.3 	"
                />
                <polygon
                  class="st61"
                  points="271.8,7.9 271.1,7.9 271.1,7.3 270.9,7.3 270.9,8.8 271.1,8.8 271.1,8.1 271.8,8.1 271.8,8.8
            272,8.8 272,7.3 271.8,7.3 	"
                />
                <polygon
                  class="st61"
                  points="273.1,7.5 273.1,7.3 272.2,7.3 272.2,8.8 273.1,8.8 273.1,8.6 272.4,8.6 272.4,8.1 273.1,8.1
            273.1,7.9 272.4,7.9 272.4,7.5 	"
                />
                <rect x="233" y="4.4" class="st26" width="29.2" height="9.2" />
                <rect x="233" y="4.4" class="st62" width="29.2" height="9.2" />
                <path
                  class="st63"
                  d="M300,335.8c-0.1-0.2-0.2-0.3-0.2-0.3c-0.1,0-0.6-0.1-0.9-0.2v0.3C299,335.6,299.7,335.7,300,335.8"
                />
                <path
                  class="st63"
                  d="M301.9,343.2H301h-3.9v0.3h4.2h0.8h2.1c0.2-0.1,0.5-0.2,0.8-0.3H301.9z"
                />
                <path
                  class="st63"
                  d="M303.1,335.4c0.3,0.5,0.8,1.6,1.2,2.2c0.1-0.1,0.1-0.2,0.2-0.3c-0.3-0.6-0.7-1.4-0.9-1.7
            c0.2-0.1,0.7-0.2,0.7-0.2v-0.9H304v0.8C303.9,335.3,303.3,335.4,303.1,335.4"
                />
                <path
                  class="st63"
                  d="M304.9,335.3v0.3c0,0,0.2,0,0.4,0.1c0.1-0.1,0.1-0.2,0.1-0.2C305.3,335.4,305.1,335.4,304.9,335.3"
                />
                <path
                  class="st63"
                  d="M306.1,343.2l0.3,0.4l-0.2,0.2c-0.4,0.4-4.3,3.1-8.5,2.5c-1.9-0.2-3.5-1-5-2.4c1.5,1.6,3.2,2.5,5.2,2.7
            c4.3,0.5,8.1-2.2,8.5-2.6l0.2-0.2l-0.3-0.3h0.6v-1.1c0,0-0.1,0-0.3-0.1v0.8h-0.5L306.1,343.2L306.1,343.2z"
                />
                <path
                  class="st63"
                  d="M307.3,335.9c-0.6,1-2.1,3.4-2.1,3.6v2.4c0.1,0,0.2,0,0.3,0.1v-2.3c0.1-0.1,1-1.6,1.6-2.7
            C307.1,336.5,307.2,336.2,307.3,335.9"
                />
                <path
                  class="st63"
                  d="M311.1,340.7c-0.3-0.2-0.7-0.4-1.1-0.6l-0.6-0.3c-0.6-0.3-1-0.6-1.3-0.8c0.4,0.4,0.9,0.8,1.7,1.2l0.6,0.3
            c0.3,0.1,0.7,0.3,0.9,0.5C311.2,340.8,311.2,340.7,311.1,340.7"
                />
                <path
                  class="st63"
                  d="M309.2,341.7c-0.2-0.3-0.4-0.7-0.5-1.2v-0.3h-0.3C308.5,340.9,308.8,341.4,309.2,341.7"
                />
                <path
                  class="st63"
                  d="M312.4,337.3C312.4,337.3,312.5,337.4,312.4,337.3l0.1,0.3h1.3l-0.1-2.8l-0.2-0.1h-0.1l0.1,2.6H312.4z"
                />
                <path
                  class="st63"
                  d="M310.7,335.3c-0.5,0-1.1,0.2-1.1,0.7c0,0.3,0.1,0.5,0.4,0.7c-0.1-0.1-0.1-0.2-0.1-0.4c0-0.5,0.6-0.7,1.1-0.7
            c0.7,0,1.1,0.3,1.4,1.6V337C312.2,335.9,311.6,335.3,310.7,335.3"
                />
                <path
                  class="st63"
                  d="M313.5,338.9c0.3,0.4,0.4,1,0.4,1.6c0,1.8-1.4,2.9-3.6,2.9c-1,0-1.9-0.2-2.7-0.6v0.2l0.2,0.1
            c0.9,0.4,1.8,0.6,2.8,0.6c2.2,0,3.6-1.1,3.6-2.9C314.2,340,314,339.3,313.5,338.9"
                />
                <path
                  class="st63"
                  d="M301.4,341.9c-0.4-1-2-5-2.6-6.7l0,0l-0.1-0.3l0,0c-0.1-0.3-0.2-0.5-0.2-0.5h-0.3c0.6,1.4,2.8,7.1,2.9,7.3
            C301.1,341.9,301.2,341.9,301.4,341.9"
                />
                <path
                  class="st63"
                  d="M295.6,341.2h2.1c0-0.1-0.1-0.2-0.1-0.3h-2.2c-0.1,0.2-0.2,0.5-0.3,0.8c0.2,0.2,0.4,0.4,0.6,0.6
            c-0.1-0.1-0.2-0.2-0.3-0.3C295.4,341.7,295.5,341.4,295.6,341.2"
                />
                <path
                  class="st63"
                  d="M295.8,339.5c0.2,0,0.3,0,0.5,0c0-0.1,0.1-0.2,0.1-0.2l0,0c0.1-0.3,0.2-0.6,0.4-1.1c-0.1-0.2-0.1-0.4-0.2-0.6
            C296.2,338.5,295.8,339.5,295.8,339.5"
                />
                <path
                  class="st63"
                  d="M294,336.2l-0.5,0.1c-0.3,0.4-0.6,0.8-1.1,1.1l0.3,0.4C293.2,337.4,293.7,336.8,294,336.2"
                />
                <path
                  class="st63"
                  d="M288.6,332.9c0.1,0,0.1,0,0.2,0c0.6,0,1.1,0.1,1.4,0.4c-0.4-0.5-0.9-0.7-1.7-0.7c-0.1,0-0.1,0-0.2,0v1.3
            l0.3,0.2L288.6,332.9L288.6,332.9z"
                />
                <path
                  class="st63"
                  d="M289,338.3l-0.1-0.1l0,0c-0.2-0.1-0.5-0.2-0.6-0.2v3.6c0.1,0,0.2,0,0.3,0.1v-3.3c0.1,0,0.3,0.1,0.4,0.1
            L289,338.3L289,338.3z"
                />
                <path
                  class="st63"
                  d="M283.7,343.2v0.3h6.6v-1.3c0,0-0.1,0-0.3-0.1v1h-6.3L283.7,343.2L283.7,343.2z"
                />
                <path
                  class="st63"
                  d="M293.7,335.7l0.4,0.1c0.1-0.3,0.2-0.7,0.2-1.1c0-1.1-0.4-1.8-1-2.3c0.4,0.5,0.6,1.1,0.6,2
            C294,334.8,293.9,335.3,293.7,335.7"
                />
                <path
                  class="st63"
                  d="M288.4,336.6l0.2-0.1v-2.2l-0.3-0.3v2.8c0,0,0.2,0,0.3,0v-0.2L288.4,336.6z"
                />
                <path
                  class="st63"
                  d="M293.6,339.9l-0.7-1.1c0,0-0.3-0.5-0.6-0.8h0.1l0.1-0.1l-0.4-0.3c0,0-0.1,0-0.1,0.1c0,0,0,0-0.1,0
            c0.2,0.3,0.6,0.8,0.6,0.8l0.7,1.1l0.1,0.1c0.1,0.2,0.2,0.3,0.3,0.5v-0.1C293.6,340,293.6,340,293.6,339.9
            C293.6,340,293.6,339.9,293.6,339.9"
                />
                <path
                  class="st63"
                  d="M284.9,332.8c-0.3,0-0.9-0.2-1.3-0.2v0.4c0,0,0.8,0.1,1.3,0.2V332.8z"
                />
                <path
                  class="st31"
                  d="M314,340.5c0-0.6-0.1-1.2-0.4-1.6c-0.1-0.2-0.2-0.3-0.4-0.4c-0.6-0.5-1.2-0.8-1.8-1.1l-0.4-0.2h-0.1
            c-0.4-0.2-0.7-0.3-0.9-0.5c-0.3-0.2-0.4-0.4-0.4-0.7c0-0.5,0.6-0.7,1.1-0.7c0.9,0,1.5,0.6,1.7,1.7v0.2v0.1l0,0h1l-0.1-2.6v-0.2
            l-0.2-0.1c-0.9-0.3-1.6-0.5-2.4-0.5c-0.6,0-1.1,0.1-1.5,0.2h-4.7v1.1c0,0,0.1,0,0.3,0.1c0.2,0,0.4,0.1,0.6,0.1
            c0,0.1-0.1,0.2-0.1,0.2c-0.3,0.5-0.7,1.1-1,1.7c-0.1,0.1-0.1,0.2-0.2,0.3c-0.3-0.6-0.9-1.7-1.2-2.2c0.3-0.1,0.8-0.2,0.8-0.2v-0.8
            v-0.3h-5.3v0.8l0,0v0.3h0.1c0.1,0,0.1,0,0.2,0c0.3,0.1,0.8,0.1,0.9,0.2c0,0,0.1,0.1,0.2,0.3c0.5,0.9,2.1,3.5,2.2,3.6v2.4
            c-0.2,0-0.5,0.1-0.7,0.1h-0.1c-0.1,0-0.3-0.1-0.4-0.1c-0.1-0.3-2.3-5.9-2.9-7.3c-0.1-0.2-0.1-0.3-0.1-0.3h-1.9l-0.7,1.8l0.3,0.1
            h-0.4l-1.6,3.9v0.1c-0.1-0.2-0.2-0.3-0.3-0.5l-0.1-0.1l-0.7-1.1c0,0-0.3-0.5-0.6-0.8h0.1c0,0,0.1,0,0.1-0.1l-0.3-0.2
            c-0.1,0.1-0.2,0.1-0.3,0.1h-0.1c0.6,0.8,1.1,1.6,1.5,2.3c0.2,0.3,0.5,0.7,0.8,1l2.6-6.2h1.5l3,7.6l0.7,0.2l1.1-0.2v-2.8L300,335h-1
            v-0.5h4.6v0.5l-1,0.2l1.7,3.2l1.8-3.2L305,335v-0.5h3.5h0.9c0.4-0.1,0.9-0.2,1.4-0.2c0.7,0,1.5,0.2,2.3,0.4l0.1,2.2h-0.4
            c-0.3-1.3-1-2-2-2c-0.8,0-1.4,0.4-1.4,1.1c0,0.8,0.6,1.1,1.6,1.5c0.6,0.3,1.4,0.6,2.1,1.1c0.5,0.4,0.7,1,0.7,1.8
            c0,1.5-1.1,2.5-3.2,2.5c-1,0-1.9-0.2-2.7-0.6l-0.1-2.2h0.4c0.2,1.4,1,2.2,2.2,2.2c0.9,0,1.4-0.5,1.4-1.1c0-0.3-0.1-0.6-0.4-0.8
            c-0.5-0.4-1.1-0.6-1.7-0.9c-1.4-0.7-2.1-1.4-2.1-2.6c0-0.8,0.3-1.4,0.8-1.9l-1,0.1l-2.5,4.2v2.8l1.5,0.2v0.5h-4.8h-0.1h-4.2v-0.5
            l1.1-0.2l-0.6-1.6H295l-0.5,1.2c0,0,0,0,0.1,0.1c2.2,2.4,5.2,4.3,11,1.4l0.3,0.3c-0.7,0.7-9.7,6.6-15.1-2.5
            c-0.1-0.1-0.2-0.3-0.2-0.4v0.2v-0.3c-0.5-0.8-0.9-1.6-1.3-2.3c0,0,0-0.1-0.1-0.2c0,0,0-0.1-0.1-0.1l-0.8-0.3v-0.1v-0.3
            c0.1,0,0.3,0,0.4,0c0.4,0,0.8-0.1,1.1-0.2l0,0c0,0,0.1,0,0.3-0.2l0,0l0,0l0,0c0.1-0.1,0.2-0.1,0.2-0.2l0.2,2l0.4-2.2l0.7,0.5
            l-0.5-0.8l1.9-0.2l-1.9-0.4l0.3-0.7l-0.6,0.4c0-0.1,0-0.3,0-0.4l0,0l0,0l0,0v-0.1l0,0l0,0l0,0c0-1.7-0.9-2.5-2.5-2.5
            c-0.2,0-0.4,0-0.5,0v1.4l0.3,0.2v-1.3c0.1,0,0.1,0,0.2,0c0.8,0,1.4,0.2,1.7,0.7c0.2,0.3,0.4,0.8,0.4,1.4l0.2,0.3l0,0
            c-0.6,0.5-0.7,1.2-0.7,1.6h-0.1c-0.3,0.2-0.7,0.3-1.3,0.3c0,0,0,0-0.1,0s-0.3,0-0.3,0V334l-0.3-0.4v8.2l1.7,0.3v0.7h-5.9v-0.7
            l1.6-0.3v-9.4l-1.6-0.3v-0.7h4.3h1.3l0,0c2.9,0,4.3,0.8,4.3,2.9c0,0.5-0.1,0.9-0.2,1.3l0.3,0.1c0.2-0.4,0.2-0.9,0.2-1.3
            c0-0.9-0.2-1.5-0.6-2c-0.9-1.1-2.6-1.3-4-1.3h-6v1.3c0,0,0.1,0,0.3,0.1c0.4,0.1,1,0.2,1.3,0.2v0.4v8.4c-0.4,0.1-1.6,0.3-1.6,0.3
            v1.3h0.3h6.3v-1v-0.3c0,0-0.8-0.1-1.3-0.2c-0.1,0-0.3,0-0.3-0.1V338c0.1,0,0.4,0.2,0.6,0.2l0,0l0.1,0.1l0,0v0.1l0.5,0.9
            c0.3,0.6,0.7,1.3,1.1,1.9c0.6,1.1,1.4,2,2.1,2.7c1.4,1.4,3.1,2.2,5,2.4c4.3,0.5,8.1-2.1,8.5-2.5l0.2-0.2l-0.3-0.4h0.6v-0.8V342
            c0,0-0.7-0.1-1.1-0.2c-0.1,0-0.3,0-0.3-0.1v-2.4c0.1-0.1,1.5-2.6,2.1-3.6c-0.1,0.3-0.2,0.7-0.2,1l0,0c0,0.8,0.3,1.5,1,2.1
            c0.3,0.3,0.8,0.6,1.3,0.8l0.6,0.3c0.4,0.2,0.8,0.3,1.1,0.6c0.1,0.1,0.2,0.2,0.2,0.2c0.1,0.1,0.1,0.2,0.1,0.3c0,0.5-0.4,0.8-1.1,0.8
            c-0.4,0-0.8-0.1-1.1-0.3c-0.4-0.3-0.7-0.8-0.8-1.5l0,0v-0.3h-1.1l0.1,2.8l0.2,0.1c0,0,0.1,0,0.1,0.1c0.8,0.4,1.7,0.6,2.7,0.6
            C312.6,343.3,314,342.2,314,340.5 M298.9,344.2c-1.4-0.3-2.5-1.1-3.3-1.9c-0.2-0.2-0.4-0.4-0.6-0.6c0.1-0.3,0.2-0.6,0.3-0.8h2.2
            c0,0.1,0.1,0.2,0.1,0.3c0.1,0.2,0.1,0.4,0.2,0.6c-0.3,0.1-1,0.2-1,0.2v1.1h0.3h3.9h0.8h3.2c-0.3,0.1-0.5,0.2-0.8,0.3
            C302.2,344.3,300.4,344.6,298.9,344.2"
                />
                <path
                  class="st31"
                  d="M296.5,336.6l-1,2.7l-0.2,0.5h2.3L296.5,336.6z M296.7,338.3c0.2,0.5,0.3,0.9,0.4,1.3c-0.3,0-0.6,0-0.8,0
            c-0.2,0-0.3,0-0.5,0c0,0,0.4-1,0.7-1.8C296.5,337.9,296.6,338.1,296.7,338.3"
                />
                <path
                  class="st31"
                  d="M293.5,336.2h-0.4c-0.2,0.3-0.5,0.6-0.8,0.8l0.2,0.3C292.8,337.1,293.2,336.7,293.5,336.2"
                />
                <path
                  class="st64"
                  d="M291.2,336.9l-0.6,3.7c0.1,0.1,0.2,0.3,0.2,0.4c5.4,9.1,14.4,3.3,15.1,2.5l-0.3-0.3c-5.9,3-8.8,1-11-1.4
            c0,0,0,0-0.1-0.1l0.5-1.2h2.7l0.6,1.6l-1.1,0.2v0.5h4.2h0.1h4.8v-0.5l-1.5-0.2v-2.8l2.5-4.2l1-0.1c-0.5,0.4-0.8,1.1-0.8,1.9
            c0,1.2,0.7,1.9,2.1,2.6c0.6,0.3,1.2,0.5,1.7,0.9c0.3,0.2,0.4,0.5,0.4,0.8c0,0.6-0.5,1.1-1.4,1.1c-1.2,0-2-0.7-2.2-2.2h-0.4l0.1,2.2
            c0.8,0.4,1.7,0.6,2.7,0.6c2.1,0,3.2-1,3.2-2.5c0-0.8-0.2-1.4-0.7-1.8c-0.6-0.6-1.4-0.9-2.1-1.1c-1-0.4-1.6-0.7-1.6-1.5
            c0-0.6,0.6-1.1,1.4-1.1c1.1,0,1.8,0.7,2,2h0.4l-0.1-2.2c-0.8-0.3-1.5-0.4-2.3-0.4c-0.5,0-1,0.1-1.4,0.2h-0.9h-3.5v0.5l1.1,0.2
            l-1.8,3.2l-1.7-3.2l1-0.2v-0.5H299v0.5l1.1,0.2l2.5,4.2v2.8l-1.1,0.2l-0.7-0.2l-3-7.6h-1.5l-2.6,6.2c-0.3-0.3-0.5-0.7-0.8-1
            c-0.5-0.6-1-1.4-1.5-2.3h0.1c0.1,0,0.2-0.1,0.3-0.1L291.2,336.9z M297.5,339.9h-2.3l0.2-0.5l1-2.7L297.5,339.9z"
                />
                <path
                  class="st64"
                  d="M293,336.3l-1.3,0.1l0.5,0.7C292.5,336.9,292.8,336.6,293,336.3"
                />
                <path
                  class="st64"
                  d="M292.5,333.3l-0.7,2l1.6,0.3c0.2-0.4,0.2-0.8,0.2-1.3c0-2-1.4-2.9-4.3-2.9l0,0H288h-4.3v0.7l1.6,0.3v9.4
            l-1.6,0.3v0.7h5.9v-0.7l-1.7-0.3v-8.2l-0.2-0.2l0.2,0.1v-1.4c0.2,0,0.4,0,0.5,0c1.6,0,2.5,0.9,2.5,2.5l0,0l0,0l0,0v0.1l0,0l0,0
            L292.5,333.3z"
                />
                <path
                  class="st64"
                  d="M290.2,336.8L290.2,336.8L290.2,336.8c-0.2,0.1-0.3,0.2-0.3,0.2l0,0c-0.3,0.1-0.7,0.2-1.1,0.2
            c-0.1,0-0.3,0-0.4,0v0.3v0.1l0.8,0.3c0,0,0,0.1,0.1,0.1c0.1,0.1,0.1,0.2,0.1,0.2c0.4,0.7,0.8,1.5,1.3,2.3L290.2,336.8z"
                />
                <path
                  class="st65"
                  d="M293.7,335.7l-0.3-0.1l-1.6-0.3l0.7-2l-1.5,1.5l0,0c0,0.1,0,0.2,0,0.4l0.6-0.4l-0.3,0.7l1.9,0.4l-1.9,0.2
            l0.5,0.8l-0.7-0.5l-0.4,2.2l-0.2-2c-0.1,0.1-0.2,0.1-0.2,0.2l0,0l0.4,3.7v0.3v-0.2l0.6-3.7l0.6,0.4l0.3,0.2l0.4,0.3l0.6,0.5
            l-0.4-0.6l-0.3-0.4l-0.2-0.3l-0.5-0.7l1.3-0.1h0.4l0.5-0.1l1.3-0.1h0.4l-0.3-0.1l-1.2-0.2L293.7,335.7z"
                />
                <path
                  class="st65"
                  d="M287.8,333.5l0.2,0.2l0.3,0.4l0.3,0.3l1.5,1.5l-1.5,0.6l-0.2,0.1h0.2l1.4-0.1h0.1c0-0.4,0.1-1,0.7-1.6l0,0
            l-0.2-0.3l-0.4-0.8l0.3,1.4l-1.9-1.2l-0.3-0.2l-0.3-0.2L287.8,333.5z"
                />
                <polygon
                  class="st64"
                  points="314.2,342.2 314.4,342.2 314.4,342.7 314.6,342.7 314.6,342.2 314.8,342.2 314.8,342.1 314.2,342.1
            "
                />
                <polygon
                  class="st64"
                  points="315.4,342.1 315.2,342.5 315.2,342.5 315.1,342.1 314.9,342.1 314.9,342.7 315,342.7 315,342.2
            315,342.2 315.2,342.7 315.3,342.7 315.5,342.2 315.5,342.2 315.5,342.7 315.6,342.7 315.6,342.1 	"
                />
                <path
                  class="st31"
                  d="M169.7,5.3c0,0.3,0,0.5,0.2,0.8c0.2,0.4,0.6,0.4,1,0.2c0.6-0.3,0.5-0.8,0.3-1.2L171.1,5l0.9-0.5v0.1
            c0.2,0.3,0.5,0.6,1,0.4c0.3-0.2,0.4-0.5,0.3-0.8c-0.1-0.2-0.3-0.3-0.5-0.4l0.9-0.7c0.2,0.1,0.6,0.4,0.8,0.8c0.5,0.8,0,1.6-0.6,2
            c-0.5,0.3-1.1,0.3-1.5,0.1l0,0c0,0.5-0.3,1.1-0.9,1.5c-0.8,0.4-1.9,0.4-2.5-0.6c-0.2-0.4-0.3-0.7-0.3-1L169.7,5.3z"
                />
                <path
                  class="st31"
                  d="M175.7,8.7L175,7.6L174.2,8c0,0,0,0.1,0.1,0.1c0.1,0.2,0.2,0.6,0,1s-0.5,0.8-1,1.1c-1,0.6-2.2,0.5-2.8-0.5
            c-0.2-0.3-0.3-0.7-0.3-1l1.1-0.4c0,0.2,0,0.5,0.2,0.7c0.2,0.4,0.7,0.5,1.1,0.2c0.7-0.4,0.6-0.9,0.3-1.4c-0.1-0.1-0.1-0.2-0.2-0.3
            l2.9-1.3l1.1,1.9L175.7,8.7z"
                />
                <path
                  class="st31"
                  d="M177.3,11.5l-0.6-1.1l-0.8,0.4c0,0,0,0.1,0.1,0.1c0.1,0.2,0.2,0.6,0,1c-0.1,0.4-0.5,0.8-1,1.1
            c-1,0.6-2.2,0.5-2.8-0.5c-0.2-0.3-0.3-0.7-0.3-1l1.1-0.4c0,0.2,0,0.5,0.2,0.7c0.2,0.4,0.7,0.5,1.1,0.2c0.7-0.4,0.6-0.9,0.3-1.4
            c-0.1-0.1-0.1-0.2-0.2-0.3l2.9-1.3l1.1,1.9L177.3,11.5z"
                />
                <path
                  class="st31"
                  d="M153.1,17.2c0,0.3,0.1,0.6,0.2,0.8c0.2,0.4,0.7,0.4,1,0.2c0.5-0.3,0.5-0.8,0.3-1.2l-0.1-0.1l0.9-0.6v0.1
            c0.2,0.3,0.5,0.6,1,0.3c0.3-0.2,0.4-0.5,0.2-0.8c-0.1-0.2-0.3-0.3-0.5-0.4l0.9-0.7c0.2,0.1,0.6,0.4,0.8,0.7c0.5,0.8,0.1,1.6-0.6,2
            c-0.5,0.3-1.1,0.3-1.5,0.1l0,0c0.1,0.5-0.2,1.1-0.9,1.5c-0.8,0.5-1.9,0.5-2.5-0.5c-0.2-0.4-0.3-0.7-0.3-1L153.1,17.2z"
                />
                <path
                  class="st31"
                  d="M159.1,20.3l-0.7-1.1l-0.8,0.4c0,0,0,0.1,0.1,0.1c0.1,0.2,0.2,0.6,0.1,1c-0.1,0.4-0.5,0.8-1,1.1
            c-1,0.6-2.2,0.6-2.8-0.4c-0.2-0.3-0.3-0.7-0.3-0.9l1.1-0.5c0,0.2,0.1,0.5,0.2,0.7c0.3,0.4,0.7,0.5,1.1,0.2c0.7-0.4,0.6-0.9,0.3-1.4
            c-0.1-0.1-0.1-0.2-0.2-0.3l2.9-1.4l1.1,1.8L159.1,20.3z"
                />
                <path
                  class="st31"
                  d="M156.5,22.8c0,0.3,0.1,0.5,0.2,0.8c0.2,0.4,0.7,0.4,1,0.2c0.5-0.3,0.5-0.8,0.3-1.2l-0.1-0.1l0.9-0.6V22
            c0.2,0.3,0.5,0.6,1,0.3c0.3-0.2,0.4-0.5,0.2-0.8c-0.1-0.2-0.3-0.3-0.5-0.4l0.9-0.7c0.2,0.1,0.6,0.4,0.8,0.7c0.5,0.8,0.1,1.6-0.6,2
            c-0.5,0.3-1.1,0.3-1.5,0.1l0,0c0.1,0.5-0.2,1.1-0.9,1.5c-0.8,0.5-1.9,0.5-2.5-0.5c-0.2-0.4-0.3-0.7-0.3-1L156.5,22.8z"
                />
                <path
                  class="st31"
                  d="M129.6,31.3c0,0.3,0.1,0.5,0.3,0.7c0.3,0.4,0.7,0.3,1,0.1c0.5-0.4,0.4-0.9,0.1-1.2l-0.1-0.1l0.8-0.7l0.1,0.1
            c0.2,0.3,0.6,0.5,1,0.2c0.3-0.2,0.3-0.5,0.1-0.8c-0.1-0.2-0.3-0.3-0.6-0.3l0.7-0.8c0.3,0.1,0.7,0.3,0.9,0.6c0.6,0.7,0.3,1.5-0.2,2
            c-0.5,0.4-1,0.5-1.5,0.3l0,0c0.1,0.5-0.1,1.1-0.6,1.6c-0.7,0.6-1.8,0.8-2.6-0.1c-0.3-0.3-0.4-0.7-0.5-0.9L129.6,31.3z"
                />
                <path
                  class="st31"
                  d="M136.1,33.5l-0.8-1l-0.7,0.5l0.1,0.1c0.1,0.1,0.3,0.6,0.2,1s-0.3,0.8-0.8,1.2c-0.9,0.8-2.1,0.9-2.9,0.1
            c-0.2-0.3-0.4-0.7-0.4-0.9l1-0.6c0,0.2,0.1,0.5,0.3,0.7c0.3,0.4,0.8,0.3,1.2,0c0.6-0.5,0.4-1,0.1-1.4c-0.1-0.1-0.2-0.2-0.2-0.2
            l2.6-1.9l1.4,1.6L136.1,33.5z"
                />
                <polygon
                  class="st31"
                  points="137.2,34.8 137.2,34.8 136.2,34.5 137,33.6 138.3,34.1 139,34.8 134.3,38.8 133.5,37.9 	"
                />
                <path
                  class="st31"
                  d="M107.7,54.3c0,0.3,0.2,0.5,0.4,0.7c0.3,0.3,0.7,0.2,1,0c0.4-0.5,0.3-0.9-0.1-1.2l-0.1-0.1l0.7-0.8l0.1,0.1
            c0.3,0.2,0.7,0.5,1,0.1c0.3-0.3,0.3-0.6,0-0.8c-0.2-0.1-0.4-0.2-0.6-0.3l0.7-0.9c0.3,0,0.7,0.2,1,0.5c0.7,0.7,0.5,1.5-0.1,2.1
            c-0.4,0.4-1,0.6-1.4,0.5l0,0c0.2,0.5,0.1,1.1-0.5,1.7c-0.6,0.7-1.7,0.9-2.6,0.1c-0.3-0.3-0.5-0.6-0.5-0.9L107.7,54.3z"
                />
                <path
                  class="st31"
                  d="M110.2,58.6l1-1l-1.2-1.2l0.7-0.7l3.8-1.6l0.8,0.8l-2.5,2.6l0.3,0.3l-0.8,0.8l-0.3-0.3l-1,1L110.2,58.6z
            M111.9,56.7l0.7-0.8c0.2-0.2,0.5-0.4,0.7-0.6l0,0c-0.3,0.1-0.5,0.3-0.8,0.4l-1.1,0.5l0,0L111.9,56.7z"
                />
                <path
                  class="st31"
                  d="M112.5,59.2c0.2,0.2,0.2,0.2,0.4,0.3c0.1,0.1,0.4,0.2,0.6,0.1c0.3,0,0.7-0.2,1-0.4l0,0c-0.2,0-0.5,0-0.7-0.2
            c-0.5-0.5-0.4-1.3,0.4-2.2c0.7-0.7,1.9-1.2,2.6-0.5s0.3,1.7-0.7,2.9c-1,1.1-2,1.5-2.7,1.6c-0.5,0.1-1-0.1-1.4-0.4
            c-0.1-0.1-0.2-0.2-0.4-0.3L112.5,59.2z M116.1,57.1c-0.2-0.2-0.5,0.1-1,0.5c-0.3,0.3-0.6,0.8-0.4,1c0.1,0.1,0.3,0.1,0.4,0
            s0.2-0.2,0.6-0.5C116,57.6,116.2,57.2,116.1,57.1L116.1,57.1z"
                />
                <path
                  class="st31"
                  d="M83.4,78.6c0.1,0.2,0.3,0.5,0.5,0.6c0.4,0.3,0.8,0.1,1-0.2c0.4-0.5,0.1-0.9-0.2-1.2l-0.1-0.1l0.6-0.9l0.1,0.1
            c0.3,0.2,0.7,0.3,1-0.1c0.2-0.3,0.2-0.6-0.1-0.8c-0.2-0.1-0.4-0.2-0.6-0.2l0.5-1c0.3,0,0.7,0.1,1.1,0.4c0.8,0.5,0.7,1.4,0.3,2
            c-0.5,0.6-1,0.9-1.5,0.8l0,0c0.3,0.5,0.2,1.1-0.2,1.7c-0.5,0.7-1.6,1.2-2.5,0.5c-0.4-0.2-0.6-0.6-0.7-0.8L83.4,78.6z"
                />
                <path
                  class="st31"
                  d="M86.5,82.5l0.8-1.1l-1.4-1l0.6-0.8l3.5-2.1l0.9,0.6L88.8,81l0.4,0.3l-0.7,0.9l-0.4-0.3L87.3,83L86.5,82.5z
            M88,80.4l0.6-0.9c0.2-0.2,0.4-0.5,0.6-0.7l0,0c-0.2,0.2-0.5,0.3-0.8,0.5l-1,0.6l0,0L88,80.4z"
                />
                <polygon
                  class="st31"
                  points="93.9,80.1 93.3,80.9 89.1,84.3 88.1,83.6 92.2,80.5 92.2,80.5 90.8,79.6 91.6,78.5 	"
                />
                <path
                  class="st31"
                  d="M68.8,107c0.1,0.2,0.3,0.4,0.5,0.6c0.4,0.2,0.8,0,1-0.3c0.3-0.6,0-0.9-0.4-1.2l-0.1-0.1l0.5-0.9h0.1
            c0.3,0.2,0.8,0.2,1-0.2c0.2-0.3,0.1-0.6-0.2-0.8c-0.2-0.1-0.4-0.1-0.7-0.1l0.4-1c0.3,0,0.7,0,1.1,0.2c0.8,0.4,0.9,1.3,0.5,2
            c-0.3,0.5-0.8,0.8-1.3,0.9l0,0c0.3,0.4,0.4,1.1,0,1.7c-0.4,0.8-1.4,1.4-2.4,0.8c-0.4-0.2-0.6-0.5-0.8-0.7L68.8,107z"
                />
                <path
                  class="st31"
                  d="M72.4,110.4l0.6-1.2l-1.5-0.8l0.5-0.9l3.2-2.6l1,0.5l-1.7,3.2l0.4,0.2l-0.5,1l-0.4-0.2l-0.6,1.2L72.4,110.4z
            M73.5,108.2l0.5-0.9c0.1-0.2,0.3-0.5,0.5-0.8l0,0c-0.2,0.2-0.4,0.4-0.7,0.6l-0.9,0.7l0,0L73.5,108.2z"
                />
                <path
                  class="st31"
                  d="M78.5,108.2l-1.1-0.6l-0.5,0.7c0,0,0.1,0,0.1,0.1c0.2,0.1,0.5,0.4,0.6,0.8s0,0.9-0.3,1.5
            c-0.6,1-1.6,1.6-2.6,1.1c-0.3-0.2-0.6-0.5-0.7-0.7l0.7-0.9c0.1,0.2,0.3,0.4,0.5,0.5c0.4,0.2,0.8,0,1.1-0.4c0.4-0.7,0-1.1-0.5-1.4
            c-0.1-0.1-0.2-0.1-0.3-0.1l1.7-2.7l1.9,1L78.5,108.2z"
                />
                <path
                  class="st31"
                  d="M51.1,138.4c0.1,0.2,0.4,0.4,0.6,0.5c0.4,0.2,0.8,0,0.9-0.4c0.3-0.6-0.1-0.9-0.5-1.1l-0.1-0.1l0.4-1h0.1
            c0.3,0.1,0.8,0.2,1-0.3c0.1-0.3,0.1-0.6-0.2-0.8c-0.2-0.1-0.4-0.1-0.7-0.1l0.3-1.1c0.3-0.1,0.7,0,1.1,0.2c0.9,0.4,1,1.2,0.7,1.9
            c-0.3,0.6-0.7,0.9-1.2,1l0,0c0.4,0.4,0.4,1,0.1,1.7c-0.4,0.8-1.3,1.5-2.4,1c-0.4-0.2-0.7-0.4-0.8-0.7L51.1,138.4z"
                />
                <path
                  class="st31"
                  d="M54.9,141.6l0.6-1.3l-1.6-0.7l0.4-0.9l3-2.8l1,0.5l-1.5,3.3l0.4,0.2l-0.5,1.1l-0.4-0.2l-0.6,1.2L54.9,141.6z
            M55.9,139.3l0.4-1c0.1-0.3,0.3-0.6,0.4-0.8l0,0c-0.2,0.2-0.4,0.4-0.6,0.7l-0.9,0.8l0,0L55.9,139.3z"
                />
                <path
                  class="st31"
                  d="M57.1,141.1c0.1,0.2,0.4,0.4,0.6,0.5c0.4,0.2,0.8,0,0.9-0.4c0.3-0.6-0.1-0.9-0.5-1.1L58,140l0.4-1h0.1
            c0.3,0.1,0.8,0.2,1-0.3c0.2-0.3,0.1-0.6-0.2-0.8c-0.2-0.1-0.4-0.1-0.7-0.1l0.3-1.1c0.3-0.1,0.7,0,1.1,0.1c0.9,0.4,1,1.2,0.7,1.9
            c-0.3,0.6-0.7,0.9-1.2,1l0,0c0.4,0.4,0.4,1,0.1,1.7c-0.4,0.8-1.3,1.5-2.4,1c-0.4-0.2-0.7-0.4-0.8-0.7L57.1,141.1z"
                />
                <path
                  class="st31"
                  d="M45.5,168.1c0.2,0.2,0.4,0.3,0.7,0.4c0.5,0.1,0.8-0.2,0.9-0.6c0.1-0.6-0.2-0.9-0.7-1h-0.1l0.2-1h0.1
            c0.4,0.1,0.8,0,0.9-0.5c0.1-0.4-0.1-0.6-0.4-0.7c-0.2,0-0.4,0-0.7,0.1l0.1-1.1c0.2-0.1,0.7-0.2,1.1-0.1c0.9,0.2,1.2,1,1,1.8
            c-0.1,0.6-0.5,1-1,1.2l0,0c0.4,0.3,0.6,0.9,0.5,1.7c-0.2,0.9-1,1.7-2.1,1.4c-0.4-0.1-0.7-0.3-0.9-0.5L45.5,168.1z"
                />
                <path
                  class="st31"
                  d="M49.8,170.5l0.3-1.3l-1.7-0.4l0.2-1l2.4-3.3l1.1,0.2l-0.8,3.5l0.5,0.1l-0.3,1.1l-0.5-0.1l-0.3,1.3L49.8,170.5
            z M50.4,168l0.2-1c0.1-0.3,0.2-0.6,0.3-0.9l0,0c-0.1,0.2-0.3,0.5-0.5,0.8l-0.7,1l0,0L50.4,168z"
                />
                <polygon
                  class="st31"
                  points="53.7,166.4 53.7,166.4 52.7,166.7 52.8,165.6 54.1,165.1 55.1,165.3 53.8,171.3 52.6,171.1 	"
                />
                <path
                  class="st31"
                  d="M149.4,364.6c0.3-0.3,0.7-0.3,1,0c0.5,0.5,0.7,1.4,0.8,2.7l0.1,1l0.7,0.7l2.5-2.5l-0.9-0.9l-1.3,1.3l0,0v-0.5
            c0-1-0.1-2.1-1-2.9c-0.6-0.6-1.6-1-2.6,0.1c-0.4,0.4-0.7,0.9-0.7,1.3l1,0.6C149,365.1,149.2,364.8,149.4,364.6"
                />
                <polygon
                  class="st31"
                  points="152.9,361.3 153,361.2 156.4,364.6 157.4,363.5 153,359.3 152.1,360.2 151.6,361.7 152.6,362.4 	"
                />
                <path
                  class="st31"
                  d="M155.8,358c0.3-0.3,0.6-0.3,0.9-0.1c0.4,0.4,0.1,0.8-0.2,1.2l-0.1,0.1l0.8,0.7l0.1-0.1
            c0.4-0.4,0.9-0.6,1.4-0.2c0.3,0.3,0.3,0.7-0.1,1.1c-0.2,0.2-0.5,0.4-0.8,0.5l0.7,0.9c0.3-0.1,0.7-0.3,1.1-0.7c1-1,0.8-2.2,0.2-2.9
            c-0.6-0.5-1.2-0.6-1.8-0.3l0,0c0.2-0.5,0.1-1.1-0.4-1.6c-0.6-0.5-1.5-0.6-2.3,0.2c-0.4,0.4-0.6,0.9-0.7,1.2l0.9,0.6
            C155.5,358.4,155.7,358.1,155.8,358"
                />
                <path
                  class="st31"
                  d="M171.2,387.2c0.3-0.3,0.7-0.3,1,0c0.5,0.5,0.7,1.4,0.8,2.7l0.1,1l0.7,0.7l2.5-2.5l-0.9-0.9l-1.3,1.3l0,0V389
            c0-1-0.1-2.1-1-2.9c-0.6-0.6-1.6-1-2.6,0.1c-0.4,0.4-0.7,0.9-0.7,1.3l1,0.6C170.9,387.8,171,387.5,171.2,387.2"
                />
                <polygon
                  class="st31"
                  points="174.8,383.9 174.8,383.9 178.2,387.2 179.2,386.2 174.8,381.9 173.9,382.9 173.4,384.4 174.4,385
            "
                />
                <polygon
                  class="st31"
                  points="178,380.6 178,380.6 181.5,383.9 182.5,382.9 178.1,378.6 177.2,379.5 176.7,381.1 177.6,381.7 	"
                />
                <path
                  class="st31"
                  d="M194.9,408.9c0.3-0.3,0.7-0.3,1,0c0.5,0.5,0.7,1.4,0.8,2.7l0.1,1l0.7,0.7l2.5-2.5l-0.9-0.9l-1.3,1.3l0,0v-0.5
            c0-1-0.1-2.1-1-2.9c-0.6-0.6-1.6-1-2.6,0.1c-0.4,0.4-0.7,0.9-0.7,1.3l1,0.6C194.5,409.5,194.6,409.2,194.9,408.9"
                />
                <path
                  class="st31"
                  d="M202.2,408.7L202.2,408.7c0.7-0.7,0.6-2-1-3.6c-0.9-0.9-2.4-2-3.5-0.8c-1,1-0.2,2.5,0.9,3.6
            C199.7,408.8,201.2,409.7,202.2,408.7 M198.6,405.1c0.2-0.2,0.7,0.2,1.6,1c1,1,1.3,1.4,1.1,1.6l0,0c-0.2,0.2-0.7,0-1.7-1
            C198.7,405.8,198.4,405.3,198.6,405.1"
                />
                <path
                  class="st31"
                  d="M203.6,404c0.3-0.3,0.3-0.5,0.3-0.8l0,0c0.2,0.4,0.4,0.8,0.4,1.1c0,0.3-0.1,0.5-0.2,0.7
            c-0.1,0.2-0.2,0.3-0.4,0.5l0.9,0.8c0.1-0.1,0.3-0.3,0.4-0.4c0.4-0.5,0.6-1.1,0.6-1.6c0-0.8-0.3-1.9-1.4-2.9
            c-1.1-1.1-2.3-1.3-3.1-0.5c-0.9,0.9-0.5,2.2,0.2,2.9C202,404.6,203,404.6,203.6,404 M201.7,401.7L201.7,401.7c0.2-0.2,0.6,0,1,0.4
            c0.4,0.3,0.5,0.5,0.5,0.6s0,0.3-0.1,0.4c-0.2,0.2-0.7,0-1-0.3C201.7,402.3,201.5,401.9,201.7,401.7"
                />
                <path
                  class="st31"
                  d="M215.7,427.3c0.3-0.3,0.7-0.3,1,0c0.5,0.5,0.7,1.4,0.8,2.7l0.1,1l0.7,0.7l2.5-2.5l-0.9-0.9l-1.3,1.3l0,0v-0.5
            c0-1-0.1-2.1-1-2.9c-0.6-0.6-1.6-1-2.6,0.1c-0.4,0.4-0.7,0.9-0.7,1.3l1,0.6C215.3,427.9,215.4,427.6,215.7,427.3"
                />
                <path
                  class="st31"
                  d="M223,427.1L223,427.1c0.7-0.7,0.6-2-1-3.6c-0.9-0.9-2.4-2-3.5-0.8c-1,1-0.2,2.5,0.9,3.6
            C220.4,427.2,221.9,428.2,223,427.1 M219.4,423.5c0.2-0.2,0.7,0.2,1.6,1c1,1,1.3,1.4,1.1,1.6l0,0c-0.2,0.2-0.7,0-1.7-1
            C219.4,424.2,219.2,423.8,219.4,423.5"
                />
                <polygon
                  class="st31"
                  points="222.9,420.1 222.9,420.1 225.1,424.8 226.1,423.8 223.7,418.8 223,418.1 220.6,420.6 221.5,421.5
            "
                />
                <path
                  class="st31"
                  d="M66.6,286.2l-0.7-0.7l-0.1-1c-0.2-1.3-0.3-2.2-0.8-2.7c-0.3-0.3-0.7-0.3-1,0c-0.2,0.3-0.4,0.6-0.4,0.9l-1-0.6
            c0.1-0.4,0.4-0.9,0.7-1.3c1-1.1,2-0.7,2.6-0.1c0.8,0.8,0.9,1.9,1,2.9v0.5l0,0l1.3-1.3l0.9,0.9L66.6,286.2z"
                />
                <path
                  class="st31"
                  d="M69.9,282.9l-0.7-0.7l-0.1-1c-0.2-1.3-0.3-2.2-0.8-2.7c-0.3-0.3-0.7-0.3-1,0s-0.4,0.6-0.4,0.9l-1-0.6
            c0.1-0.4,0.3-0.9,0.7-1.3c1-1.1,2-0.7,2.6-0.1c0.8,0.8,0.9,1.9,1,2.9v0.5l0,0l1.3-1.3l0.9,0.9L69.9,282.9z"
                />
                <polygon
                  class="st31"
                  points="70.7,275.2 70.7,275.2 70.3,276.3 69.4,275.7 69.9,274.1 70.8,273.2 75.2,277.5 74.2,278.5 	"
                />
                <path
                  class="st31"
                  d="M84.2,302.8l-0.7-0.7l-0.1-1c-0.2-1.3-0.3-2.2-0.8-2.7c-0.3-0.3-0.7-0.3-1,0s-0.4,0.6-0.4,0.9l-1-0.6
            c0.1-0.4,0.4-0.9,0.7-1.3c1-1.1,2-0.7,2.6-0.1c0.8,0.8,0.9,1.9,1,2.9v0.5l0,0l1.3-1.3l0.9,0.9L84.2,302.8z"
                />
                <polygon
                  class="st31"
                  points="85,295.1 85,295.1 84.7,296.2 83.7,295.6 84.2,294 85.1,293.1 89.5,297.4 88.5,298.4 	"
                />
                <path
                  class="st31"
                  d="M90.3,295c0.2-0.2,0.3-0.3,0.4-0.5s0.2-0.4,0.2-0.7c0-0.3-0.1-0.7-0.4-1.1l0,0c0,0.3-0.1,0.5-0.3,0.8
            c-0.6,0.6-1.6,0.6-2.4-0.2c-0.7-0.7-1.1-2-0.2-2.9c0.8-0.8,2-0.6,3.1,0.5c1.1,1,1.4,2.1,1.4,2.9c0,0.5-0.2,1.1-0.6,1.6
            c-0.1,0.2-0.3,0.3-0.4,0.4L90.3,295z M88.3,291.2c-0.2,0.2,0,0.6,0.4,1c0.3,0.3,0.8,0.6,1,0.3c0.1-0.1,0.1-0.3,0.1-0.4
            c-0.1-0.1-0.2-0.2-0.5-0.6C88.9,291.2,88.5,291,88.3,291.2L88.3,291.2z"
                />
                <path
                  class="st31"
                  d="M103.8,320.7c0.3-0.3,0.7-0.3,1,0c0.5,0.5,0.7,1.4,0.8,2.7l0.1,1l0.7,0.7l2.5-2.5l-0.9-0.9l-1.3,1.3l0,0v-0.5
            c0-1-0.1-2.1-1-2.9c-0.6-0.6-1.6-1-2.6,0.1c-0.4,0.4-0.7,0.9-0.7,1.3l1,0.6C103.4,321.3,103.5,321,103.8,320.7"
                />
                <polygon
                  class="st31"
                  points="107.3,317.4 107.3,317.5 106.9,318.6 105.9,317.9 106.4,316.4 107.3,315.5 111.7,319.7 110.7,320.8
            "
                />
                <polygon
                  class="st31"
                  points="111.2,311.6 111.8,312.2 114.2,317.2 113.2,318.2 111.1,313.5 111,313.5 109.6,315 108.7,314.1 	"
                />
                <path
                  class="st31"
                  d="M52.1,271.4l-0.7-0.7l-0.1-1c-0.2-1.3-0.3-2.2-0.8-2.7c-0.3-0.3-0.7-0.3-1,0s-0.4,0.6-0.4,0.9l-1-0.6
            c0.1-0.4,0.4-0.9,0.7-1.3c1-1.1,2-0.7,2.6-0.1c0.8,0.8,0.9,1.9,1,2.9v0.5l0,0l1.3-1.3l0.9,0.9L52.1,271.4z"
                />
                <path
                  class="st31"
                  d="M55.3,268.1l-0.7-0.7l-0.1-1c-0.2-1.3-0.3-2.2-0.8-2.7c-0.3-0.3-0.7-0.3-1,0s-0.4,0.6-0.4,0.9l-1-0.6
            c0.1-0.4,0.3-0.9,0.7-1.3c1-1.1,2-0.7,2.6-0.1c0.8,0.8,0.9,1.9,1,2.9v0.5l0,0l1.3-1.3l0.9,0.9L55.3,268.1z"
                />
                <path
                  class="st31"
                  d="M56,260.6c0.3-0.3,0.6-0.3,0.9-0.1c0.4,0.4,0.1,0.8-0.2,1.2l-0.1,0.1l0.8,0.7l0.1-0.1
            c0.4-0.4,0.9-0.6,1.4-0.2c0.3,0.3,0.3,0.7-0.1,1.1c-0.2,0.2-0.5,0.4-0.8,0.5l0.7,0.9c0.3-0.1,0.7-0.3,1.1-0.7c1-1,0.8-2.2,0.2-2.9
            c-0.5-0.5-1.2-0.6-1.8-0.3l0,0c0.2-0.5,0.1-1.1-0.4-1.6c-0.6-0.5-1.5-0.6-2.3,0.2c-0.4,0.4-0.6,0.9-0.7,1.2l0.9,0.6
            C55.6,261,55.8,260.8,56,260.6"
                />
                <path
                  class="st31"
                  d="M126.8,342.8c0.3-0.3,0.7-0.3,1,0c0.5,0.5,0.7,1.4,0.8,2.7l0.1,1l0.7,0.7l2.5-2.5l-0.9-0.9l-1.3,1.3l0,0v-0.5
            c0-1-0.1-2.1-1-2.9c-0.6-0.6-1.6-1-2.6,0.1c-0.4,0.4-0.7,0.9-0.7,1.3l1,0.6C126.4,343.3,126.5,343,126.8,342.8"
                />
                <polygon
                  class="st31"
                  points="130.3,339.5 130.3,339.4 133.7,342.8 134.8,341.7 130.3,337.5 129.4,338.4 128.9,339.9 129.9,340.6
            "
                />
                <path
                  class="st31"
                  d="M134.4,337.8c0.5-0.5,1.1-0.8,1.6-0.2c0.4,0.4,0.4,0.9,0,1.3c-0.2,0.2-0.5,0.4-0.8,0.5l0.7,0.9
            c0.3-0.1,0.7-0.4,1-0.7c1-1,0.8-2.3,0-3.1c-0.4-0.4-0.9-0.6-1.4-0.6s-1,0.3-1.1,0.5l-0.1,0.1l-0.6-0.7l1.1-1.2l-0.9-0.9l-1.9,1.9
            l2.1,2.4C134.2,338.1,134.3,338,134.4,337.8"
                />
                <path
                  class="st31"
                  d="M448.7,356.2l-1.3-1.3l0,0h0.5c1,0,2.1-0.1,2.9-1c0.6-0.6,1-1.6-0.1-2.6c-0.4-0.4-0.9-0.7-1.3-0.7l-0.6,1
            c0.3,0.1,0.6,0.2,0.9,0.4c0.3,0.3,0.3,0.7,0,1c-0.5,0.5-1.4,0.7-2.7,0.8l-1,0.1l-0.7,0.7l2.5,2.5L448.7,356.2z"
                />
                <polygon
                  class="st31"
                  points="450.7,359.9 455,355.5 454,354.6 452.5,354.1 451.9,355.1 453,355.5 453,355.5 449.6,358.9 	"
                />
                <path
                  class="st31"
                  d="M453.4,362.5l0.9,0.9l1-1l0.4,0.4l0.8-0.8l-0.4-0.4l2.5-2.6l-1-1l-4.1,1.3l-0.7,0.7l1.5,1.5L453.4,362.5z
            M454.5,360.1l1.2-0.4c0.3-0.1,0.6-0.2,0.9-0.3l0,0c-0.2,0.2-0.5,0.4-0.7,0.6l-0.7,0.8L454.5,360.1L454.5,360.1z"
                />
                <path
                  class="st31"
                  d="M470,332.3l-1.3-1.3l0,0h0.5c1,0,2.1-0.1,2.9-1c0.6-0.6,1-1.6-0.1-2.6c-0.4-0.4-0.9-0.7-1.3-0.7l-0.6,1
            c0.3,0.1,0.6,0.2,0.9,0.4c0.3,0.3,0.3,0.7,0,1c-0.5,0.5-1.4,0.7-2.7,0.8l-1,0.1l-0.7,0.7l2.5,2.5L470,332.3z"
                />
                <polygon
                  class="st31"
                  points="472,336 476.3,331.6 475.4,330.7 473.8,330.2 473.2,331.2 474.3,331.6 474.3,331.6 471,335 	"
                />
                <path
                  class="st31"
                  d="M477.5,338.4c0.8-0.8,0.9-1.8,0.3-2.3c-0.3-0.3-0.6-0.4-1-0.3l0,0c0.6-0.4,1.3-0.5,1.9-0.1
            c0.2,0.1,0.3,0.2,0.4,0.3l0.8-0.8c-0.1-0.1-0.3-0.2-0.5-0.4c-0.4-0.3-1-0.5-1.6-0.5c-0.8,0-1.8,0.3-2.8,1.3
            c-1.1,1.1-1.2,2.4-0.4,3.2C475.6,339.6,476.8,339.1,477.5,338.4 M475.8,336.8c0.2-0.2,0.4-0.4,0.5-0.4c0.2-0.1,0.4-0.1,0.5,0
            c0.3,0.3,0,0.7-0.3,0.9c-0.4,0.4-0.9,0.8-1.1,0.6l0,0C475.1,337.7,475.4,337.2,475.8,336.8"
                />
                <path
                  class="st31"
                  d="M488.5,309.9l0.7-0.7l1-0.1c1.3-0.2,2.2-0.3,2.7-0.9c0.3-0.3,0.3-0.7,0-1c-0.3-0.2-0.6-0.4-0.9-0.4l0.6-1
            c0.4,0.1,0.9,0.3,1.3,0.7c1.1,1,0.7,2,0.1,2.6c-0.8,0.8-1.9,1-2.9,1h-0.5l0,0l1.3,1.2l-0.9,0.9L488.5,309.9z"
                />
                <polygon
                  class="st31"
                  points="494,315.1 498.2,310.6 497.3,309.8 495.7,309.3 495.1,310.3 496.2,310.6 496.3,310.6 493,314.1 	"
                />
                <path
                  class="st31"
                  d="M499.3,317.7c0.5-0.5,0.6-1.2,0.4-1.8l0,0c0.8,0.2,1.2-0.2,1.5-0.4c0.7-0.7,0.5-1.7-0.2-2.3l0,0
            c-0.7-0.7-1.8-0.8-2.5-0.1c-0.3,0.3-0.5,0.9-0.4,1.5l0,0c-0.6-0.1-1.2,0-1.7,0.5c-0.8,0.8-0.6,1.8,0.2,2.6
            C497.4,318.4,498.5,318.5,499.3,317.7 M499.5,314c0.2-0.2,0.5-0.4,0.8-0.2l0,0c0.2,0.2,0,0.6-0.2,0.8c-0.2,0.2-0.6,0.4-0.8,0.3
            C499.2,314.6,499.3,314.3,499.5,314 M497.5,316c0.3-0.3,0.7-0.4,1-0.4c0.1,0.3,0.1,0.8-0.2,1.2c-0.3,0.3-0.7,0.5-0.9,0.3l0,0
            C497,316.7,497.2,316.3,497.5,316"
                />
                <path
                  class="st31"
                  d="M509.7,287.1l0.7-0.7l1-0.1c1.3-0.2,2.2-0.3,2.7-0.9c0.3-0.3,0.3-0.7,0-1c-0.3-0.2-0.6-0.4-0.9-0.4l0.6-1
            c0.4,0.1,0.9,0.3,1.3,0.7c1.1,1,0.7,2,0.1,2.6c-0.8,0.8-1.9,1-2.9,1h-0.5l0,0l1.3,1.2l-0.9,0.9L509.7,287.1z"
                />
                <path
                  class="st31"
                  d="M513.1,290.3l0.7-0.7l1-0.1c1.3-0.2,2.2-0.3,2.7-0.9c0.3-0.3,0.3-0.7,0-1c-0.3-0.2-0.6-0.4-0.9-0.4l0.6-1
            c0.4,0.1,0.9,0.3,1.3,0.7c1.1,1,0.7,2,0.1,2.6c-0.8,0.8-1.9,1-2.9,1h-0.5l0,0l1.3,1.2l-0.9,0.9L513.1,290.3z"
                />
                <path
                  class="st31"
                  d="M517.9,294.8c-1.1-1-0.2-2.5,0.8-3.6c1.1-1.2,2.6-1.9,3.6-1c1.2,1.1,0.1,2.6-0.8,3.5
            C519.9,295.4,518.6,295.5,517.9,294.8L517.9,294.8z M518.8,293.9c0.2,0.2,0.6-0.1,1.6-1.1c0.9-0.9,1.2-1.4,1-1.6s-0.7,0-1.6,1.1
            C518.7,293.2,518.5,293.7,518.8,293.9L518.8,293.9z"
                />
                <path
                  class="st31"
                  d="M526.9,269.8l0.7-0.7l1-0.1c1.3-0.2,2.2-0.3,2.7-0.9c0.3-0.3,0.3-0.7,0-1c-0.3-0.2-0.6-0.4-0.9-0.4l0.6-1
            c0.4,0.1,0.9,0.3,1.3,0.7c1.1,1,0.7,2,0.1,2.6c-0.8,0.8-1.9,1-2.9,1H529l0,0l1.3,1.2l-0.9,0.9L526.9,269.8z"
                />
                <path
                  class="st31"
                  d="M530.4,273l0.7-0.7l1-0.1c1.3-0.2,2.2-0.3,2.7-0.9c0.3-0.3,0.3-0.7,0-1c-0.3-0.2-0.6-0.4-0.9-0.4l0.6-1
            c0.4,0.1,0.9,0.3,1.3,0.7c1.1,1,0.7,2,0.1,2.6c-0.8,0.8-1.9,1-2.9,1h-0.5l0,0l1.3,1.2l-0.9,0.9L530.4,273z"
                />
                <path
                  class="st31"
                  d="M533.8,276.2l0.7-0.7l1-0.1c1.3-0.2,2.2-0.3,2.7-0.9c0.3-0.3,0.3-0.7,0-1c-0.3-0.2-0.6-0.4-0.9-0.4l0.6-1
            c0.4,0.1,0.9,0.3,1.3,0.7c1.1,1,0.7,2,0.1,2.6c-0.8,0.8-1.9,1-2.9,1h-0.5l0,0l1.3,1.2l-0.9,0.9L533.8,276.2z"
                />
                <path
                  class="st31"
                  d="M542.6,253.8l0.7-0.7l1-0.1c1.3-0.1,2.2-0.2,2.7-0.8c0.3-0.3,0.3-0.7,0-1c-0.2-0.3-0.6-0.4-0.9-0.5l0.6-1
            c0.4,0.1,0.9,0.4,1.3,0.8c1.1,1,0.7,2,0.1,2.6c-0.8,0.8-1.9,0.9-2.9,0.9h-0.5l0,0l1.3,1.3l-0.9,0.9L542.6,253.8z"
                />
                <path
                  class="st31"
                  d="M545.8,256.9l0.7-0.7l1-0.1c1.3-0.1,2.2-0.2,2.7-0.8c0.3-0.3,0.3-0.7,0-1s-0.6-0.4-0.9-0.5l0.6-1
            c0.4,0.1,0.9,0.4,1.3,0.8c1,1,0.7,2,0.1,2.6c-0.8,0.8-1.9,0.9-2.9,0.9h-0.5l0,0l1.3,1.3l-0.9,0.9L545.8,256.9z"
                />
                <path
                  class="st31"
                  d="M550.6,261.1l0.9,0.9l1-1l0.4,0.4l0.8-0.8l-0.4-0.4l2.5-2.6l-1-1l-4.1,1.3l-0.7,0.7l1.5,1.5L550.6,261.1z
            M551.7,258.6l1.2-0.4c0.3-0.1,0.6-0.2,0.9-0.3l0,0c-0.2,0.2-0.5,0.4-0.7,0.6l-0.7,0.8L551.7,258.6L551.7,258.6z"
                />
                <path
                  class="st31"
                  d="M381.7,423.9l-1.3-1.3l0,0h0.5c1,0,2.1-0.1,2.9-1c0.6-0.6,1-1.6-0.1-2.6c-0.4-0.4-0.9-0.7-1.3-0.7l-0.6,1
            c0.3,0.1,0.6,0.2,0.9,0.4c0.3,0.3,0.3,0.7,0,1c-0.5,0.5-1.4,0.7-2.7,0.8l-1,0.1l-0.7,0.7l2.5,2.5L381.7,423.9z"
                />
                <path
                  class="st31"
                  d="M383,427c0.7,0.7,2,0.6,3.6-1c0.9-0.9,2-2.4,0.8-3.5c-1-1-2.5-0.2-3.6,0.9C382.8,424.5,381.9,426,383,427
            L383,427z M384.8,424.5c1-1,1.4-1.2,1.7-1c0.2,0.2-0.2,0.7-1,1.6c-1,1-1.4,1.3-1.6,1.1l0,0C383.6,425.9,383.8,425.5,384.8,424.5"
                />
                <path
                  class="st31"
                  d="M389,430.3c0.5-0.5,0.6-1.2,0.4-1.8l0,0c0.8,0.2,1.2-0.1,1.5-0.4c0.7-0.7,0.5-1.7-0.1-2.3l0,0
            c-0.7-0.7-1.8-0.8-2.5-0.1c-0.3,0.3-0.5,0.8-0.4,1.4l0,0c-0.6-0.1-1.2,0-1.7,0.5c-0.8,0.8-0.6,1.8,0.2,2.6
            C387,431,388.1,431.2,389,430.3 M389.2,426.6c0.2-0.2,0.6-0.4,0.8-0.2l0,0c0.2,0.2,0,0.6-0.2,0.8c-0.2,0.2-0.6,0.4-0.8,0.3
            C388.9,427.2,389,426.9,389.2,426.6 M387.2,428.6c0.3-0.3,0.7-0.4,1-0.4c0.1,0.3,0.1,0.8-0.3,1.2c-0.3,0.3-0.7,0.5-0.9,0.2l0,0
            C386.7,429.3,386.9,428.9,387.2,428.6"
                />
                <path
                  class="st31"
                  d="M403.6,401.4l-1.3-1.3l0,0h0.5c1,0,2.1-0.1,2.9-1c0.6-0.6,1-1.6-0.1-2.6c-0.4-0.4-0.9-0.7-1.3-0.7l-0.6,1
            c0.3,0.1,0.6,0.2,0.9,0.4c0.3,0.3,0.3,0.7,0,1c-0.5,0.5-1.4,0.7-2.7,0.8l-1,0.1l-0.7,0.7l2.5,2.5L403.6,401.4z"
                />
                <polygon
                  class="st31"
                  points="405.6,405.1 409.9,400.7 408.9,399.8 407.4,399.3 406.8,400.3 407.9,400.7 407.9,400.7 404.5,404.1
            "
                />
                <path
                  class="st31"
                  d="M408.2,407.8c0.7,0.7,2,0.6,3.6-1c0.9-0.9,2-2.4,0.8-3.5c-1-1-2.5-0.2-3.6,0.9
            C408,405.2,407.1,406.7,408.2,407.8L408.2,407.8z M410,405.2c1-1,1.4-1.2,1.7-1c0.2,0.2-0.2,0.7-1,1.6c-1,1-1.4,1.3-1.6,1.1l0,0
            C408.8,406.6,409,406.2,410,405.2"
                />
                <path
                  class="st31"
                  d="M426.2,378.9l-1.3-1.3l0,0h0.5c1,0,2.1-0.1,2.9-1c0.6-0.6,1-1.6-0.1-2.6c-0.4-0.4-0.9-0.7-1.3-0.7l-0.6,1
            c0.3,0.1,0.6,0.2,0.9,0.4c0.3,0.3,0.3,0.7,0,1c-0.5,0.5-1.4,0.7-2.7,0.8l-1,0.1l-0.7,0.7l2.5,2.5L426.2,378.9z"
                />
                <polygon
                  class="st31"
                  points="428.2,382.6 432.5,378.2 431.6,377.3 430,376.8 429.4,377.8 430.5,378.2 430.5,378.2 427.2,381.6
            "
                />
                <path
                  class="st31"
                  d="M432.9,385.4l-1.3-1.3l0,0h0.5c1,0,2.1-0.1,2.9-1c0.6-0.6,1-1.6-0.1-2.6c-0.4-0.4-0.9-0.7-1.3-0.7l-0.6,1
            c0.3,0.1,0.6,0.2,0.9,0.4c0.3,0.3,0.3,0.7,0,1c-0.5,0.5-1.4,0.7-2.7,0.8l-1,0.1l-0.7,0.7l2.5,2.5L432.9,385.4z"
                />
              </g>
            </svg>
          </b-col>
          <b-col lg="5" md="12">
            <h1>Membership Seating Map</h1>
            <div class="line"></div>
            <h2>Select your Membership Level</h2>
            <p>
              Select your Membership Level to view available seat locations.
              Please note, each Membership Level provides access to purchase
              tickets in different seat locations, subject to availability.
              Increase your Membership Level to gain access to additional
              locations.
            </p>
            <select v-model="selected">
              <option disabled value="">Please select one</option>
              <option value="$500">$500</option>
              <option value="$2,000">$2,000</option>
              <option value="$4,000">$4,000</option>
              <option value="$8,000">$8,000</option>
              <option value="$12,000">$12,000</option>
              <option value="$20,000">$20,000</option>
            </select>
            <!-- <div class="seatingRow">
              <div class="box white"></div><p>DEX Imaging Home Place Club</p>
            </div>
            <div class="seatingRow">
              <div class="box purple"></div><p>Rays Club</p>
            </div>
            <div class="seatingRow">
              <div class="box pink"></div><p>Fieldside Club</p>
            </div>
            <div class="seatingRow">
              <div class="box black"></div><p>Lower Infield Box</p>
            </div>
            <div class="seatingRow">
              <div class="box lightBlue"></div><p>Lower Box Preferred</p>
            </div>
            <div class="seatingRow">
              <div class="box blue"></div><p>Lower Box</p>
            </div>
            <div class="seatingRow">
              <div class="box yellow"></div><p>Press Level</p>
            </div>
            <div class="seatingRow">
              <div class="box darkGreen"></div><p>Press Outfield</p>
            </div>
            <div class="seatingRow">
              <div class="box green"></div><p>Lower Corners</p>
            </div>
            <div class="seatingRow">
              <div class="box peach"></div><p>GTE Financial Party Deck</p>
            </div>
            <div class="seatingRow">
              <div class="box orange"></div><p>Louisiana Hot Sauce Left Field Ledge</p>
            </div> -->
            <div class="total">
              <p>
                Discount Tier:
                <span v-show="selected === ''"></span>
                <span v-show="selected === '$500'">Bronze</span>
                <span v-show="selected === '$2,000'">Bronze</span>
                <span v-show="selected === '$4,000'">Silver</span>
                <span v-show="selected === '$8,000'">Gold</span>
                <span v-show="selected === '$12,000'">Gold</span>
                <span v-show="selected === '$20,000'">Gold</span>
              </p>
            </div>
            <!-- <b-row class="question">
              <b-col>
                <Accordion :accordionData="accordionData" />
              </b-col>
            </b-row> -->
            <b-row class="renewBtn">
              <b-col>
                <a v-scroll-to="'#Renew'">Renew Now</a>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="text-center">
            <!-- <p class="smallPrint">Discounts, estimated to be between 0 – 30%, will vary depending on games selected and membership tier. Gold discounted ticket pricing will be the largest discount, followed by Silver, then Bronze.</p> -->
            <p class="smallPrint">
              Please note, all seat locations, game availability and access to
              benefits are subject to change. Seating capacity may be restricted
              and/or vary throughout the 2021 season.
            </p>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <!-- <Banner bannerDivider="fans" /> -->
  </div>
</template>

<script>
import { seatingData } from "@/data/seatingData";
import { TweenLite } from "gsap/dist/gsap";
import Accordion from "@/components/sections/Seating/Accordion";
import Banner from "@/components/sections/Banner/Banner";

export default {
  name: "SeatingBK",
  components: {
    Accordion,
    Banner,
  },
  data() {
    return {
      selected: "",
      accordionData: seatingData(),
      selectedCategory: "",
      activeItemKey: "",
    };
  },
  watch: {
    selected() {
      var partyDeck = document.getElementById("party-deck");
      var pressLevel = document.getElementById("press-level");
      var preferredLevel = document.getElementById("preferred-level");
      var lowerReserved = document.getElementById("lower-reserved");
      var lowerBox = document.getElementById("lower-box");
      var lowerBoxPreferred = document.getElementById("lower-box-preferred");
      var lowerInfieldBox = document.getElementById("lower-infield-box");
      var chalkBox = document.getElementById("chalk-box");
      var fieldsideBox = document.getElementById("fieldside-box");
      var fieldsideBoxGrey = document.getElementById("fieldside-box-grey");
      var raysClub = document.getElementById("rays-club");
      var dexHomePlate = document.getElementById("dex-home-plate");
      var dexHomePlateGrey = document.getElementById("dex-home-plate-grey");
      var leftFieldLedge = document.getElementById("hotSauce");
      var thirdLevelBases = document.getElementById("third-level-bases");
      var upperHomePlate = document.getElementById("upper-home-plate");
      if (this.selected === "$500") {
        partyDeck.classList.add("showSeats") &
          partyDeck.classList.remove("hideSeats");
        pressLevel.classList.remove("showSeats") &
          pressLevel.classList.add("hideSeats");
        preferredLevel.classList.remove("showSeats") &
          preferredLevel.classList.add("hideSeats");
        lowerReserved.classList.add("showSeats") &
          lowerReserved.classList.remove("hideSeats");
        lowerBox.classList.remove("showSeats") &
          lowerBox.classList.add("hideSeats");
        lowerBoxPreferred.classList.remove("showSeats") &
          lowerBoxPreferred.classList.add("hideSeats");
        leftFieldLedge.classList.remove("showSeats") &
          leftFieldLedge.classList.add("hideSeats");
        lowerInfieldBox.classList.remove("showSeats") &
          lowerInfieldBox.classList.add("hideSeats");
        chalkBox.classList.remove("showSeats") &
          chalkBox.classList.add("hideSeats");
        fieldsideBox.classList.remove("showSeats") &
          fieldsideBox.classList.add("hideSeats");
        fieldsideBoxGrey.classList.add("showSeats") &
          fieldsideBoxGrey.classList.remove("hideSeats");
        raysClub.classList.remove("showSeats") &
          raysClub.classList.add("hideSeats");
        dexHomePlate.classList.remove("showSeats") &
          dexHomePlate.classList.add("hideSeats");
        dexHomePlateGrey.classList.add("showSeats") &
          dexHomePlateGrey.classList.remove("hideSeats");
        thirdLevelBases.classList.add("showSeats") &
          thirdLevelBases.classList.remove("hideSeats");
        upperHomePlate.classList.remove("showSeats") &
          upperHomePlate.classList.add("hideSeats");
      }
      if (this.selected === "$2,000") {
        partyDeck.classList.add("showSeats") &
          partyDeck.classList.remove("hideSeats");
        pressLevel.classList.add("showSeats") &
          pressLevel.classList.remove("hideSeats");
        preferredLevel.classList.add("showSeats") &
          preferredLevel.classList.remove("hideSeats");
        lowerReserved.classList.add("showSeats") &
          lowerReserved.classList.remove("hideSeats");
        lowerBox.classList.remove("showSeats") &
          lowerBox.classList.add("hideSeats");
        lowerBoxPreferred.classList.remove("showSeats") &
          lowerBoxPreferred.classList.add("hideSeats");
        leftFieldLedge.classList.remove("showSeats") &
          leftFieldLedge.classList.add("hideSeats");
        lowerInfieldBox.classList.remove("showSeats") &
          lowerInfieldBox.classList.add("hideSeats");
        chalkBox.classList.remove("showSeats") &
          chalkBox.classList.add("hideSeats");
        fieldsideBox.classList.remove("showSeats") &
          fieldsideBox.classList.add("hideSeats");
        fieldsideBoxGrey.classList.add("showSeats") &
          fieldsideBoxGrey.classList.remove("hideSeats");
        raysClub.classList.remove("showSeats") &
          raysClub.classList.add("hideSeats");
        dexHomePlate.classList.remove("showSeats") &
          dexHomePlate.classList.add("hideSeats");
        dexHomePlateGrey.classList.add("showSeats") &
          dexHomePlateGrey.classList.remove("hideSeats");
        thirdLevelBases.classList.add("showSeats") &
          thirdLevelBases.classList.remove("hideSeats");
        upperHomePlate.classList.add("showSeats") &
          upperHomePlate.classList.remove("hideSeats");
      }
      if (this.selected === "$4,000") {
        partyDeck.classList.add("showSeats") &
          partyDeck.classList.remove("hideSeats");
        pressLevel.classList.add("showSeats") &
          pressLevel.classList.remove("hideSeats");
        preferredLevel.classList.add("showSeats") &
          preferredLevel.classList.remove("hideSeats");
        lowerReserved.classList.add("showSeats") &
          lowerReserved.classList.remove("hideSeats");
        lowerBox.classList.add("showSeats") &
          lowerBox.classList.remove("hideSeats");
        lowerBoxPreferred.classList.add("showSeats") &
          lowerBoxPreferred.classList.remove("hideSeats");
        leftFieldLedge.classList.add("showSeats") &
          leftFieldLedge.classList.remove("hideSeats");
        lowerInfieldBox.classList.remove("showSeats") &
          lowerInfieldBox.classList.add("hideSeats");
        chalkBox.classList.remove("showSeats") &
          chalkBox.classList.add("hideSeats");
        fieldsideBox.classList.remove("showSeats") &
          fieldsideBox.classList.add("hideSeats");
        fieldsideBoxGrey.classList.add("showSeats") &
          fieldsideBoxGrey.classList.remove("hideSeats");
        raysClub.classList.remove("showSeats") &
          raysClub.classList.add("hideSeats");
        dexHomePlate.classList.remove("showSeats") &
          dexHomePlate.classList.add("hideSeats");
        dexHomePlateGrey.classList.add("showSeats") &
          dexHomePlateGrey.classList.remove("hideSeats");
        thirdLevelBases.classList.add("showSeats") &
          thirdLevelBases.classList.remove("hideSeats");
        upperHomePlate.classList.add("showSeats") &
          upperHomePlate.classList.remove("hideSeats");
      }
      if (this.selected === "$8,000") {
        partyDeck.classList.add("showSeats") &
          partyDeck.classList.remove("hideSeats");
        pressLevel.classList.add("showSeats") &
          pressLevel.classList.remove("hideSeats");
        preferredLevel.classList.add("showSeats") &
          preferredLevel.classList.remove("hideSeats");
        lowerReserved.classList.add("showSeats") &
          lowerReserved.classList.remove("hideSeats");
        lowerBox.classList.add("showSeats") &
          lowerBox.classList.remove("hideSeats");
        lowerBoxPreferred.classList.add("showSeats") &
          lowerBoxPreferred.classList.remove("hideSeats");
        leftFieldLedge.classList.add("showSeats") &
          leftFieldLedge.classList.remove("hideSeats");
        lowerInfieldBox.classList.add("showSeats") &
          lowerInfieldBox.classList.remove("hideSeats");
        chalkBox.classList.remove("showSeats") &
          chalkBox.classList.add("hideSeats");
        fieldsideBox.classList.remove("showSeats") &
          fieldsideBox.classList.add("hideSeats");
        fieldsideBoxGrey.classList.add("showSeats") &
          fieldsideBoxGrey.classList.remove("hideSeats");
        raysClub.classList.remove("showSeats") &
          raysClub.classList.add("hideSeats");
        dexHomePlate.classList.remove("showSeats") &
          dexHomePlate.classList.add("hideSeats");
        dexHomePlateGrey.classList.add("showSeats") &
          dexHomePlateGrey.classList.remove("hideSeats");
        thirdLevelBases.classList.add("showSeats") &
          thirdLevelBases.classList.remove("hideSeats");
        upperHomePlate.classList.add("showSeats") &
          upperHomePlate.classList.remove("hideSeats");
      }
      if (this.selected === "$12,000") {
        partyDeck.classList.add("showSeats") &
          partyDeck.classList.remove("hideSeats");
        pressLevel.classList.add("showSeats") &
          pressLevel.classList.remove("hideSeats");
        preferredLevel.classList.add("showSeats") &
          preferredLevel.classList.remove("hideSeats");
        lowerReserved.classList.add("showSeats") &
          lowerReserved.classList.remove("hideSeats");
        lowerBox.classList.add("showSeats") &
          lowerBox.classList.remove("hideSeats");
        lowerBoxPreferred.classList.add("showSeats") &
          lowerBoxPreferred.classList.remove("hideSeats");
        leftFieldLedge.classList.add("showSeats") &
          leftFieldLedge.classList.remove("hideSeats");
        lowerInfieldBox.classList.add("showSeats") &
          lowerInfieldBox.classList.remove("hideSeats");
        chalkBox.classList.add("showSeats") &
          chalkBox.classList.remove("hideSeats");
        fieldsideBox.classList.add("showSeats") &
          fieldsideBox.classList.remove("hideSeats");
        fieldsideBoxGrey.classList.remove("showSeats") &
          fieldsideBoxGrey.classList.add("hideSeats");
        raysClub.classList.add("showSeats") &
          raysClub.classList.remove("hideSeats");
        dexHomePlate.classList.remove("showSeats") &
          dexHomePlate.classList.add("hideSeats");
        dexHomePlateGrey.classList.add("showSeats") &
          dexHomePlateGrey.classList.remove("hideSeats");
        thirdLevelBases.classList.add("showSeats") &
          thirdLevelBases.classList.remove("hideSeats");
        upperHomePlate.classList.add("showSeats") &
          upperHomePlate.classList.remove("hideSeats");
      }
      if (this.selected === "$20,000") {
        partyDeck.classList.add("showSeats") &
          partyDeck.classList.remove("hideSeats");
        pressLevel.classList.add("showSeats") &
          pressLevel.classList.remove("hideSeats");
        preferredLevel.classList.add("showSeats") &
          preferredLevel.classList.remove("hideSeats");
        lowerReserved.classList.add("showSeats") &
          lowerReserved.classList.remove("hideSeats");
        lowerBox.classList.add("showSeats") &
          lowerBox.classList.remove("hideSeats");
        lowerBoxPreferred.classList.add("showSeats") &
          lowerBoxPreferred.classList.remove("hideSeats");
        leftFieldLedge.classList.add("showSeats") &
          leftFieldLedge.classList.remove("hideSeats");
        lowerInfieldBox.classList.add("showSeats") &
          lowerInfieldBox.classList.remove("hideSeats");
        chalkBox.classList.add("showSeats") &
          chalkBox.classList.remove("hideSeats");
        fieldsideBox.classList.add("showSeats") &
          fieldsideBox.classList.remove("hideSeats");
        fieldsideBoxGrey.classList.remove("showSeats") &
          fieldsideBoxGrey.classList.add("hideSeats");
        raysClub.classList.add("showSeats") &
          raysClub.classList.remove("hideSeats");
        dexHomePlate.classList.add("showSeats") &
          dexHomePlate.classList.remove("hideSeats");
        dexHomePlateGrey.classList.remove("showSeats") &
          dexHomePlateGrey.classList.add("hideSeats");
        thirdLevelBases.classList.add("showSeats") &
          thirdLevelBases.classList.remove("hideSeats");
        upperHomePlate.classList.add("showSeats") &
          upperHomePlate.classList.remove("hideSeats");
      }
    },
  },
  mounted() {
    var partyDeck = document.getElementById("party-deck");
    var pressLevel = document.getElementById("press-level");
    var preferredLevel = document.getElementById("preferred-level");
    var lowerReserved = document.getElementById("lower-reserved");
    var lowerBox = document.getElementById("lower-box");
    var lowerBoxPreferred = document.getElementById("lower-box-preferred");
    var lowerInfieldBox = document.getElementById("lower-infield-box");
    var chalkBox = document.getElementById("chalk-box");
    var fieldsideBox = document.getElementById("fieldside-box");
    var fieldsideBoxGrey = document.getElementById("fieldside-box-grey");
    var raysClub = document.getElementById("rays-club");
    var dexHomePlate = document.getElementById("dex-home-plate");
    var dexHomePlateGrey = document.getElementById("dex-home-plate-grey");
    var leftFieldLedge = document.getElementById("hotSauce");
    var thirdLevelBases = document.getElementById("third-level-bases");
    var upperHomePlate = document.getElementById("upper-home-plate");

    partyDeck.classList.remove("showSeats") &
      partyDeck.classList.add("hideSeats");
    pressLevel.classList.remove("showSeats") &
      pressLevel.classList.add("hideSeats");
    preferredLevel.classList.remove("showSeats") &
      preferredLevel.classList.add("hideSeats");
    lowerReserved.classList.remove("showSeats") &
      lowerReserved.classList.add("hideSeats");
    lowerBox.classList.remove("showSeats") &
      lowerBox.classList.add("hideSeats");
    lowerBoxPreferred.classList.remove("showSeats") &
      lowerBoxPreferred.classList.add("hideSeats");
    leftFieldLedge.classList.remove("showSeats") &
      leftFieldLedge.classList.add("hideSeats");
    lowerInfieldBox.classList.remove("showSeats") &
      lowerInfieldBox.classList.add("hideSeats");
    chalkBox.classList.remove("showSeats") &
      chalkBox.classList.add("hideSeats");
    fieldsideBox.classList.remove("showSeats") &
      fieldsideBox.classList.add("hideSeats");
    fieldsideBoxGrey.classList.remove("showSeats") &
      fieldsideBoxGrey.classList.add("hideSeats");
    raysClub.classList.remove("showSeats") &
      raysClub.classList.add("hideSeats");
    dexHomePlate.classList.remove("showSeats") &
      dexHomePlate.classList.add("hideSeats");
    dexHomePlateGrey.classList.remove("showSeats") &
      dexHomePlateGrey.classList.add("hideSeats");
    thirdLevelBases.classList.remove("showSeats") &
      thirdLevelBases.classList.add("hideSeats");
    upperHomePlate.classList.remove("showSeats") &
      upperHomePlate.classList.add("hideSeats");
  },
};
</script>

<style lang="scss" scoped>
#SeatingBK {
  display: none;
  // padding: 0 0 100px 0;

  .seatingMain {
    padding: 0 7%;
    .map {
      img {
        width: 100%;
      }
      .st0 {
        fill: #d1d2d3;
      }
      .st1 {
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: #d1d2d3;
      }
      .st2 {
        display: none;
        fill: #d1d2d3;
      }
      .st3 {
        display: none;
      }
      .st4 {
        display: inline;
        fill: #d1d2d3;
      }
      .st5 {
        fill: #00275d;
      }
      .st6 {
        fill: #bdbfc1;
      }
      .st7 {
        fill: #0d5330;
      }
      .st8 {
        fill: #79bde9;
      }
      .st9 {
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: #79bde9;
      }
      .st10 {
        fill: #03532f;
      }
      .st11 {
        fill: #f78f1e;
      }
      .st12 {
        fill: #72c06c;
      }
      .st13 {
        fill: #fcd20b;
      }
      .st14 {
        fill: #271f10;
      }
      .st15 {
        font-family: "HelveticaNeue-CondensedBold";
      }
      .st16 {
        font-size: 7.0965px;
      }
      .st17 {
        fill: #050707;
      }
      .st18 {
        display: none;
        fill: #bdbfc1;
      }
      .st19 {
        fill: #e7e7e8;
      }
      .st20 {
        fill: #929497;
      }
      .st21 {
        fill: #e6e7e7;
      }
      .st22 {
        fill: #1d2d5c;
      }
      .st23 {
        fill: none;
        stroke: #282011;
        stroke-width: 0.5;
      }
      .st24 {
        fill: none;
        stroke: #d1d3d4;
      }
      .st25 {
        fill: #282011;
      }
      .st26 {
        fill: #dbdcdd;
      }
      .st27 {
        fill: #bfbdb6;
      }
      .st28 {
        fill: #bdc0c1;
      }
      .st29 {
        fill: #a8a8a8;
      }
      .st30 {
        fill: #d1d3d4;
      }
      .st31 {
        fill: #ffffff;
      }
      .st32 {
        fill: none;
        stroke: #bdbfc1;
        stroke-width: 0.696;
      }
      .st33 {
        fill: none;
        stroke: #bdbfc1;
        stroke-width: 0.696;
        stroke-miterlimit: 4.0004;
      }
      .st34 {
        fill: none;
        stroke: #bdbfc1;
        stroke-width: 0.696;
        stroke-miterlimit: 4;
      }
      .st35 {
        fill: #c8503b;
      }
      .st36 {
        fill: #838383;
      }
      .st37 {
        fill: #005f35;
      }
      .st38 {
        fill: #221f1f;
      }
      .st39 {
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: #0155a3;
      }
      .st40 {
        fill: none;
        stroke: #ffffff;
        stroke-width: 0.238;
      }
      .st41 {
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: #ffffff;
      }
      .st42 {
        fill: none;
      }
      .st43 {
        font-size: 5.1819px;
      }
      .st44 {
        font-size: 5.1818px;
      }
      .st45 {
        font-size: 4.9736px;
      }
      .st46 {
        fill: none;
        stroke: #bdbfc1;
        stroke-width: 0.798;
      }
      .st47 {
        fill: #bec0c1;
      }
      .st48 {
        fill: none;
        stroke: #221f1f;
        stroke-width: 0.25;
        stroke-linecap: square;
        stroke-miterlimit: 10;
      }
      .st49 {
        font-size: 5.1044px;
      }
      .st50 {
        font-size: 5.1124px;
      }
      .st51 {
        fill: #231f20;
      }
      .st52 {
        font-size: 5.1053px;
      }
      .st53 {
        font-size: 8.9339px;
      }
      .st54 {
        fill: #bcbfc1;
      }
      .st55 {
        fill: #e7e6e6;
      }
      .st56 {
        fill: #272013;
      }
      .st57 {
        font-size: 5.0802px;
      }
      .st58 {
        font-size: 3.5996px;
      }
      .st59 {
        font-size: 3.5952px;
      }
      .st60 {
        font-size: 4.2889px;
      }
      .st61 {
        fill: #ce0e2d;
      }
      .st62 {
        fill: none;
        stroke: #a8a8a8;
        stroke-width: 0.25;
        stroke-miterlimit: 10;
      }
      .st63 {
        fill: #79bde8;
      }
      .st64 {
        fill: #00285d;
      }
      .st65 {
        fill: #ffd200;
      }
      #hotSauce {
        fill: #bdbfc1;
        transition: all 0.25s ease-in-out;
        &.showSeats {
          fill: $dark-blue;
        }
      }
    }
    h1 {
      font-family: "UniversLTStd-UltraCn";
      color: $dark-blue;
      font-size: 50px;
      text-transform: uppercase;
      @media only screen and (max-width: $lg) {
        margin-top: 50px;
      }
      @media only screen and (max-width: $sm) {
        font-size: 42px;
      }
    }
    h2 {
      font-family: "UniversLTStd-UltraCn";
      color: $dark-blue;
      font-size: 32px;
      text-transform: uppercase;
    }
    p {
      font-family: "UniversLTStd";
      text-align: justify;
      text-justify: inter-word;
      &.smallPrint {
        font-family: "UniversLTStd-Obl";
        font-size: 12px;
        margin: 10px 0;
      }
    }
    .line {
      background-color: $yellow;
      width: 190px;
      height: 3px;
      margin: 10px 0 20px 0;
    }
    select {
      font-family: "UniversLTStd";
      font-size: 18px;
      color: $grey-blue;
      padding: 5px 10px;
      width: 300px;
      border: 1px solid $dark-blue;
      border-radius: 5px;
      margin: 10px 0;
      box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.1);
      @media only screen and (max-width: $sm) {
        width: 100%;
      }
      option {
        color: $dark-blue;
        &:disabled {
          color: $grey-blue;
        }
      }
    }
    .total {
      margin-bottom: 15px;
      p {
        color: $dark-blue;
        font-size: 24px;
        font-family: "UniversLTStd-UltraCn";
        span {
          font-family: "UniversLTStd-BoldCn";
        }
      }
    }
    .seatingRow {
      height: 40px;
      .box {
        width: 25px;
        height: 25px;
        border: 1px solid #000;
        float: left;
        margin-top: -2px;
        &.white {
          background-color: #fff;
        }
        &.purple {
          background-color: #9d4d9f;
        }
        &.pink {
          background-color: #f48798;
        }
        &.black {
          background-color: #000;
        }
        &.lightBlue {
          background-color: #a0ccee;
        }
        &.blue {
          background-color: #00afdb;
        }
        &.yellow {
          background-color: #fed302;
        }
        &.darkGreen {
          background-color: #01532b;
        }
        &.green {
          background-color: #d3e6a8;
        }
        &.peach {
          background-color: #e1ceac;
        }
        &.orange {
          background-color: #f69418;
        }
      }
      p {
        font-family: "UniversLTStd";
        font-size: 16px;
        color: #000;
        margin-left: 40px;
      }
    }
    .renewBtn {
      margin: 25px 0;
      .col {
        margin: 0;
        padding: 0;
      }
      a {
        font-family: "UniversLTStd-Bold";
        font-size: 16px;
        color: #000;
        background-color: $yellow;
        border-radius: 25px;
        padding: 15px 40px;
        text-transform: uppercase;
        cursor: pointer;
        &:hover {
          text-decoration: none;
        }
      }
    }
  }
  #party-deck {
    transition: all 0.25s ease-in-out;
    opacity: 1;
    &.hideSeats {
      visibility: hidden;
      opacity: 0;
    }
    &.showSeats {
      visibility: visible;
      opacity: 1;
    }
  }
  #press-level {
    transition: all 0.25s ease-in-out;
    opacity: 1;
    &.hideSeats {
      visibility: hidden;
      opacity: 0;
    }
    &.showSeats {
      visibility: visible;
      opacity: 1;
    }
  }
  #preferred-level {
    transition: all 0.25s ease-in-out;
    opacity: 1;
    &.hideSeats {
      visibility: hidden;
      opacity: 0;
    }
    &.showSeats {
      visibility: visible;
      opacity: 1;
    }
  }
  #lower-reserved {
    transition: all 0.25s ease-in-out;
    opacity: 1;
    &.hideSeats {
      visibility: hidden;
      opacity: 0;
    }
    &.showSeats {
      visibility: visible;
      opacity: 1;
    }
  }
  #lower-box {
    transition: all 0.25s ease-in-out;
    opacity: 1;
    &.hideSeats {
      visibility: hidden;
      opacity: 0;
    }
    &.showSeats {
      visibility: visible;
      opacity: 1;
    }
  }
  #lower-box-preferred {
    transition: all 0.25s ease-in-out;
    opacity: 1;
    &.hideSeats {
      visibility: hidden;
      opacity: 0;
    }
    &.showSeats {
      visibility: visible;
      opacity: 1;
    }
  }
  #lower-infield-box {
    transition: all 0.25s ease-in-out;
    opacity: 1;
    &.hideSeats {
      visibility: hidden;
      opacity: 0;
    }
    &.showSeats {
      visibility: visible;
      opacity: 1;
    }
  }
  #chalk-box {
    transition: all 0.25s ease-in-out;
    opacity: 1;
    &.hideSeats {
      visibility: hidden;
      opacity: 0;
    }
    &.showSeats {
      visibility: visible;
      opacity: 1;
    }
  }
  #fieldside-box {
    transition: all 0.25s ease-in-out;
    opacity: 1;
    &.hideSeats {
      visibility: hidden;
      opacity: 0;
    }
    &.showSeats {
      visibility: visible;
      opacity: 1;
    }
  }
  #fieldside-box-grey {
    transition: all 0.25s ease-in-out;
    opacity: 1;
    &.hideSeats {
      visibility: hidden;
      opacity: 0;
    }
    &.showSeats {
      visibility: visible;
      opacity: 1;
    }
  }
  #rays-club {
    transition: all 0.25s ease-in-out;
    opacity: 1;
    &.hideSeats {
      visibility: hidden;
      opacity: 0;
    }
    &.showSeats {
      visibility: visible;
      opacity: 1;
    }
  }
  #dex-home-plate {
    transition: all 0.25s ease-in-out;
    opacity: 1;
    &.hideSeats {
      visibility: hidden;
      opacity: 0;
    }
    &.showSeats {
      visibility: visible;
      opacity: 1;
    }
  }
  #dex-home-plate-grey {
    transition: all 0.25s ease-in-out;
    opacity: 1;
    &.hideSeats {
      visibility: hidden;
      opacity: 0;
    }
    &.showSeats {
      visibility: visible;
      opacity: 1;
    }
  }
  #third-level-bases {
    transition: all 0.25s ease-in-out;
    opacity: 1;
    &.hideSeats {
      visibility: hidden;
      opacity: 0;
    }
    &.showSeats {
      visibility: visible;
      opacity: 1;
    }
  }
  #upper-home-plate {
    transition: all 0.25s ease-in-out;
    opacity: 1;
    &.hideSeats {
      visibility: hidden;
      opacity: 0;
    }
    &.showSeats {
      visibility: visible;
      opacity: 1;
    }
  }
}
</style>
